import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Output, Component, Input, ViewChild, ViewContainerRef, Directive, ElementRef, forwardRef, ChangeDetectionStrategy, Inject, Optional, ContentChild, HostBinding, HostListener, LOCALE_ID, Pipe, ViewChildren, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i3$2 from '@angular/forms';
import { UntypedFormControl, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i4 from '@angular/material/legacy-button';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import * as i2$2 from '@angular/material/legacy-card';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import * as i4$1 from '@angular/material/legacy-checkbox';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import * as i2$1 from '@angular/material/legacy-chips';
import { MatLegacyChipsModule } from '@angular/material/legacy-chips';
import { MAT_RIPPLE_GLOBAL_OPTIONS, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i1$4 from '@angular/material/legacy-dialog';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import * as i6$2 from '@angular/material/divider';
import { MatDividerModule } from '@angular/material/divider';
import * as i7$1 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i6$1 from '@angular/material/legacy-form-field';
import { MatLegacyFormField, MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import * as i2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i7 from '@angular/material/legacy-input';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import * as i6 from '@angular/material/legacy-menu';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import * as i8$1 from '@angular/material/legacy-paginator';
import { MatLegacyPaginatorModule } from '@angular/material/legacy-paginator';
import * as i3 from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressBarModule } from '@angular/material/legacy-progress-bar';
import * as i9$1 from '@angular/material/legacy-progress-spinner';
import { MatLegacyProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule } from '@angular/material/legacy-radio';
import * as i11 from '@angular/material/legacy-select';
import { MatLegacySelect, MatLegacySelectModule } from '@angular/material/legacy-select';
import * as i7$2 from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import * as i5 from '@angular/material/legacy-slide-toggle';
import { MatLegacySlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySliderModule } from '@angular/material/legacy-slider';
import * as i1$2 from '@angular/material/legacy-snack-bar';
import { MatLegacySnackBarModule } from '@angular/material/legacy-snack-bar';
import * as i9 from '@angular/material/sort';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import * as i10 from '@angular/material/legacy-table';
import { MatLegacyTableModule } from '@angular/material/legacy-table';
import * as i8$2 from '@angular/material/legacy-tabs';
import { MatLegacyTabsModule } from '@angular/material/legacy-tabs';
import * as i8 from '@angular/material/legacy-tooltip';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { HttpClientModule } from '@angular/common/http';
import * as i1$3 from '@angular/platform-browser';
import { tap, switchMap, map, startWith, delay, takeUntil, take, filter } from 'rxjs/operators';
import * as d3 from 'd3';
import * as moment_ from 'moment';
import { Subscription, BehaviorSubject, of, combineLatest, Subject } from 'rxjs';
import * as i12 from '@angular/material/legacy-core';
import { _countGroupLabelsBeforeLegacyOption, MatLegacyOption } from '@angular/material/legacy-core';
import { A, Z, ZERO, NINE, SPACE, HOME, END, ENTER, ESCAPE, UP_ARROW, DOWN_ARROW } from '@angular/cdk/keycodes';
import * as i1$1 from '@angular/cdk/scrolling';
import * as i2$3 from '@angular/cdk/a11y';
import { SelectionModel } from '@angular/cdk/collections';
import * as i2$4 from 'ngx-cookie-service';
import * as mtz from 'moment-timezone';
import { trigger, state, style, transition, animate } from '@angular/animations';

class FilterService {
    constructor() {
        this.filters = {
            applications: [],
            vulnerabilities: [],
            devices: []
        };
        this.filters.applications = [{
                id: 'category',
                name: 'By Category',
                children: [{
                        id: 'Antiphishing',
                        name: 'Antiphishing'
                    }, {
                        id: 'Antivirus',
                        name: 'Anti-Malware'
                    }, {
                        id: 'BackupClient',
                        name: 'Backup'
                    }, {
                        id: 'Cleaner_Optimizer',
                        name: 'Cleaner / Optimizer'
                    }, {
                        id: 'Cloud_Storage',
                        name: 'Cloud Storage'
                    }, {
                        id: 'Developer_Tool',
                        name: 'Developer Tool'
                    }, {
                        id: 'Firewall',
                        name: 'Firewall'
                    }, {
                        id: 'Hard_Disk_Encryption',
                        name: 'Encryption'
                    }, {
                        id: 'Instant_Messegener',
                        name: 'Chat / IM'
                    }, {
                        id: 'Media_Player',
                        name: 'Media Player'
                    }, {
                        id: 'Patch_Management',
                        name: 'Patch Management'
                    }, {
                        id: 'PublicFileSharing',
                        name: 'Public File Sharing'
                    }, {
                        id: 'Recording_Web_Meeting',
                        name: 'Screen Sharing'
                    }, {
                        id: 'Remote_Control',
                        name: 'Remote Control'
                    }, {
                        id: 'Toolbars',
                        name: 'Toolbar'
                    }, {
                        id: 'Unclassified_PUA',
                        name: 'Unclassified PUA'
                    }, {
                        id: 'Uninstaller',
                        name: 'Uninstaller'
                    }, {
                        id: 'VPN_Client',
                        name: 'VPN Client'
                    }, {
                        id: 'unclassified',
                        name: 'Unclassified'
                    }]
            }, {
                id: 'severity',
                name: 'By Severity',
                children: [{
                        id: 'critical',
                        name: 'Critical'
                    }, {
                        id: 'important',
                        name: 'Important'
                    }, {
                        id: 'moderate',
                        name: 'Moderate'
                    }, {
                        id: 'low',
                        name: 'Low'
                    }, {
                        id: 'unknown',
                        name: 'Unknown'
                    }]
            }, {
                id: 'whitelist',
                name: 'By Whitelist',
                children: [{
                        id: 'none',
                        name: 'Non-Whitelisted'
                    }, {
                        id: 'all-policy',
                        name: 'Whitelisted'
                    }]
            }];
        this.filters.vulnerabilities = [{
                id: 'severity',
                name: 'Vulnerability Severity',
                children: [{
                        id: 'critical',
                        name: 'Critical'
                    }, {
                        id: 'important',
                        name: 'Important'
                    }, {
                        id: 'moderate',
                        name: 'Moderate'
                    }, {
                        id: 'low',
                        name: 'Low'
                    }, {
                        id: 'unknown',
                        name: 'Unknown'
                    }]
            }, {
                id: 'whitelist',
                name: 'By Whitelist',
                children: [{
                        id: 'apply',
                        name: 'Whitelisted'
                    }, {
                        id: 'none',
                        name: 'Not whitelisted'
                    }]
            }];
        this.filters.devices = [{
                id: 'mal_detection',
                name: 'Malware Detection',
                children: [{
                        id: 'md_threat_detected',
                        name: 'Threats detected'
                    }, {
                        id: 'md_threat_ip',
                        name: 'Suspicious IP connections'
                    }]
            }, {
                id: 'category',
                name: 'Compliance Issues',
                children: [{
                        id: 'Antivirus',
                        name: 'Anti-Malware'
                    }, {
                        id: 'System',
                        name: 'User Authentication'
                    }, {
                        id: 'threat_metascan',
                        name: 'Threats detected by Multiscanning technology'
                    }, {
                        id: 'Vulnerability_CVE',
                        name: 'Vulnerabilities and Exposures'
                    }, {
                        id: 'Hard_Disk_Encryption',
                        name: 'Encryption'
                    }, {
                        id: 'threat_antivirus',
                        name: 'Repeated Threats'
                    }, {
                        id: 'Patch_Management',
                        name: 'Patch Management'
                    }, {
                        id: 'Antiphishing',
                        name: 'Antiphishing'
                    }, {
                        id: 'BackupClient',
                        name: 'Backup'
                    }, {
                        id: 'Cleaner_Optimizer',
                        name: 'Cleaner / Optimizer'
                    }, {
                        id: 'Cloud_Storage',
                        name: 'Cloud Storage'
                    }, {
                        id: 'CustomCheck',
                        name: 'Custom Check'
                    }, {
                        id: 'Developer_Tool',
                        name: 'Developer Tool'
                    }, {
                        id: 'Firewall',
                        name: 'Firewall'
                    }, {
                        id: 'Hard_Drive',
                        name: 'Hard Drive'
                    }, {
                        id: 'Instant_Messegener',
                        name: 'Chat / IM'
                    }, {
                        id: 'Media_Player',
                        name: 'Media Player'
                    }, {
                        id: 'Operating_System',
                        name: 'Operating System'
                    }, {
                        id: 'PublicFileSharing',
                        name: 'Public File Sharing'
                    }, {
                        id: 'Recording_Web_Meeting',
                        name: 'Screen Sharing'
                    }, {
                        id: 'Remote_Control',
                        name: 'Remote Control'
                    }, {
                        id: 'SystemSecurity',
                        name: 'Security & Health (Mobile)'
                    }, {
                        id: 'Toolbars',
                        name: 'Toolbar'
                    }, {
                        id: 'Uninstaller',
                        name: 'Uninstaller'
                    }, {
                        id: 'VPN_Client',
                        name: 'VPN Client'
                    }, {
                        id: 'Unclassified_PUA',
                        name: 'Unclassified PUA'
                    }, {
                        id: 'threat_ip',
                        name: 'IP Connections'
                    }]
            }, {
                id: 'severity',
                name: 'Issue Severity',
                children: [{
                        id: 'no_issues',
                        name: 'No Issue'
                    }, {
                        id: 'warning',
                        name: 'Warning Issues'
                    }, {
                        id: 'critical',
                        name: 'Critical Issues'
                    }]
            }, {
                id: 'device_status',
                name: 'Device Status',
                children: [{
                        id: 'installed',
                        name: 'Agent Installed'
                    }, {
                        id: 'ignored',
                        name: 'Ignored'
                    }, {
                        id: 'compliant',
                        name: 'Compliant'
                    }, {
                        id: 'exempted',
                        name: 'Exempted'
                    }, {
                        id: 'unknown',
                        name: 'Unknown'
                    }, {
                        id: 'out_of_license_usage',
                        name: 'Out of License Usage'
                    }, {
                        id: 'non_compliant',
                        name: 'Non-Compliant'
                    }, {
                        id: 'monitored',
                        name: 'Monitored'
                    }]
            }, {
                id: 'device_type',
                name: 'Device Type',
                children: [{
                        id: 'desktop',
                        name: 'Desktop'
                    }, {
                        id: 'server',
                        name: 'Server'
                    }, {
                        id: 'phone',
                        name: 'Phone'
                    }, {
                        id: 'tablet',
                        name: 'Tablet'
                    }, {
                        id: 'laptop',
                        name: 'Laptop'
                    }, {
                        id: 'vm',
                        name: 'Virtual Machine'
                    }]
            }, {
                id: 'agent_type',
                name: 'Installed Agent',
                children: [{
                        id: 'persistent',
                        name: 'OPSWAT Persistent Client'
                    }, {
                        id: 'dc',
                        name: 'Domain Controller'
                    }, {
                        id: 'ondemand',
                        name: 'OPSWAT On-Demand Client'
                    }]
            }, {
                id: 'agent_status',
                name: 'Agent Status',
                children: [{
                        id: 'connected',
                        name: 'Connected'
                    }, {
                        id: 'unseen',
                        name: 'Unseen'
                    }, {
                        id: 'disconnected',
                        name: 'Disconnected'
                    }, {
                        id: 'out_of_date',
                        name: 'Agent Out of Date'
                    }]
            }, {
                id: 'os',
                name: 'Operating System',
                children: [{
                        id: 'windows',
                        name: 'Windows'
                    }, {
                        id: 'android',
                        name: 'Android'
                    }, {
                        id: 'linux',
                        name: 'Linux'
                    }, {
                        id: 'mac',
                        name: 'macOS'
                    }, {
                        id: 'ios',
                        name: 'iOS'
                    }]
            }, {
                id: 'cve_severity',
                name: 'Vulnerability Severity',
                children: [{
                        id: 'critical',
                        name: 'Critical Vulnerabilities'
                    }, {
                        id: 'important',
                        name: 'Important Vulnerabilities'
                    }, {
                        id: 'moderate',
                        name: 'Moderate Vulnerabilities'
                    }, {
                        id: 'low',
                        name: 'Low Vulnerabilities'
                    }, {
                        id: 'unknown',
                        name: 'Unknown Vulnerabilities'
                    }]
            }];
        this.filters.vulnerabilitiesShort = [{
                id: 'severity',
                name: 'Vulnerability Severity',
                children: [{
                        id: 'critical',
                        name: 'Critical'
                    }, {
                        id: 'important',
                        name: 'Important'
                    }, {
                        id: 'moderate',
                        name: 'Moderate'
                    }, {
                        id: 'low',
                        name: 'Low'
                    }, {
                        id: 'unknown',
                        name: 'Unknown'
                    }]
            }];
        this.filters.activities = [{
                id: 'actions',
                name: 'Action',
                children: [{
                        id: 'block',
                        name: 'Blocked'
                    }, {
                        id: 'allow',
                        name: 'Allowed'
                    }, {
                        id: 'being-block',
                        name: 'Monitored (Block)'
                    }, {
                        id: 'being-allow',
                        name: 'Monitored (Allow)'
                    }, {
                        id: 'bypass',
                        name: 'Temporary Allowed'
                    }]
            }, {
                id: 'type',
                name: 'Method',
                children: [{
                        id: 'idp',
                        name: 'IDP'
                    }, {
                        id: 'sdp',
                        name: 'SDP'
                    }]
            }];
        this.filters.activitiesSession = [{
                id: 'status',
                name: 'Status',
                children: [{
                        id: 'active',
                        name: 'Active'
                    }, {
                        id: 'disconnected',
                        name: 'Disconnected'
                    }]
            },
            {
                id: 'device_status',
                name: 'Device Status',
                children: [{
                        id: 'unknown',
                        name: 'Unknown'
                    }, {
                        id: 'ignored',
                        name: 'Ignored'
                    }, {
                        id: 'exempted',
                        name: 'Exempted'
                    }, {
                        id: 'non_compliant',
                        name: 'Non-Compliant'
                    }, {
                        id: 'quarantined',
                        name: 'Quarantined'
                    }, {
                        id: 'compliant',
                        name: 'Compliant'
                    }, {
                        id: 'out_of_token_usage',
                        name: 'Out of Token Usage'
                    }]
            }];
        this.filters.administratorEvents = [{
                id: 'device_events',
                name: 'Admin Events',
                children: [{
                        id: 'login',
                        name: 'Admin Logged On'
                    }, {
                        id: 'logout',
                        name: 'Admin Logged Off'
                    }, {
                        id: 'failed_auth',
                        name: 'Admin Failed Authentication'
                    }, {
                        id: 'config',
                        name: 'Configuration Change'
                    }, {
                        id: 'rev_mobile_code',
                        name: 'Revoke Registration Code'
                    }, {
                        id: 'submit_ticket',
                        name: 'Submit Support Ticket'
                    }, {
                        id: 'cac_change',
                        name: 'Secure Access Configuration Change'
                    }, {
                        id: 'whitelist',
                        name: 'Whitelisted vulnerabilities'
                    }]
            }];
        this.filters.gatewayEvents = [{
                id: 'gatewayEvents',
                name: 'Gateway Events',
                children: [{
                        id: 'registered',
                        name: 'Registered'
                    }, {
                        id: 'restarted',
                        name: 'Rebooted'
                    }, {
                        id: 'connection-lost',
                        name: 'Connection Lost'
                    }, {
                        id: 'connection-restored',
                        name: 'Connection Restored'
                    }]
            }];
        this.filters.deviceEvents = [{
                id: 'device_events',
                name: 'Device Events',
                children: [{
                        id: 'added',
                        name: 'Added'
                    }, {
                        id: 'added_duplicate_mac',
                        name: 'Added with a duplicate MAC address'
                    }, {
                        id: 'exempt_all',
                        name: 'Exempted'
                    }, {
                        id: 'unexempt',
                        name: 'Unexempted'
                    }, {
                        id: 'deleted',
                        name: 'Removed by an administrator'
                    }, {
                        id: 'deleted_user',
                        name: 'Uninstalled by a user'
                    }, {
                        id: 'compliant',
                        name: 'Changed status to compliant'
                    }, {
                        id: 'noncompliant',
                        name: 'Changed status to non-compliant'
                    }, {
                        id: 'access_granted',
                        name: 'Granted access'
                    }, {
                        id: 'access_revoked',
                        name: 'Revoked access'
                    }, {
                        id: 'unseen',
                        name: 'Deleted by unseen setting'
                    }, {
                        id: 'fetch_log',
                        name: 'Fetch log'
                    }, {
                        id: 'scan_threat',
                        name: 'Scan threats'
                    }, {
                        id: 'compliance_check',
                        name: 'Compliance check'
                    }, {
                        id: 'agent_update',
                        name: 'Changed Agent Version'
                    }, {
                        id: 'sdk_update',
                        name: 'Changed SDK Version'
                    }, {
                        id: 'sdp_update',
                        name: 'Changed SDP Version'
                    }]
            }, {
                id: 'agent_types',
                name: 'Agent Type',
                children: [{
                        id: '0',
                        name: 'MetaAccess'
                    }, {
                        id: '2',
                        name: 'Domain Controller'
                    }]
            }];
        this.filters.webhookEvents = [{
                id: 'device_events',
                name: 'Webhook Events',
                children: [{
                        id: 'added',
                        name: 'Added'
                    }, {
                        id: 'deleted',
                        name: 'Deleted'
                    }, {
                        id: 'status_changed_to_compliant',
                        name: 'Changed status to compliant'
                    }, {
                        id: 'status_changed_to_non_compliant',
                        name: 'Changed status to non-compliant'
                    }, {
                        id: 'status_changed_to_exempted',
                        name: 'Changed status to exempted'
                    }]
            }];
        this.filters.deviceEventsShort = [{
                id: 'device_events',
                name: 'Device Events',
                children: [{
                        id: 'added',
                        name: 'Added'
                    }, {
                        id: 'added_duplicate_mac',
                        name: 'Added with a duplicate MAC address'
                    }, {
                        id: 'exempt_all',
                        name: 'Exempted'
                    }, {
                        id: 'unexempt',
                        name: 'Unexempted'
                    }, {
                        id: 'deleted',
                        name: 'Removed by an administrator'
                    }, {
                        id: 'deleted_user',
                        name: 'Uninstalled by a user'
                    }, {
                        id: 'compliant',
                        name: 'Changed status to compliant'
                    }, {
                        id: 'noncompliant',
                        name: 'Changed status to non-compliant'
                    }, {
                        id: 'access_granted',
                        name: 'Granted access'
                    }, {
                        id: 'access_revoked',
                        name: 'Revoked access'
                    }, {
                        id: 'unseen',
                        name: 'Deleted by unseen setting'
                    }, {
                        id: 'fetch_log',
                        name: 'Fetch log'
                    }, {
                        id: 'scan_threat',
                        name: 'Scan threats'
                    }, {
                        id: 'compliance_check',
                        name: 'Compliance check'
                    }, {
                        id: 'agent_update',
                        name: 'Changed Agent Version'
                    }, {
                        id: 'sdk_update',
                        name: 'Changed SDK Version'
                    }, {
                        id: 'sdp_update',
                        name: 'Changed SDP Version'
                    }]
            }];
        this.filters.actionLogsStatuses = [{
                id: 'statuses',
                name: 'Action Status',
                children: [{
                        id: 'Queued',
                        name: 'In Queue'
                    }, {
                        id: 'Failed',
                        name: 'Failed'
                    }, {
                        id: 'Pending',
                        name: 'Pending'
                    }, {
                        id: 'Processing',
                        name: 'In Progress'
                    }, {
                        id: 'Complete',
                        name: 'Completed'
                    }, {
                        id: 'Partial',
                        name: 'Partial Completed'
                    }]
            }];
        this.filters.actionLogsActions = [{
                id: 'actions',
                name: 'Action',
                children: [{
                        id: 'fetch_log',
                        name: 'Remote Fetch Log'
                    }, {
                        id: 'copy_to_drive',
                        name: 'Copied files to a removable media'
                    }, {
                        id: 'scan_threat',
                        name: 'Scan threats'
                    }, {
                        id: 'unblock',
                        name: 'Unblocked a removable media'
                    }, {
                        id: 'blocked',
                        name: 'Blocked a removable media'
                    }, {
                        id: 'fetch_full_log',
                        name: 'Retrieved full threat scan report'
                    }, {
                        id: 'copy_from_drive',
                        name: 'Copied files from a removable media'
                    }, {
                        id: 'compliance_check',
                        name: 'Compliance Check'
                    }, {
                        id: 'on_demand_scan_by_user',
                        name: 'Malware scan triggered by a user'
                    }]
            }];
        this.filters.timeframeWeekly = [{
                id: 'age',
                name: 'Timeframe',
                children: [{
                        id: 0,
                        name: 'Today'
                    }, {
                        id: 1,
                        name: 'Yesterday'
                    }, {
                        id: 7,
                        name: 'Last 7 days'
                    }, {
                        id: 30,
                        name: 'Last 30 days'
                    }, {
                        id: 1000,
                        name: 'Custom'
                    }]
            }];
        this.filters.timeframeHourly = [{
                id: 'age',
                name: 'Timeframe',
                children: [{
                        id: 1,
                        name: 'Last 1 hour'
                    }, {
                        id: 12,
                        name: 'Last 12 hours'
                    }, {
                        id: 24,
                        name: 'Last 24 hours'
                    }, {
                        id: -1,
                        name: 'Custom'
                    }]
            }];
        this.filters.user = [{
                id: 'role',
                name: 'User Role',
                children: [{
                        id: 'Administrator',
                        name: 'Administrator'
                    }, {
                        id: 'Read-Only',
                        name: 'Read Only'
                    },
                    {
                        id: 'End-User',
                        name: 'End User'
                    }]
            }, {
                id: 'user_type',
                name: 'User Type',
                children: [{
                        id: '0',
                        name: 'OPSWAT Portal'
                    }, {
                        id: '1',
                        name: '3rd Party IDP'
                    },
                    {
                        id: '4',
                        name: 'Local'
                    }]
            }, {
                id: 'status',
                name: 'Status',
                children: [{
                        id: 'Active',
                        name: 'Active'
                    }, {
                        id: 'Invited',
                        name: 'Invited'
                    }, {
                        id: 'Declined',
                        name: 'Declined'
                    }]
            }];
        this.filters.userProfile = [{
                id: 'roles',
                name: 'User Role',
                children: [{
                        id: 'Administrator',
                        name: 'Administrator'
                    }, {
                        id: 'Read-Only',
                        name: 'Read Only'
                    }]
            }, {
                id: 'statuses',
                name: 'Status',
                children: [{
                        id: 'Active',
                        name: 'Active'
                    }, {
                        id: 'Invited',
                        name: 'Invited'
                    }]
            }];
    }
    static { this.ɵfac = function FilterService_Factory(t) { return new (t || FilterService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FilterService, factory: FilterService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class RightDrawerService {
    constructor() {
        this.isDrawerOpened = false;
        this.width = 340;
        this.customWidth = null;
    }
    open(template, customWidth) {
        this.customWidth = customWidth;
        this.template = template;
        this.isDrawerOpened = true;
    }
    close() {
        this.isDrawerOpened = false;
    }
    isOpened() {
        return this.isDrawerOpened;
    }
    getTemplate() {
        return this.template;
    }
    static { this.ɵfac = function RightDrawerService_Factory(t) { return new (t || RightDrawerService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RightDrawerService, factory: RightDrawerService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RightDrawerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class LayoutService {
    constructor() {
        this.scrollToTop = new EventEmitter();
        this.isMenuExpanded = true;
        this.sideNavAutosize = false;
        this.navAutoSizingEvent = new EventEmitter();
        this.headerButtonsEnabled = true;
    }
    getMainNavigationComponent() {
        return this.mainNavigationComponent;
    }
    getHeaderComponent() {
        return this.headerComponent;
    }
    getFooterComponent() {
        return this.footerComponent;
    }
    toggleLeftMenu() {
        this.isMenuExpanded = !this.isMenuExpanded;
        this.forceAutoSizing();
    }
    // turn on auto size when toggle to force caculate containter
    forceAutoSizing() {
        this.sideNavAutosize = true;
        // this.navAutoSizingEvent.emit(this.sideNavAutosize);
        setTimeout(() => {
            this.sideNavAutosize = false;
            // this.navAutoSizingEvent.emit(this.sideNavAutosize);
        }, 500);
    }
    static { this.ɵfac = function LayoutService_Factory(t) { return new (t || LayoutService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LayoutService, factory: LayoutService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LayoutService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, { navAutoSizingEvent: [{
            type: Output
        }] }); })();

class LoadingBarService {
    constructor() {
        this.emitter = new EventEmitter();
        this.enabled = false;
    }
    showLoadingBar(isShow) {
        this.enabled = isShow;
    }
    static { this.ɵfac = function LoadingBarService_Factory(t) { return new (t || LoadingBarService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoadingBarService, factory: LoadingBarService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoadingBarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, null); })();

class SearchProductService {
    constructor() {
        this.currentSearch = '';
        this.searchTerm = '';
        this.activeIndex = 1;
        this.total = 0;
        this.filteredProducts = [];
        this.isSearching = false;
        this.highlightedSpans = [];
        this.activeClass = '';
        this.isShowNotFoundMessage = false;
    }
    init(dataSource, textContainer, activeClass = 'bg-primary-200') {
        this.dataSource = dataSource;
        this.textContainer = textContainer;
        this.activeClass = activeClass;
    }
    searchProducts(dataSource) {
        const filteredProducts = [];
        dataSource.forEach((productType) => {
            if (productType.name
                ?.toLowerCase()
                .indexOf(this.searchTerm.toLowerCase()) >= 0) {
                filteredProducts.push({
                    id: productType.category,
                    category: productType.category,
                    name: productType.name,
                });
            }
            if (productType.subProducts?.length) {
                productType.subProducts.forEach((product) => {
                    if (product.name
                        ?.toLowerCase()
                        .indexOf(this.searchTerm.toLowerCase()) >= 0) {
                        filteredProducts.push({
                            id: product.productId ? product.productId : product.id,
                            category: product.category,
                            name: product.name,
                        });
                    }
                    if (product.subProducts?.length) {
                        product.subProducts.forEach((subProduct) => {
                            if (subProduct.name
                                ?.toLowerCase()
                                .indexOf(this.searchTerm.toLowerCase()) >= 0) {
                                filteredProducts.push({
                                    id: subProduct.productId,
                                    parentId: product.productId ? product.productId : product.id,
                                    category: product.category,
                                    name: subProduct.name,
                                });
                            }
                        });
                    }
                });
            }
        });
        this.filteredProducts = filteredProducts;
        this.isSearching = true;
        this.activeIndex = 1;
    }
    openProducts() {
        this.filteredProducts.forEach((filteredProduct) => {
            const elementByCategory = document.getElementById(filteredProduct.category);
            this.openProductByElementID(elementByCategory);
            if (filteredProduct.parentId) {
                const elementByProductId = document.getElementById(filteredProduct.parentId);
                this.openProductByElementID(elementByProductId);
            }
        });
    }
    openProductByElementID(element) {
        if (!element?.className.includes('expanded-row')) {
            element?.classList.add('expanded-row');
            element?.click();
        }
    }
    scrollIntoProductView() {
        setTimeout(() => {
            this.highlightedSpans[this.activeIndex - 1]?.scrollIntoView({
                block: 'center',
                behavior: 'smooth',
            });
        }, 0);
    }
    findHighlightedSpans() {
        setTimeout(() => {
            this.highlightedSpans =
                this.textContainer.nativeElement.querySelectorAll('.highlighted-text');
            this.total = this.highlightedSpans.length;
            this.isShowNotFoundMessage = !this.highlightedSpans.length;
        }, 0);
    }
    addActiveClass(index) {
        setTimeout(() => {
            this.highlightedSpans[index - 1]?.classList.add(this.activeClass);
        }, 0);
    }
    removeActiveClass(index) {
        setTimeout(() => {
            this.highlightedSpans[index - 1]?.classList.remove(this.activeClass);
        }, 0);
    }
    clear() {
        this.activeIndex = 1;
        this.total = 0;
        this.currentSearch = '';
        this.isSearching = false;
        this.isShowNotFoundMessage = false;
    }
    search() {
        this.isShowNotFoundMessage = false;
        if (!this.isSearching) {
            this.currentSearch = this.searchTerm;
            this.searchProducts(this.dataSource);
            this.findHighlightedSpans();
            this.openProducts();
            this.scrollIntoProductView();
            this.addActiveClass(this.activeIndex);
        }
        else {
            if (this.total) {
                this.moveToNext();
            }
            else {
                this.isShowNotFoundMessage = !this.highlightedSpans.length;
            }
        }
    }
    moveToNext() {
        if (this.activeIndex < this.total) {
            this.activeIndex++;
        }
        else {
            this.activeIndex = 1;
        }
        if (this.activeIndex === 1) {
            this.removeActiveClass(this.total);
        }
        else {
            this.removeActiveClass(this.activeIndex - 1);
        }
        this.openProducts();
        this.scrollIntoProductView();
        this.addActiveClass(this.activeIndex);
    }
    moveToBack() {
        if (this.activeIndex > 1) {
            this.activeIndex--;
        }
        else {
            this.activeIndex = this.total;
        }
        if (this.activeIndex === this.total) {
            this.removeActiveClass(1);
        }
        else {
            this.removeActiveClass(this.activeIndex + 1);
        }
        this.openProducts();
        this.scrollIntoProductView();
        this.addActiveClass(this.activeIndex);
    }
    static { this.ɵfac = function SearchProductService_Factory(t) { return new (t || SearchProductService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SearchProductService, factory: SearchProductService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchProductService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, null); })();

class UiService {
    constructor() {
        this.pinResponse = null;
    }
    trim(string, length, appendix = '...') {
        if (typeof string !== 'string') {
            return '';
        }
        return `${string.substr(0, length)}${string.length > length ? appendix : ''}`;
    }
    trimTitle(str, length) {
        if (typeof str !== 'string') {
            return str;
        }
        if (typeof length !== 'number') {
            return str;
        }
        if (length < 1) {
            return str;
        }
        if (str.length <= length) {
            return str;
        }
        return `${str.substring(0, length)}...`;
    }
    willTrim(str, item) {
        if (typeof str !== 'string') {
            return false;
        }
        if (typeof item !== 'object') {
            return false;
        }
        if (!item.maxLength) {
            return false;
        }
        if (str.length > item.maxLength) {
            return true;
        }
    }
    static { this.ɵfac = function UiService_Factory(t) { return new (t || UiService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UiService, factory: UiService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, null); })();

function LoadingBarComponent_mat_progress_bar_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-progress-bar", 1);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("mode", ctx_r0.isLoadingDelay ? "indeterminate" : "determinate");
} }
class LoadingBarComponent {
    constructor(loadingBarService) {
        this.loadingBarService = loadingBarService;
        this.isLoading = false;
        this.isLoadingDelay = false;
        this.loading = {};
        this.minLoadingTime = 1000;
    }
    ngAfterViewInit() {
        this.loadingBarService.emitter.pipe(tap(val => {
            this.loading[val.signature] = val.status;
            const prevLoading = this.isLoading;
            this.isLoading = this.isAnyLoading();
            // from false to true (started loading)
            if (!prevLoading && this.isLoading) {
                this.startTime = new Date();
                setTimeout(() => {
                    this.isLoadingDelay = true;
                });
            }
            // from true to false (stopped loading)
            if (prevLoading && !this.isLoading) {
                const now = new Date();
                const diff = now.getMilliseconds() - this.startTime.getMilliseconds();
                const delay = this.minLoadingTime - diff;
                setTimeout(() => {
                    this.isLoadingDelay = false;
                }, delay);
            }
        }))
            .subscribe();
    }
    isAnyLoading() {
        for (const item in this.loading) {
            if (this.loading[item]) {
                return true;
            }
        }
        return false;
    }
    static { this.ɵfac = function LoadingBarComponent_Factory(t) { return new (t || LoadingBarComponent)(i0.ɵɵdirectiveInject(LoadingBarService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoadingBarComponent, selectors: [["app-loading-bar"]], decls: 1, vars: 1, consts: [[3, "mode", 4, "ngIf"], [3, "mode"]], template: function LoadingBarComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, LoadingBarComponent_mat_progress_bar_0_Template, 1, 1, "mat-progress-bar", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.loadingBarService.enabled);
        } }, dependencies: [i1.NgIf, i3.MatLegacyProgressBar], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoadingBarComponent, [{
        type: Component,
        args: [{ selector: 'app-loading-bar', template: "<mat-progress-bar *ngIf=\"loadingBarService.enabled\" [mode]=\"isLoadingDelay ? 'indeterminate' : 'determinate'\"></mat-progress-bar>\r\n" }]
    }], function () { return [{ type: LoadingBarService }]; }, null); })();

const _c0$l = ["chart"];
function DonutChartComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "button", 3);
    i0.ɵɵlistener("click", function DonutChartComponent_div_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onPrev()); });
    i0.ɵɵtext(2, "Previous");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 4);
    i0.ɵɵlistener("click", function DonutChartComponent_div_2_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onNext()); });
    i0.ɵɵtext(4, "Next");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r1.isPrevDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.isNextDisabled);
} }
class DonutChartComponent {
    constructor(router, uiService) {
        this.router = router;
        this.uiService = uiService;
        this.data = [];
        this.radius = 120;
        this.thickness = 20;
        this.isHoverable = true;
        this.sort = false;
        this.percentage = false;
        this.noDataColor = 'neutral';
        this.noDataMessage = '';
        this.defaultHighlightedIndex = -1;
        this.hasLegend = false;
        this.legendRowsPerColumn = this.data.length;
        this.classMap = {};
        this.isPrevDisabled = true;
        this.isNextDisabled = false;
        this.hasButtons = false;
        this.total = 0;
        this.X_AXIS_TRIM = 25;
        this.X_AXIS_TOP = 32;
    }
    ngOnInit() {
        if (this.sort) {
            this.sortFce = (a, b) => b.value - a.value;
            this.data = this.data.sort(this.sortFce);
        }
        this.legendData = this.arrayToColumn(this.data, this.legendRowsPerColumn);
        if (this.hasLegend) {
            if (this.legendData.length > 1) {
                this.hasButtons = true;
            }
        }
    }
    ngAfterViewInit() {
        this.buildChart();
    }
    onNext() {
        this.translateXCols(2 * this.radius);
    }
    onPrev() {
        this.translateXCols(-2 * this.radius);
    }
    translateXCols(translateXAmount) {
        if (this.legendData.length > 1) {
            const allLegendColumns = this.svg.selectAll('.legend-column');
            const nodes = allLegendColumns.nodes();
            nodes.forEach((d, i) => {
                const currentSelection = d3.select(d);
                const transformAttr = currentSelection.attr('transform');
                // IE11 specific code:
                // if (typeof window.navigator.msSaveBlob === 'function') {
                //   transformAttr = transformAttr.split(' ').join(', ');
                // }
                // Parse translate(x,y) for an array containing [x, y];
                const transformCoordinates = transformAttr
                    .substring(10, transformAttr.length - 1)
                    .split(',');
                // Move x coordinate
                transformCoordinates[0] = String(+transformCoordinates[0] - translateXAmount);
                currentSelection.attr('transform', `translate(${transformCoordinates[0]},${transformCoordinates[1]})`);
                if (i === 0) {
                    // eslint-disable-next-line
                    +transformCoordinates[0] === 0
                        ? (this.isPrevDisabled = true)
                        : (this.isPrevDisabled = false);
                }
                if (i === nodes.length - 1) {
                    // eslint-disable-next-line
                    +transformCoordinates[0] === 0
                        ? (this.isNextDisabled = true)
                        : (this.isNextDisabled = false);
                }
            });
        }
    }
    getValue(item) {
        if (this.percentage &&
            typeof item === 'number' &&
            typeof this.total === 'number') {
            const percentage = Math.round((item / this.total) * 100);
            const percentage10 = Math.ceil((item / this.total) * 1000) / 10;
            return `${percentage === 0 ? percentage10 : percentage}%`;
        }
        return item;
    }
    onSliceClick(data) {
        if (typeof data === 'object' && typeof data.href === 'string') {
            const queryParams = {};
            if (typeof data['queryParams'] === 'object') {
                queryParams['queryParams'] = data['queryParams'];
            }
            this.router.navigate([data['href']], queryParams);
        }
    }
    buildChart() {
        const side = this.radius * 2;
        const innerRadius = this.radius - this.thickness;
        this.total = 0;
        this.data.forEach((item) => {
            if (typeof item.value === 'number') {
                this.total += item.value;
            }
        });
        const noItems = !(Array.isArray(this.data) && this.data.length);
        const allItemsZero = !this.data.reduce((val, item) => (val ? val : item.value > 0), false);
        const legendProperties = {
            dotRadius: 5,
            fontSize: 14,
            rowHeight: 20,
            textLeftSpacing: 10,
            groupOffset: 20,
        };
        const heightLegend = noItems
            ? 0
            : (this.data.length * legendProperties.rowHeight) /
                this.legendData.length +
                (this.legendData.length > 1 ? 20 : 0);
        const heightChartLegend = side + legendProperties.groupOffset + heightLegend;
        const height = this.hasLegend && !noItems && !allItemsZero
            ? heightChartLegend + 10
            : side;
        const element = this.chartElement.nativeElement;
        const tooltip = d3
            .select(element)
            .append('div')
            .attr('class', 'bar-toolTip mat-tooltip');
        this.svg = d3
            .select(element)
            .append('svg')
            .attr('class', `chart donut-chart no-data-color-${this.noDataColor}`)
            .attr('width', side)
            .attr('height', height)
            .attr('viewBox', `0 0 ${side} ${side}`)
            .attr('preserveAspectRatio', 'xMinYMin meet');
        if (noItems || allItemsZero) {
            const halfSide = side / 2;
            this.svg
                .append('circle')
                .attr('stroke-width', this.thickness)
                .attr('class', 'no-data circle')
                .attr('fill', 'none')
                .attr('cx', halfSide)
                .attr('cy', halfSide)
                .attr('r', halfSide - this.thickness / 2);
            this.svg
                .append('text')
                .text(noItems
                ? this.noDataMessage.length
                    ? this.noDataMessage
                    : 'No data'
                : 'Nothing to Show')
                .attr('class', 'no-data text')
                .attr('fill', 'white')
                .attr('text-anchor', 'middle')
                .attr('dy', halfSide + 6)
                .attr('dx', halfSide);
            if (!allItemsZero) {
                return;
            }
        }
        let defaultTitleText = null;
        let defaultSubtitleText = null;
        const group = this.svg
            .append('g')
            .attr('transform', `translate(${this.radius}, ${this.radius})`);
        const title = group
            .append('text')
            .attr('class', 'title')
            .attr('dy', -4)
            .attr('text-anchor', 'middle');
        const subtitle = group
            .append('text')
            .attr('class', 'subtitle')
            .attr('dy', 22)
            .attr('text-anchor', 'middle');
        const onSliceOver = (i) => {
            const data = this.data.sort(this.sortFce)[i];
            title.text(this.getValue(data['value']));
            subtitle.text(this.uiService.trim(data['label'], this.X_AXIS_TRIM));
            // Fade all arces ...
            this.svg.selectAll('.arc').classed('fade-out', true);
            // ... except the one being hovered over
            this.svg.selectAll(`.arc.index-${i}`).classed('fade-out', false);
        };
        const onSliceOut = (i) => {
            title.text(defaultTitleText);
            subtitle.text(this.uiService.trim(defaultSubtitleText, this.X_AXIS_TRIM));
            // Show all arces
            this.svg.selectAll('.arc').classed('fade-out', false);
            if (this.defaultHighlightedIndex !== -1) {
                this.svg
                    .selectAll('.arc:not(.index-' + this.defaultHighlightedIndex)
                    .classed('fade-out', true);
            }
        };
        if (this.hasLegend && !noItems && !allItemsZero) {
            const legendContainer = this.svg
                .append('g')
                .attr('class', 'legend-container');
            let sum = 0;
            for (let j = 0; j < this.legendData.length; j++) {
                const legendItem = this.legendData[j];
                const legendColumn = legendContainer
                    .append('g')
                    .attr('class', 'legend-column')
                    .attr('transform', (d, i) => `translate(${j * side}, ${side + legendProperties.groupOffset})`);
                const legend = legendColumn
                    .selectAll('.legend')
                    .data(legendItem)
                    .enter()
                    .append('g')
                    .attr('class', 'legend')
                    // eslint-disable-next-line max-len
                    .attr('class', (d, i) => this.assignColorClass(`legend-dot ${d.queryParams?.category
                    ? d.queryParams.category.toLowerCase()
                    : ''}`, d, i, sum))
                    .classed('legend-is-clickable', (d) => d.hasOwnProperty('href'))
                    .attr('transform', (d, i) => `translate(0, ${i * legendProperties.rowHeight})`)
                    .on('click', this.onSliceClick.bind(this))
                    .on('mouseover', (d, i) => {
                    if (d.label.length > this.X_AXIS_TRIM) {
                        tooltip
                            .style('display', 'block')
                            .style('width', '170px')
                            .style('opacity', 1)
                            .style('z-index', 1)
                            .text(d.label);
                    }
                    else {
                        tooltip.text('').style('opacity', 0);
                    }
                    onSliceOver(j * this.legendRowsPerColumn + i);
                })
                    .on('mouseout', (d, i) => {
                    tooltip.style('opacity', 0);
                    onSliceOut(j * this.legendRowsPerColumn + i);
                })
                    .on('mousemove', (d) => {
                    const viewTopDistance = element.getBoundingClientRect().y;
                    const viewLeftDistance = element.getBoundingClientRect().x;
                    tooltip
                        .style('left', d3.event.pageX - viewLeftDistance + 'px')
                        .style('top', d3.event.pageY - viewTopDistance - this.X_AXIS_TOP + 'px');
                });
                legend
                    .append('text')
                    .attr('class', 'legend-text')
                    .attr('x', legendProperties.dotRadius * 2 + legendProperties.textLeftSpacing)
                    .attr('y', legendProperties.fontSize)
                    .text((d) => `${d.value}${this.percentage ? '/' + this.total : ''} ${this.uiService.trim(d.label, this.X_AXIS_TRIM)}`)
                    .style('font-size', legendProperties.fontSize);
                legend
                    .append('circle')
                    .attr('r', legendProperties.dotRadius)
                    .attr('cx', legendProperties.dotRadius)
                    .attr('cy', legendProperties.fontSize - legendProperties.dotRadius);
                legendColumn.append('legend');
                sum += legendItem.length;
            }
            if (this.legendData.length <= 1) {
                this.isNextDisabled = true;
            }
        }
        if (allItemsZero) {
            return;
        }
        const arc = d3.arc().innerRadius(innerRadius).outerRadius(this.radius);
        const pie = d3
            .pie()
            .value((d) => d['value'])
            .sort(null);
        const path = group
            .selectAll('path')
            .data(pie(this.data))
            .enter()
            .append('g')
            .attr('fill', (d) => d.data['color'])
            .attr('class', (d, i) => this.assignColorClass('arc', d.data, i, 0))
            // If 'href' property exists, then we navigate to the link
            .on('click', (d) => this.onSliceClick(d.data));
        if (this.defaultHighlightedIndex === -2) {
            const firstNonZeroItem = this.data.findIndex((item) => item.value !== 0);
            this.defaultHighlightedIndex = firstNonZeroItem;
        }
        // If a default highlighted index is given, then check if it is of type 'number' and the corresponding item exists
        if (typeof this.defaultHighlightedIndex === 'number') {
            this.svg.classed('has-default-highlighted-state', true);
            // Set default title and subtitle value
            defaultTitleText = this.getValue(this.data[this.defaultHighlightedIndex].value);
            defaultSubtitleText = this.data[this.defaultHighlightedIndex].label;
            // Fade all arces except the highlighted one
            this.svg
                .selectAll('.arc:not(.index-' + this.defaultHighlightedIndex)
                .classed('fade-out', true);
        }
        title.text(defaultTitleText);
        subtitle.text(this.uiService.trim(defaultSubtitleText, 20, ''));
        // If the chart is hoverable
        if (this.isHoverable) {
            path
                .on('mouseover', (d) => onSliceOver(d.index))
                .on('mouseout', (d) => onSliceOut(d.index));
        }
        path.append('path').attr('d', arc);
    }
    assignColorClass(customClass, d, i, sum) {
        let fillClass = ((sum + i) % 10) + 1;
        if (this.classMap.hasOwnProperty(d.label)) {
            fillClass = this.classMap[d.label];
        }
        else {
            this.classMap[d.label] = fillClass;
        }
        let classes = `${customClass} fill fill-${fillClass} index-${i}`;
        // If href is defined, we add 'is-clickable' to classes
        if (d['href']) {
            classes = `${classes} fill-is-clickable`;
        }
        // If color is defined, we're not interested in type and return
        if (d['color']) {
            return `${classes} fill-has-color`;
        }
        // If color is not defined, and type is defined, we return type
        if (d['type']) {
            return `${classes} fill-has-type fill-type-${d['type']}`;
        }
        // If no data, draw an empty circle
        if (d['value'] === 0) {
            return `${classes} fill-no-data`;
        }
        // If neither color and type are defined
        return classes;
    }
    // convert array data to column before binding on chart
    arrayToColumn(arr, row) {
        if (!arr) {
            return false;
        }
        if (!row) {
            row = arr.length;
        }
        const cols = Math.ceil(arr.length / row);
        const list = [];
        for (let i = 0; i < cols; i++) {
            const col = [];
            const startIndex = i * row;
            const endIndex = startIndex + row;
            // add item to every column
            for (let j = startIndex; j < endIndex; j++) {
                if (arr[j] != null) {
                    col.push(arr[j]);
                }
            }
            list.push(col);
        }
        return list;
    }
    static { this.ɵfac = function DonutChartComponent_Factory(t) { return new (t || DonutChartComponent)(i0.ɵɵdirectiveInject(i3$1.Router), i0.ɵɵdirectiveInject(UiService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DonutChartComponent, selectors: [["app-donut-chart"]], viewQuery: function DonutChartComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$l, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartElement = _t.first);
        } }, inputs: { data: "data", radius: "radius", thickness: "thickness", isHoverable: "isHoverable", sort: "sort", percentage: "percentage", noDataColor: "noDataColor", noDataMessage: "noDataMessage", defaultHighlightedIndex: "defaultHighlightedIndex", hasLegend: "hasLegend", legendRowsPerColumn: "legendRowsPerColumn" }, decls: 3, vars: 1, consts: [["chart", ""], ["class", "donut-chart-btn-container flex flex-space-between", 4, "ngIf"], [1, "donut-chart-btn-container", "flex", "flex-space-between"], ["mat-button", "", "color", "neutral", 1, "outline", "is-small", "mat-button", "mat-neutral", "donut-chart-btn", "btn-previous", "m-r-xs", 3, "disabled", "click"], ["mat-button", "", "color", "neutral", 1, "outline", "is-small", "mat-button", "mat-neutral", "donut-chart-btn", "btn-next", "m-l-xs", 3, "disabled", "click"]], template: function DonutChartComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "div", null, 0);
            i0.ɵɵtemplate(2, DonutChartComponent_div_2_Template, 5, 2, "div", 1);
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.hasButtons);
        } }, dependencies: [i1.NgIf, i4.MatLegacyButton], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DonutChartComponent, [{
        type: Component,
        args: [{ selector: 'app-donut-chart', template: "<div #chart></div>\r\n<div class=\"donut-chart-btn-container flex flex-space-between\" *ngIf=\"hasButtons\">\r\n  <button\r\n    mat-button\r\n    class=\"outline is-small mat-button mat-neutral donut-chart-btn btn-previous m-r-xs\"\r\n    color=\"neutral\"\r\n    (click)=\"onPrev()\"\r\n    [disabled]=\"isPrevDisabled\"\r\n  >Previous</button>\r\n  <button\r\n    mat-button\r\n    class=\"outline is-small mat-button mat-neutral donut-chart-btn btn-next m-l-xs\"\r\n    color=\"neutral\"\r\n    (click)=\"onNext()\"\r\n    [disabled]=\"isNextDisabled\"\r\n  >Next</button>\r\n</div>\r\n" }]
    }], function () { return [{ type: i3$1.Router }, { type: UiService }]; }, { data: [{
            type: Input
        }], radius: [{
            type: Input
        }], thickness: [{
            type: Input
        }], isHoverable: [{
            type: Input
        }], sort: [{
            type: Input
        }], percentage: [{
            type: Input
        }], noDataColor: [{
            type: Input
        }], noDataMessage: [{
            type: Input
        }], defaultHighlightedIndex: [{
            type: Input
        }], hasLegend: [{
            type: Input
        }], legendRowsPerColumn: [{
            type: Input
        }], chartElement: [{
            type: ViewChild,
            args: ['chart']
        }] }); })();

const _c0$k = ["chart"];
const moment$3 = moment_;
class LineChartComponent {
    constructor() {
        this.visibleSeriesSubscription = null;
        this.data = [];
        this.color = '';
        this.isHoverable = false;
        this.hasCircles = true;
        this.xAxisTicks = null;
        this.yAxisTicks = null;
        this.width = 1200;
        this.height = 500;
        this.timeFormatOutput = '%Y-%m-%d';
        this.formattedTooltip = false;
    }
    ngAfterViewInit() {
        this.buildChart();
        this.visibleSeriesSubscription = this.visibleSeries.changed.subscribe(() => this.buildChart());
    }
    ngOnDestroy() {
        if (this.visibleSeriesSubscription instanceof Subscription) {
            this.visibleSeriesSubscription.unsubscribe();
        }
    }
    ngOnChanges(changes) {
        if (changes &&
            changes.data &&
            !changes.data.isFirstChange()) {
            const previousValue = JSON.stringify(changes.data.previousValue);
            const currentValue = JSON.stringify(changes.data.currentValue);
            if (previousValue !== currentValue) {
                this.buildChart();
            }
        }
    }
    isDataNull() {
        let totalVal;
        this.data.forEach((d) => {
            totalVal = +d.value;
        });
        return totalVal === 0;
    }
    buildChart() {
        if (this.svg) {
            this.svg.remove();
        }
        const margin = {
            top: 65,
            right: 40,
            bottom: 35,
            left: 50
        };
        // Circle specifications
        const circleProperties = {
            radius: 6,
            duration: 500,
            opacity: 1,
        };
        const chartWidth = this.width - margin.left - margin.right;
        const chartHeight = this.height - margin.top - margin.bottom;
        // Formatting Data
        const bisectDate = d3.bisector((d) => d['date']).left;
        this.data.forEach((d) => {
            d.date = this.timeFormatOutput.includes('%H') ? moment$3.utc(d.date).startOf('hour').toDate() : moment$3(d.date).startOf('day').toDate();
        });
        const validDates = this.data.every(item => item.date);
        if (!validDates) {
            return;
        }
        // Adding Scales
        const xScale = d3.scaleTime()
            .domain(d3.extent(this.data, d => d.date))
            .range([0, chartWidth]);
        let yScale = d3.scaleLinear()
            .domain([
            d3.min(this.data, d => {
                const values = this.visibleSeries.selected.map((a) => d.value[a].count);
                return Math.min(...values);
            }),
            d3.max(this.data, d => {
                const values = this.visibleSeries.selected.map((a) => d.value[a].count);
                // show atleast 4 y-axis ticks if the max value is 0
                return Math.max(...values) === 0 ? 4 : Math.max(...values);
            })
        ])
            .range([chartHeight, 0]);
        if (this.isDataNull()) {
            yScale = d3.scaleLinear()
                .domain([0, this.yAxisTicks || 10])
                .range([chartHeight, 0]);
        }
        // Adding SVG
        this.svg = d3.select(this.chartElement.nativeElement)
            .append('svg')
            .attr('class', `chart line-chart ${this.color}`)
            .classed('is-hoverable', this.isHoverable)
            .classed('has-circles', this.hasCircles)
            .attr('width', this.width)
            .attr('height', this.height + margin.top)
            .attr('viewBox', `0 0 ${this.width} ${this.height}`)
            .attr('preserveAspectRatio', 'xMinYMin meet');
        // Adding Group to SVG
        const group = this.svg.append('g')
            .attr('transform', `translate(${margin.left}, ${margin.top})`);
        // Add Axis into SVG
        const xAxis = d3
            .axisBottom(xScale)
            .tickFormat(d3.timeFormat(this.timeFormatOutput))
            .ticks(this.xAxisTicks || this.data.length);
        const yAxisTicks = yScale
            .ticks()
            .filter(tick => Number.isInteger(tick));
        const yAxis = d3
            .axisLeft(yScale)
            .tickSize(-chartWidth)
            .tickPadding(15)
            .tickValues(yAxisTicks)
            .tickFormat(d3.format('d'));
        // Append X-axis
        group
            .append('g')
            .attr('class', 'x-axis')
            .attr('transform', `translate(0, ${chartHeight})`)
            .call(xAxis)
            .call(g => g.select('.domain').remove());
        // Append Y-axis
        group
            .append('g')
            .attr('class', 'y-axis')
            .call(yAxis)
            .call(g => g.select('.domain').remove());
        // Tooltip line
        const tooltipLine = group
            .append('rect')
            .classed('tooltip-line', true)
            .attr('opacity', 0)
            .attr('width', 1)
            .attr('height', chartHeight + margin.top)
            .attr('transform', `translate(0, ${-margin.top})`);
        const series = [];
        this.data
            .forEach(item => {
            Object.keys(item.value)
                .forEach(key => {
                if (!series.find(i => i.key === key)) {
                    series.push({
                        key,
                        name: item.value[key].name
                    });
                }
            });
        });
        const lines = group
            .append('g')
            .attr('class', 'lines');
        // Render all series
        series.forEach((serie, i) => {
            if (this.visibleSeries.isSelected(serie.key)) {
                const line = d3.line()
                    .x((d) => xScale(d['date']))
                    .y((d) => yScale(d['value'][serie.key]['count']));
                lines
                    .append('path')
                    .datum(this.data)
                    .attr('class', `line serie-${i} ${serie.key.toLowerCase()}`)
                    .attr('d', line);
                const circleGroup = lines
                    .append('g')
                    .attr('class', 'circles')
                    .selectAll('circle')
                    .data(this.data)
                    .enter()
                    .append('g')
                    .classed('circle-group', true)
                    .attr('transform', d => `translate(${xScale(d['date'])}, ${yScale(d['value'][serie.key]['count'])})`);
                circleGroup
                    .append('rect')
                    .attr('class', 'tooltip-rect')
                    .attr('width', 20)
                    .attr('height', 20)
                    .attr('x', -10)
                    .attr('y', -30)
                    .style('display', 'none');
                circleGroup
                    .append('text')
                    .text(d => d.value[serie.key].count)
                    .attr('class', 'tooltip-text')
                    .attr('y', -15)
                    .style('display', 'none')
                    .attr('text-anchor', 'middle');
                if (this.hasCircles) {
                    circleGroup
                        .append('circle')
                        .attr('class', `circle serie-${i} ${serie.key.toLowerCase()}`)
                        .attr('r', circleProperties.radius);
                }
            }
        });
        if (this.isHoverable) {
            this.svg
                .on('mousemove', () => {
                const leftMargin = 50;
                const date = xScale.invert(d3.mouse(d3.event.currentTarget)[0] - leftMargin);
                const i = bisectDate(this.data, date, 1);
                const d0 = { value: this.data[i - 1], i: i - 1 };
                const d1 = { value: this.data[i], i };
                if (d0 && d1) {
                    const d = d1 && d1.value && (date - d0.value.date > d1.value.date - date) ? d1 : d0;
                    d3.selectAll('.circle-group rect').style('display', 'none');
                    d3.selectAll('.circle-group text').style('display', 'none');
                    d3.selectAll(`.circle-group:nth-child(${d.i + 1}) rect`).style('display', 'block');
                    d3.selectAll(`.circle-group:nth-child(${d.i + 1}) text`).style('display', 'block');
                    tooltipLine
                        .attr('transform', `translate(${xScale(d.value.date)}, ${-margin.top})`)
                        .attr('opacity', 1);
                }
            })
                .on('mouseout', () => {
                tooltipLine.attr('opacity', 0);
                d3.selectAll('.circle-group rect').style('display', 'none');
                d3.selectAll('.circle-group text').style('display', 'none');
            });
        }
    }
    static { this.ɵfac = function LineChartComponent_Factory(t) { return new (t || LineChartComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LineChartComponent, selectors: [["app-line-chart"]], viewQuery: function LineChartComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$k, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartElement = _t.first);
        } }, inputs: { data: "data", color: "color", isHoverable: "isHoverable", hasCircles: "hasCircles", xAxisTicks: "xAxisTicks", yAxisTicks: "yAxisTicks", width: "width", height: "height", timeFormatOutput: "timeFormatOutput", formattedTooltip: "formattedTooltip", visibleSeries: "visibleSeries" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [["chart", ""]], template: function LineChartComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "div", null, 0);
        } }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LineChartComponent, [{
        type: Component,
        args: [{ selector: 'app-line-chart', template: "<div #chart></div>" }]
    }], function () { return []; }, { data: [{
            type: Input
        }], color: [{
            type: Input
        }], isHoverable: [{
            type: Input
        }], hasCircles: [{
            type: Input
        }], xAxisTicks: [{
            type: Input
        }], yAxisTicks: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], timeFormatOutput: [{
            type: Input
        }], formattedTooltip: [{
            type: Input
        }], visibleSeries: [{
            type: Input
        }], chartElement: [{
            type: ViewChild,
            args: ['chart']
        }] }); })();

function SeverityIndicatorComponent_ng_container_1_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "block");
    i0.ɵɵelementEnd();
} }
function SeverityIndicatorComponent_ng_container_1_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "warning");
    i0.ɵɵelementEnd();
} }
function SeverityIndicatorComponent_ng_container_1_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "change_history");
    i0.ɵɵelementEnd();
} }
function SeverityIndicatorComponent_ng_container_1_mat_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "arrow_downward");
    i0.ɵɵelementEnd();
} }
function SeverityIndicatorComponent_ng_container_1_mat_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "radio_button_unchecked");
    i0.ɵɵelementEnd();
} }
function SeverityIndicatorComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SeverityIndicatorComponent_ng_container_1_mat_icon_1_Template, 2, 0, "mat-icon", 1);
    i0.ɵɵtemplate(2, SeverityIndicatorComponent_ng_container_1_mat_icon_2_Template, 2, 0, "mat-icon", 1);
    i0.ɵɵtemplate(3, SeverityIndicatorComponent_ng_container_1_mat_icon_3_Template, 2, 0, "mat-icon", 1);
    i0.ɵɵtemplate(4, SeverityIndicatorComponent_ng_container_1_mat_icon_4_Template, 2, 0, "mat-icon", 1);
    i0.ɵɵtemplate(5, SeverityIndicatorComponent_ng_container_1_mat_icon_5_Template, 2, 0, "mat-icon", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.severity === "critical");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.severity === "important");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.severity === "moderate");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.severity === "low");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.severity === "unknown");
} }
const _c0$j = function (a0) { return { "hide-icon": a0 }; };
class SeverityIndicatorComponent {
    constructor() {
        this.severity = 'critical';
        this.count = undefined;
        this.showIcon = true;
    }
    ngOnInit() {
    }
    static { this.ɵfac = function SeverityIndicatorComponent_Factory(t) { return new (t || SeverityIndicatorComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SeverityIndicatorComponent, selectors: [["app-severity-indicator"]], inputs: { severity: "severity", count: "count", showIcon: "showIcon" }, decls: 4, vars: 9, consts: [[3, "ngClass"], [4, "ngIf"], [1, "label"]], template: function SeverityIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, SeverityIndicatorComponent_ng_container_1_Template, 6, 5, "ng-container", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("flex severity severity-", ctx.severity, "");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$j, !ctx.showIcon));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showIcon);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate2("", ctx.count, " ", ctx.severity, "");
        } }, dependencies: [i1.NgClass, i1.NgIf, i2.MatIcon], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SeverityIndicatorComponent, [{
        type: Component,
        args: [{ selector: 'app-severity-indicator', template: "<div class=\"flex severity severity-{{ severity }}\" [ngClass]=\"{'hide-icon': !showIcon}\">\r\n  <ng-container *ngIf=\"showIcon\">\r\n    <mat-icon *ngIf=\"severity === 'critical'\">block</mat-icon>\r\n    <mat-icon *ngIf=\"severity === 'important'\">warning</mat-icon>\r\n    <mat-icon *ngIf=\"severity === 'moderate'\">change_history</mat-icon>\r\n    <mat-icon *ngIf=\"severity === 'low'\">arrow_downward</mat-icon>\r\n    <mat-icon *ngIf=\"severity === 'unknown'\">radio_button_unchecked</mat-icon>\r\n  </ng-container>\r\n  <div class=\"label\">{{ count }} {{ severity }}</div>\r\n</div>" }]
    }], function () { return []; }, { severity: [{
            type: Input
        }], count: [{
            type: Input
        }], showIcon: [{
            type: Input
        }] }); })();

function ActionIndicatorComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵelement(1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("ngClass", ctx_r0.action);
    i0.ɵɵproperty("matTooltip", ctx_r0.labelMap[ctx_r0.action] || ctx_r0.action);
} }
function ActionIndicatorComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.labelMap[ctx_r1.action]);
} }
const _c0$i = function (a0) { return { "has-label": a0 }; };
class ActionIndicatorComponent {
    constructor() {
        this.action = 'block';
        this.showLabel = false;
        this.showIcon = true;
        this.labelMap = {
            block: 'Blocked',
            allow: 'Allowed',
            bypass: 'Temporary Allowed',
            'being-allow': 'Monitored (Allow)',
            'being-block': 'Monitored (Block)'
        };
    }
    ngOnInit() {
    }
    static { this.ɵfac = function ActionIndicatorComponent_Factory(t) { return new (t || ActionIndicatorComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ActionIndicatorComponent, selectors: [["app-action-indicator"]], inputs: { action: "action", showLabel: "showLabel", showIcon: "showIcon" }, decls: 3, vars: 8, consts: [[3, "ngClass"], ["class", "icon-action", 4, "ngIf"], ["class", "label nowrap", 4, "ngIf"], [1, "icon-action"], [3, "ngClass", "matTooltip"], [1, "label", "nowrap"]], template: function ActionIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ActionIndicatorComponent_span_1_Template, 2, 2, "span", 1);
            i0.ɵɵtemplate(2, ActionIndicatorComponent_div_2_Template, 2, 1, "div", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("flex action-", ctx.action, " action");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$i, ctx.showLabel));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showIcon);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showLabel);
        } }, dependencies: [i1.NgClass, i1.NgIf, i8.MatLegacyTooltip], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ActionIndicatorComponent, [{
        type: Component,
        args: [{ selector: 'app-action-indicator', template: "<div class=\"flex action-{{ action }} action\" [ngClass]=\"{'has-label': showLabel}\">\r\n  <span *ngIf=\"showIcon\" class=\"icon-action\">\r\n    <span ngClass=\"{{action}}\" [matTooltip]=\"labelMap[action] || action\"></span>\r\n  </span>\r\n  <div *ngIf=\"showLabel\" class=\"label nowrap\">{{ labelMap[action] }}</div>\r\n</div>" }]
    }], function () { return []; }, { action: [{
            type: Input
        }], showLabel: [{
            type: Input
        }], showIcon: [{
            type: Input
        }] }); })();

function ScoreTagComponent_mat_chip_list_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-chip-list")(1, "mat-chip", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("color", ctx_r0.color);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.score);
} }
function ScoreTagComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtext(1, "-");
    i0.ɵɵelementEnd();
} }
class ScoreTagComponent {
    constructor() {
        this.score = 0;
        this.color = '';
    }
    ngOnInit() {
        if (this.score >= 8) {
            this.color = 'warn';
        }
        else if (this.score >= 6) {
            this.color = 'highlight';
        }
        else if (this.score >= 4) {
            this.color = 'primary';
        }
        else if (this.score >= 2) {
            this.color = 'success';
        }
        else {
            this.color = 'fuzzy';
        }
    }
    static { this.ɵfac = function ScoreTagComponent_Factory(t) { return new (t || ScoreTagComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScoreTagComponent, selectors: [["app-score-tag"]], inputs: { score: "score" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["noscore", ""], ["selectable", "false", 1, "outline", "is-small", 3, "color"], [1, "score-tag-no-score"]], template: function ScoreTagComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ScoreTagComponent_mat_chip_list_0_Template, 3, 2, "mat-chip-list", 0);
            i0.ɵɵtemplate(1, ScoreTagComponent_ng_template_1_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.score > 0)("ngIfElse", _r1);
        } }, dependencies: [i1.NgIf, i2$1.MatLegacyChipList, i2$1.MatLegacyChip], styles: [".score-tag-no-score[_ngcontent-%COMP%]{padding-left:10px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScoreTagComponent, [{
        type: Component,
        args: [{ selector: 'app-score-tag', template: "<mat-chip-list *ngIf=\"score > 0; else noscore\">\r\n    <mat-chip\r\n        [color]=\"color\"\r\n        class=\"outline is-small\"\r\n        selectable=\"false\"\r\n    >{{score}}</mat-chip>\r\n</mat-chip-list>\r\n<ng-template #noscore>\r\n    <div class=\"score-tag-no-score\">-</div>\r\n</ng-template>", styles: [".score-tag-no-score{padding-left:10px}\n"] }]
    }], function () { return []; }, { score: [{
            type: Input
        }] }); })();

function StatusIndicatorComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 3)(2, "mat-icon");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matTooltip", ctx_r0.getLabel(ctx_r0.status))("matTooltipDisabled", ctx_r0.showLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getIconFromStatus(ctx_r0.status), " ");
} }
function StatusIndicatorComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getLabel(ctx_r1.status), " ");
} }
const _c0$h = function (a0, a1, a2) { return { "has-label": a0, "has-icon status": a1, "warn": a2 }; };
class StatusIndicatorComponent {
    constructor() {
        this.status = '';
        this.showLabel = false;
        this.showIcon = true;
        this.iconMap = {
            close: ['Non-Compliant', 'Non-compliant', 'non-compliant'],
            check_circle: ['Exempted', 'exempted'],
            visibility_off: ['Ignored'],
            warning: ['Out of license usage'],
            done: ['Compliant', 'compliant'],
            help: ['Unknown'],
            storage: ['Domain controller', 'Quarantined']
        };
    }
    ngOnInit() {
    }
    getIconFromStatus(status) {
        const unknownIcon = 'help_outline';
        if (typeof status !== 'string') {
            return unknownIcon;
        }
        const iconNames = Object.keys(this.iconMap);
        for (const iconName of iconNames) {
            if (this.iconMap[iconName].includes(status)) {
                return iconName;
            }
        }
        return unknownIcon;
    }
    getClass(status) {
        if (typeof status !== 'string') {
            return '';
        }
        return `status-${status.replace(/\s/g, '-').toLowerCase()}`;
    }
    getLabel(status) {
        if (typeof status !== 'string') {
            return '';
        }
        const icon = this.getIconFromStatus(status);
        const names = this.iconMap[icon];
        return Array.isArray(names) ? names[0] : status;
    }
    static { this.ɵfac = function StatusIndicatorComponent_Factory(t) { return new (t || StatusIndicatorComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StatusIndicatorComponent, selectors: [["app-status-indicator"]], inputs: { status: "status", showLabel: "showLabel", showIcon: "showIcon" }, decls: 3, vars: 10, consts: [[3, "ngClass"], [4, "ngIf"], ["class", "label", 4, "ngIf"], [3, "matTooltip", "matTooltipDisabled"], [1, "label"]], template: function StatusIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, StatusIndicatorComponent_div_1_Template, 4, 3, "div", 1);
            i0.ɵɵtemplate(2, StatusIndicatorComponent_div_2_Template, 2, 1, "div", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("flex ", ctx.getClass(ctx.status), "");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(6, _c0$h, ctx.showLabel, ctx.showIcon, ctx.iconMap["close"].includes(ctx.status)));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showIcon);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showLabel);
        } }, dependencies: [i1.NgClass, i1.NgIf, i2.MatIcon, i8.MatLegacyTooltip], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StatusIndicatorComponent, [{
        type: Component,
        args: [{ selector: 'app-status-indicator', template: "<div\r\n  class=\"flex {{ getClass(status) }}\"\r\n  [ngClass]=\"{\r\n    'has-label': showLabel,\r\n    'has-icon status': showIcon,\r\n    'warn': iconMap['close'].includes(status)\r\n  }\"\r\n>\r\n  <div *ngIf=\"showIcon\">\r\n    <div\r\n      [matTooltip]=\"getLabel(status)\"\r\n      [matTooltipDisabled]=\"showLabel\"\r\n    >\r\n      <mat-icon>\r\n        {{ getIconFromStatus(status) }}\r\n      </mat-icon>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"showLabel\" class=\"label\">\r\n    {{ getLabel(status) }}\r\n  </div>\r\n</div>" }]
    }], function () { return []; }, { status: [{
            type: Input
        }], showLabel: [{
            type: Input
        }], showIcon: [{
            type: Input
        }] }); })();

function LoadingIndicatorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 1);
} }
class LoadingIndicatorComponent {
    constructor() {
        this.nrRows = 3;
        this.nrRowsCollection = [0, 1, 2];
    }
    ngOnInit() {
        this.nrRowsCollection = Array(this.nrRows).fill(0).map((x, i) => i);
    }
    static { this.ɵfac = function LoadingIndicatorComponent_Factory(t) { return new (t || LoadingIndicatorComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoadingIndicatorComponent, selectors: [["app-loading-indicator"]], inputs: { nrRows: "nrRows" }, decls: 1, vars: 1, consts: [["class", "loading-bar", 4, "ngFor", "ngForOf"], [1, "loading-bar"]], template: function LoadingIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, LoadingIndicatorComponent_div_0_Template, 1, 0, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngForOf", ctx.nrRowsCollection);
        } }, dependencies: [i1.NgForOf], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoadingIndicatorComponent, [{
        type: Component,
        args: [{ selector: 'app-loading-indicator', template: "<div class=\"loading-bar\" *ngFor=\"let i of nrRowsCollection\"></div>" }]
    }], function () { return []; }, { nrRows: [{
            type: Input
        }] }); })();

class LogTypeIndicatorComponent {
    constructor() {
        // TODO: '2' should be an integer
        this.issueType = '2';
        // TODO: can this be skipped altogether? we can send issueType='issue' from the parent component/template
        this.issueTypeMap = {
            0: 'no-issue',
            1: 'issue',
            2: 'monitor'
        };
    }
    ngOnInit() {
    }
    static { this.ɵfac = function LogTypeIndicatorComponent_Factory(t) { return new (t || LogTypeIndicatorComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LogTypeIndicatorComponent, selectors: [["app-log-type-indicator"]], inputs: { issueType: "issueType" }, decls: 3, vars: 3, consts: [[1, "log-status-icon"]], template: function LogTypeIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "span")(1, "mat-icon", 0);
            i0.ɵɵtext(2, "fiber_manual_record");
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("log-", ctx.issueTypeMap[ctx.issueType], "");
        } }, dependencies: [i2.MatIcon], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogTypeIndicatorComponent, [{
        type: Component,
        args: [{ selector: 'app-log-type-indicator', template: "<span class=\"log-{{ issueTypeMap[issueType] }}\">\r\n  <mat-icon class=\"log-status-icon\">fiber_manual_record</mat-icon>\r\n</span>" }]
    }], function () { return []; }, { issueType: [{
            type: Input
        }] }); })();

function LoadingErrorIndicatorComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-card")(2, "div", 2);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.errorMessage);
} }
function LoadingErrorIndicatorComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "app-loading-indicator", 3);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("nrRows", ctx_r2.nrRows);
} }
class LoadingErrorIndicatorComponent {
    constructor() {
        this.nrRows = 3;
        this.errorMessage = 'Something went wrong';
    }
    ngOnInit() { }
    static { this.ɵfac = function LoadingErrorIndicatorComponent_Factory(t) { return new (t || LoadingErrorIndicatorComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoadingErrorIndicatorComponent, selectors: [["app-loading-error-indicator"]], inputs: { nrRows: "nrRows", errorMessage: "errorMessage", hasError: "hasError", error$: "error$" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["loading", ""], ["data-cy", "ui-loading-error-indicator-message", 1, "message"], [3, "nrRows"]], template: function LoadingErrorIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, LoadingErrorIndicatorComponent_ng_container_0_Template, 4, 1, "ng-container", 0);
            i0.ɵɵtemplate(1, LoadingErrorIndicatorComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.hasError)("ngIfElse", _r1);
        } }, dependencies: [i1.NgIf, i2$2.MatLegacyCard, LoadingIndicatorComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoadingErrorIndicatorComponent, [{
        type: Component,
        args: [{ selector: 'app-loading-error-indicator', template: "<ng-container *ngIf=\"hasError; else loading\">\r\n  <mat-card>\r\n    <div\r\n      class=\"message\"\r\n      data-cy=\"ui-loading-error-indicator-message\"\r\n    >{{ errorMessage }}</div>\r\n  </mat-card>\r\n</ng-container>\r\n<ng-template #loading>\r\n  <app-loading-indicator [nrRows]=\"nrRows\"></app-loading-indicator>\r\n</ng-template>" }]
    }], function () { return []; }, { nrRows: [{
            type: Input
        }], errorMessage: [{
            type: Input
        }], hasError: [{
            type: Input
        }], error$: [{
            type: Input
        }] }); })();

class ComplianceIndicatorComponent {
    constructor() { }
    ngOnInit() {
    }
    static { this.ɵfac = function ComplianceIndicatorComponent_Factory(t) { return new (t || ComplianceIndicatorComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ComplianceIndicatorComponent, selectors: [["app-compliance-indicator"]], inputs: { complianceStatus: "complianceStatus" }, decls: 1, vars: 3, template: function ComplianceIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "div");
        } if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("flex status status-", ctx.complianceStatus, "");
        } }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComplianceIndicatorComponent, [{
        type: Component,
        args: [{ selector: 'app-compliance-indicator', template: "<div class=\"flex status status-{{ complianceStatus }}\"></div>" }]
    }], function () { return []; }, { complianceStatus: [{
            type: Input
        }] }); })();

const _c0$g = ["countdownDiv"];
const moment$2 = moment_;
class CountdownComponent {
    constructor() {
        this.countdown = 0;
        this.textTime = {};
    }
    ngAfterViewInit() {
        const dictionary = {
            days: ['days', 'day'],
            hours: ['hours', 'hour'],
            minutes: ['minutes', 'minute'],
            seconds: ['seconds', 'second']
        };
        Object.keys(this.textTime)
            .forEach(key => {
            if (dictionary[key]) {
                dictionary[key] = [this.textTime[key], this.textTime[key]];
            }
        });
        // const expiredMessage = this.i18n('Exemption period expired');
        const countdownDate = moment$2().add(this.countdown, 'second');
        const countdownDiv = this.countdownDiv.nativeElement;
        const interval = setInterval(() => {
            const distance = countdownDate.diff(moment$2(), 'milliseconds');
            const hourMs = 3600000;
            const minuteMs = 60000;
            const days = Math.floor(distance / (hourMs * 24));
            const hours = Math.floor((distance % (hourMs * 24)) / hourMs);
            const minutes = Math.floor((distance % hourMs) / minuteMs);
            const seconds = Math.floor((distance % minuteMs) / 1000);
            const arr = [];
            if (days > 0) {
                arr.push(`${days} ${days !== 1 ? dictionary.days[0] : dictionary.days[1]}`);
            }
            if (hours > 0) {
                arr.push(`${hours} ${hours !== 1 ? dictionary.hours[0] : dictionary.hours[1]}`);
            }
            arr.push(`${minutes} ${minutes !== 1 ? dictionary.minutes[0] : dictionary.minutes[1]}`);
            arr.push(`${seconds} ${seconds !== 1 ? dictionary.seconds[0] : dictionary.seconds[1]}`);
            countdownDiv.innerHTML = arr.join(' ');
            if (distance < 0) {
                clearInterval(interval);
                countdownDiv.innerHTML = 'Unlimited';
            }
        }, 1000);
    }
    static { this.ɵfac = function CountdownComponent_Factory(t) { return new (t || CountdownComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CountdownComponent, selectors: [["app-countdown"]], viewQuery: function CountdownComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$g, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.countdownDiv = _t.first);
        } }, inputs: { countdown: "countdown", textTime: "textTime" }, decls: 2, vars: 0, consts: [["countdownDiv", ""]], template: function CountdownComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "div", null, 0);
        } }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CountdownComponent, [{
        type: Component,
        args: [{ selector: 'app-countdown', template: "<div #countdownDiv></div>" }]
    }], function () { return []; }, { countdown: [{
            type: Input
        }], textTime: [{
            type: Input
        }], countdownDiv: [{
            type: ViewChild,
            args: ['countdownDiv']
        }] }); })();

// eslint-disable-next-line
var GenericTable;
(function (GenericTable) {
    // eslint-disable-next-line
    let RowDataType;
    (function (RowDataType) {
        RowDataType["RouterLink"] = "routerLink";
        RowDataType["Clickable"] = "clickable";
        RowDataType["NonClickable"] = "nonClickable";
    })(RowDataType = GenericTable.RowDataType || (GenericTable.RowDataType = {}));
})(GenericTable || (GenericTable = {}));

const _c0$f = ["custom"];
function CustomColumnComponent_ng_template_0_Template(rf, ctx) { }
class CustomColumnComponent {
    constructor(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
    }
    ngOnInit() {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.componentConstructor);
        const component = this.viewContainerRef.createComponent(componentFactory);
        this.initFunc(component, this.data);
    }
    static { this.ɵfac = function CustomColumnComponent_Factory(t) { return new (t || CustomColumnComponent)(i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CustomColumnComponent, selectors: [["app-custom-column"]], viewQuery: function CustomColumnComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$f, 7, ViewContainerRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewContainerRef = _t.first);
        } }, inputs: { componentConstructor: "componentConstructor", data: "data", initFunc: "initFunc" }, decls: 2, vars: 0, consts: [["custom", ""]], template: function CustomColumnComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, CustomColumnComponent_ng_template_0_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomColumnComponent, [{
        type: Component,
        args: [{ selector: 'app-custom-column', template: "<ng-template #custom>\r\n</ng-template>" }]
    }], function () { return [{ type: i0.ComponentFactoryResolver }]; }, { componentConstructor: [{
            type: Input
        }], data: [{
            type: Input
        }], initFunc: [{
            type: Input
        }], viewContainerRef: [{
            type: ViewChild,
            args: ['custom', {
                    read: ViewContainerRef,
                    static: true
                }]
        }] }); })();

function MaIconComponent_ng_container_0_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r1.toolTip);
    i0.ɵɵproperty("ngClass", ctx_r1.cssClass);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.name);
} }
function MaIconComponent_ng_container_0_i_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 5);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("sdp-fa-icon fa fa-", ctx_r2.name, "");
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r2.toolTip);
    i0.ɵɵproperty("ngClass", ctx_r2.cssClass);
} }
function MaIconComponent_ng_container_0_img_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 6);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r3.src, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r3.toolTip);
    i0.ɵɵproperty("ngClass", ctx_r3.cssClass)("alt", ctx_r3.name);
} }
function MaIconComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 1);
    i0.ɵɵtemplate(2, MaIconComponent_ng_container_0_mat_icon_2_Template, 2, 3, "mat-icon", 2);
    i0.ɵɵtemplate(3, MaIconComponent_ng_container_0_i_3_Template, 1, 5, "i", 3);
    i0.ɵɵtemplate(4, MaIconComponent_ng_container_0_img_4_Template, 1, 4, "img", 4);
    i0.ɵɵelementContainerEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r0.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "material");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "fa");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "image");
} }
class MaIconComponent {
    async ngOnInit() {
        if (typeof this.icon === 'function') {
            this.icon = await this.icon();
        }
    }
    get toolTip() {
        if (typeof this.icon === 'function' || typeof this.icon === 'undefined') {
            return undefined;
        }
        return this.icon.toolTip;
    }
    get type() {
        if (typeof this.icon === 'function' || typeof this.icon === 'undefined') {
            return undefined;
        }
        return this.icon.type;
    }
    get src() {
        if (typeof this.icon === 'function' || typeof this.icon === 'undefined') {
            return undefined;
        }
        return this.icon.type === 'image' ? this.icon.src : undefined;
    }
    get name() {
        if (typeof this.icon === 'function' || typeof this.icon === 'undefined') {
            return undefined;
        }
        if (typeof this.icon.name === 'function') {
            return this.icon.name(this.row);
        }
        return this.icon.name;
    }
    get cssClass() {
        if (typeof this.icon === 'function' || typeof this.icon === 'undefined') {
            return undefined;
        }
        if (typeof this.icon.cssClass === 'function') {
            return this.icon.cssClass(this.row);
        }
        return this.icon.cssClass;
    }
    static { this.ɵfac = function MaIconComponent_Factory(t) { return new (t || MaIconComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MaIconComponent, selectors: [["ma-icon"]], inputs: { icon: "icon", row: "row" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "ngSwitch"], [3, "ngClass", "matTooltip", 4, "ngSwitchCase"], [3, "class", "ngClass", "matTooltip", 4, "ngSwitchCase"], ["class", "sdp-img-icon", 3, "ngClass", "src", "alt", "matTooltip", 4, "ngSwitchCase"], [3, "ngClass", "matTooltip"], [1, "sdp-img-icon", 3, "ngClass", "src", "alt", "matTooltip"]], template: function MaIconComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, MaIconComponent_ng_container_0_Template, 5, 4, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.icon);
        } }, dependencies: [i1.NgClass, i1.NgIf, i1.NgSwitch, i1.NgSwitchCase, i2.MatIcon, i8.MatLegacyTooltip], styles: [".sdp-fa-icon[_ngcontent-%COMP%] {\n\t\tfont-size: 30px;\n\t}\n\n\timg.sdp-img-icon[_ngcontent-%COMP%] {\n\t\twidth: 36px;\n\t\theight: 36px;\n\t}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MaIconComponent, [{
        type: Component,
        args: [{ selector: 'ma-icon', template: "<style>\r\n\t.sdp-fa-icon {\r\n\t\tfont-size: 30px;\r\n\t}\r\n\r\n\timg.sdp-img-icon {\r\n\t\twidth: 36px;\r\n\t\theight: 36px;\r\n\t}\r\n</style>\r\n<ng-container *ngIf=\"icon\">\r\n\t<ng-container [ngSwitch]=\"type\">\r\n\t\t<mat-icon\r\n\t\t\t*ngSwitchCase=\"'material'\"\r\n\t\t\t[ngClass]=\"cssClass\"\r\n\t\t\tmatTooltip=\"{{ toolTip }}\"\r\n\t\t>{{ name }}</mat-icon>\r\n\t\t<i\r\n\t\t\t*ngSwitchCase=\"'fa'\"\r\n\t\t\tclass=\"sdp-fa-icon fa fa-{{ name }}\"\r\n\t\t\t[ngClass]=\"cssClass\"\r\n\t\t\tmatTooltip=\"{{ toolTip }}\"\r\n\t\t></i>\r\n\t\t<img\r\n\t\t\t*ngSwitchCase=\"'image'\"\r\n\t\t\t[ngClass]=\"cssClass\"\r\n\t\t\tsrc=\"{{ src }}\"\r\n\t\t\t[alt]=\"name\"\r\n\t\t\tmatTooltip=\"{{ toolTip }}\"\r\n\t\t\tclass=\"sdp-img-icon\"\r\n\t\t>\r\n\t</ng-container>\r\n</ng-container>", styles: ["\n\t.sdp-fa-icon {\n\t\tfont-size: 30px;\n\t}\n\n\timg.sdp-img-icon {\n\t\twidth: 36px;\n\t\theight: 36px;\n\t}\n"] }]
    }], null, { icon: [{
            type: Input
        }], row: [{
            type: Input
        }] }); })();

function GenericTableComponent_ng_container_1_ng_container_1_th_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 11)(1, "mat-checkbox", 12);
    i0.ɵɵlistener("change", function GenericTableComponent_ng_container_1_ng_container_1_th_1_Template_mat_checkbox_change_1_listener($event) { i0.ɵɵrestoreView(_r17); const col_r9 = i0.ɵɵnextContext(2).$implicit; return i0.ɵɵresetView($event ? col_r9.headerSchema.change($event) : null); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const col_r9 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("checked", col_r9.headerSchema.isChecked())("indeterminate", col_r9.headerSchema.isIndeterminate());
} }
function GenericTableComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenericTableComponent_ng_container_1_ng_container_1_th_1_Template, 2, 2, "th", 10);
    i0.ɵɵelementContainerEnd();
} }
function GenericTableComponent_ng_container_1_ng_container_2_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 14)(1, "div", 15)(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const col_r9 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r19.getStringContent(col_r9.headerSchema.cssClass, undefined));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", col_r9.headerSchema.headerText, " ");
} }
function GenericTableComponent_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenericTableComponent_ng_container_1_ng_container_2_th_1_Template, 4, 2, "th", 13);
    i0.ɵɵelementContainerEnd();
} }
function GenericTableComponent_ng_container_1_ng_container_3_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 11)(1, "div", 15)(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const col_r9 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r21.getStringContent(col_r9.headerSchema.cssClass, undefined));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", col_r9.headerSchema.headerText, " ");
} }
function GenericTableComponent_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenericTableComponent_ng_container_1_ng_container_3_th_1_Template, 4, 2, "th", 10);
    i0.ɵɵelementContainerEnd();
} }
function GenericTableComponent_ng_container_1_td_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "mat-checkbox", 21);
    i0.ɵɵlistener("click", function GenericTableComponent_ng_container_1_td_4_div_1_Template_mat_checkbox_click_1_listener($event) { return $event.stopPropagation(); })("change", function GenericTableComponent_ng_container_1_td_4_div_1_Template_mat_checkbox_change_1_listener($event) { i0.ɵɵrestoreView(_r34); const row_r23 = i0.ɵɵnextContext().$implicit; const col_r9 = i0.ɵɵnextContext().$implicit; const ctx_r32 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r32.getSelectChange($event, col_r9.bodySchema.change, row_r23, col_r9.bodySchema.displayColumn)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const row_r23 = i0.ɵɵnextContext().$implicit;
    const col_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r24 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("checked", ctx_r24.getSelectCheckedState(row_r23, col_r9.bodySchema.isChecked, col_r9.bodySchema.displayColumn));
} }
function GenericTableComponent_ng_container_1_td_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const row_r23 = i0.ɵɵnextContext().$implicit;
    const col_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r25 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r25.getStringContent(col_r9.bodySchema.tooltip, row_r23));
    i0.ɵɵproperty("ngClass", ctx_r25.getStringContent(col_r9.bodySchema.cssClass, row_r23));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", !!col_r9.bodySchema.displayCallback ? col_r9.bodySchema.displayCallback(row_r23) : row_r23[col_r9.bodySchema.boundField], " ");
} }
function GenericTableComponent_ng_container_1_td_4_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "ma-icon", 23);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r23 = i0.ɵɵnextContext(2).$implicit;
    const col_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r40 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r40.getStringContent(col_r9.bodySchema.tooltip, row_r23));
    i0.ɵɵproperty("icon", col_r9.bodySchema.icon)("row", row_r23);
} }
function GenericTableComponent_ng_container_1_td_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericTableComponent_ng_container_1_td_4_div_3_ng_container_1_Template, 2, 3, "ng-container", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r23 = i0.ɵɵnextContext().$implicit;
    const col_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r9.bodySchema.showIcon === undefined || col_r9.bodySchema.showIcon(row_r23));
} }
function GenericTableComponent_ng_container_1_td_4_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "span", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r23 = i0.ɵɵnextContext().$implicit;
    const col_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r27 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r27.getStringContent(col_r9.bodySchema.cssClass, row_r23));
} }
function GenericTableComponent_ng_container_1_td_4_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵelement(2, "app-custom-column", 25);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const row_r23 = i0.ɵɵnextContext().$implicit;
    const col_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("componentConstructor", col_r9.bodySchema.customComponent)("initFunc", col_r9.bodySchema.callback)("data", row_r23);
} }
function GenericTableComponent_ng_container_1_td_4_div_6_ng_container_1_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 31);
    i0.ɵɵlistener("click", function GenericTableComponent_ng_container_1_td_4_div_6_ng_container_1_button_2_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r55); const button_r50 = i0.ɵɵnextContext().$implicit; const row_r23 = i0.ɵɵnextContext(2).$implicit; $event.stopPropagation(); return i0.ɵɵresetView(button_r50.onClick(row_r23)); });
    i0.ɵɵelement(1, "ma-icon", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r50 = i0.ɵɵnextContext().$implicit;
    const row_r23 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate("color", button_r50.color);
    i0.ɵɵproperty("disabled", !!button_r50.disabled && button_r50.disabled(row_r23));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", button_r50.icon);
} }
function GenericTableComponent_ng_container_1_td_4_div_6_ng_container_1_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r61 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 33);
    i0.ɵɵlistener("click", function GenericTableComponent_ng_container_1_td_4_div_6_ng_container_1_button_4_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r61); const button_r50 = i0.ɵɵnextContext().$implicit; const row_r23 = i0.ɵɵnextContext(2).$implicit; $event.stopPropagation(); return i0.ɵɵresetView(button_r50.onClick(row_r23)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r50 = i0.ɵɵnextContext().$implicit;
    const row_r23 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r52 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("color", button_r50.color);
    i0.ɵɵproperty("ngClass", button_r50.cssClass)("disabled", !!button_r50.disabled && button_r50.disabled(row_r23));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r52.getStringContent(button_r50.text, row_r23), " ");
} }
function GenericTableComponent_ng_container_1_td_4_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 28);
    i0.ɵɵtemplate(2, GenericTableComponent_ng_container_1_td_4_div_6_ng_container_1_button_2_Template, 2, 3, "button", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 28);
    i0.ɵɵtemplate(4, GenericTableComponent_ng_container_1_td_4_div_6_ng_container_1_button_4_Template, 2, 4, "button", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r50 = ctx.$implicit;
    const row_r23 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r49 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r49.getStringContent(button_r50.tooltip, row_r23));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", button_r50.type === "icon" && (button_r50.showButton === undefined || button_r50.showButton(row_r23)));
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r49.getStringContent(button_r50.tooltip, row_r23));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", button_r50.type === "text" && (button_r50.showButton === undefined || button_r50.showButton(row_r23)));
} }
function GenericTableComponent_ng_container_1_td_4_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, GenericTableComponent_ng_container_1_td_4_div_6_ng_container_1_Template, 5, 4, "ng-container", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r9 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", col_r9.bodySchema.buttons);
} }
function GenericTableComponent_ng_container_1_td_4_div_7_ng_container_6_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r74 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function GenericTableComponent_ng_container_1_td_4_div_7_ng_container_6_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r74); const button_r69 = i0.ɵɵnextContext().$implicit; const row_r23 = i0.ɵɵnextContext(2).$implicit; return i0.ɵɵresetView(button_r69.onClick(row_r23)); });
    i0.ɵɵelement(1, "ma-icon", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r69 = i0.ɵɵnextContext().$implicit;
    const row_r23 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r70 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r70.getStringContent(button_r69.tooltip, row_r23));
    i0.ɵɵproperty("disabled", !!button_r69.disabled && button_r69.disabled(row_r23));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", button_r69.icon);
} }
function GenericTableComponent_ng_container_1_td_4_div_7_ng_container_6_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r80 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function GenericTableComponent_ng_container_1_td_4_div_7_ng_container_6_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r80); const button_r69 = i0.ɵɵnextContext().$implicit; const row_r23 = i0.ɵɵnextContext(2).$implicit; return i0.ɵɵresetView(button_r69.onClick(row_r23)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r69 = i0.ɵɵnextContext().$implicit;
    const row_r23 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r71 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r71.getStringContent(button_r69.tooltip, row_r23));
    i0.ɵɵproperty("disabled", !!button_r69.disabled && button_r69.disabled(row_r23));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r71.getStringContent(button_r69.text, row_r23), " ");
} }
function GenericTableComponent_ng_container_1_td_4_div_7_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenericTableComponent_ng_container_1_td_4_div_7_ng_container_6_button_1_Template, 2, 3, "button", 36);
    i0.ɵɵtemplate(2, GenericTableComponent_ng_container_1_td_4_div_7_ng_container_6_button_2_Template, 2, 3, "button", 36);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r69 = ctx.$implicit;
    const row_r23 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", button_r69.type === "icon" && (button_r69.showButton === undefined || button_r69.showButton(row_r23)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", button_r69.type === "text" && (button_r69.showButton === undefined || button_r69.showButton(row_r23)));
} }
function GenericTableComponent_ng_container_1_td_4_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "button", 34);
    i0.ɵɵlistener("click", function GenericTableComponent_ng_container_1_td_4_div_7_Template_button_click_1_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "more_vert");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "mat-menu", null, 35);
    i0.ɵɵtemplate(6, GenericTableComponent_ng_container_1_td_4_div_7_ng_container_6_Template, 3, 2, "ng-container", 27);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r67 = i0.ɵɵreference(5);
    const col_r9 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matMenuTriggerFor", _r67);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", col_r9.bodySchema.buttons);
} }
function GenericTableComponent_ng_container_1_td_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 16);
    i0.ɵɵtemplate(1, GenericTableComponent_ng_container_1_td_4_div_1_Template, 2, 1, "div", 17);
    i0.ɵɵtemplate(2, GenericTableComponent_ng_container_1_td_4_div_2_Template, 3, 3, "div", 18);
    i0.ɵɵtemplate(3, GenericTableComponent_ng_container_1_td_4_div_3_Template, 2, 1, "div", 17);
    i0.ɵɵtemplate(4, GenericTableComponent_ng_container_1_td_4_div_4_Template, 2, 1, "div", 19);
    i0.ɵɵtemplate(5, GenericTableComponent_ng_container_1_td_4_div_5_Template, 3, 3, "div", 17);
    i0.ɵɵtemplate(6, GenericTableComponent_ng_container_1_td_4_div_6_Template, 2, 1, "div", 20);
    i0.ɵɵtemplate(7, GenericTableComponent_ng_container_1_td_4_div_7_Template, 7, 2, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngSwitch", col_r9.bodySchema.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "select");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "string");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "icon");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "dot");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "customComponent");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "button");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "actions");
} }
function GenericTableComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 8);
    i0.ɵɵtemplate(1, GenericTableComponent_ng_container_1_ng_container_1_Template, 2, 0, "ng-container", 3);
    i0.ɵɵtemplate(2, GenericTableComponent_ng_container_1_ng_container_2_Template, 2, 0, "ng-container", 3);
    i0.ɵɵtemplate(3, GenericTableComponent_ng_container_1_ng_container_3_Template, 2, 0, "ng-container", 3);
    i0.ɵɵtemplate(4, GenericTableComponent_ng_container_1_td_4_Template, 8, 8, "td", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r9 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("matColumnDef", col_r9.bodySchema.boundField ? col_r9.bodySchema.boundField : col_r9.bodySchema.displayColumn);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r9.headerSchema.type === "select");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r9.headerSchema.type !== "none" && col_r9.headerSchema.sortable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r9.headerSchema.type === "none" || !col_r9.headerSchema.sortable);
} }
function GenericTableComponent_tr_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 38);
} }
function GenericTableComponent_ng_container_3_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 40);
} if (rf & 2) {
    const row_r89 = ctx.$implicit;
    const ctx_r88 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("routerLink", ctx_r88.rowData.callback(row_r89))("ngClass", ctx_r88.getStringContent(ctx_r88.rowData.cssClass, row_r89));
} }
function GenericTableComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenericTableComponent_ng_container_3_tr_1_Template, 1, 2, "tr", 39);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r2.displayedColumns);
} }
function GenericTableComponent_ng_container_4_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r93 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 42);
    i0.ɵɵlistener("click", function GenericTableComponent_ng_container_4_tr_1_Template_tr_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r93); const row_r91 = restoredCtx.$implicit; const ctx_r92 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r92.rowData.callback(row_r91)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r91 = ctx.$implicit;
    const ctx_r90 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r90.getStringContent(ctx_r90.rowData.cssClass, row_r91));
} }
function GenericTableComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenericTableComponent_ng_container_4_tr_1_Template, 1, 1, "tr", 41);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r3.displayedColumns);
} }
function GenericTableComponent_ng_container_5_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 44);
} }
function GenericTableComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenericTableComponent_ng_container_5_tr_1_Template, 1, 0, "tr", 43);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r4.displayedColumns);
} }
function GenericTableComponent_ng_container_6_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 46);
} if (rf & 2) {
    const row_r97 = ctx.$implicit;
    const ctx_r96 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r96.getStringContent(ctx_r96.rowData.cssClass, row_r97));
} }
function GenericTableComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenericTableComponent_ng_container_6_tr_1_Template, 1, 1, "tr", 45);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r5.displayedColumns);
} }
const _c0$e = function () { return [5, 10, 25, 100]; };
function GenericTableComponent_mat_paginator_9_Template(rf, ctx) { if (rf & 1) {
    const _r99 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-paginator", 47);
    i0.ɵɵlistener("page", function GenericTableComponent_mat_paginator_9_Template_mat_paginator_page_0_listener($event) { i0.ɵɵrestoreView(_r99); const ctx_r98 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r98.pagingData == null ? null : ctx_r98.pagingData.callback($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("length", ctx_r6.pagingData == null ? null : ctx_r6.pagingData.length)("pageSize", ctx_r6.pagingData == null ? null : ctx_r6.pagingData.size)("pageSizeOptions", i0.ɵɵpureFunction0(4, _c0$e))("pageIndex", ctx_r6.pagingData == null ? null : ctx_r6.pagingData.index);
} }
function GenericTableComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 48);
} }
class GenericTableComponent {
    constructor(location) {
        this.location = location;
        this.rowDataType = GenericTable.RowDataType;
        this.currentPage = 0;
        this.limit = 0;
    }
    ngOnInit() {
        if (!!this.parentSubject) {
            this.parentSubject.subscribe((newValue) => {
                this.tableData = newValue;
            });
        }
        const path = this.location.path();
        const limitIndex = path.indexOf('limit=') + 6;
        this.limit = parseInt(path.slice(limitIndex, limitIndex + 4), 10);
        if (isNaN(this.limit)) {
            // default limit
            this.limit = !!this.pagingData ? this.pagingData.size : 1000;
        }
        const hasBoundField = (x) => typeof x.boundField === 'string';
        // If the column is not a bound column we still need a display column for the mat-table
        this.displayedColumns = this.columnSchema.map((c, i) => {
            if (hasBoundField(c.bodySchema)) {
                return c.bodySchema.boundField;
            }
            else {
                return c.bodySchema.displayColumn;
            }
        });
    }
    ngOnDestroy() {
        // needed if child gets re-created (eg on some model changes)
        // note that subsequent subscriptions on the same subject will fail
        // so the parent has to re-create parentSubject on changes
        if (!!this.parentSubject) {
            this.parentSubject.unsubscribe();
        }
    }
    get tableData() {
        if (this._tableData === undefined) {
            return ['undefined'];
        }
        else {
            return this._tableData;
        }
    }
    set tableData(value) {
        this._tableData = value;
    }
    getSelectChange(event, func, row, displayColumn) {
        if (!!this.selectedRowIds && !event.checked) {
            const index = this.selectedRowIds.indexOf(row[displayColumn]);
            if (index >= 0) {
                this.selectedRowIds.splice(index, 1);
            }
        }
        return event ? func(row) : null;
    }
    getSelectCheckedState(row, func, displayColumn) {
        if (!this.selectedRowIds) {
            return false;
        }
        const index = this.selectedRowIds.indexOf(row[displayColumn]);
        if (index >= 0) {
            return true;
        }
        if (!!func) {
            if (typeof func === 'function') {
                return func(row);
            }
        }
        return false;
    }
    getStringContent(content, row) {
        let result;
        if (!!content) {
            if (typeof content === 'function') {
                result = content(row);
            }
            else {
                result = content;
            }
        }
        return result;
    }
    static { this.ɵfac = function GenericTableComponent_Factory(t) { return new (t || GenericTableComponent)(i0.ɵɵdirectiveInject(i1.Location)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GenericTableComponent, selectors: [["generic-table"]], inputs: { columnSchema: "columnSchema", tableName: "tableName", disabled: "disabled", pagingData: "pagingData", sortData: "sortData", rowData: "rowData", selectedRowIds: "selectedRowIds", parentSubject: "parentSubject", tableData: "tableData" }, decls: 12, vars: 12, consts: [["mat-table", "", "matSort", "", "matSortDisableClear", "", 1, "w-100-p", "ma-generic-table", 3, "dataSource", "matSortActive", "matSortDirection", "matSortChange"], [3, "matColumnDef", 4, "ngFor", "ngForOf"], ["mat-header-row", "", 4, "matHeaderRowDef", "matHeaderRowDefSticky"], [4, "ngIf"], [1, "flex", "selection-bottom"], [1, "flex", "flex-equal-width", "flex-end", "m-t-md"], ["class", "pagination", 3, "length", "pageSize", "pageSizeOptions", "pageIndex", "page", 4, "ngIf", "ngIfElse"], ["noPaginator", ""], [3, "matColumnDef"], ["mat-cell", "", 3, "ngSwitch", 4, "matCellDef"], ["mat-header-cell", "", 4, "matHeaderCellDef"], ["mat-header-cell", ""], [3, "checked", "indeterminate", "change"], ["mat-header-cell", "", "mat-sort-header", "", 4, "matHeaderCellDef"], ["mat-header-cell", "", "mat-sort-header", ""], [3, "ngClass"], ["mat-cell", "", 3, "ngSwitch"], [4, "ngSwitchCase"], [3, "ngClass", "matTooltip", 4, "ngSwitchCase"], [3, "ngClass", 4, "ngSwitchCase"], ["class", "sdp-generic-table-body-column sdp-generic-table-body-column-button", 4, "ngSwitchCase"], [3, "checked", "click", "change"], [3, "ngClass", "matTooltip"], [3, "icon", "row", "matTooltip"], [1, "dot"], [3, "componentConstructor", "initFunc", "data"], [1, "sdp-generic-table-body-column", "sdp-generic-table-body-column-button"], [4, "ngFor", "ngForOf"], [3, "matTooltip"], ["mat-icon-button", "", "class", "sdp-icon-button", 3, "color", "disabled", "click", 4, "ngIf"], ["mat-raised-button", "", 3, "color", "ngClass", "disabled", "click", 4, "ngIf"], ["mat-icon-button", "", 1, "sdp-icon-button", 3, "color", "disabled", "click"], [3, "icon"], ["mat-raised-button", "", 3, "color", "ngClass", "disabled", "click"], ["mat-icon-button", "", 3, "matMenuTriggerFor", "click"], ["policyContextMenu", "matMenu"], ["mat-menu-item", "", 3, "matTooltip", "disabled", "click", 4, "ngIf"], ["mat-menu-item", "", 3, "matTooltip", "disabled", "click"], ["mat-header-row", ""], ["mat-row", "", "class", "is-clickable", 3, "routerLink", "ngClass", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", 1, "is-clickable", 3, "routerLink", "ngClass"], ["mat-row", "", "class", "is-clickable", 3, "ngClass", "click", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", 1, "is-clickable", 3, "ngClass", "click"], ["mat-row", "", 4, "matRowDef", "matRowDefColumns"], ["mat-row", ""], ["mat-row", "", 3, "ngClass", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", 3, "ngClass"], [1, "pagination", 3, "length", "pageSize", "pageSizeOptions", "pageIndex", "page"], [1, "generic-table-no-paginator"]], template: function GenericTableComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "table", 0);
            i0.ɵɵlistener("matSortChange", function GenericTableComponent_Template_table_matSortChange_0_listener($event) { return ctx.sortData == null ? null : ctx.sortData.onChange($event); });
            i0.ɵɵtemplate(1, GenericTableComponent_ng_container_1_Template, 5, 4, "ng-container", 1);
            i0.ɵɵtemplate(2, GenericTableComponent_tr_2_Template, 1, 0, "tr", 2);
            i0.ɵɵtemplate(3, GenericTableComponent_ng_container_3_Template, 2, 1, "ng-container", 3);
            i0.ɵɵtemplate(4, GenericTableComponent_ng_container_4_Template, 2, 1, "ng-container", 3);
            i0.ɵɵtemplate(5, GenericTableComponent_ng_container_5_Template, 2, 1, "ng-container", 3);
            i0.ɵɵtemplate(6, GenericTableComponent_ng_container_6_Template, 2, 1, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 4)(8, "div", 5);
            i0.ɵɵtemplate(9, GenericTableComponent_mat_paginator_9_Template, 1, 5, "mat-paginator", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(10, GenericTableComponent_ng_template_10_Template, 1, 0, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r7 = i0.ɵɵreference(11);
            i0.ɵɵproperty("dataSource", ctx.tableData)("matSortActive", ctx.sortData == null ? null : ctx.sortData.active)("matSortDirection", ctx.sortData == null ? null : ctx.sortData.direction);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.columnSchema);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("matHeaderRowDef", ctx.displayedColumns)("matHeaderRowDefSticky", true);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.rowData && ctx.rowData.type === ctx.rowDataType.RouterLink);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.rowData && ctx.rowData.type === ctx.rowDataType.Clickable);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.rowData);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.rowData && ctx.rowData.type === ctx.rowDataType.NonClickable);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !!ctx.pagingData && (ctx.tableData.length > 10 || ctx.pagingData.length > ctx.limit))("ngIfElse", _r7);
        } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgSwitch, i1.NgSwitchCase, i3$1.RouterLink, i4.MatLegacyButton, i4$1.MatLegacyCheckbox, i2.MatIcon, i6.MatLegacyMenu, i6.MatLegacyMenuItem, i6.MatLegacyMenuTrigger, i8.MatLegacyTooltip, i8$1.MatLegacyPaginator, i9.MatSort, i9.MatSortHeader, i10.MatLegacyTable, i10.MatLegacyHeaderCellDef, i10.MatLegacyHeaderRowDef, i10.MatLegacyColumnDef, i10.MatLegacyCellDef, i10.MatLegacyRowDef, i10.MatLegacyHeaderCell, i10.MatLegacyCell, i10.MatLegacyHeaderRow, i10.MatLegacyRow, CustomColumnComponent, MaIconComponent], styles: [".generic-table-no-paginator[_ngcontent-%COMP%]{padding:10px}table.mat-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:last-child   td[_ngcontent-%COMP%]{border-bottom:0}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericTableComponent, [{
        type: Component,
        args: [{ selector: 'generic-table', template: "<table mat-table [dataSource]=\"tableData\" matSort (matSortChange)=\"sortData?.onChange($event)\"\r\n\t[matSortActive]=\"sortData?.active\" [matSortDirection]=\"sortData?.direction\" matSortDisableClear\r\n\tclass=\"w-100-p ma-generic-table\">\r\n\t<ng-container\r\n\t\tmatColumnDef=\"{{col.bodySchema.boundField ? col.bodySchema.boundField : col.bodySchema.displayColumn}}\"\r\n\t\t*ngFor=\"let col of columnSchema\">\r\n\t\t<ng-container *ngIf=\"col.headerSchema.type==='select'\">\r\n\t\t\t<th mat-header-cell *matHeaderCellDef>\r\n\t\t\t\t<mat-checkbox (change)=\"$event ? col.headerSchema.change($event) : null\"\r\n\t\t\t\t\t[checked]=\"col.headerSchema.isChecked()\" [indeterminate]=\"col.headerSchema.isIndeterminate()\">\r\n\t\t\t\t</mat-checkbox>\r\n\t\t\t</th>\r\n\t\t</ng-container>\r\n\t\t<ng-container *ngIf=\"col.headerSchema.type!=='none' && col.headerSchema.sortable\">\r\n\t\t\t<th mat-header-cell *matHeaderCellDef mat-sort-header>\r\n\t\t\t\t<div [ngClass]=\"getStringContent(col.headerSchema.cssClass, undefined)\">\r\n\t\t\t\t\t<div>\r\n\t\t\t\t\t\t{{ col.headerSchema.headerText }}\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</th>\r\n\t\t</ng-container>\r\n\t\t<ng-container *ngIf=\"col.headerSchema.type==='none' || !col.headerSchema.sortable\">\r\n\t\t\t<th mat-header-cell *matHeaderCellDef>\r\n\t\t\t\t<div [ngClass]=\"getStringContent(col.headerSchema.cssClass, undefined)\">\r\n\t\t\t\t\t<div>\r\n\t\t\t\t\t\t{{ col.headerSchema.headerText }}\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</th>\r\n\t\t</ng-container>\r\n\t\t<td mat-cell *matCellDef=\"let row\" [ngSwitch]=\"col.bodySchema.type\">\r\n\t\t\t<div *ngSwitchCase=\"'select'\">\r\n\t\t\t\t<mat-checkbox (click)=\"$event.stopPropagation()\"\r\n\t\t\t\t\t(change)=\"getSelectChange($event,col.bodySchema.change, row, col.bodySchema.displayColumn)\"\r\n\t\t\t\t\t[checked]=\"getSelectCheckedState(row,col.bodySchema.isChecked, col.bodySchema.displayColumn)\">\r\n\t\t\t\t</mat-checkbox>\r\n\t\t\t</div>\r\n\t\t\t<div *ngSwitchCase=\"'string'\" [ngClass]=\"getStringContent(col.bodySchema.cssClass, row)\"\r\n\t\t\t\tmatTooltip=\"{{ getStringContent(col.bodySchema.tooltip, row) }}\">\r\n\t\t\t\t<span>\r\n\t\t\t\t\t{{ !!col.bodySchema.displayCallback ? col.bodySchema.displayCallback(row) : row[col.bodySchema.boundField] }}\r\n\t\t\t\t</span>\r\n\t\t\t</div>\r\n\t\t\t<div *ngSwitchCase=\"'icon'\">\r\n\t\t\t\t<ng-container *ngIf=\"col.bodySchema.showIcon === undefined || col.bodySchema.showIcon(row)\">\r\n\t\t\t\t\t<ma-icon [icon]=\"col.bodySchema.icon\" [row]=\"row\"\r\n\t\t\t\t\t\tmatTooltip=\"{{ getStringContent(col.bodySchema.tooltip, row) }}\"></ma-icon>\r\n\t\t\t\t</ng-container>\r\n\t\t\t</div>\r\n\t\t\t<div *ngSwitchCase=\"'dot'\" [ngClass]=\"getStringContent(col.bodySchema.cssClass, row)\">\r\n\t\t\t\t<span class=\"dot\"></span>\r\n\t\t\t</div>\r\n\t\t\t<div *ngSwitchCase=\"'customComponent'\">\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<app-custom-column [componentConstructor]=\"col.bodySchema.customComponent\"\r\n\t\t\t\t\t\t[initFunc]=\"col.bodySchema.callback\" [data]=\"row\"></app-custom-column>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div *ngSwitchCase=\"'button'\" class=\"sdp-generic-table-body-column sdp-generic-table-body-column-button\">\r\n\t\t\t\t<ng-container *ngFor=\"let button of col.bodySchema.buttons\">\r\n\t\t\t\t\t<span matTooltip=\"{{ getStringContent(button.tooltip, row) }}\">\r\n\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t*ngIf=\"button.type === 'icon' && (button.showButton === undefined || button.showButton(row))\"\r\n\t\t\t\t\t\t\tmat-icon-button (click)=\"$event.stopPropagation(); button.onClick(row)\"\r\n\t\t\t\t\t\t\tcolor=\"{{ button.color }}\" class=\"sdp-icon-button\"\r\n\t\t\t\t\t\t\t[disabled]=\"!!button.disabled && button.disabled(row)\">\r\n\t\t\t\t\t\t\t<ma-icon [icon]=\"button.icon\"></ma-icon>\r\n\t\t\t\t\t\t</button>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<span matTooltip=\"{{ getStringContent(button.tooltip, row) }}\">\r\n\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t*ngIf=\"button.type === 'text' && (button.showButton === undefined || button.showButton(row))\"\r\n\t\t\t\t\t\t\tmat-raised-button (click)=\"$event.stopPropagation(); button.onClick(row)\"\r\n\t\t\t\t\t\t\tcolor=\"{{ button.color }}\" [ngClass]=\"button.cssClass\"\r\n\t\t\t\t\t\t\t[disabled]=\"!!button.disabled && button.disabled(row)\">\r\n\t\t\t\t\t\t\t{{ getStringContent(button.text, row) }}\r\n\t\t\t\t\t\t</button>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</ng-container>\r\n\t\t\t</div>\r\n\t\t\t<div *ngSwitchCase=\"'actions'\">\r\n\t\t\t\t<button mat-icon-button [matMenuTriggerFor]=\"policyContextMenu\" (click)=\"$event.stopPropagation()\">\r\n\t\t\t\t\t<mat-icon>more_vert</mat-icon>\r\n\t\t\t\t</button>\r\n\t\t\t\t<mat-menu #policyContextMenu=\"matMenu\">\r\n\t\t\t\t\t<ng-container *ngFor=\"let button of col.bodySchema.buttons\">\r\n\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t*ngIf=\"button.type === 'icon' && (button.showButton === undefined || button.showButton(row))\"\r\n\t\t\t\t\t\t\tmat-menu-item (click)=\"button.onClick(row)\"\r\n\t\t\t\t\t\t\tmatTooltip=\"{{ getStringContent(button.tooltip, row) }}\"\r\n\t\t\t\t\t\t\t[disabled]=\"!!button.disabled && button.disabled(row)\">\r\n\t\t\t\t\t\t\t<ma-icon [icon]=\"button.icon\"></ma-icon>\r\n\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t*ngIf=\"button.type === 'text' && (button.showButton === undefined || button.showButton(row))\"\r\n\t\t\t\t\t\t\tmat-menu-item (click)=\"button.onClick(row)\"\r\n\t\t\t\t\t\t\tmatTooltip=\"{{ getStringContent(button.tooltip, row) }}\"\r\n\t\t\t\t\t\t\t[disabled]=\"!!button.disabled && button.disabled(row)\">\r\n\t\t\t\t\t\t\t{{ getStringContent(button.text, row) }}\r\n\t\t\t\t\t\t</button>\r\n\t\t\t\t\t</ng-container>\r\n\t\t\t\t</mat-menu>\r\n\t\t\t</div>\r\n\t\t</td>\r\n\r\n\t</ng-container>\r\n\t<tr mat-header-row *matHeaderRowDef=\"displayedColumns; sticky: true\"></tr>\r\n\t<ng-container *ngIf=\"!!rowData && rowData.type === rowDataType.RouterLink\">\r\n\t\t<tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" class=\"is-clickable\"\r\n\t\t\t[routerLink]=\"rowData.callback(row)\" [ngClass]=\"getStringContent(rowData.cssClass, row)\"></tr>\r\n\t</ng-container>\r\n\t<ng-container *ngIf=\"!!rowData && rowData.type === rowDataType.Clickable\">\r\n\t\t<tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" class=\"is-clickable\"\r\n\t\t\t(click)=\"rowData.callback(row)\" [ngClass]=\"getStringContent(rowData.cssClass, row)\"></tr>\r\n\t</ng-container>\r\n\t<ng-container *ngIf=\"!rowData\">\r\n\t\t<tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\t</ng-container>\r\n\t<ng-container *ngIf=\"!!rowData && rowData.type === rowDataType.NonClickable\">\r\n\t\t<tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"\r\n\t\t\t[ngClass]=\"getStringContent(rowData.cssClass, row)\"></tr>\r\n\t</ng-container>\r\n</table>\r\n<div class=\"flex selection-bottom\">\r\n\t<div class=\"flex flex-equal-width flex-end m-t-md\">\r\n\t\t<mat-paginator *ngIf=\"!!pagingData && (tableData.length > 10 || pagingData.length > limit); else noPaginator\"\r\n\t\t\t[length]=\"pagingData?.length\" [pageSize]=\"pagingData?.size\" [pageSizeOptions]=\"[5, 10, 25, 100]\"\r\n\t\t\t[pageIndex]=\"pagingData?.index\" (page)=\"pagingData?.callback($event)\" class=\"pagination\">\r\n\t\t</mat-paginator>\r\n\t</div>\r\n</div>\r\n<ng-template #noPaginator>\r\n\t<div class=\"generic-table-no-paginator\"></div>\r\n</ng-template>", styles: [".generic-table-no-paginator{padding:10px}table.mat-table tr:last-child td{border-bottom:0}\n"] }]
    }], function () { return [{ type: i1.Location }]; }, { columnSchema: [{
            type: Input
        }], tableName: [{
            type: Input
        }], disabled: [{
            type: Input
        }], pagingData: [{
            type: Input
        }], sortData: [{
            type: Input
        }], rowData: [{
            type: Input
        }], selectedRowIds: [{
            type: Input
        }], parentSubject: [{
            type: Input
        }], tableData: [{
            type: Input
        }] }); })();

/**
 * Directive for providing a custom clear-icon.
 * e.g.
 * <ngx-mat-select-search [formControl]="bankFilterCtrl">
 *   <mat-icon appMatSelectSearchClear>delete</mat-icon>
 * </ngx-mat-select-search>
 */
class MatSelectSearchClearDirective {
    static { this.ɵfac = function MatSelectSearchClearDirective_Factory(t) { return new (t || MatSelectSearchClearDirective)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: MatSelectSearchClearDirective, selectors: [["", "appMatSelectSearchClear", ""]] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatSelectSearchClearDirective, [{
        type: Directive,
        args: [{
                selector: '[appMatSelectSearchClear]'
            }]
    }], null, null); })();

const _c0$d = ["searchSelectInput"];
const _c1$8 = ["innerSelectSearch"];
function MatSelectSearchComponent_mat_checkbox_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 9);
    i0.ɵɵlistener("change", function MatSelectSearchComponent_mat_checkbox_3_Template_mat_checkbox_change_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6._emitSelectAllBooleanToParent($event.checked)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("color", ctx_r1.matFormField == null ? null : ctx_r1.matFormField.color)("checked", ctx_r1.toggleAllCheckboxChecked)("indeterminate", ctx_r1.toggleAllCheckboxIndeterminate)("matTooltip", ctx_r1.toggleAllCheckboxTooltipMessage)("matTooltipPosition", ctx_r1.toogleAllCheckboxTooltipPosition);
} }
function MatSelectSearchComponent_mat_spinner_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 10);
} }
function MatSelectSearchComponent_button_7_ng_content_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 1, ["*ngIf", "clearIcon; else defaultIcon"]);
} }
function MatSelectSearchComponent_button_7_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "close");
    i0.ɵɵelementEnd();
} }
function MatSelectSearchComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function MatSelectSearchComponent_button_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11._reset(true)); });
    i0.ɵɵtemplate(1, MatSelectSearchComponent_button_7_ng_content_1_Template, 1, 0, "ng-content", 12);
    i0.ɵɵtemplate(2, MatSelectSearchComponent_button_7_ng_template_2_Template, 2, 0, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r9 = i0.ɵɵreference(3);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.clearIcon)("ngIfElse", _r9);
} }
function MatSelectSearchComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.noEntriesFoundLabel, "\n");
} }
const _c2$6 = [[["", 8, "mat-select-search-custom-header-content"]], [["", "appMatSelectSearchClear", ""]]];
const _c3$6 = function (a0, a1) { return { "mat-select-search-inner-multiple": a0, "mat-select-search-inner-toggle-all": a1 }; };
const _c4$5 = [".mat-select-search-custom-header-content", "[appMatSelectSearchClear]"];
class MatSelectSearchComponent {
    get isInsideMatOption() {
        return !!this.matOption;
    }
    /** Current search value */
    get value() {
        return this._formControl.value;
    }
    /** Reference to the MatSelect options */
    set _options(_options) {
        this._options$.next(_options);
    }
    get _options() {
        return this._options$.getValue();
    }
    constructor(matSelect, changeDetectorRef, _viewportRuler, matOption = null, liveAnnouncer, matFormField = null) {
        this.matSelect = matSelect;
        this.changeDetectorRef = changeDetectorRef;
        this._viewportRuler = _viewportRuler;
        this.matOption = matOption;
        this.liveAnnouncer = liveAnnouncer;
        this.matFormField = matFormField;
        this._options$ = new BehaviorSubject(null);
        this.optionsList$ = this._options$.pipe(switchMap((_options) => _options
            ? _options.changes.pipe(map((options) => options.toArray()), startWith(_options.toArray()))
            : of(null)));
        this.optionsLength$ = this.optionsList$.pipe(map((options) => (options ? options.length : 0)));
        this._formControl = new UntypedFormControl('');
        /** whether to show the no entries found message */
        this._showNoEntriesFound$ = combineLatest([this._formControl.valueChanges, this.optionsLength$]).pipe(map(([value, optionsLength]) => this.noEntriesFoundLabel && value && optionsLength === this.getOptionsLengthOffset()));
        /** Subject that emits when the component has been destroyed. */
        this._onDestroy = new Subject();
        /** Label of the search placeholder */
        this.placeholderLabel = 'Search...';
        /** Type of the search input field */
        this.type = 'text';
        /** Label to be shown when no entries are found. Set to null if no message should be shown. */
        this.noEntriesFoundLabel = 'Not found!';
        /**
         *  Text that is appended to the currently active item label announced by screen readers,
         *  informing the user of the current index, value and total options.
         *  eg: Bank R (Germany) 1 of 6
         */
        this.indexAndLengthScreenReaderText = ' of ';
        /**
         * Whether or not the search field should be cleared after the dropdown menu is closed.
         * Useful for server-side filtering. See [#3](https://github.com/bithost-gmbh/ngx-mat-select-search/issues/3)
         */
        this.clearSearchInput = true;
        /** Whether to show the search-in-progress indicator */
        this.searching = false;
        /** Disables initial focusing of the input field */
        this.disableInitialFocus = false;
        /** Enable clear input on escape pressed */
        this.enableClearOnEscapePressed = false;
        /**
         * Prevents home / end key being propagated to mat-select,
         * allowing to move the cursor within the search input instead of navigating the options
         */
        this.preventHomeEndKeyPropagation = false;
        /** Disables scrolling to active options when option list changes. Useful for server-side search */
        this.disableScrollToActiveOnOptionsChanged = false;
        /** Adds 508 screen reader support for search box */
        this.ariaLabel = 'dropdown search';
        /** Whether to show Select All Checkbox (for mat-select[multi=true]) */
        this.showToggleAllCheckbox = false;
        /** select all checkbox checked state */
        this.toggleAllCheckboxChecked = false;
        /** select all checkbox indeterminate state */
        this.toggleAllCheckboxIndeterminate = false;
        /** Display a message in a tooltip on the toggle-all checkbox */
        this.toggleAllCheckboxTooltipMessage = '';
        /** Define the position of the tooltip on the toggle-all checkbox. */
        this.toogleAllCheckboxTooltipPosition = 'below';
        /** Output emitter to send to parent component with the toggle all boolean */
        this.toggleAll = new EventEmitter();
        this.onTouched = (_) => { };
    }
    ngOnInit() {
        // set custom panel class
        const panelClass = 'mat-select-search-panel';
        if (this.matSelect.panelClass) {
            if (Array.isArray(this.matSelect.panelClass)) {
                this.matSelect.panelClass.push(panelClass);
            }
            else if (typeof this.matSelect.panelClass === 'string') {
                this.matSelect.panelClass = [this.matSelect.panelClass, panelClass];
            }
            else if (typeof this.matSelect.panelClass === 'object') {
                this.matSelect.panelClass[panelClass] = true;
            }
        }
        else {
            this.matSelect.panelClass = panelClass;
        }
        // set custom mat-option class if the component was placed inside a mat-option
        if (this.matOption) {
            this.matOption.disabled = true;
            this.matOption._getHostElement().classList.add('contains-mat-select-search');
        }
        if (this.matSelect.multiple) {
            this.initMultiSelectedValuesTracking();
            this.previousSelectedValues = this.matSelect.ngControl.value;
        }
        // when the select dropdown panel is opened or closed
        this.matSelect.openedChange.pipe(delay(1), takeUntil(this._onDestroy)).subscribe((opened) => {
            if (opened) {
                this.updateInputWidth();
                // focus the search field when opening
                if (!this.disableInitialFocus) {
                    this._focus();
                }
            }
            else {
                // clear it when closing
                if (this.clearSearchInput) {
                    this._reset();
                }
            }
        });
        // set the first item active after the options changed
        this.matSelect.openedChange
            .pipe(take(1))
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
            if (this.matSelect._keyManager) {
                this.matSelect._keyManager.change
                    .pipe(takeUntil(this._onDestroy))
                    .subscribe(() => this.adjustScrollTopToFitActiveOptionIntoView());
            }
            else {
                console.log('_keyManager was not initialized.');
            }
            this._options = this.matSelect.options;
            // Closure variable for tracking the most recent first option.
            // In order to avoid avoid causing the list to
            // scroll to the top when options are added to the bottom of
            // the list (eg: infinite scroll), we compare only
            // the changes to the first options to determine if we
            // should set the first item as active.
            // This prevents unnecessary scrolling to the top of the list
            // when options are appended, but allows the first item
            // in the list to be set as active by default when there
            // is no active selection
            let previousFirstOption = this._options.toArray()[this.getOptionsLengthOffset()];
            this._options.changes.pipe(takeUntil(this._onDestroy)).subscribe(() => {
                // avoid "expression has been changed" error
                setTimeout(() => {
                    // Convert the QueryList to an array
                    const options = this._options.toArray();
                    // The true first item is offset by 1
                    const currentFirstOption = options[this.getOptionsLengthOffset()];
                    const keyManager = this.matSelect._keyManager;
                    if (keyManager && this.matSelect.panelOpen) {
                        // set first item active and input width
                        // Check to see if the first option in these changes is different from the previous.
                        const firstOptionIsChanged = !this.matSelect.compareWith(previousFirstOption, currentFirstOption);
                        // CASE: The first option is different now.
                        // Indiciates we should set it as active and scroll to the top.
                        if (firstOptionIsChanged ||
                            !keyManager.activeItem ||
                            !options.find((option) => this.matSelect.compareWith(option, keyManager.activeItem))) {
                            keyManager.setFirstItemActive();
                        }
                        // wait for panel width changes
                        setTimeout(() => {
                            this.updateInputWidth();
                        });
                        if (!this.disableScrollToActiveOnOptionsChanged) {
                            this.adjustScrollTopToFitActiveOptionIntoView();
                        }
                    }
                    // Update our reference
                    previousFirstOption = currentFirstOption;
                });
            });
        });
        // add or remove css class depending on whether to show the no entries found message
        // note: this is hacky
        this._showNoEntriesFound$.pipe(takeUntil(this._onDestroy)).subscribe((showNoEntriesFound) => {
            // set no entries found class on mat option
            if (this.matOption) {
                if (showNoEntriesFound) {
                    this.matOption._getHostElement().classList.add('mat-select-search-no-entries-found');
                }
                else {
                    this.matOption._getHostElement().classList.remove('mat-select-search-no-entries-found');
                }
            }
        });
        // resize the input width when the viewport is resized, i.e. the trigger width could potentially be resized
        this._viewportRuler
            .change()
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
            if (this.matSelect.panelOpen) {
                this.updateInputWidth();
            }
        });
        this.initMultipleHandling();
        this.optionsList$.pipe(takeUntil(this._onDestroy)).subscribe(() => {
            // update view when available options change
            this.changeDetectorRef.markForCheck();
        });
    }
    _emitSelectAllBooleanToParent(state) {
        this.toggleAll.emit(state);
    }
    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
    _isToggleAllCheckboxVisible() {
        return this.matSelect.multiple && this.showToggleAllCheckbox;
    }
    _handleKeydown(event) {
        // Prevent propagation for all alphanumeric characters in order to avoid selection issues
        // eslint-disable-next-line
        if ((event.key && event.key.length === 1) ||
            (event.keyCode >= A && event.keyCode <= Z) ||
            (event.keyCode >= ZERO && event.keyCode <= NINE) ||
            event.keyCode === SPACE ||
            (this.preventHomeEndKeyPropagation && (event.keyCode === HOME || event.keyCode === END))) {
            event.stopPropagation();
        }
        // eslint-disable-next-line
        if (this.matSelect.multiple && event.key && event.keyCode === ENTER) {
            // Regain focus after multiselect, so we can further type
            setTimeout(() => this._focus());
        }
        // Special case if click Escape, if input is empty, close the dropdown, if not, empty out the search field
        // eslint-disable-next-line
        if (this.enableClearOnEscapePressed === true && event.keyCode === ESCAPE && this.value) {
            this._reset(true);
            event.stopPropagation();
        }
    }
    /**
     * Handles the key up event with MatSelect.
     * Allows e.g. the announcing of the currently activeDescendant by screen readers.
     */
    _handleKeyup(event) {
        // eslint-disable-next-line
        if (event.keyCode === UP_ARROW || event.keyCode === DOWN_ARROW) {
            const ariaActiveDescendantId = this.matSelect._getAriaActiveDescendant();
            const index = this._options.toArray().findIndex((item) => item.id === ariaActiveDescendantId);
            if (index !== -1) {
                const activeDescendant = this._options.toArray()[index];
                this.liveAnnouncer.announce(activeDescendant.viewValue + ' ' + this.getAriaIndex(index) + this.indexAndLengthScreenReaderText + this.getAriaLength());
            }
        }
    }
    /**
     * Calculate the index of the current option, taking the offset to length into account.
     * examples:
     *    Case 1 [Search, 1, 2, 3] will have offset of 1, due to search and will read index of total.
     *    Case 2 [1, 2, 3] will have offset of 0 and will read index +1 of total.
     */
    getAriaIndex(optionIndex) {
        if (this.getOptionsLengthOffset() === 0) {
            return optionIndex + 1;
        }
        return optionIndex;
    }
    /**
     * Calculate the length of the options, taking the offset to length into account.
     * examples:
     *    Case 1 [Search, 1, 2, 3] will have length of options.length -1, due to search.
     *    Case 2 [1, 2, 3] will have length of options.length.
     */
    getAriaLength() {
        return this._options.toArray().length - this.getOptionsLengthOffset();
    }
    writeValue(value) {
        this._lastExternalInputValue = value;
        this._formControl.setValue(value);
        this.changeDetectorRef.markForCheck();
    }
    onBlur() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this._formControl.valueChanges
            .pipe(filter((value) => value !== this._lastExternalInputValue), tap(() => (this._lastExternalInputValue = undefined)), takeUntil(this._onDestroy))
            .subscribe(fn);
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Focuses the search input field
     */
    _focus() {
        if (!this.searchSelectInput || !this.matSelect.panel) {
            return;
        }
        // save and restore scrollTop of panel, since it will be reset by focus()
        // note: this is hacky
        const panel = this.matSelect.panel.nativeElement;
        const scrollTop = panel.scrollTop;
        // focus
        this.searchSelectInput.nativeElement.focus();
        panel.scrollTop = scrollTop;
    }
    /**
     * Resets the current search value
     *
     * @param focus whether to focus after resetting
     */
    _reset(focus) {
        this._formControl.setValue('');
        if (focus) {
            this._focus();
        }
    }
    /**
     * Initializes handling <mat-select [multiple]="true">
     * Note: to improve this code, mat-select should be extended to allow disabling resetting the selection while filtering.
     */
    initMultipleHandling() {
        // if <mat-select [multiple]="true">
        // store previously selected values and restore them when they are deselected
        // because the option is not available while we are currently filtering
        this.matSelect.valueChange.pipe(takeUntil(this._onDestroy)).subscribe((values) => {
            if (this.matSelect.multiple) {
                let restoreSelectedValues = false;
                if (this._formControl.value &&
                    this._formControl.value.length &&
                    this.previousSelectedValues &&
                    Array.isArray(this.previousSelectedValues)) {
                    if (!values || !Array.isArray(values)) {
                        values = [];
                    }
                    const optionValues = this.matSelect.options.map((option) => option.value);
                    this.previousSelectedValues.forEach((previousValue) => {
                        if (!values.some((v) => this.matSelect.compareWith(v, previousValue)) &&
                            !optionValues.some((v) => this.matSelect.compareWith(v, previousValue))) {
                            // if a value that was selected before is deselected and not found in the options, it was deselected
                            // due to the filtering, so we restore it.
                            values.push(previousValue);
                            restoreSelectedValues = true;
                        }
                    });
                }
                this.previousSelectedValues = values;
                if (restoreSelectedValues) {
                    this.matSelect._onChange(values);
                }
            }
        });
    }
    /**
     * Scrolls the currently active option into the view if it is not yet visible.
     */
    adjustScrollTopToFitActiveOptionIntoView() {
        if (this.matSelect.panel && this.matSelect.options.length > 0) {
            const matOptionHeight = this.getMatOptionHeight();
            const activeOptionIndex = this.matSelect._keyManager.activeItemIndex || 0;
            const labelCount = _countGroupLabelsBeforeLegacyOption(activeOptionIndex, this.matSelect.options, this.matSelect.optionGroups);
            // If the component is in a MatOption, the activeItemIndex will be offset by one.
            const indexOfOptionToFitIntoView = (this.matOption ? -1 : 0) + labelCount + activeOptionIndex;
            const currentScrollTop = this.matSelect.panel.nativeElement.scrollTop;
            const searchInputHeight = this.innerSelectSearch.nativeElement.offsetHeight;
            const amountOfVisibleOptions = Math.floor((256 - searchInputHeight) / matOptionHeight);
            const indexOfFirstVisibleOption = Math.round((currentScrollTop + searchInputHeight) / matOptionHeight) - 1;
            if (indexOfFirstVisibleOption >= indexOfOptionToFitIntoView) {
                this.matSelect.panel.nativeElement.scrollTop = indexOfOptionToFitIntoView * matOptionHeight;
            }
            else if (indexOfFirstVisibleOption + amountOfVisibleOptions <= indexOfOptionToFitIntoView) {
                this.matSelect.panel.nativeElement.scrollTop =
                    (indexOfOptionToFitIntoView + 1) * matOptionHeight - (256 - searchInputHeight);
            }
        }
    }
    /**
     *  Set the width of the innerSelectSearch to fit even custom scrollbars
     *  And support all Operation Systems
     */
    updateInputWidth() {
        if (!this.innerSelectSearch || !this.innerSelectSearch.nativeElement) {
            return;
        }
        let element = this.innerSelectSearch.nativeElement;
        let panelElement;
        // eslint-disable-next-line
        while ((element = element.parentElement)) {
            if (element.classList.contains('mat-select-panel')) {
                panelElement = element;
                break;
            }
        }
        if (panelElement) {
            this.innerSelectSearch.nativeElement.style.width = panelElement.clientWidth + 'px';
        }
    }
    getMatOptionHeight() {
        if (this.matSelect.options.length > 0) {
            return this.matSelect.options.first._getHostElement().getBoundingClientRect().height;
        }
        return 0;
    }
    /**
     *  this.previousSelectedValues whenever selected values for multiselect changes.
     */
    initMultiSelectedValuesTracking() {
        this.matSelect.ngControl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((values) => {
            this.previousSelectedValues = values;
        });
    }
    /**
     * Determine the offset to length that can be caused by the optional matOption used as a search input.
     */
    getOptionsLengthOffset() {
        if (this.matOption) {
            return 1;
        }
        else {
            return 0;
        }
    }
    static { this.ɵfac = function MatSelectSearchComponent_Factory(t) { return new (t || MatSelectSearchComponent)(i0.ɵɵdirectiveInject(MatLegacySelect), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$1.ViewportRuler), i0.ɵɵdirectiveInject(MatLegacyOption, 8), i0.ɵɵdirectiveInject(i2$3.LiveAnnouncer), i0.ɵɵdirectiveInject(MatLegacyFormField, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MatSelectSearchComponent, selectors: [["app-mat-select-search"]], contentQueries: function MatSelectSearchComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, MatSelectSearchClearDirective, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.clearIcon = _t.first);
        } }, viewQuery: function MatSelectSearchComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$d, 7, ElementRef);
            i0.ɵɵviewQuery(_c1$8, 7, ElementRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchSelectInput = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.innerSelectSearch = _t.first);
        } }, hostVars: 2, hostBindings: function MatSelectSearchComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassProp("mat-select-search-inside-mat-option", ctx.isInsideMatOption);
        } }, inputs: { placeholderLabel: "placeholderLabel", type: "type", noEntriesFoundLabel: "noEntriesFoundLabel", indexAndLengthScreenReaderText: "indexAndLengthScreenReaderText", clearSearchInput: "clearSearchInput", searching: "searching", disableInitialFocus: "disableInitialFocus", enableClearOnEscapePressed: "enableClearOnEscapePressed", preventHomeEndKeyPropagation: "preventHomeEndKeyPropagation", disableScrollToActiveOnOptionsChanged: "disableScrollToActiveOnOptionsChanged", ariaLabel: "ariaLabel", showToggleAllCheckbox: "showToggleAllCheckbox", toggleAllCheckboxChecked: "toggleAllCheckboxChecked", toggleAllCheckboxIndeterminate: "toggleAllCheckboxIndeterminate", toggleAllCheckboxTooltipMessage: "toggleAllCheckboxTooltipMessage", toogleAllCheckboxTooltipPosition: "toogleAllCheckboxTooltipPosition" }, outputs: { toggleAll: "toggleAll" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => MatSelectSearchComponent),
                    multi: true,
                },
            ])], ngContentSelectors: _c4$5, decls: 11, vars: 14, consts: [["matInput", "", 1, "mat-select-search-input", "mat-select-search-hidden"], [1, "mat-select-search-inner", "mat-typography", "mat-datepicker-content", "mat-tab-header", 3, "ngClass"], ["innerSelectSearch", ""], ["class", "mat-select-search-toggle-all-checkbox", "matTooltipClass", "ngx-mat-select-search-toggle-all-tooltip", 3, "color", "checked", "indeterminate", "matTooltip", "matTooltipPosition", "change", 4, "ngIf"], ["autocomplete", "off", 1, "mat-select-search-input", "mat-input-element", 3, "type", "formControl", "placeholder", "keydown", "keyup", "blur"], ["searchSelectInput", ""], ["class", "mat-select-search-spinner", "diameter", "16", 4, "ngIf"], ["mat-button", "", "mat-icon-button", "", "aria-label", "Clear", "class", "mat-select-search-clear", 3, "click", 4, "ngIf"], ["class", "mat-select-search-no-entries-found", 4, "ngIf"], ["matTooltipClass", "ngx-mat-select-search-toggle-all-tooltip", 1, "mat-select-search-toggle-all-checkbox", 3, "color", "checked", "indeterminate", "matTooltip", "matTooltipPosition", "change"], ["diameter", "16", 1, "mat-select-search-spinner"], ["mat-button", "", "mat-icon-button", "", "aria-label", "Clear", 1, "mat-select-search-clear", 3, "click"], [4, "ngIf", "ngIfElse"], ["defaultIcon", ""], [1, "mat-select-search-no-entries-found"]], template: function MatSelectSearchComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c2$6);
            i0.ɵɵelement(0, "input", 0);
            i0.ɵɵelementStart(1, "div", 1, 2);
            i0.ɵɵtemplate(3, MatSelectSearchComponent_mat_checkbox_3_Template, 1, 5, "mat-checkbox", 3);
            i0.ɵɵelementStart(4, "input", 4, 5);
            i0.ɵɵlistener("keydown", function MatSelectSearchComponent_Template_input_keydown_4_listener($event) { return ctx._handleKeydown($event); })("keyup", function MatSelectSearchComponent_Template_input_keyup_4_listener($event) { return ctx._handleKeyup($event); })("blur", function MatSelectSearchComponent_Template_input_blur_4_listener() { return ctx.onBlur(); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, MatSelectSearchComponent_mat_spinner_6_Template, 1, 0, "mat-spinner", 6);
            i0.ɵɵtemplate(7, MatSelectSearchComponent_button_7_Template, 4, 2, "button", 7);
            i0.ɵɵprojection(8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, MatSelectSearchComponent_div_9_Template, 2, 1, "div", 8);
            i0.ɵɵpipe(10, "async");
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c3$6, ctx.matSelect.multiple, ctx._isToggleAllCheckboxVisible()));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx._isToggleAllCheckboxVisible());
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("type", ctx.type)("formControl", ctx._formControl)("placeholder", ctx.placeholderLabel);
            i0.ɵɵattribute("aria-label", ctx.ariaLabel);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.searching);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.value && !ctx.searching);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(10, 9, ctx._showNoEntriesFound$));
        } }, dependencies: [i1.NgClass, i1.NgIf, i3$2.DefaultValueAccessor, i3$2.NgControlStatus, i3$2.FormControlDirective, i4.MatLegacyButton, i4$1.MatLegacyCheckbox, i2.MatIcon, i7.MatLegacyInput, i9$1.MatLegacyProgressSpinner, i8.MatLegacyTooltip, i1.AsyncPipe], styles: [".mat-select-search-hidden[_ngcontent-%COMP%]{visibility:hidden}.mat-select-search-inner[_ngcontent-%COMP%]{position:absolute;top:0;width:calc(100% + 15px);border-bottom:1px solid #cccccc;background:#fff;z-index:100}.mat-select-search-inner.mat-select-search-inner-multiple[_ngcontent-%COMP%]{width:344px!important;box-shadow:none}.mat-select-search-panel[_ngcontent-%COMP%]{transform:none!important;max-height:350px;width:280px}.mat-select-search-panel[_ngcontent-%COMP%]   .mat-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{transform:translate(calc(-50% + .2rem));margin-bottom:4px;padding-right:4px}.mat-select-search-panel[_ngcontent-%COMP%]   .mat-select-option[_ngcontent-%COMP%]{overflow:auto;max-height:207px;margin-top:5px}.mat-select-search-input[_ngcontent-%COMP%]{padding:12px 60px 12px 16px;box-sizing:border-box}.mat-select-search-no-entries-found[_ngcontent-%COMP%]{padding:12px 60px 10px 16px;margin-top:5px}.mat-select-search-clear[_ngcontent-%COMP%]{position:absolute;right:15px;top:4px}.cdk-overlay-pane-select-search[_ngcontent-%COMP%]{margin-top:-50px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatSelectSearchComponent, [{
        type: Component,
        args: [{ selector: 'app-mat-select-search', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MatSelectSearchComponent),
                        multi: true,
                    },
                ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<input matInput class=\"mat-select-search-input mat-select-search-hidden\"/>\r\n\r\n<!-- Note: the  mat-datepicker-content mat-tab-header are needed to inherit the material theme colors, see PR #22 -->\r\n<div\r\n      #innerSelectSearch\r\n      class=\"mat-select-search-inner mat-typography mat-datepicker-content mat-tab-header\"\r\n      [ngClass]=\"{'mat-select-search-inner-multiple': matSelect.multiple, 'mat-select-search-inner-toggle-all': _isToggleAllCheckboxVisible() }\">\r\n\r\n  <mat-checkbox *ngIf=\"_isToggleAllCheckboxVisible()\"\r\n                [color]=\"matFormField?.color\"\r\n                class=\"mat-select-search-toggle-all-checkbox\"\r\n                [checked]=\"toggleAllCheckboxChecked\"\r\n                [indeterminate]=\"toggleAllCheckboxIndeterminate\"\r\n                [matTooltip]=\"toggleAllCheckboxTooltipMessage\"\r\n                matTooltipClass=\"ngx-mat-select-search-toggle-all-tooltip\"\r\n                [matTooltipPosition]=\"toogleAllCheckboxTooltipPosition\"\r\n                (change)=\"_emitSelectAllBooleanToParent($event.checked)\"\r\n  ></mat-checkbox>\r\n\r\n  <input class=\"mat-select-search-input mat-input-element\"\r\n         autocomplete=\"off\"\r\n         [type]=\"type\"\r\n         [formControl]=\"_formControl\"\r\n         #searchSelectInput\r\n         (keydown)=\"_handleKeydown($event)\"\r\n         (keyup)=\"_handleKeyup($event)\"\r\n         (blur)=\"onBlur()\"\r\n         [placeholder]=\"placeholderLabel\"\r\n         [attr.aria-label]=\"ariaLabel\"\r\n  />\r\n  <mat-spinner *ngIf=\"searching\"\r\n          class=\"mat-select-search-spinner\"\r\n          diameter=\"16\"></mat-spinner>\r\n\r\n  <button mat-button\r\n          *ngIf=\"value && !searching\"\r\n          mat-icon-button\r\n          aria-label=\"Clear\"\r\n          (click)=\"_reset(true)\"\r\n          class=\"mat-select-search-clear\">\r\n    <ng-content *ngIf=\"clearIcon; else defaultIcon\" select=\"[appMatSelectSearchClear]\"></ng-content>\r\n    <ng-template #defaultIcon>\r\n      <mat-icon>close</mat-icon>\r\n    </ng-template>\r\n  </button>\r\n\r\n  <ng-content select=\".mat-select-search-custom-header-content\"></ng-content>\r\n\r\n</div>\r\n\r\n<div *ngIf=\"_showNoEntriesFound$ | async\"\r\n     class=\"mat-select-search-no-entries-found\">\r\n  {{noEntriesFoundLabel}}\r\n</div>", styles: [".mat-select-search-hidden{visibility:hidden}.mat-select-search-inner{position:absolute;top:0;width:calc(100% + 15px);border-bottom:1px solid #cccccc;background:#fff;z-index:100}.mat-select-search-inner.mat-select-search-inner-multiple{width:344px!important;box-shadow:none}.mat-select-search-panel{transform:none!important;max-height:350px;width:280px}.mat-select-search-panel .mat-button .mat-icon{transform:translate(calc(-50% + .2rem));margin-bottom:4px;padding-right:4px}.mat-select-search-panel .mat-select-option{overflow:auto;max-height:207px;margin-top:5px}.mat-select-search-input{padding:12px 60px 12px 16px;box-sizing:border-box}.mat-select-search-no-entries-found{padding:12px 60px 10px 16px;margin-top:5px}.mat-select-search-clear{position:absolute;right:15px;top:4px}.cdk-overlay-pane-select-search{margin-top:-50px}\n"] }]
    }], function () { return [{ type: i11.MatLegacySelect, decorators: [{
                type: Inject,
                args: [MatLegacySelect]
            }] }, { type: i0.ChangeDetectorRef }, { type: i1$1.ViewportRuler }, { type: i12.MatLegacyOption, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MatLegacyOption]
            }] }, { type: i2$3.LiveAnnouncer }, { type: i6$1.MatLegacyFormField, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MatLegacyFormField]
            }] }]; }, { placeholderLabel: [{
            type: Input
        }], type: [{
            type: Input
        }], noEntriesFoundLabel: [{
            type: Input
        }], indexAndLengthScreenReaderText: [{
            type: Input
        }], clearSearchInput: [{
            type: Input
        }], searching: [{
            type: Input
        }], disableInitialFocus: [{
            type: Input
        }], enableClearOnEscapePressed: [{
            type: Input
        }], preventHomeEndKeyPropagation: [{
            type: Input
        }], disableScrollToActiveOnOptionsChanged: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], showToggleAllCheckbox: [{
            type: Input
        }], toggleAllCheckboxChecked: [{
            type: Input
        }], toggleAllCheckboxIndeterminate: [{
            type: Input
        }], toggleAllCheckboxTooltipMessage: [{
            type: Input
        }], toogleAllCheckboxTooltipPosition: [{
            type: Input
        }], toggleAll: [{
            type: Output
        }], searchSelectInput: [{
            type: ViewChild,
            args: ['searchSelectInput', { read: ElementRef, static: true }]
        }], innerSelectSearch: [{
            type: ViewChild,
            args: ['innerSelectSearch', { read: ElementRef, static: true }]
        }], clearIcon: [{
            type: ContentChild,
            args: [MatSelectSearchClearDirective]
        }], isInsideMatOption: [{
            type: HostBinding,
            args: ['class.mat-select-search-inside-mat-option']
        }] }); })();

const _c0$c = ["tooltipTemplate"];
class OpswatTooltipDirective {
    constructor(renderer, el, viewContainerRef) {
        this.renderer = renderer;
        this.el = el;
        this.viewContainerRef = viewContainerRef;
        this.delayTime = 0;
    }
    onMouseEnter() {
        this.getDelayHidden(this.defaultDelayHidden);
        const view = this.viewContainerRef.createEmbeddedView(this.tooltipTemplateRef);
        view.rootNodes.forEach(node => this.renderer.appendChild(this.el.nativeElement, node));
    }
    onMouseLeave() {
        if (this.viewContainerRef) {
            window.setTimeout(() => {
                this.viewContainerRef.clear();
            }, this.delayTime);
        }
    }
    getDelayHidden(second) {
        if (second) {
            const isValid = !isNaN(second);
            this.delayTime = isValid ? second : this.delayTime;
        }
    }
    static { this.ɵfac = function OpswatTooltipDirective_Factory(t) { return new (t || OpswatTooltipDirective)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: OpswatTooltipDirective, selectors: [["", "appOpswatTooltip", ""]], contentQueries: function OpswatTooltipDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, _c0$c, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltipTemplateRef = _t.first);
        } }, hostBindings: function OpswatTooltipDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("mouseenter", function OpswatTooltipDirective_mouseenter_HostBindingHandler() { return ctx.onMouseEnter(); })("mouseleave", function OpswatTooltipDirective_mouseleave_HostBindingHandler() { return ctx.onMouseLeave(); });
        } }, inputs: { defaultDelayHidden: "defaultDelayHidden" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OpswatTooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[appOpswatTooltip]',
            }]
    }], function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.ViewContainerRef }]; }, { defaultDelayHidden: [{
            type: Input
        }], tooltipTemplateRef: [{
            type: ContentChild,
            args: ['tooltipTemplate']
        }], onMouseEnter: [{
            type: HostListener,
            args: ['mouseenter']
        }], onMouseLeave: [{
            type: HostListener,
            args: ['mouseleave']
        }] }); })();

function SplitSelectComponent_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.title);
} }
function SplitSelectComponent_span_6_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.availableTooltipText, " ");
} }
function SplitSelectComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19)(1, "mat-icon", 20);
    i0.ɵɵtext(2, "info");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SplitSelectComponent_span_6_ng_template_3_Template, 3, 1, "ng-template", null, 21, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} }
const _c0$b = function () { return { standalone: true }; };
function SplitSelectComponent_div_9_input_2_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 29);
    i0.ɵɵlistener("ngModelChange", function SplitSelectComponent_div_9_input_2_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.search = $event); })("keyup.enter", function SplitSelectComponent_div_9_input_2_Template_input_keyup_enter_0_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r22 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r22.onSearchChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("placeholder", ctx_r17.availablePlaceholder)("ngModel", ctx_r17.search)("ngModelOptions", i0.ɵɵpureFunction0(3, _c0$b));
} }
function SplitSelectComponent_div_9_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 30);
    i0.ɵɵlistener("ngModelChange", function SplitSelectComponent_div_9_input_3_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.search = $event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("placeholder", ctx_r18.availablePlaceholder)("ngModel", ctx_r18.search)("ngModelOptions", i0.ɵɵpureFunction0(3, _c0$b));
} }
function SplitSelectComponent_div_9_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 31);
    i0.ɵɵlistener("click", function SplitSelectComponent_div_9_span_4_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.onClearSearchField(ctx_r25.searchCallAPILeft)); });
    i0.ɵɵelementStart(1, "mat-icon")(2, "span", 32);
    i0.ɵɵtext(3, "close");
    i0.ɵɵelementEnd()()();
} }
const _c1$7 = function (a0) { return { "min-w-250": a0 }; };
function SplitSelectComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24)(1, "mat-form-field", 25);
    i0.ɵɵtemplate(2, SplitSelectComponent_div_9_input_2_Template, 1, 4, "input", 26);
    i0.ɵɵtemplate(3, SplitSelectComponent_div_9_input_3_Template, 1, 4, "input", 27);
    i0.ɵɵtemplate(4, SplitSelectComponent_div_9_span_4_Template, 4, 0, "span", 28);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1$7, !ctx_r2.isCVE));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.searchCallAPILeft);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.searchCallAPILeft);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!ctx_r2.search);
} }
function SplitSelectComponent_ng_container_11_div_1_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r28 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r28.icon);
} }
function SplitSelectComponent_ng_container_11_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 36);
} }
const _c2$5 = function (a0) { return { "is-selected": a0 }; };
function SplitSelectComponent_ng_container_11_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵlistener("click", function SplitSelectComponent_ng_container_11_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r33); const item_r28 = restoredCtx.$implicit; const ctx_r32 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r32.onSelectAvailableItem(item_r28)); })("dblclick", function SplitSelectComponent_ng_container_11_div_1_Template_div_dblclick_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r33); const item_r28 = restoredCtx.$implicit; const ctx_r34 = i0.ɵɵnextContext(2); ctx_r34.onSelectAvailableItem(item_r28); return i0.ɵɵresetView(ctx_r34.onAssign()); });
    i0.ɵɵtemplate(1, SplitSelectComponent_ng_container_11_div_1_mat_icon_1_Template, 2, 1, "mat-icon", 0);
    i0.ɵɵtemplate(2, SplitSelectComponent_ng_container_11_div_1_span_2_Template, 1, 0, "span", 35);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r28 = ctx.$implicit;
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c2$5, ctx_r27.isAvailableItemSelected(item_r28)))("matTooltip", ctx_r27.getValue(item_r28));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!item_r28.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r28.icon && ctx_r27.hasIcons);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" \u00A0 ", ctx_r27.getValue(item_r28), " ");
} }
function SplitSelectComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SplitSelectComponent_ng_container_11_div_1_Template, 4, 7, "div", 33);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.availableFormatted);
} }
function SplitSelectComponent_span_22_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("/", ctx_r35.selectedMax, "");
} }
function SplitSelectComponent_span_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, SplitSelectComponent_span_22_span_2_Template, 2, 1, "span", 0);
    i0.ɵɵtext(3, ")");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", ctx_r4.selected.length, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.selectedMax);
} }
function SplitSelectComponent_span_23_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r37.selectedTooltipText, " ");
} }
function SplitSelectComponent_span_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19)(1, "mat-icon", 20);
    i0.ɵɵtext(2, "info");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SplitSelectComponent_span_23_ng_template_3_Template, 3, 1, "ng-template", null, 21, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} }
function SplitSelectComponent_div_26_div_1_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 38);
    i0.ɵɵlistener("click", function SplitSelectComponent_div_26_div_1_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r40.onClearSearchSelectedField()); });
    i0.ɵɵelementStart(1, "mat-icon")(2, "span", 32);
    i0.ɵɵtext(3, "close");
    i0.ɵɵelementEnd()()();
} }
function SplitSelectComponent_div_26_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "mat-form-field", 25)(2, "input", 30);
    i0.ɵɵlistener("ngModelChange", function SplitSelectComponent_div_26_div_1_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r42.searchTermSelected = $event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SplitSelectComponent_div_26_div_1_button_3_Template, 4, 0, "button", 37);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1$7, !ctx_r38.isCVE));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("placeholder", ctx_r38.selectedPlaceholder)("ngModel", ctx_r38.searchTermSelected)("ngModelOptions", i0.ɵɵpureFunction0(7, _c0$b));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!ctx_r38.searchTermSelected);
} }
function SplitSelectComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SplitSelectComponent_div_26_div_1_Template, 4, 8, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!ctx_r6.searchChange);
} }
function SplitSelectComponent_ng_container_28_div_1_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r45 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r45.icon);
} }
function SplitSelectComponent_ng_container_28_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 36);
} }
function SplitSelectComponent_ng_container_28_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵlistener("click", function SplitSelectComponent_ng_container_28_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r50); const item_r45 = restoredCtx.$implicit; const ctx_r49 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r49.onSelectSelectedItem(item_r45)); })("dblclick", function SplitSelectComponent_ng_container_28_div_1_Template_div_dblclick_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r50); const item_r45 = restoredCtx.$implicit; const ctx_r51 = i0.ɵɵnextContext(2); ctx_r51.onSelectSelectedItem(item_r45); return i0.ɵɵresetView(ctx_r51.onUnassign()); });
    i0.ɵɵtemplate(1, SplitSelectComponent_ng_container_28_div_1_mat_icon_1_Template, 2, 1, "mat-icon", 0);
    i0.ɵɵtemplate(2, SplitSelectComponent_ng_container_28_div_1_span_2_Template, 1, 0, "span", 35);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r45 = ctx.$implicit;
    const ctx_r44 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c2$5, ctx_r44.isSelectedItemSelected(item_r45)))("matTooltip", ctx_r44.getValue(item_r45));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!item_r45.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r45.icon && ctx_r44.hasIcons);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" \u00A0 ", ctx_r44.getValue(item_r45), " ");
} }
function SplitSelectComponent_ng_container_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SplitSelectComponent_ng_container_28_div_1_Template, 4, 7, "div", 33);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r7.filteredSelected);
} }
const _c3$5 = function (a0) { return { "opacity-05": a0 }; };
function SplitSelectComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39)(1, "a", 40);
    i0.ɵɵlistener("click", function SplitSelectComponent_div_29_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r53); const ctx_r52 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r52.onClearSelected()); });
    i0.ɵɵtext(2, " Clear All ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c3$5, !ctx_r8.hasSelectedItems));
} }
function SplitSelectComponent_ng_template_30_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r55 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r55.dataAdded() ? ctx_r55.errorMsg(ctx_r55.typeSpecific) : ctx_r55.searchNotFoundLeft, " ");
} }
function SplitSelectComponent_ng_template_30_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SplitSelectComponent_ng_template_30_ng_container_0_div_1_Template, 2, 1, "div", 41);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r54.searchNotFoundLeft);
} }
function SplitSelectComponent_ng_template_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SplitSelectComponent_ng_template_30_ng_container_0_Template, 2, 1, "ng-container", 8);
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    const _r13 = i0.ɵɵreference(35);
    i0.ɵɵproperty("ngIf", ctx_r10.isCVE)("ngIfElse", _r13);
} }
function SplitSelectComponent_ng_template_32_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r57.searchNotFoundRight);
} }
function SplitSelectComponent_ng_template_32_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SplitSelectComponent_ng_template_32_ng_container_0_div_1_Template, 2, 1, "div", 41);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r56 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r56.searchNotFoundRight);
} }
function SplitSelectComponent_ng_template_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SplitSelectComponent_ng_template_32_ng_container_0_Template, 2, 1, "ng-container", 8);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    const _r13 = i0.ɵɵreference(35);
    i0.ɵɵproperty("ngIf", ctx_r12.isCVE)("ngIfElse", _r13);
} }
function SplitSelectComponent_ng_template_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r14.searchNotFound);
} }
const _c4$4 = function (a0) { return { "ui-disabled": a0 }; };
const _c5$1 = function (a0, a1) { return { "ma-split-select-cve": a0, "w-300": a1 }; };
const _c6 = function (a0, a1) { return { "m-t-md": a0, "m-t-none": a1 }; };
const _c7 = function (a0) { return { "ma-split-select-list-offset": a0 }; };
const _c8 = function (a0) { return { "list-item-without-search": a0 }; };
class SplitSelectComponent {
    get selected() {
        if (this.selectedSelection instanceof SelectionModel) {
            return this.selectedSelection.selected;
        }
        return [];
    }
    get hasChanges() {
        return this.hasChangesValue;
    }
    set selected(val) {
        if (this.selectedSelection instanceof SelectionModel &&
            Array.isArray(val)) {
            this.selectedSelection.select(...val);
            // Don't emit when setting the value for the first time
            if (this.initSelected) {
                this.initSelected = false;
            }
            else {
                this.selectedChange.emit(this.selectedSelection.selected);
            }
        }
        const selectedIdsString = this.selected
            .map(this.idExtractor)
            .sort(this.sortAlphabetically)
            .join();
        const originalIdsString = this.originalIds
            .sort(this.sortAlphabetically)
            .join();
        this.hasChanges = selectedIdsString !== originalIdsString;
    }
    set hasChanges(val) {
        this.hasChangesValue = val;
        this.hasChangesChange.emit(val);
    }
    get availableFormatted() {
        if (this.searchCallAPILeft) {
            if (!Array.isArray(this.available)) {
                return [];
            }
            return this.available.filter(item => {
                if (this.selectedSelection instanceof SelectionModel &&
                    this.contains(this.selectedSelection.selected, item)) {
                    return false;
                }
                return true;
            });
        }
        else {
            if (Array.isArray(this.available)) {
                return this.available.filter(item => {
                    const value = this.valueExtractor(item);
                    const term = typeof this.search === 'string' ? this.search.toLowerCase() : '';
                    if (typeof value === 'string') {
                        if (this.selectedSelection instanceof SelectionModel &&
                            this.contains(this.selectedSelection.selected, item)) {
                            return false;
                        }
                        return value.toLowerCase().includes(term);
                    }
                    else {
                        return false;
                    }
                });
            }
            return [];
        }
    }
    constructor(snackBar, differs) {
        this.snackBar = snackBar;
        this.differs = differs;
        this.searchNotFound = null;
        this.searchNotFoundLeft = null;
        this.searchNotFoundRight = null;
        this.search = '';
        this.searchTermSelected = '';
        this.hasIcons = false;
        this.selectedHighlightedSelection = null;
        this.availableHighlightedSelection = null;
        this.selectedSelection = null;
        this.hasChangesValue = false;
        this.originalIds = [];
        this.initSelected = true;
        this.selectedChange = new EventEmitter();
        this.hasChangesChange = new EventEmitter();
        this.availableLabel = 'Available';
        this.selectedLabel = 'Selected';
        this.availablePlaceholder = 'Search';
        this.selectedPlaceholder = 'Search';
        this.available = [];
        this.clearForm = false;
        this.isCVE = false;
        this.typeSpecific = '';
        this.searchValue = false;
        this.searchCallAPILeft = true;
        this.hideSearchRight = false;
        this.canClearSelected = true;
        this.showTotalSelected = true;
        this.disabledForm = false;
        this.availableTooltipText = null;
        this.selectedTooltipText = null;
        this.valueExtractor = item => item;
        this.idExtractor = item => item;
        this.selectedHighlightedSelection = new SelectionModel(true);
        this.availableHighlightedSelection = new SelectionModel(true);
        this.selectedSelection = new SelectionModel(true);
        this.differ = this.differs.find(this.available).create();
    }
    get filteredSelected() {
        if (Array.isArray(this.selected)) {
            return this.selected
                .filter(item => {
                const value = this.valueExtractor(item);
                const term = typeof this.searchTermSelected === 'string' ?
                    this.searchTermSelected.toLowerCase() : '';
                return (typeof value === 'string' ?
                    value.toLowerCase().includes(term) :
                    false);
            });
        }
        return [];
    }
    get hasSelectedAvailableItems() {
        return (this.availableHighlightedSelection instanceof SelectionModel &&
            !!this.availableHighlightedSelection.selected.length);
    }
    get hasSelectedSelectedItems() {
        return (this.selectedHighlightedSelection instanceof SelectionModel &&
            !!this.selectedHighlightedSelection.selected.length);
    }
    get hasSelectedItems() {
        return (this.selectedSelection instanceof SelectionModel &&
            !!this.selectedSelection.selected.length);
    }
    ngOnInit() {
        // TODO figure out how to not use settimeout
        setTimeout(() => {
            this.originalIds = this.selected.map(this.idExtractor);
            const combined = this.available.concat(this.selected);
            this.hasIcons = combined.filter((item) => item.hasOwnProperty('icon')).length > 0;
        });
    }
    ngDoCheck() {
        const change = this.differ.diff(this.available);
        if (!!change && sessionStorage.getItem('deviceSubmited')) {
            this.selected = [...this.available];
            sessionStorage.removeItem('deviceSubmited');
        }
    }
    ngOnChanges(changes) {
        if (changes) {
            if (this.clearForm) {
                this.clearAll();
            }
        }
    }
    onSelectAvailableItem(item) {
        if (this.availableHighlightedSelection instanceof SelectionModel) {
            this.availableHighlightedSelection.toggle(item);
        }
    }
    onSelectSelectedItem(item) {
        if (this.selectedHighlightedSelection instanceof SelectionModel) {
            this.selectedHighlightedSelection.toggle(item);
        }
    }
    isAvailableItemSelected(item) {
        if (this.availableHighlightedSelection instanceof SelectionModel) {
            return this.availableHighlightedSelection.isSelected(item);
        }
        return false;
    }
    isSelectedItemSelected(item) {
        if (this.selectedHighlightedSelection instanceof SelectionModel) {
            return this.selectedHighlightedSelection.isSelected(item);
        }
        return false;
    }
    onAssign() {
        if (this.availableHighlightedSelection instanceof SelectionModel &&
            this.selectedSelection instanceof SelectionModel) {
            if (typeof this.selectedMax === 'number') {
                const countAfterAssign = (this.availableHighlightedSelection.selected.length +
                    this.selectedSelection.selected.length);
                if (countAfterAssign > this.selectedMax) {
                    this.snackBar.open(`Maximum number of selected items is ${this.selectedMax}`, null, { panelClass: 'error' });
                    return;
                }
            }
            this.selected = this.availableHighlightedSelection.selected;
            this.availableHighlightedSelection.clear();
        }
    }
    onUnassign() {
        if (this.selectedHighlightedSelection instanceof SelectionModel &&
            this.selectedSelection instanceof SelectionModel) {
            this.selectedSelection.deselect(...this.selectedHighlightedSelection.selected);
            this.selected = this.selectedSelection.selected;
            this.selectedHighlightedSelection.clear();
        }
    }
    getValue(item) {
        const value = this.valueExtractor(item);
        return ['string', 'number', 'boolean'].includes(typeof value) ?
            value : '-';
    }
    sortAlphabetically(a, b) {
        if (a > b) {
            return -1;
        }
        if (b > a) {
            return 1;
        }
        return 0;
    }
    onSearchChange(event) {
        event.preventDefault();
        if (sessionStorage.getItem('deviceSubmited')) {
            sessionStorage.removeItem('deviceSubmited');
        }
        this.searchChange(this.search);
    }
    onClearSearchField(isCallAPI) {
        this.search = '';
        if (isCallAPI) {
            this.searchChange(this.search);
        }
    }
    onClearSearchSelectedField() {
        this.searchTermSelected = '';
    }
    onClearSelected() {
        if (this.canClearSelected &&
            this.selectedHighlightedSelection instanceof SelectionModel &&
            this.selectedSelection instanceof SelectionModel &&
            this.selectedSelection.selected.length) {
            this.selectedHighlightedSelection.select(...this.selectedSelection.selected);
            this.onUnassign();
        }
    }
    contains(list, obj) {
        return list.some(elem => JSON.stringify(obj) === JSON.stringify(elem));
    }
    dataAdded() {
        return this.availableFormatted.length === 0 && this.searchValue;
    }
    errorMsg(type) {
        return `Found ${type} have been added to the whitelist`;
    }
    clearAll() {
        this.onClearSearchField(this.searchCallAPILeft);
        this.onClearSearchSelectedField();
        this.onClearSelected();
    }
    static { this.ɵfac = function SplitSelectComponent_Factory(t) { return new (t || SplitSelectComponent)(i0.ɵɵdirectiveInject(i1$2.MatLegacySnackBar), i0.ɵɵdirectiveInject(i0.KeyValueDiffers)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SplitSelectComponent, selectors: [["app-split-select"]], inputs: { searchNotFound: "searchNotFound", searchNotFoundLeft: "searchNotFoundLeft", searchNotFoundRight: "searchNotFoundRight", selected: "selected", hasChanges: "hasChanges", searchChange: "searchChange", title: "title", availableLabel: "availableLabel", selectedLabel: "selectedLabel", availablePlaceholder: "availablePlaceholder", selectedPlaceholder: "selectedPlaceholder", available: "available", clearForm: "clearForm", isCVE: "isCVE", typeSpecific: "typeSpecific", searchValue: "searchValue", searchCallAPILeft: "searchCallAPILeft", hideSearchRight: "hideSearchRight", canClearSelected: "canClearSelected", showTotalSelected: "showTotalSelected", disabledForm: "disabledForm", selectedMax: "selectedMax", availableTooltipText: "availableTooltipText", selectedTooltipText: "selectedTooltipText", valueExtractor: "valueExtractor", idExtractor: "idExtractor" }, outputs: { selectedChange: "selectedChange", hasChangesChange: "hasChangesChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 36, vars: 40, consts: [[4, "ngIf"], [1, "flex", 3, "ngClass"], [3, "ngClass"], [1, "m-b-md", 3, "ngClass"], ["appOpswatTooltip", "", 4, "ngIf"], ["data-cy", "ui-split-select-list-available", 1, "list"], ["class", "ma-split-select-search-offset", 4, "ngIf"], [1, "list-item"], [4, "ngIf", "ngIfElse"], [1, "flex", "flex-column", "flex-center", "flex-middle", "p-md", "middle", "m-t-lg"], ["mat-icon-button", "", 1, "is-large", 3, "disabled", "click"], ["mat-icon-button", "", 1, "is-large", "m-t-md", 3, "disabled", "click"], [1, "ma-split-select-list-offset"], [1, "list"], ["data-cy", "ui-split-select-list-selected", 1, "list-item", 3, "ngClass"], ["class", "flex flex-end m-t-sm", 4, "ngIf"], ["checkNotFoundLeft", ""], ["checkNotFoundRight", ""], ["notFound", ""], ["appOpswatTooltip", ""], [1, "info-icon"], ["tooltipTemplate", ""], [1, "tooltip", "tooltip-bottom"], [1, "tooltip-content"], [1, "ma-split-select-search-offset"], ["appearance", "outline", 1, "search", "ma-split-select-search", 3, "ngClass"], ["matInput", "", 3, "placeholder", "ngModel", "ngModelOptions", "ngModelChange", "keyup.enter", 4, "ngIf"], ["matInput", "", 3, "placeholder", "ngModel", "ngModelOptions", "ngModelChange", 4, "ngIf"], ["matSuffix", "", "class", "ng-star-inserted mat-icon-button custom-clear", "mat-icon-button", "", "aria-label", "Clear", 3, "click", 4, "ngIf"], ["matInput", "", 3, "placeholder", "ngModel", "ngModelOptions", "ngModelChange", "keyup.enter"], ["matInput", "", 3, "placeholder", "ngModel", "ngModelOptions", "ngModelChange"], ["matSuffix", "", "mat-icon-button", "", "aria-label", "Clear", 1, "ng-star-inserted", "mat-icon-button", "custom-clear", 3, "click"], ["il8n", ""], ["class", "item ma-ellipsis", 3, "ngClass", "matTooltip", "click", "dblclick", 4, "ngFor", "ngForOf"], [1, "item", "ma-ellipsis", 3, "ngClass", "matTooltip", "click", "dblclick"], ["class", "ma-split-no-icon-padding", 4, "ngIf"], [1, "ma-split-no-icon-padding"], ["matSuffix", "", "mat-icon-button", "", "aria-label", "Clear", 3, "click", 4, "ngIf"], ["matSuffix", "", "mat-icon-button", "", "aria-label", "Clear", 3, "click"], [1, "flex", "flex-end", "m-t-sm"], [3, "ngClass", "click"], ["style", "padding: 5px 15px;", 4, "ngIf"], [2, "padding", "5px 15px"]], template: function SplitSelectComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, SplitSelectComponent_h2_1_Template, 2, 1, "h2", 0);
            i0.ɵɵelementStart(2, "div", 1)(3, "div", 2)(4, "h5", 3);
            i0.ɵɵtext(5);
            i0.ɵɵtemplate(6, SplitSelectComponent_span_6_Template, 5, 0, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 2)(8, "div", 5);
            i0.ɵɵtemplate(9, SplitSelectComponent_div_9_Template, 5, 6, "div", 6);
            i0.ɵɵelementStart(10, "div", 7);
            i0.ɵɵtemplate(11, SplitSelectComponent_ng_container_11_Template, 2, 1, "ng-container", 8);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(12, "div", 9)(13, "button", 10);
            i0.ɵɵlistener("click", function SplitSelectComponent_Template_button_click_13_listener() { return ctx.onAssign(); });
            i0.ɵɵelementStart(14, "mat-icon");
            i0.ɵɵtext(15, "arrow_right");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "button", 11);
            i0.ɵɵlistener("click", function SplitSelectComponent_Template_button_click_16_listener() { return ctx.onUnassign(); });
            i0.ɵɵelementStart(17, "mat-icon");
            i0.ɵɵtext(18, "arrow_left");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(19, "div", 2)(20, "h5", 3);
            i0.ɵɵtext(21);
            i0.ɵɵtemplate(22, SplitSelectComponent_span_22_Template, 4, 2, "span", 0);
            i0.ɵɵtemplate(23, SplitSelectComponent_span_23_Template, 5, 0, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(24, "div", 12)(25, "div", 13);
            i0.ɵɵtemplate(26, SplitSelectComponent_div_26_Template, 2, 1, "div", 0);
            i0.ɵɵelementStart(27, "div", 14);
            i0.ɵɵtemplate(28, SplitSelectComponent_ng_container_28_Template, 2, 1, "ng-container", 8);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(29, SplitSelectComponent_div_29_Template, 3, 3, "div", 15);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(30, SplitSelectComponent_ng_template_30_Template, 1, 2, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(32, SplitSelectComponent_ng_template_32_Template, 1, 2, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(34, SplitSelectComponent_ng_template_34_Template, 2, 1, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r9 = i0.ɵɵreference(31);
            const _r11 = i0.ɵɵreference(33);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.title);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c4$4, ctx.disabledForm));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(24, _c5$1, ctx.isCVE, !ctx.isCVE));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(27, _c6, ctx.isCVE, !ctx.isCVE));
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.availableLabel, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.availableTooltipText);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(30, _c7, !!ctx.searchChange));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !!ctx.searchChange);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.availableFormatted.length > 0)("ngIfElse", _r9);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", !ctx.hasSelectedAvailableItems);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", !ctx.hasSelectedSelectedItems);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(32, _c5$1, ctx.isCVE, !ctx.isCVE));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(35, _c6, ctx.isCVE, !ctx.isCVE));
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.selectedLabel, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showTotalSelected);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.selectedTooltipText);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.hideSearchRight);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(38, _c8, ctx.hideSearchRight));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.filteredSelected.length > 0)("ngIfElse", _r11);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.canClearSelected);
        } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i3$2.DefaultValueAccessor, i3$2.NgControlStatus, i3$2.NgModel, i4.MatLegacyButton, i2.MatIcon, i6$1.MatLegacyFormField, i6$1.MatLegacySuffix, i7.MatLegacyInput, i8.MatLegacyTooltip, OpswatTooltipDirective], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SplitSelectComponent, [{
        type: Component,
        args: [{ selector: 'app-split-select', template: "<div>\r\n  <h2 *ngIf=\"!!title\">{{ title }}</h2>\r\n  <div\r\n    class=\"flex\"\r\n    [ngClass]=\"{'ui-disabled': disabledForm}\"\r\n  >\r\n    <div [ngClass]=\"{'ma-split-select-cve': isCVE, 'w-300': !isCVE}\">\r\n      <h5\r\n        class=\"m-b-md\"\r\n        [ngClass]=\"{'m-t-md': isCVE, 'm-t-none': !isCVE}\"\r\n      >\r\n        {{ availableLabel }}\r\n        <span\r\n          appOpswatTooltip\r\n          *ngIf=\"availableTooltipText\"\r\n        >\r\n          <mat-icon class=\"info-icon\">info</mat-icon>\r\n          <ng-template #tooltipTemplate>\r\n            <div class=\"tooltip tooltip-bottom\">\r\n              <div class=tooltip-content>\r\n                {{availableTooltipText}}\r\n              </div>\r\n            </div>\r\n          </ng-template>\r\n        </span>\r\n      </h5>\r\n      <div [ngClass]=\"{'ma-split-select-list-offset': !!searchChange}\">\r\n        <div\r\n          class=\"list\"\r\n          data-cy=\"ui-split-select-list-available\"\r\n        >\r\n          <div\r\n            *ngIf=\"!!searchChange\"\r\n            class=\"ma-split-select-search-offset\"\r\n          >\r\n            <mat-form-field\r\n              appearance=\"outline\"\r\n              class=\"search ma-split-select-search\"\r\n              [ngClass]=\"{'min-w-250': !isCVE}\"\r\n            >\r\n              <input\r\n                *ngIf=\"searchCallAPILeft\"\r\n                matInput\r\n                [placeholder]=\"availablePlaceholder\"\r\n                [(ngModel)]=\"search\"\r\n                (keyup.enter)=\"onSearchChange($event)\"\r\n                [ngModelOptions]=\"{standalone: true}\"\r\n              />\r\n              <input\r\n                *ngIf=\"!searchCallAPILeft\"\r\n                matInput\r\n                [placeholder]=\"availablePlaceholder\"\r\n                [(ngModel)]=\"search\"\r\n                [ngModelOptions]=\"{standalone: true}\"\r\n              />\r\n              <span\r\n                *ngIf=\"!!search\"\r\n                matSuffix\r\n                class=\"ng-star-inserted mat-icon-button custom-clear\"\r\n                mat-icon-button\r\n                aria-label=\"Clear\"\r\n                (click)=\"onClearSearchField(searchCallAPILeft)\"\r\n              >\r\n                <mat-icon><span il8n>close</span></mat-icon>\r\n              </span>\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"list-item\">\r\n            <ng-container *ngIf=\"availableFormatted.length > 0; else checkNotFoundLeft\">\r\n              <div\r\n                *ngFor=\"let item of availableFormatted\"\r\n                (click)=\"onSelectAvailableItem(item)\"\r\n                (dblclick)=\"onSelectAvailableItem(item); onAssign()\"\r\n                [ngClass]=\"{'is-selected': isAvailableItemSelected(item)}\"\r\n                class=\"item ma-ellipsis\"\r\n                [matTooltip]=\"getValue(item)\"\r\n              >\r\n                <mat-icon *ngIf=\"!!item.icon\">{{item.icon}}</mat-icon>\r\n                <span\r\n                  class=\"ma-split-no-icon-padding\"\r\n                  *ngIf=\"!item.icon && hasIcons\"\r\n                ></span>\r\n                &nbsp;\r\n                {{ getValue(item) }}\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"flex flex-column flex-center flex-middle p-md middle m-t-lg\">\r\n      <button\r\n        mat-icon-button\r\n        class=\"is-large\"\r\n        [disabled]=\"!hasSelectedAvailableItems\"\r\n        (click)=\"onAssign()\"\r\n      >\r\n        <mat-icon>arrow_right</mat-icon>\r\n      </button>\r\n      <button\r\n        mat-icon-button\r\n        class=\"is-large m-t-md\"\r\n        [disabled]=\"!hasSelectedSelectedItems\"\r\n        (click)=\"onUnassign()\"\r\n      >\r\n        <mat-icon>arrow_left</mat-icon>\r\n      </button>\r\n    </div>\r\n    <div [ngClass]=\"{'ma-split-select-cve': isCVE, 'w-300': !isCVE}\">\r\n      <h5\r\n        class=\"m-b-md\"\r\n        [ngClass]=\"{'m-t-md': isCVE, 'm-t-none': !isCVE}\"\r\n      >\r\n        {{ selectedLabel }} <span *ngIf=\"showTotalSelected\">({{ selected.length }}<span *ngIf=\"selectedMax\">/{{ selectedMax }}</span>)</span>\r\n        <span\r\n          appOpswatTooltip\r\n          *ngIf=\"selectedTooltipText\"\r\n        >\r\n          <mat-icon class=\"info-icon\">info</mat-icon>\r\n          <ng-template #tooltipTemplate>\r\n            <div class=\"tooltip tooltip-bottom\">\r\n              <div class=tooltip-content>\r\n                {{selectedTooltipText}}\r\n              </div>\r\n            </div>\r\n          </ng-template>\r\n        </span>\r\n      </h5>\r\n      <div class=\"ma-split-select-list-offset\">\r\n        <div class=\"list\">\r\n          <div *ngIf=\"!hideSearchRight\">\r\n            <div\r\n              *ngIf=\"!!searchChange\"\r\n              class=\"ma-split-select-search-offset\"\r\n            >\r\n              <mat-form-field\r\n                appearance=\"outline\"\r\n                class=\"search ma-split-select-search\"\r\n                [ngClass]=\"{'min-w-250': !isCVE}\"\r\n              >\r\n                <input\r\n                  matInput\r\n                  [placeholder]=\"selectedPlaceholder\"\r\n                  [(ngModel)]=\"searchTermSelected\"\r\n                  [ngModelOptions]=\"{standalone: true}\"\r\n                />\r\n                <button\r\n                  *ngIf=\"!!searchTermSelected\"\r\n                  matSuffix\r\n                  mat-icon-button\r\n                  aria-label=\"Clear\"\r\n                  (click)=\"onClearSearchSelectedField()\"\r\n                >\r\n                  <mat-icon><span il8n>close</span></mat-icon>\r\n                </button>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div\r\n            class=\"list-item\"\r\n            [ngClass]=\"{'list-item-without-search': hideSearchRight}\"\r\n            data-cy=\"ui-split-select-list-selected\"\r\n          >\r\n            <ng-container *ngIf=\"filteredSelected.length > 0; else checkNotFoundRight\">\r\n              <div\r\n                *ngFor=\"let item of filteredSelected\"\r\n                (click)=\"onSelectSelectedItem(item)\"\r\n                (dblclick)=\"onSelectSelectedItem(item); onUnassign()\"\r\n                [ngClass]=\"{'is-selected': isSelectedItemSelected(item)}\"\r\n                class=\"item ma-ellipsis\"\r\n                [matTooltip]=\"getValue(item)\"\r\n              >\r\n                <mat-icon *ngIf=\"!!item.icon\">{{item.icon}}</mat-icon>\r\n                <span\r\n                  class=\"ma-split-no-icon-padding\"\r\n                  *ngIf=\"!item.icon && hasIcons\"\r\n                ></span>\r\n                &nbsp;\r\n                {{ getValue(item) }}\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div\r\n        *ngIf=\"canClearSelected\"\r\n        class=\"flex flex-end m-t-sm\"\r\n      >\r\n        <a\r\n          [ngClass]=\"{'opacity-05': !hasSelectedItems}\"\r\n          (click)=\"onClearSelected()\"\r\n        >\r\n          Clear All\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #checkNotFoundLeft>\r\n  <ng-container *ngIf=\"isCVE; else notFound\">\r\n    <div\r\n      style=\"padding: 5px 15px;\"\r\n      *ngIf=\"searchNotFoundLeft\"\r\n    >\r\n      {{dataAdded() ? errorMsg(typeSpecific) : searchNotFoundLeft}}\r\n    </div>\r\n  </ng-container>\r\n</ng-template>\r\n<ng-template #checkNotFoundRight>\r\n  <ng-container *ngIf=\"isCVE; else notFound\">\r\n    <div\r\n      style=\"padding: 5px 15px;\"\r\n      *ngIf=\"searchNotFoundRight\"\r\n    >{{searchNotFoundRight}}</div>\r\n  </ng-container>\r\n</ng-template>\r\n<ng-template #notFound>\r\n  <div style=\"padding: 5px 15px;\">{{searchNotFound}}</div>\r\n</ng-template>" }]
    }], function () { return [{ type: i1$2.MatLegacySnackBar }, { type: i0.KeyValueDiffers }]; }, { searchNotFound: [{
            type: Input
        }], searchNotFoundLeft: [{
            type: Input
        }], searchNotFoundRight: [{
            type: Input
        }], selected: [{
            type: Input
        }], hasChanges: [{
            type: Input
        }], selectedChange: [{
            type: Output
        }], hasChangesChange: [{
            type: Output
        }], searchChange: [{
            type: Input
        }], title: [{
            type: Input
        }], availableLabel: [{
            type: Input
        }], selectedLabel: [{
            type: Input
        }], availablePlaceholder: [{
            type: Input
        }], selectedPlaceholder: [{
            type: Input
        }], available: [{
            type: Input
        }], clearForm: [{
            type: Input
        }], isCVE: [{
            type: Input
        }], typeSpecific: [{
            type: Input
        }], searchValue: [{
            type: Input
        }], searchCallAPILeft: [{
            type: Input
        }], hideSearchRight: [{
            type: Input
        }], canClearSelected: [{
            type: Input
        }], showTotalSelected: [{
            type: Input
        }], disabledForm: [{
            type: Input
        }], selectedMax: [{
            type: Input
        }], availableTooltipText: [{
            type: Input
        }], selectedTooltipText: [{
            type: Input
        }], valueExtractor: [{
            type: Input
        }], idExtractor: [{
            type: Input
        }] }); })();

function SplitSelectNotificationComponent_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.title);
} }
function SplitSelectNotificationComponent_span_6_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "div", 26);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.availableTooltipText, " ");
} }
function SplitSelectNotificationComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22)(1, "mat-icon", 23);
    i0.ɵɵtext(2, "info");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SplitSelectNotificationComponent_span_6_ng_template_3_Template, 3, 1, "ng-template", null, 24, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} }
const _c0$a = function () { return { standalone: true }; };
function SplitSelectNotificationComponent_div_9_input_2_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 32);
    i0.ɵɵlistener("ngModelChange", function SplitSelectNotificationComponent_div_9_input_2_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.search = $event); })("keyup.enter", function SplitSelectNotificationComponent_div_9_input_2_Template_input_keyup_enter_0_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r22 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r22.onSearchChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("placeholder", ctx_r17.availablePlaceholder)("ngModel", ctx_r17.search)("ngModelOptions", i0.ɵɵpureFunction0(3, _c0$a));
} }
function SplitSelectNotificationComponent_div_9_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 33);
    i0.ɵɵlistener("ngModelChange", function SplitSelectNotificationComponent_div_9_input_3_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.search = $event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("placeholder", ctx_r18.availablePlaceholder)("ngModel", ctx_r18.search)("ngModelOptions", i0.ɵɵpureFunction0(3, _c0$a));
} }
function SplitSelectNotificationComponent_div_9_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵlistener("click", function SplitSelectNotificationComponent_div_9_span_4_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.onClearSearchField(ctx_r25.searchCallAPILeft)); });
    i0.ɵɵelementStart(1, "mat-icon")(2, "span", 35);
    i0.ɵɵtext(3, "close");
    i0.ɵɵelementEnd()()();
} }
function SplitSelectNotificationComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27)(1, "mat-form-field", 28);
    i0.ɵɵtemplate(2, SplitSelectNotificationComponent_div_9_input_2_Template, 1, 4, "input", 29);
    i0.ɵɵtemplate(3, SplitSelectNotificationComponent_div_9_input_3_Template, 1, 4, "input", 30);
    i0.ɵɵtemplate(4, SplitSelectNotificationComponent_div_9_span_4_Template, 4, 0, "span", 31);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.searchCallAPILeft);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.searchCallAPILeft);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!ctx_r2.search);
} }
const _c1$6 = function (a0) { return { "is-selected": a0 }; };
function SplitSelectNotificationComponent_ng_container_11_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵlistener("click", function SplitSelectNotificationComponent_ng_container_11_div_6_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r30); const item_r28 = restoredCtx.$implicit; const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29.onSelectAvailableItem(item_r28)); })("dblclick", function SplitSelectNotificationComponent_ng_container_11_div_6_Template_div_dblclick_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r30); const item_r28 = restoredCtx.$implicit; const ctx_r31 = i0.ɵɵnextContext(2); ctx_r31.onSelectAvailableItem(item_r28); return i0.ɵɵresetView(ctx_r31.onAssign()); });
    i0.ɵɵelementStart(1, "span", 41);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 42);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r28 = ctx.$implicit;
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1$6, ctx_r27.isAvailableItemSelected(item_r28)))("matTooltip", ctx_r27.getValue(item_r28));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r27.getValue(item_r28));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r27.getValueContentRight(ctx_r27.showFormat, item_r28));
} }
function SplitSelectNotificationComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 36)(2, "span", 37);
    i0.ɵɵtext(3, "Notification Group");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 38);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, SplitSelectNotificationComponent_ng_container_11_div_6_Template, 5, 6, "div", 39);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r3.showFormat ? "Format" : "Event Type");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.availableFormatted);
} }
function SplitSelectNotificationComponent_span_22_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("/", ctx_r32.selectedMax, "");
} }
function SplitSelectNotificationComponent_span_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, SplitSelectNotificationComponent_span_22_span_2_Template, 2, 1, "span", 13);
    i0.ɵɵtext(3, ")");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", ctx_r4.selected.length, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.selectedMax);
} }
function SplitSelectNotificationComponent_span_23_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "div", 26);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r34.selectedTooltipText, " ");
} }
function SplitSelectNotificationComponent_span_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22)(1, "mat-icon", 23);
    i0.ɵɵtext(2, "info");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SplitSelectNotificationComponent_span_23_ng_template_3_Template, 3, 1, "ng-template", null, 24, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} }
function SplitSelectNotificationComponent_div_26_div_1_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 44);
    i0.ɵɵlistener("click", function SplitSelectNotificationComponent_div_26_div_1_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r37.onClearSearchSelectedField()); });
    i0.ɵɵelementStart(1, "mat-icon")(2, "span", 35);
    i0.ɵɵtext(3, "close");
    i0.ɵɵelementEnd()()();
} }
function SplitSelectNotificationComponent_div_26_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "mat-form-field", 28)(2, "input", 33);
    i0.ɵɵlistener("ngModelChange", function SplitSelectNotificationComponent_div_26_div_1_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r39.searchTermSelected = $event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SplitSelectNotificationComponent_div_26_div_1_button_3_Template, 4, 0, "button", 43);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", ctx_r35.selectedPlaceholder)("ngModel", ctx_r35.searchTermSelected)("ngModelOptions", i0.ɵɵpureFunction0(4, _c0$a));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!ctx_r35.searchTermSelected);
} }
function SplitSelectNotificationComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SplitSelectNotificationComponent_div_26_div_1_Template, 4, 5, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!ctx_r6.searchChange);
} }
function SplitSelectNotificationComponent_ng_container_28_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵlistener("click", function SplitSelectNotificationComponent_ng_container_28_div_6_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r44); const item_r42 = restoredCtx.$implicit; const ctx_r43 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r43.onSelectSelectedItem(item_r42)); })("dblclick", function SplitSelectNotificationComponent_ng_container_28_div_6_Template_div_dblclick_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r44); const item_r42 = restoredCtx.$implicit; const ctx_r45 = i0.ɵɵnextContext(2); ctx_r45.onSelectSelectedItem(item_r42); return i0.ɵɵresetView(ctx_r45.onUnassign()); });
    i0.ɵɵelementStart(1, "span", 41);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 42);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r42 = ctx.$implicit;
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1$6, ctx_r41.isSelectedItemSelected(item_r42)))("matTooltip", ctx_r41.getValue(item_r42));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r41.getValue(item_r42));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r41.getValueContentRight(ctx_r41.showFormat, item_r42));
} }
function SplitSelectNotificationComponent_ng_container_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 36)(2, "span", 37);
    i0.ɵɵtext(3, "Notification Group");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 38);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, SplitSelectNotificationComponent_ng_container_28_div_6_Template, 5, 6, "div", 39);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r7.showFormat ? "Format" : "Event Type");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r7.filteredSelected);
} }
const _c2$4 = function (a0) { return { "opacity-05": a0 }; };
function SplitSelectNotificationComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45)(1, "a", 46);
    i0.ɵɵlistener("click", function SplitSelectNotificationComponent_div_29_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r47); const ctx_r46 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r46.onClearSelected()); });
    i0.ɵɵtext(2, " Clear All ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c2$4, !ctx_r8.hasSelectedItems));
} }
function SplitSelectNotificationComponent_ng_template_30_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r48.searchNotFoundLeft);
} }
function SplitSelectNotificationComponent_ng_template_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SplitSelectNotificationComponent_ng_template_30_div_0_Template, 2, 1, "div", 47);
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r10.searchNotFoundLeft);
} }
function SplitSelectNotificationComponent_ng_template_32_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r49.searchNotFoundRight);
} }
function SplitSelectNotificationComponent_ng_template_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SplitSelectNotificationComponent_ng_template_32_div_0_Template, 2, 1, "div", 47);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r12.searchNotFoundRight);
} }
function SplitSelectNotificationComponent_ng_template_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r14.searchNotFound);
} }
const _c3$4 = function (a0) { return { "ui-disabled": a0 }; };
const _c4$3 = function (a0) { return { "ma-split-select-list-offset": a0 }; };
const _c5 = function (a0) { return { "list-item-without-search": a0 }; };
class SplitSelectNotificationComponent {
    get selected() {
        if (this.selectedSelection instanceof SelectionModel) {
            return this.selectedSelection.selected;
        }
        return [];
    }
    get hasChanges() {
        return this.hasChangesValue;
    }
    set selected(val) {
        if (this.selectedSelection instanceof SelectionModel &&
            Array.isArray(val)) {
            this.selectedSelection.select(...val);
            // Don't emit when setting the value for the first time
            if (this.initSelected) {
                this.initSelected = false;
            }
            else {
                this.selectedChange.emit(this.selectedSelection.selected);
            }
        }
        const selectedIdsString = this.selected
            .map(this.idExtractor)
            .sort(this.sortAlphabetically)
            .join();
        const originalIdsString = this.originalIds
            .sort(this.sortAlphabetically)
            .join();
        this.hasChanges = selectedIdsString !== originalIdsString;
    }
    set hasChanges(val) {
        this.hasChangesValue = val;
        this.hasChangesChange.emit(val);
    }
    get availableFormatted() {
        if (this.searchCallAPILeft) {
            if (!Array.isArray(this.available)) {
                return [];
            }
            return this.available.filter(item => {
                if (this.selectedSelection instanceof SelectionModel &&
                    this.contains(this.selectedSelection.selected, item)) {
                    return false;
                }
                return true;
            });
        }
        else {
            if (Array.isArray(this.available)) {
                return this.available.filter(item => {
                    const value = this.valueExtractor(item);
                    const term = typeof this.search === 'string' ? this.search.toLowerCase() : '';
                    if (typeof value === 'string') {
                        if (this.selectedSelection instanceof SelectionModel &&
                            this.contains(this.selectedSelection.selected, item)) {
                            return false;
                        }
                        return value.toLowerCase().includes(term);
                    }
                    else {
                        return false;
                    }
                });
            }
            return [];
        }
    }
    constructor(snackBar, differs) {
        this.snackBar = snackBar;
        this.differs = differs;
        this.searchNotFound = null;
        this.searchNotFoundLeft = null;
        this.searchNotFoundRight = null;
        this.search = '';
        this.searchTermSelected = '';
        this.selectedHighlightedSelection = null;
        this.availableHighlightedSelection = null;
        this.selectedSelection = null;
        this.hasChangesValue = false;
        this.originalIds = [];
        this.initSelected = true;
        this.selectedChange = new EventEmitter();
        this.hasChangesChange = new EventEmitter();
        this.availableLabel = 'Available';
        this.selectedLabel = 'Selected';
        this.availablePlaceholder = 'Search';
        this.selectedPlaceholder = 'Search';
        this.available = [];
        this.clearForm = false;
        this.searchValue = false;
        this.searchCallAPILeft = true;
        this.hideSearchRight = false;
        this.canClearSelected = true;
        this.showTotalSelected = true;
        this.disabledForm = false;
        this.availableTooltipText = null;
        this.selectedTooltipText = null;
        this.showFormat = null;
        this.valueExtractor = item => item;
        this.idExtractor = item => item;
        this.selectedHighlightedSelection = new SelectionModel(true);
        this.availableHighlightedSelection = new SelectionModel(true);
        this.selectedSelection = new SelectionModel(true);
        this.differ = this.differs.find(this.available).create();
    }
    get filteredSelected() {
        if (Array.isArray(this.selected)) {
            return this.selected
                .filter(item => {
                const value = this.valueExtractor(item);
                const term = typeof this.searchTermSelected === 'string' ?
                    this.searchTermSelected.toLowerCase() : '';
                return (typeof value === 'string' ?
                    value.toLowerCase().includes(term) :
                    false);
            });
        }
        return [];
    }
    get hasSelectedAvailableItems() {
        return (this.availableHighlightedSelection instanceof SelectionModel &&
            !!this.availableHighlightedSelection.selected.length);
    }
    get hasSelectedSelectedItems() {
        return (this.selectedHighlightedSelection instanceof SelectionModel &&
            !!this.selectedHighlightedSelection.selected.length);
    }
    get hasSelectedItems() {
        return (this.selectedSelection instanceof SelectionModel &&
            !!this.selectedSelection.selected.length);
    }
    ngOnInit() {
        // TODO figure out how to not use settimeout
        setTimeout(() => {
            this.originalIds = this.selected.map(this.idExtractor);
        });
    }
    ngDoCheck() {
        const change = this.differ.diff(this.available);
        if (!!change && sessionStorage.getItem('deviceSubmited')) {
            this.selected = [...this.available];
            sessionStorage.removeItem('deviceSubmited');
        }
    }
    ngOnChanges(changes) {
        if (changes) {
            if (this.clearForm) {
                this.clearAll();
            }
        }
    }
    onSelectAvailableItem(item) {
        if (this.availableHighlightedSelection instanceof SelectionModel) {
            this.availableHighlightedSelection.toggle(item);
        }
    }
    onSelectSelectedItem(item) {
        if (this.selectedHighlightedSelection instanceof SelectionModel) {
            this.selectedHighlightedSelection.toggle(item);
        }
    }
    isAvailableItemSelected(item) {
        if (this.availableHighlightedSelection instanceof SelectionModel) {
            return this.availableHighlightedSelection.isSelected(item);
        }
        return false;
    }
    isSelectedItemSelected(item) {
        if (this.selectedHighlightedSelection instanceof SelectionModel) {
            return this.selectedHighlightedSelection.isSelected(item);
        }
        return false;
    }
    onAssign() {
        if (this.availableHighlightedSelection instanceof SelectionModel &&
            this.selectedSelection instanceof SelectionModel) {
            if (typeof this.selectedMax === 'number') {
                const countAfterAssign = (this.availableHighlightedSelection.selected.length +
                    this.selectedSelection.selected.length);
                if (countAfterAssign > this.selectedMax) {
                    this.snackBar.open(`Maximum number of selected items is ${this.selectedMax}`, null, { panelClass: 'error' });
                    return;
                }
            }
            this.selected = this.availableHighlightedSelection.selected;
            this.availableHighlightedSelection.clear();
        }
    }
    onUnassign() {
        if (this.selectedHighlightedSelection instanceof SelectionModel &&
            this.selectedSelection instanceof SelectionModel) {
            this.selectedSelection.deselect(...this.selectedHighlightedSelection.selected);
            this.selected = this.selectedSelection.selected;
            this.selectedHighlightedSelection.clear();
        }
    }
    getValue(item) {
        const value = this.valueExtractor(item);
        return ['string', 'number', 'boolean'].includes(typeof value) ?
            value : '-';
    }
    getValueContentRight(showFormat, value) {
        if (showFormat) {
            return `${value.emailFormat === 0 ? 'HTML' : 'JSON'}`;
        }
        else {
            return `${value.eventType}`;
        }
    }
    sortAlphabetically(a, b) {
        if (a > b) {
            return -1;
        }
        if (b > a) {
            return 1;
        }
        return 0;
    }
    onSearchChange(event) {
        event.preventDefault();
        this.searchChange(this.search);
    }
    onClearSearchField(isCallAPI) {
        this.search = '';
        if (isCallAPI) {
            this.searchChange(this.search);
        }
    }
    onClearSearchSelectedField() {
        this.searchTermSelected = '';
    }
    onClearSelected() {
        if (this.canClearSelected &&
            this.selectedHighlightedSelection instanceof SelectionModel &&
            this.selectedSelection instanceof SelectionModel &&
            this.selectedSelection.selected.length) {
            this.selectedHighlightedSelection.select(...this.selectedSelection.selected);
            this.onUnassign();
        }
    }
    contains(list, obj) {
        return list.some(elem => JSON.stringify(obj.id) === JSON.stringify(elem.id));
    }
    dataAdded() {
        return this.availableFormatted.length === 0 && this.searchValue;
    }
    clearAll() {
        this.onClearSearchField(this.searchCallAPILeft);
        this.onClearSearchSelectedField();
        this.onClearSelected();
    }
    static { this.ɵfac = function SplitSelectNotificationComponent_Factory(t) { return new (t || SplitSelectNotificationComponent)(i0.ɵɵdirectiveInject(i1$2.MatLegacySnackBar), i0.ɵɵdirectiveInject(i0.KeyValueDiffers)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SplitSelectNotificationComponent, selectors: [["app-split-select-notification"]], inputs: { searchNotFound: "searchNotFound", searchNotFoundLeft: "searchNotFoundLeft", searchNotFoundRight: "searchNotFoundRight", selected: "selected", hasChanges: "hasChanges", searchChange: "searchChange", title: "title", availableLabel: "availableLabel", selectedLabel: "selectedLabel", availablePlaceholder: "availablePlaceholder", selectedPlaceholder: "selectedPlaceholder", available: "available", clearForm: "clearForm", searchValue: "searchValue", searchCallAPILeft: "searchCallAPILeft", hideSearchRight: "hideSearchRight", canClearSelected: "canClearSelected", showTotalSelected: "showTotalSelected", disabledForm: "disabledForm", selectedMax: "selectedMax", availableTooltipText: "availableTooltipText", selectedTooltipText: "selectedTooltipText", showFormat: "showFormat", valueExtractor: "valueExtractor", idExtractor: "idExtractor" }, outputs: { selectedChange: "selectedChange", hasChangesChange: "hasChangesChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 36, vars: 24, consts: [["class", "main-title", 4, "ngIf"], [1, "flex", 3, "ngClass"], [1, "w-300"], [1, "m-b-md", "m-t-none", "split-title"], ["appOpswatTooltip", "", 4, "ngIf"], [3, "ngClass"], ["data-cy", "ui-split-select-list-available", 1, "list"], ["class", "ma-split-select-search-offset", 4, "ngIf"], [1, "list-item"], [4, "ngIf", "ngIfElse"], [1, "groups-actions", "flex", "flex-column", "flex-center", "flex-middle", "p-md", "middle", "m-t-lg"], ["mat-icon-button", "", 1, "is-large", 3, "disabled", "click"], ["mat-icon-button", "", 1, "is-large", "m-t-md", 3, "disabled", "click"], [4, "ngIf"], [1, "ma-split-select-list-offset"], [1, "list"], ["data-cy", "ui-split-select-list-selected", 1, "list-item", 3, "ngClass"], ["class", "flex flex-end m-t-sm", 4, "ngIf"], ["checkNotFoundLeft", ""], ["checkNotFoundRight", ""], ["notFound", ""], [1, "main-title"], ["appOpswatTooltip", ""], [1, "info-icon"], ["tooltipTemplate", ""], [1, "tooltip", "tooltip-bottom"], [1, "tooltip-content"], [1, "ma-split-select-search-offset"], ["appearance", "outline", 1, "search", "ma-split-select-search", "min-w-250"], ["matInput", "", 3, "placeholder", "ngModel", "ngModelOptions", "ngModelChange", "keyup.enter", 4, "ngIf"], ["matInput", "", 3, "placeholder", "ngModel", "ngModelOptions", "ngModelChange", 4, "ngIf"], ["matSuffix", "", "class", "ng-star-inserted mat-icon-button custom-clear", "mat-icon-button", "", "aria-label", "Clear", 3, "click", 4, "ngIf"], ["matInput", "", 3, "placeholder", "ngModel", "ngModelOptions", "ngModelChange", "keyup.enter"], ["matInput", "", 3, "placeholder", "ngModel", "ngModelOptions", "ngModelChange"], ["matSuffix", "", "mat-icon-button", "", "aria-label", "Clear", 1, "ng-star-inserted", "mat-icon-button", "custom-clear", 3, "click"], ["il8n", ""], [1, "flex", "m-b-xs", "content-title"], [1, "content-left"], [1, "content-right", "p-l-md"], ["class", "item ma-ellipsis flex", 3, "ngClass", "matTooltip", "click", "dblclick", 4, "ngFor", "ngForOf"], [1, "item", "ma-ellipsis", "flex", 3, "ngClass", "matTooltip", "click", "dblclick"], [1, "content-left", "ma-ellipsis"], [1, "capitalize", "content-right", "p-l-md"], ["matSuffix", "", "mat-icon-button", "", "aria-label", "Clear", 3, "click", 4, "ngIf"], ["matSuffix", "", "mat-icon-button", "", "aria-label", "Clear", 3, "click"], [1, "flex", "flex-end", "m-t-sm"], [3, "ngClass", "click"], ["class", "error-msg", 4, "ngIf"], [1, "error-msg"]], template: function SplitSelectNotificationComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, SplitSelectNotificationComponent_h2_1_Template, 2, 1, "h2", 0);
            i0.ɵɵelementStart(2, "div", 1)(3, "div", 2)(4, "div", 3);
            i0.ɵɵtext(5);
            i0.ɵɵtemplate(6, SplitSelectNotificationComponent_span_6_Template, 5, 0, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 5)(8, "div", 6);
            i0.ɵɵtemplate(9, SplitSelectNotificationComponent_div_9_Template, 5, 3, "div", 7);
            i0.ɵɵelementStart(10, "div", 8);
            i0.ɵɵtemplate(11, SplitSelectNotificationComponent_ng_container_11_Template, 7, 2, "ng-container", 9);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(12, "div", 10)(13, "button", 11);
            i0.ɵɵlistener("click", function SplitSelectNotificationComponent_Template_button_click_13_listener() { return ctx.onAssign(); });
            i0.ɵɵelementStart(14, "mat-icon");
            i0.ɵɵtext(15, "arrow_right");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "button", 12);
            i0.ɵɵlistener("click", function SplitSelectNotificationComponent_Template_button_click_16_listener() { return ctx.onUnassign(); });
            i0.ɵɵelementStart(17, "mat-icon");
            i0.ɵɵtext(18, "arrow_left");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(19, "div", 2)(20, "div", 3);
            i0.ɵɵtext(21);
            i0.ɵɵtemplate(22, SplitSelectNotificationComponent_span_22_Template, 4, 2, "span", 13);
            i0.ɵɵtemplate(23, SplitSelectNotificationComponent_span_23_Template, 5, 0, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(24, "div", 14)(25, "div", 15);
            i0.ɵɵtemplate(26, SplitSelectNotificationComponent_div_26_Template, 2, 1, "div", 13);
            i0.ɵɵelementStart(27, "div", 16);
            i0.ɵɵtemplate(28, SplitSelectNotificationComponent_ng_container_28_Template, 7, 2, "ng-container", 9);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(29, SplitSelectNotificationComponent_div_29_Template, 3, 3, "div", 17);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(30, SplitSelectNotificationComponent_ng_template_30_Template, 1, 1, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(32, SplitSelectNotificationComponent_ng_template_32_Template, 1, 1, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(34, SplitSelectNotificationComponent_ng_template_34_Template, 2, 1, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r9 = i0.ɵɵreference(31);
            const _r11 = i0.ɵɵreference(33);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.title);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c3$4, ctx.disabledForm));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.availableLabel, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.availableTooltipText);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c4$3, !!ctx.searchChange));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !!ctx.searchChange);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.availableFormatted.length > 0)("ngIfElse", _r9);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", !ctx.hasSelectedAvailableItems);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", !ctx.hasSelectedSelectedItems);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.selectedLabel, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showTotalSelected);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.selectedTooltipText);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.hideSearchRight);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c5, ctx.hideSearchRight));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.filteredSelected.length > 0)("ngIfElse", _r11);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.canClearSelected);
        } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i3$2.DefaultValueAccessor, i3$2.NgControlStatus, i3$2.NgModel, i4.MatLegacyButton, i2.MatIcon, i6$1.MatLegacyFormField, i6$1.MatLegacySuffix, i7.MatLegacyInput, i8.MatLegacyTooltip, OpswatTooltipDirective], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SplitSelectNotificationComponent, [{
        type: Component,
        args: [{ selector: 'app-split-select-notification', template: "<div>\r\n  <h2 class=\"main-title\" *ngIf=\"!!title\">{{ title }}</h2>\r\n  <div\r\n    class=\"flex\"\r\n    [ngClass]=\"{'ui-disabled': disabledForm}\"\r\n  >\r\n    <div class=\"w-300\">\r\n      <div\r\n        class=\"m-b-md m-t-none split-title\"\r\n      >\r\n        {{ availableLabel }}\r\n        <span\r\n          appOpswatTooltip\r\n          *ngIf=\"availableTooltipText\"\r\n        >\r\n          <mat-icon class=\"info-icon\">info</mat-icon>\r\n          <ng-template #tooltipTemplate>\r\n            <div class=\"tooltip tooltip-bottom\">\r\n              <div class=tooltip-content>\r\n                {{availableTooltipText}}\r\n              </div>\r\n            </div>\r\n          </ng-template>\r\n        </span>\r\n      </div>\r\n      <div [ngClass]=\"{'ma-split-select-list-offset': !!searchChange}\">\r\n        <div\r\n          class=\"list\"\r\n          data-cy=\"ui-split-select-list-available\"\r\n        >\r\n          <div\r\n            *ngIf=\"!!searchChange\"\r\n            class=\"ma-split-select-search-offset\"\r\n          >\r\n            <mat-form-field\r\n              appearance=\"outline\"\r\n              class=\"search ma-split-select-search min-w-250\"\r\n            >\r\n              <input\r\n                *ngIf=\"searchCallAPILeft\"\r\n                matInput\r\n                [placeholder]=\"availablePlaceholder\"\r\n                [(ngModel)]=\"search\"\r\n                (keyup.enter)=\"onSearchChange($event)\"\r\n                [ngModelOptions]=\"{standalone: true}\"\r\n              />\r\n              <input\r\n                *ngIf=\"!searchCallAPILeft\"\r\n                matInput\r\n                [placeholder]=\"availablePlaceholder\"\r\n                [(ngModel)]=\"search\"\r\n                [ngModelOptions]=\"{standalone: true}\"\r\n              />\r\n              <span\r\n                *ngIf=\"!!search\"\r\n                matSuffix\r\n                class=\"ng-star-inserted mat-icon-button custom-clear\"\r\n                mat-icon-button\r\n                aria-label=\"Clear\"\r\n                (click)=\"onClearSearchField(searchCallAPILeft)\"\r\n              >\r\n                <mat-icon><span il8n>close</span></mat-icon>\r\n              </span>\r\n            </mat-form-field>\r\n          </div>\r\n          <div class=\"list-item\">\r\n            <ng-container *ngIf=\"availableFormatted.length > 0; else checkNotFoundLeft\">\r\n              <div class=\"flex m-b-xs content-title\">\r\n                <span class=\"content-left\">Notification Group</span>\r\n                <span class=\"content-right p-l-md\">{{showFormat ? 'Format' : 'Event Type'}}</span>\r\n              </div>\r\n              <div\r\n                *ngFor=\"let item of availableFormatted\"\r\n                (click)=\"onSelectAvailableItem(item)\"\r\n                (dblclick)=\"onSelectAvailableItem(item); onAssign()\"\r\n                [ngClass]=\"{'is-selected': isAvailableItemSelected(item)}\"\r\n                class=\"item ma-ellipsis flex\"\r\n                [matTooltip]=\"getValue(item)\"\r\n              >\r\n                <span class=\"content-left ma-ellipsis\">{{ getValue(item) }}</span>\r\n                <span class=\"capitalize content-right p-l-md\">{{ getValueContentRight(showFormat, item) }}</span>\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"groups-actions flex flex-column flex-center flex-middle p-md middle m-t-lg\">\r\n      <button\r\n        mat-icon-button\r\n        class=\"is-large\"\r\n        [disabled]=\"!hasSelectedAvailableItems\"\r\n        (click)=\"onAssign()\"\r\n      >\r\n        <mat-icon>arrow_right</mat-icon>\r\n      </button>\r\n      <button\r\n        mat-icon-button\r\n        class=\"is-large m-t-md\"\r\n        [disabled]=\"!hasSelectedSelectedItems\"\r\n        (click)=\"onUnassign()\"\r\n      >\r\n        <mat-icon>arrow_left</mat-icon>\r\n      </button>\r\n    </div>\r\n    <div class=\"w-300\">\r\n      <div\r\n        class=\"m-b-md m-t-none split-title\"\r\n      >\r\n        {{ selectedLabel }} <span *ngIf=\"showTotalSelected\">({{ selected.length }}<span *ngIf=\"selectedMax\">/{{ selectedMax }}</span>)</span>\r\n        <span\r\n          appOpswatTooltip\r\n          *ngIf=\"selectedTooltipText\"\r\n        >\r\n          <mat-icon class=\"info-icon\">info</mat-icon>\r\n          <ng-template #tooltipTemplate>\r\n            <div class=\"tooltip tooltip-bottom\">\r\n              <div class=tooltip-content>\r\n                {{selectedTooltipText}}\r\n              </div>\r\n            </div>\r\n          </ng-template>\r\n        </span>\r\n      </div>\r\n      <div class=\"ma-split-select-list-offset\">\r\n        <div class=\"list\">\r\n          <div *ngIf=\"!hideSearchRight\">\r\n            <div\r\n              *ngIf=\"!!searchChange\"\r\n              class=\"ma-split-select-search-offset\"\r\n            >\r\n              <mat-form-field\r\n                appearance=\"outline\"\r\n                class=\"search ma-split-select-search min-w-250\"\r\n              >\r\n                <input\r\n                  matInput\r\n                  [placeholder]=\"selectedPlaceholder\"\r\n                  [(ngModel)]=\"searchTermSelected\"\r\n                  [ngModelOptions]=\"{standalone: true}\"\r\n                />\r\n                <button\r\n                  *ngIf=\"!!searchTermSelected\"\r\n                  matSuffix\r\n                  mat-icon-button\r\n                  aria-label=\"Clear\"\r\n                  (click)=\"onClearSearchSelectedField()\"\r\n                >\r\n                  <mat-icon><span il8n>close</span></mat-icon>\r\n                </button>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <div\r\n            class=\"list-item\"\r\n            [ngClass]=\"{'list-item-without-search': hideSearchRight}\"\r\n            data-cy=\"ui-split-select-list-selected\"\r\n          >\r\n            <ng-container *ngIf=\"filteredSelected.length > 0; else checkNotFoundRight\">\r\n              <div class=\"flex m-b-xs content-title\">\r\n                <span class=\"content-left\">Notification Group</span>\r\n                <span class=\"content-right p-l-md\">{{showFormat ? 'Format' : 'Event Type'}}</span>\r\n              </div>\r\n              <div\r\n                *ngFor=\"let item of filteredSelected\"\r\n                (click)=\"onSelectSelectedItem(item)\"\r\n                (dblclick)=\"onSelectSelectedItem(item); onUnassign()\"\r\n                [ngClass]=\"{'is-selected': isSelectedItemSelected(item)}\"\r\n                class=\"item ma-ellipsis flex\"\r\n                [matTooltip]=\"getValue(item)\"\r\n              >\r\n                <span class=\"content-left ma-ellipsis\">{{ getValue(item) }}</span>\r\n                <span class=\"capitalize content-right p-l-md\">{{ getValueContentRight(showFormat, item) }}</span>\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div\r\n        *ngIf=\"canClearSelected\"\r\n        class=\"flex flex-end m-t-sm\"\r\n      >\r\n        <a\r\n          [ngClass]=\"{'opacity-05': !hasSelectedItems}\"\r\n          (click)=\"onClearSelected()\"\r\n        >\r\n          Clear All\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #checkNotFoundLeft>\r\n  <div class=\"error-msg\" *ngIf=\"searchNotFoundLeft\">{{searchNotFoundLeft}}</div>\r\n</ng-template>\r\n<ng-template #checkNotFoundRight>\r\n  <div class=\"error-msg\" *ngIf=\"searchNotFoundRight\">{{searchNotFoundRight}}</div>\r\n</ng-template>\r\n<ng-template #notFound>\r\n  <div class=\"error-msg\">{{searchNotFound}}</div>\r\n</ng-template>" }]
    }], function () { return [{ type: i1$2.MatLegacySnackBar }, { type: i0.KeyValueDiffers }]; }, { searchNotFound: [{
            type: Input
        }], searchNotFoundLeft: [{
            type: Input
        }], searchNotFoundRight: [{
            type: Input
        }], selected: [{
            type: Input
        }], hasChanges: [{
            type: Input
        }], selectedChange: [{
            type: Output
        }], hasChangesChange: [{
            type: Output
        }], searchChange: [{
            type: Input
        }], title: [{
            type: Input
        }], availableLabel: [{
            type: Input
        }], selectedLabel: [{
            type: Input
        }], availablePlaceholder: [{
            type: Input
        }], selectedPlaceholder: [{
            type: Input
        }], available: [{
            type: Input
        }], clearForm: [{
            type: Input
        }], searchValue: [{
            type: Input
        }], searchCallAPILeft: [{
            type: Input
        }], hideSearchRight: [{
            type: Input
        }], canClearSelected: [{
            type: Input
        }], showTotalSelected: [{
            type: Input
        }], disabledForm: [{
            type: Input
        }], selectedMax: [{
            type: Input
        }], availableTooltipText: [{
            type: Input
        }], selectedTooltipText: [{
            type: Input
        }], showFormat: [{
            type: Input
        }], valueExtractor: [{
            type: Input
        }], idExtractor: [{
            type: Input
        }] }); })();

class BarChartService {
    constructor() { }
    /**
     * mapping colors from ColorMap to labels from array of Bar
     *
     * @param data api data
     * @param subgroups all unique subgroup labels
     * @param colors color objects to be mapped to subgroups
     */
    colorMap(data, subgroups, colors) {
        const colorMap = [];
        const mapping = [];
        data.forEach((m) => {
            if (m.label.trim().length > 0) {
                m.values.forEach((v) => {
                    const row = { label: v.label, color: colors.find((r) => r.type === v.type).color };
                    if (mapping.findIndex((a) => a.label === row.label) === -1) {
                        mapping.push(row);
                    }
                });
            }
        });
        subgroups.forEach(s => {
            const row = mapping.find((d) => d.label === s);
            colorMap.push(row.color);
        });
        return colorMap;
    }
    /**
     * summming up the values of all numbers of an object
     *
     * @param obj flattened bar to sum numbers from
     */
    stackSum(obj) {
        let sum = 0;
        for (const el in obj) {
            if (obj.hasOwnProperty(el) && typeof obj[el] === 'number') {
                sum += obj[el];
            }
        }
        return sum;
    }
    /**
     * flattening data for use with stacked bar chart
     *
     * @param data api data
     */
    processData(data) {
        const output = {
            data: [],
            subgroups: []
        };
        data.forEach((d) => {
            const row = { group: d.label };
            d.values.forEach(e => {
                const key = e.label;
                row[key] = e.value;
                if (typeof e.value === 'number' && !output.subgroups.includes(key) && key.length > 0) {
                    output.subgroups.push(key);
                }
            });
            output.data.push(row);
        });
        return output;
    }
    /**
     * padding chart with empty bars max length is 10
     *
     * @param data  api data to be used to populate chart
     */
    fillToTenEntries(data) {
        const needed = 10 - data.length;
        const front = Math.floor(needed / 2);
        const end = Math.ceil(needed / 2);
        const char = ' ';
        for (let i = 0; i < front; i++) {
            data.unshift({
                label: char.repeat(i), values: [
                    { label: '', value: 0, type: '' }
                ]
            });
        }
        for (let i = 0; i < end; i++) {
            data.push({
                label: char.repeat(i + front), values: [
                    { label: '', value: 0, type: '' }
                ]
            });
        }
        return data;
    }
    /**
     * Sorts entries by number of sessions
     */
    sortEntries(data, order) {
        data = data
            .sort((a, b) => {
            const reducer = (sum, bar) => sum + (typeof bar.value === 'number' ? bar.value : 0);
            const sumA = Array.isArray(a.values) ? a.values.reduce(reducer, 0) : 0;
            const sumB = Array.isArray(b.values) ? b.values.reduce(reducer, 0) : 0;
            return sumB - sumA;
        });
        if (Array.isArray(order)) {
            data.forEach(item => {
                item.values.sort((a, b) => order.indexOf(b.label) - order.indexOf(a.label));
            });
        }
        return data;
    }
    /**
     * Get display value for tooltips
     *
     * @param d [35,70,data: {group: "Okta", Allowed sessions: 35, Blocked sessions: 35, Third sessions: 35 }]
     */
    tooltipText(d) {
        const selectedBarRect = this.selectedBarRect(d);
        return selectedBarRect ? `${selectedBarRect.label}: ${selectedBarRect.value}` : 'N/A';
    }
    /**
     * margin around the x y axis, allows labels to be displayed in the svg
     */
    getMargins() {
        return {
            top: 10,
            right: 0,
            bottom: 100,
            left: 20
        };
    }
    /**
     * Based on the event object returned, we get the correct flattened data to work with
     *
     * @param d [35,70,data: {group: "Okta", Allowed sessions: 35, Blocked sessions: 35, Third sessions: 35 }]
     */
    selectedBarRect(d) {
        let counter = 0;
        const keys = Object.keys(d.data);
        // all but the first key are values from non flattened data
        // eslint-disable-next-line
        for (let i = 0; i < keys.length; i++) {
            // Only act on keys where their values are numbers,
            // the first key should be the only one not a number
            if (typeof d.data[keys[i]] === 'number') {
                // If the sequence (d[0],d[1]) matches the counts location then we have the right key
                if (counter === d[0] && d[1] === (d.data[keys[i]] + counter)) {
                    // flatten data is values turned into keys which might have had a space in the key
                    // cast to 'any' is because the index of the element is a literal and not a number
                    const row = d['data'];
                    return { group: row.group, label: keys[i], value: d[1] - d[0] };
                }
                else {
                    // up the counter to the next rect start point(Stacked)
                    counter += d.data[keys[i]];
                }
            }
        }
        return undefined;
    }
    static { this.ɵfac = function BarChartService_Factory(t) { return new (t || BarChartService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BarChartService, factory: BarChartService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BarChartService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0$9 = ["barChart"];
class BarChartComponent {
    onResize(_) {
        if (!!this.svg) {
            this.svg.remove();
        }
        this.createChart();
    }
    constructor(service, uiService) {
        this.service = service;
        this.uiService = uiService;
        this.DEFAULT_HEIGHT = 280;
        this.X_AXIS_TRIM = 12;
        this.X_AXIS_TOP = 40;
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (!this.chartElement) {
            return;
        }
        if (!!changes &&
            !!changes.args) {
            const previousValue = JSON.stringify(changes.args.previousValue);
            const currentValue = JSON.stringify(changes.args.currentValue);
            if (previousValue !== currentValue) {
                this.args = changes.args.currentValue;
                this.createChart();
            }
        }
    }
    createChart() {
        try {
            const sortedData = this.service
                .sortEntries(this.args.data, this.args.barOrder)
                .slice(0, this.args.maxNrBars || this.args.data.length);
            const filledData = this.service.fillToTenEntries(sortedData);
            const svgData = this.service.processData(filledData);
            const element = this.chartElement.nativeElement;
            const containerHeight = !!this.args.height ? this.args.height : this.DEFAULT_HEIGHT;
            this.svg = this.getSvg(element, containerHeight);
            const margin = this.service.getMargins();
            const width = +this.svg.attr('width') - margin.left - margin.right;
            const height = +this.svg.attr('height') - margin.top - margin.bottom;
            const g = this.svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
            const tooltip = d3.select(element).append('div').attr('class', 'bar-toolTip mat-tooltip');
            const x = this.scaleX(width);
            const y = this.scaleY(height);
            this.domainXY(x, y, svgData.data);
            this.gridlinesY(g, y, width);
            this.axisX(g, x, height, tooltip, element);
            this.axisY(g, y);
            this.bar(g, x, y, svgData, tooltip, element, filledData, width, margin);
        }
        catch (e) {
            this.args.noDataMessage = 'There is an issue processing this Chart. Try again later.';
        }
    }
    domainXY(x, y, data) {
        x.domain(data.map((d) => d.group));
        y.domain([0, d3.max(data, (d) => {
                const sum = this.service.stackSum(d);
                return Number(sum);
            })]);
    }
    axisX(g, x, height, tooltip, element) {
        g.append('g')
            .attr('class', 'bar-axis bar-axis--x')
            .attr('transform', 'translate(0,' + height + ')')
            .call(d3.axisBottom(x))
            .selectAll('text')
            .style('text-anchor', 'end')
            .text(label => this.uiService.trim(label, this.X_AXIS_TRIM))
            .attr('dx', '-.2em')
            .attr('dy', '.2em')
            .attr('transform', 'rotate(-50)')
            .on('click', (c) => {
            if (!!this.args.xLabelClickCallback) {
                this.args.xLabelClickCallback(c);
            }
        })
            .on('mouseover', (text) => {
            if (text.length > this.X_AXIS_TRIM) {
                tooltip
                    .style('display', 'block')
                    .style('width', '170px')
                    .style('opacity', 1)
                    .text(text);
            }
        })
            .on('mouseout', (text) => {
            tooltip.style('opacity', 0);
        })
            .on('mousemove', (text) => {
            const viewTopDistance = element.getBoundingClientRect().y;
            const viewLeftDistance = element.getBoundingClientRect().x;
            tooltip
                .style('left', d3.event.pageX - viewLeftDistance + 'px')
                .style('top', d3.event.pageY - viewTopDistance - this.X_AXIS_TOP + 'px');
        });
    }
    axisY(g, y) {
        const yAxisTicks = y
            .ticks()
            .filter(tick => Number.isInteger(tick));
        g.append('g')
            .attr('class', 'bar-axis bar-axis--y')
            .call(d3.axisLeft(y)
            .tickSize(20)
            .tickValues(yAxisTicks)
            .tickFormat(d3.format('d')))
            .selectAll('text')
            .attr('transform', 'translate(17,-6)');
    }
    bar(g, x, y, svgData, tooltip, element, filledData, width, margin) {
        const viewLeftDistance = element.getBoundingClientRect().x;
        const color = d3
            .scaleOrdinal()
            .domain(svgData.subgroups)
            .range(this.service.colorMap(filledData, svgData.subgroups, this.args.colors)); // TODO can this be done with class(css)
        const stackedData = d3
            .stack()
            .keys(svgData.subgroups)(svgData.data);
        g.append('g')
            .attr('class', 'bar')
            .classed('is-clickable', !!this.args.barClickCallback)
            .selectAll('g')
            // Enter in the stack data = loop key per key = group per group
            .data(stackedData)
            .enter()
            .append('g')
            .attr('fill', d => color(d.key))
            .selectAll('rect')
            // enter a second time = loop subgroup per subgroup to add all rectangles
            .data(d => d)
            .enter()
            .append('rect')
            .attr('x', d => x(d.data.group))
            .attr('y', d => y(d[1]))
            .attr('height', d => {
            if (!isNaN(d[1])) {
                return y(d[0]) - y(d[1]);
            }
            else {
                return 0;
            }
        })
            .attr('width', x.bandwidth())
            .on('click', (c) => {
            if (!!this.args.barClickCallback) {
                this.args.barClickCallback(this.service.selectedBarRect(c));
            }
        })
            .on('mouseover', (d) => {
            if (this.args.isHoverable) {
                tooltip.style('opacity', 1).text(`${this.service.tooltipText(d)}`);
            }
        })
            .on('mouseout', (d) => {
            if (this.args.isHoverable) {
                tooltip.style('opacity', 0);
            }
        })
            .on('mousemove', (d) => {
            if (this.args.isHoverable) {
                const distanceFromEdgeOfCanvas = (d3.event.pageX - Math.ceil(viewLeftDistance)) * 2;
                const halfwayOfCanvas = width + margin.left + margin.right + 20;
                const showOnLeft = halfwayOfCanvas > distanceFromEdgeOfCanvas;
                // tooltip should be on right for first 5 entries and on the left for last 5 entries
                const offset = showOnLeft ? 30 : -168;
                const top = d3.event.pageY - element.getBoundingClientRect().y + element.offsetTop - 20;
                tooltip
                    .style('left', d3.event.pageX - viewLeftDistance + offset + 'px')
                    .style('top', top + 'px')
                    .style('display', 'block')
                    .style('width', '170px');
            }
        });
    }
    gridlinesY(g, y, width) {
        g.append('g')
            .attr('class', 'axis-grid')
            .call(d3.axisLeft(y)
            .ticks(5)
            .tickSize(-width));
    }
    scaleX(width) {
        return d3.scaleBand()
            .rangeRound([0, width])
            .padding(0.4);
    }
    scaleY(height) {
        return d3.scaleLinear()
            .rangeRound([height, 0]);
    }
    getSvg(element, height) {
        const parent = d3.select(element);
        parent.select('svg').remove();
        return parent.append('svg')
            .attr('width', element.offsetWidth)
            .attr('height', height)
            .attr('class', 'bar-chart');
    }
    static { this.ɵfac = function BarChartComponent_Factory(t) { return new (t || BarChartComponent)(i0.ɵɵdirectiveInject(BarChartService), i0.ɵɵdirectiveInject(UiService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BarChartComponent, selectors: [["app-bar-chart"]], viewQuery: function BarChartComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$9, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartElement = _t.first);
        } }, hostBindings: function BarChartComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("resize", function BarChartComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
        } }, inputs: { args: "args" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [["barChart", ""]], template: function BarChartComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "div", null, 0);
        } }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BarChartComponent, [{
        type: Component,
        args: [{ selector: 'app-bar-chart', template: "<div #barChart></div>" }]
    }], function () { return [{ type: BarChartService }, { type: UiService }]; }, { args: [{
            type: Input
        }], chartElement: [{
            type: ViewChild,
            args: ['barChart', { static: true }]
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

class ClipboardDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        // Target HTML element to copy innerText of.
        this.targetElement = null;
        this.cbOnSuccess = new EventEmitter();
        this.cbOnError = new EventEmitter();
    }
    onclick() {
        this.copy();
    }
    isSupported() {
        return document.queryCommandSupported && document.queryCommandSupported('copy');
    }
    copy() {
        if (!this.isSupported()) {
            this.handleResult(false);
        }
        else {
            this.copyTargetElementContent()
                .then((result) => {
                this.handleResult(result, result);
            });
        }
    }
    // Copies content of targetElement
    async copyTargetElementContent() {
        let result = null;
        try {
            if (typeof (this.targetElement) === 'string') {
                await navigator.clipboard.writeText(this.targetElement);
                result = this.targetElement;
            }
            else {
                const range = document.createRange();
                const selection = window.getSelection();
                range.selectNodeContents(this.targetElement);
                selection.removeAllRanges();
                selection.addRange(range);
                await document.execCommand('copy');
                result = this.targetElement.innerText;
            }
        }
        catch (e) {
            result = null;
        }
        return result;
    }
    // Handles success/failure and emits result.
    handleResult(success, cbString) {
        if (success) {
            this.cbOnSuccess.emit({ isSuccess: true, content: cbString, elementRef: this.elementRef });
        }
        else {
            this.cbOnError.emit({ isSuccess: false, content: null, elementRef: this.elementRef });
        }
    }
    static { this.ɵfac = function ClipboardDirective_Factory(t) { return new (t || ClipboardDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ClipboardDirective, selectors: [["", "appClipboard", ""]], hostBindings: function ClipboardDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function ClipboardDirective_click_HostBindingHandler() { return ctx.onclick(); });
        } }, inputs: { targetElement: ["appClipboard", "targetElement"] }, outputs: { cbOnSuccess: "cbOnSuccess", cbOnError: "cbOnError" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClipboardDirective, [{
        type: Directive,
        args: [{
                selector: '[appClipboard]'
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { targetElement: [{
            type: Input,
            args: ['appClipboard']
        }], cbOnSuccess: [{
            type: Output
        }], cbOnError: [{
            type: Output
        }], onclick: [{
            type: HostListener,
            args: ['click']
        }] }); })();

const moment$1 = moment_;
class MomentPipe {
    constructor(localeId) {
        this.localeId = localeId;
        moment$1.locale(this.localeId); // set locale for future uses of moment
    }
    transform(value, args) {
        const date = moment$1(value);
        if (args === 'iso') {
            return date.toISOString();
        }
        if (args === 'long') {
            return `${date.format('MMM DD, YYYY h:mm:ss A')}`;
        }
        if (args === 'long-custom') {
            if (value === 0 || date.format('MMM DD, YYYY h:mm:ss A') === 'Invalid date') {
                return ' ';
            }
            return `${date.format('MMM DD, YYYY h:mm:ss A')}`;
        }
        if (args === 'ago-custom') {
            let ago = Math.floor(moment$1().diff(date) / 1000);
            if (ago < 0) {
                return 'Just now';
            }
            if (ago < 60) {
                return `${ago} seconds`;
            }
            ago = Math.floor(ago / 60);
            if (ago < 60) {
                return `${ago} minutes`;
            }
            ago = Math.floor(ago / 60);
            if (ago < 24) {
                return `${ago} hours`;
            }
            ago = Math.floor(ago / 24);
            return `${ago} days`;
        }
        return date.format(args);
    }
    static { this.ɵfac = function MomentPipe_Factory(t) { return new (t || MomentPipe)(i0.ɵɵdirectiveInject(LOCALE_ID, 16)); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "moment", type: MomentPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MomentPipe, [{
        type: Pipe,
        args: [{
                name: 'moment'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }]; }, null); })();

class TrimPipe {
    transform(value, args) {
        const limit = Number.isNaN(parseInt(args, 10)) ? 10 : parseInt(args, 10);
        if (typeof value === 'string') {
            return value.length > limit - 3 ? `${value.substring(0, limit)}...` : value;
        }
        return value;
    }
    static { this.ɵfac = function TrimPipe_Factory(t) { return new (t || TrimPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "trim", type: TrimPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrimPipe, [{
        type: Pipe,
        args: [{
                name: 'trim'
            }]
    }], null, null); })();

class SafeUrlPipe {
    constructor(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    transform(url, args) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
    static { this.ɵfac = function SafeUrlPipe_Factory(t) { return new (t || SafeUrlPipe)(i0.ɵɵdirectiveInject(i1$3.DomSanitizer, 16)); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "safeUrl", type: SafeUrlPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafeUrlPipe, [{
        type: Pipe,
        args: [{
                name: 'safeUrl'
            }]
    }], function () { return [{ type: i1$3.DomSanitizer }]; }, null); })();

class SafeHtmlPipe {
    constructor(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    transform(html, args) {
        return this.domSanitizer.bypassSecurityTrustHtml(html);
    }
    static { this.ɵfac = function SafeHtmlPipe_Factory(t) { return new (t || SafeHtmlPipe)(i0.ɵɵdirectiveInject(i1$3.DomSanitizer, 16)); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "safeHtml", type: SafeHtmlPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafeHtmlPipe, [{
        type: Pipe,
        args: [{
                name: 'safeHtml'
            }]
    }], function () { return [{ type: i1$3.DomSanitizer }]; }, null); })();

class StorageCacheService {
    constructor() {
        this.showSurvey = false;
    }
    checkSurvey() {
        const surveyId = localStorage.getItem('M4s5');
        const cn = localStorage.getItem('cn');
        if (['accepted', 'cancelled'].includes(cn) && !['accepted', 'cancelled'].includes(surveyId)) {
            this.showSurvey = true;
        }
    }
    static { this.ɵfac = function StorageCacheService_Factory(t) { return new (t || StorageCacheService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: StorageCacheService, factory: StorageCacheService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StorageCacheService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function CookiesSettingDialogComponent_mat_icon_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 23);
} }
function CookiesSettingDialogComponent_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 24);
} }
function CookiesSettingDialogComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "div", 26)(2, "div", 27)(3, "div", 28)(4, "h6", 29);
    i0.ɵɵtext(5, "Cookie");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "h6", 30);
    i0.ɵɵtext(7, "__opswat-login");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 28)(9, "h6", 29);
    i0.ɵɵtext(10, "Duration");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "h6", 30);
    i0.ɵɵtext(12, "session");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 28)(14, "h6", 29);
    i0.ɵɵtext(15, "Description");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "h6", 30);
    i0.ɵɵtext(17, "This cookie is managed by OPSWAT SSO.");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(18, "hr");
    i0.ɵɵelementStart(19, "div", 27)(20, "div", 28)(21, "h6", 29);
    i0.ɵɵtext(22, "Cookie");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "h6", 30);
    i0.ɵɵtext(24, "__opswat-payload-login");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(25, "div", 28)(26, "h6", 29);
    i0.ɵɵtext(27, "Duration");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "h6", 30);
    i0.ɵɵtext(29, "session");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(30, "div", 28)(31, "h6", 29);
    i0.ɵɵtext(32, "Description");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "h6", 30);
    i0.ɵɵtext(34, "This cookie is managed by OPSWAT SSO.");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(35, "hr");
    i0.ɵɵelementStart(36, "div", 27)(37, "div", 28)(38, "h6", 29);
    i0.ɵɵtext(39, "Cookie");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "h6", 30);
    i0.ɵɵtext(41, "__opswat-refresh-login");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(42, "div", 28)(43, "h6", 29);
    i0.ɵɵtext(44, "Duration");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(45, "h6", 30);
    i0.ɵɵtext(46, "session");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(47, "div", 28)(48, "h6", 29);
    i0.ɵɵtext(49, "Description");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(50, "h6", 30);
    i0.ɵɵtext(51, "This cookie is managed by OPSWAT SSO.");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(52, "hr");
    i0.ɵɵelementStart(53, "div", 27)(54, "div", 28)(55, "h6", 29);
    i0.ɵɵtext(56, "Cookie");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(57, "h6", 30);
    i0.ɵɵtext(58, "__opswat-session-login");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(59, "div", 28)(60, "h6", 29);
    i0.ɵɵtext(61, "Duration");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(62, "h6", 30);
    i0.ɵɵtext(63, "session");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(64, "div", 28)(65, "h6", 29);
    i0.ɵɵtext(66, "Description");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(67, "h6", 30);
    i0.ɵɵtext(68, "This cookie is managed by OPSWAT SSO.");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(69, "hr");
    i0.ɵɵelementStart(70, "div", 27)(71, "div", 28)(72, "h6", 29);
    i0.ɵɵtext(73, "Cookie");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(74, "h6", 30);
    i0.ɵɵtext(75, "ocmJwtToken");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(76, "div", 28)(77, "h6", 29);
    i0.ɵɵtext(78, "Duration");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(79, "h6", 30);
    i0.ɵɵtext(80, "session");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(81, "div", 28)(82, "h6", 29);
    i0.ɵɵtext(83, "Description");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(84, "h6", 30);
    i0.ɵɵtext(85, "This cookie is used for My Products configuration.");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(86, "hr");
    i0.ɵɵelementStart(87, "div", 27)(88, "div", 28)(89, "h6", 29);
    i0.ɵɵtext(90, "Cookie");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(91, "h6", 30);
    i0.ɵɵtext(92, "JsessionID");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(93, "div", 28)(94, "h6", 29);
    i0.ɵɵtext(95, "Duration");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(96, "h6", 30);
    i0.ɵɵtext(97, "session");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(98, "div", 28)(99, "h6", 29);
    i0.ɵɵtext(100, "Description");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(101, "h6", 30);
    i0.ɵɵtext(102, "This cookie is used for session management.");
    i0.ɵɵelementEnd()()()()();
} }
function CookiesSettingDialogComponent_mat_icon_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 23);
} }
function CookiesSettingDialogComponent_ng_template_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 24);
} }
function CookiesSettingDialogComponent_div_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 31);
} }
class CookiesSettingDialogComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
        this.panel = {
            uncategorized: false,
            necessary: false,
        };
    }
    ngOnInit() { }
    acceptAll() {
        this.dialogRef.close('all');
    }
    saveSetting() {
        this.dialogRef.close('necessary');
    }
    togglePannel(val) {
        this.panel[val] = !this.panel[val];
    }
    static { this.ɵfac = function CookiesSettingDialogComponent_Factory(t) { return new (t || CookiesSettingDialogComponent)(i0.ɵɵdirectiveInject(i1$4.MatLegacyDialogRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CookiesSettingDialogComponent, selectors: [["lib-cookies-setting-dialog"]], decls: 51, vars: 17, consts: [[1, "dialog-large__header", "flex", "flex-space-between"], ["mat-button", "", "type", "button", "mat-dialog-close", ""], ["mat-dialog-content", ""], [1, "cookies-terms"], [1, "m-t-lg"], ["hideToggle", "", "expanded", "true", "disabled", "true", 1, "expansion-v8", 2, "border-bottom", "none"], [2, "border-bottom", "none", "height", "50px", 3, "click"], [1, "flex", "flex-space-between"], [1, "flex"], ["svgIcon", "solid-down", 4, "ngIf", "ngIfElse"], ["necessary", ""], [1, "always-active"], [1, "expansion-body"], [1, "pl-20"], ["class", "expanded-body pl-20", 4, "ngIf"], ["hideToggle", "", "expanded", "true", "disabled", "true", 1, "expansion-v8", "pl-20", 2, "border-bottom", "none"], [2, "border-bottom", "none", "height", "50px"], ["svgIcon", "solid-down", 4, "ngIf"], ["uncategorized", ""], ["class", "expanded-body", 4, "ngIf"], [1, "dialog-large__footer", "cookie-notice-footer", "m-t-lg"], ["mat-button", "", "color", "neutral", 1, "outline", 3, "click"], ["mat-button", "", "color", "primary", 3, "click"], ["svgIcon", "solid-down"], ["svgIcon", "solid-right"], [1, "expanded-body", "pl-20"], [1, "cookie-container-box"], [1, "cookie-container-row"], [1, "cookie-content-row"], [1, "cookie-content", "cookie-content-title"], [1, "font-medium", "cookie-content"], [1, "expanded-body"]], template: function CookiesSettingDialogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h4");
            i0.ɵɵtext(2, "Customize Consent Preferences");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "mat-icon", 1);
            i0.ɵɵtext(4, " close ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 2)(6, "div", 3)(7, "p");
            i0.ɵɵtext(8, " We use cookies to help you navigate efficiently and perform certain functions. You will find detailed information about all cookies under each consent category below. ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "p");
            i0.ɵɵtext(10, " The cookies that are categorized as \"Necessary\" are stored on your browser as they are essential for enabling the basic functionalities of the site. ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "p");
            i0.ɵɵtext(12, " We also use third-party cookies that help us analyze how you use this website. These cookies will only be stored in your browser with your prior consent. You can choose to enable or disable some or all of these cookies but disabling some of them may affect your browsing experience. ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(13, "mat-divider", 4);
            i0.ɵɵelementStart(14, "mat-expansion-panel", 5)(15, "mat-expansion-panel-header", 6);
            i0.ɵɵlistener("click", function CookiesSettingDialogComponent_Template_mat_expansion_panel_header_click_15_listener() { return ctx.togglePannel("necessary"); });
            i0.ɵɵelementStart(16, "mat-panel-title")(17, "div", 7)(18, "div", 8);
            i0.ɵɵtemplate(19, CookiesSettingDialogComponent_mat_icon_19_Template, 1, 0, "mat-icon", 9);
            i0.ɵɵtemplate(20, CookiesSettingDialogComponent_ng_template_20_Template, 1, 0, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(22, "div");
            i0.ɵɵtext(23, "Necessary");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "strong", 11);
            i0.ɵɵtext(25, "Always Active");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(26, "div", 12)(27, "div", 13);
            i0.ɵɵtext(28, " Necessary cookies are required to enable the basic features of this site, such as providing secure log-in or adjusting your consent preferences. These cookies do not store any personally identifiable data. ");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(29, CookiesSettingDialogComponent_div_29_Template, 103, 0, "div", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(30, "mat-divider", 4);
            i0.ɵɵelementStart(31, "mat-expansion-panel", 15)(32, "mat-expansion-panel-header", 16)(33, "mat-panel-title")(34, "div", 7)(35, "div", 8);
            i0.ɵɵtemplate(36, CookiesSettingDialogComponent_mat_icon_36_Template, 1, 0, "mat-icon", 17);
            i0.ɵɵtemplate(37, CookiesSettingDialogComponent_ng_template_37_Template, 1, 0, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(39, "div");
            i0.ɵɵtext(40, "Uncategorized");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(41, "mat-slide-toggle");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(42, "div", 12)(43, "div", 13);
            i0.ɵɵtext(44, " Other uncategorized cookies are those that are being analyzed and have not been classified into a category as yet. ");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(45, CookiesSettingDialogComponent_div_45_Template, 1, 0, "div", 19);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(46, "div", 20)(47, "button", 21);
            i0.ɵɵlistener("click", function CookiesSettingDialogComponent_Template_button_click_47_listener() { return ctx.saveSetting(); });
            i0.ɵɵtext(48, "Save My Preferences");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(49, "button", 22);
            i0.ɵɵlistener("click", function CookiesSettingDialogComponent_Template_button_click_49_listener() { return ctx.acceptAll(); });
            i0.ɵɵtext(50, "Accept All");
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(21);
            i0.ɵɵadvance(17);
            i0.ɵɵstyleProp("width", 100, "%");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.panel.necessary)("ngIfElse", _r1);
            i0.ɵɵadvance(3);
            i0.ɵɵstyleProp("font-size", 14, "px");
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ngIf", ctx.panel.necessary);
            i0.ɵɵadvance(5);
            i0.ɵɵstyleProp("width", 100, "%");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", false);
            i0.ɵɵadvance(3);
            i0.ɵɵstyleProp("font-size", 14, "px");
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngIf", ctx.panel.uncategorized);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("width", 49, "%");
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("width", 50, "%");
        } }, dependencies: [i1.NgIf, i4.MatLegacyButton, i2.MatIcon, i5.MatLegacySlideToggle, i6$2.MatDivider, i7$1.MatExpansionPanel, i7$1.MatExpansionPanelHeader, i7$1.MatExpansionPanelTitle, i1$4.MatLegacyDialogClose, i1$4.MatLegacyDialogContent], styles: [".cookie-notice-footer[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;justify-content:space-between}.always-active[_ngcontent-%COMP%]{color:#04cb04;font-size:14px}.pl-20[_ngcontent-%COMP%]{padding-left:20px}.cookie-container-box[_ngcontent-%COMP%]{background-color:#d9d9d9;padding:8px 16px;border-radius:4px;margin-top:16px}.cookie-container-box[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{margin:0 0 8px;flex-shrink:0;border-width:0px 0px thin;border-style:solid;border-color:#e7e9ee}.font-medium[_ngcontent-%COMP%]{font-weight:500}.cookie-container-box[_ngcontent-%COMP%]   .cookie-content-row[_ngcontent-%COMP%]{display:flex;align-items:center;min-height:0px;margin-bottom:8px;flex-wrap:wrap}.cookie-container-box[_ngcontent-%COMP%]   .cookie-content-row[_ngcontent-%COMP%]   .cookie-content[_ngcontent-%COMP%]{margin:0;font-size:13px;line-height:16px;font-family:Roboto,sans-serif;letter-spacing:0px;color:#3d4a68}.cookie-container-box[_ngcontent-%COMP%]   .cookie-content-row[_ngcontent-%COMP%]   .cookie-content-title[_ngcontent-%COMP%]{font-weight:400;flex-basis:25%;flex-grow:0;margin-right:8px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CookiesSettingDialogComponent, [{
        type: Component,
        args: [{ selector: 'lib-cookies-setting-dialog', template: "<div class=\"dialog-large__header flex flex-space-between\">\r\n\t<h4>Customize Consent Preferences</h4>\r\n\t<mat-icon mat-button type=\"button\" mat-dialog-close> close </mat-icon>\r\n</div>\r\n<div mat-dialog-content>\r\n\t<div class=\"cookies-terms\">\r\n\t\t<p>\r\n\t\t\tWe use cookies to help you navigate efficiently and perform certain functions. You will find detailed information about all\r\n\t\t\tcookies under each consent category below.\r\n\t\t</p>\r\n\t\t<p>\r\n\t\t\tThe cookies that are categorized as \"Necessary\" are stored on your browser as they are essential for enabling the basic\r\n\t\t\tfunctionalities of the site.\r\n\t\t</p>\r\n\t\t<p>\r\n\t\t\tWe also use third-party cookies that help us analyze how you use this website. These cookies will only be stored in your browser\r\n\t\t\twith your prior consent. You can choose to enable or disable some or all of these cookies but disabling some of them may affect\r\n\t\t\tyour browsing experience.\r\n\t\t</p>\r\n\t</div>\r\n\t<mat-divider class=\"m-t-lg\"></mat-divider>\r\n\t<mat-expansion-panel style=\"border-bottom: none\" hideToggle class=\"expansion-v8\" expanded=\"true\" disabled=\"true\">\r\n\t\t<mat-expansion-panel-header style=\"border-bottom: none; height: 50px\" (click)=\"togglePannel('necessary')\">\r\n\t\t\t<mat-panel-title>\r\n\t\t\t\t<div [style.width.%]=\"100\" class=\"flex flex-space-between\">\r\n\t\t\t\t\t<div class=\"flex\">\r\n\t\t\t\t\t\t<mat-icon *ngIf=\"panel.necessary; else necessary\" svgIcon=\"solid-down\"></mat-icon>\r\n\t\t\t\t\t\t<ng-template #necessary><mat-icon svgIcon=\"solid-right\"></mat-icon></ng-template>\r\n\t\t\t\t\t\t<div [style.font-size.px]=\"14\">Necessary</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<strong class=\"always-active\">Always Active</strong>\r\n\t\t\t\t</div>\r\n\t\t\t</mat-panel-title>\r\n\t\t</mat-expansion-panel-header>\r\n\t\t<div class=\"expansion-body\">\r\n\t\t\t<div class=\"pl-20\">\r\n\t\t\t\tNecessary cookies are required to enable the basic features of this site, such as providing secure log-in or adjusting your\r\n\t\t\t\tconsent preferences. These cookies do not store any personally identifiable data.\r\n\t\t\t</div>\r\n\t\t\t<div class=\"expanded-body pl-20\" *ngIf=\"panel.necessary\">\r\n\t\t\t\t<div class=\"cookie-container-box\">\r\n\t\t\t\t\t<div class=\"cookie-container-row\">\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Cookie</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">__opswat-login</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Duration</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">session</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Description</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">This cookie is managed by OPSWAT SSO.</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<hr />\r\n\t\t\t\t\t<div class=\"cookie-container-row\">\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Cookie</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">__opswat-payload-login</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Duration</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">session</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Description</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">This cookie is managed by OPSWAT SSO.</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<hr />\r\n\t\t\t\t\t<div class=\"cookie-container-row\">\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Cookie</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">__opswat-refresh-login</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Duration</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">session</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Description</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">This cookie is managed by OPSWAT SSO.</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<hr />\r\n\t\t\t\t\t<div class=\"cookie-container-row\">\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Cookie</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">__opswat-session-login</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Duration</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">session</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Description</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">This cookie is managed by OPSWAT SSO.</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<hr />\r\n\t\t\t\t\t<div class=\"cookie-container-row\">\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Cookie</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">ocmJwtToken</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Duration</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">session</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Description</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">This cookie is used for My Products configuration.</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<hr />\r\n\t\t\t\t\t<div class=\"cookie-container-row\">\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Cookie</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">JsessionID</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Duration</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">session</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"cookie-content-row\">\r\n\t\t\t\t\t\t\t<h6 class=\"cookie-content cookie-content-title\">Description</h6>\r\n\t\t\t\t\t\t\t<h6 class=\"font-medium cookie-content\">This cookie is used for session management.</h6>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</mat-expansion-panel>\r\n\t<mat-divider class=\"m-t-lg\"></mat-divider>\r\n\t<mat-expansion-panel style=\"border-bottom: none\" hideToggle class=\"expansion-v8 pl-20\" expanded=\"true\" disabled=\"true\">\r\n\t\t<mat-expansion-panel-header style=\"border-bottom: none; height: 50px\">\r\n\t\t\t<mat-panel-title>\r\n\t\t\t\t<div [style.width.%]=\"100\" class=\"flex flex-space-between\">\r\n\t\t\t\t\t<div class=\"flex\">\r\n\t\t\t\t\t\t<mat-icon *ngIf=\"false\" svgIcon=\"solid-down\"></mat-icon>\r\n\t\t\t\t\t\t<ng-template #uncategorized><mat-icon svgIcon=\"solid-right\"></mat-icon></ng-template>\r\n\r\n\t\t\t\t\t\t<div [style.font-size.px]=\"14\">Uncategorized</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<mat-slide-toggle></mat-slide-toggle>\r\n\t\t\t\t</div>\r\n\t\t\t</mat-panel-title>\r\n\t\t</mat-expansion-panel-header>\r\n\t\t<div class=\"expansion-body\">\r\n\t\t\t<div class=\"pl-20\">\r\n\t\t\t\tOther uncategorized cookies are those that are being analyzed and have not been classified into a category as yet.\r\n\t\t\t</div>\r\n\t\t\t<div class=\"expanded-body\" *ngIf=\"panel.uncategorized\"></div>\r\n\t\t</div>\r\n\t</mat-expansion-panel>\r\n</div>\r\n<div class=\"dialog-large__footer cookie-notice-footer m-t-lg\">\r\n\t<button mat-button [style.width.%]=\"49\" color=\"neutral\" class=\"outline\" (click)=\"saveSetting()\">Save My Preferences</button>\r\n\t<button mat-button [style.width.%]=\"50\" color=\"primary\" (click)=\"acceptAll()\">Accept All</button>\r\n</div>\r\n", styles: [".cookie-notice-footer{display:flex;flex-direction:row;align-items:center;justify-content:space-between}.always-active{color:#04cb04;font-size:14px}.pl-20{padding-left:20px}.cookie-container-box{background-color:#d9d9d9;padding:8px 16px;border-radius:4px;margin-top:16px}.cookie-container-box hr{margin:0 0 8px;flex-shrink:0;border-width:0px 0px thin;border-style:solid;border-color:#e7e9ee}.font-medium{font-weight:500}.cookie-container-box .cookie-content-row{display:flex;align-items:center;min-height:0px;margin-bottom:8px;flex-wrap:wrap}.cookie-container-box .cookie-content-row .cookie-content{margin:0;font-size:13px;line-height:16px;font-family:Roboto,sans-serif;letter-spacing:0px;color:#3d4a68}.cookie-container-box .cookie-content-row .cookie-content-title{font-weight:400;flex-basis:25%;flex-grow:0;margin-right:8px}\n"] }]
    }], function () { return [{ type: i1$4.MatLegacyDialogRef }]; }, null); })();

function CookieNoticeComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div")(2, "button", 2);
    i0.ɵɵlistener("click", function CookieNoticeComponent_div_0_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onClickSetting()); });
    i0.ɵɵtext(3, " Cookies Details ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "p", 3);
    i0.ɵɵtext(5, " To improve the user experience this website stores cookies on your computer. ");
    i0.ɵɵelement(6, "br");
    i0.ɵɵtext(7, " By continuing you accept our cookie policy. For additional information please read the ");
    i0.ɵɵelementStart(8, "a", 4);
    i0.ɵɵtext(9, "Cookie Policy.");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(10, ". ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div")(12, "button", 5);
    i0.ɵɵlistener("click", function CookieNoticeComponent_div_0_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r2); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onClick("all")); });
    i0.ɵɵtext(13, " Accept All ");
    i0.ɵɵelementEnd()()();
} }
class CookieNoticeComponent {
    constructor(storageCacheService, cookieService, dialog) {
        this.storageCacheService = storageCacheService;
        this.cookieService = cookieService;
        this.dialog = dialog;
        this.show = true;
    }
    ngOnInit() {
        const cn = localStorage.getItem('cn');
        this.show = !['all', 'necessary'].includes(cn);
    }
    // Clear cookies and reload location so webapp can applied
    // no cookie policy if any
    onClickSetting() {
        this.show = false;
        const ref = this.dialog.open(CookiesSettingDialogComponent, { width: '700px', autoFocus: false, disableClose: false });
        ref.afterClosed().subscribe((val) => {
            this.show = true;
            if (val === 'all') {
                localStorage.setItem('cn', 'all');
                this.show = false;
                this.storageCacheService.showSurvey = true;
            }
            if (val === 'necessary') {
                localStorage.setItem('cn', 'necessary');
                this.show = false;
                this.storageCacheService.showSurvey = true;
            }
        });
    }
    onClick(status) {
        localStorage.setItem('cn', status);
        this.show = false;
        this.storageCacheService.showSurvey = true;
    }
    clearAllCookies() {
        let dotIndex = location.hostname.indexOf('.');
        dotIndex = dotIndex >= 0 ? dotIndex : 0;
        this.cookieService.deleteAll('/', location.hostname.slice(dotIndex));
    }
    static { this.ɵfac = function CookieNoticeComponent_Factory(t) { return new (t || CookieNoticeComponent)(i0.ɵɵdirectiveInject(StorageCacheService), i0.ɵɵdirectiveInject(i2$4.CookieService), i0.ɵɵdirectiveInject(i1$4.MatLegacyDialog)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CookieNoticeComponent, selectors: [["app-cookie-notice"]], decls: 1, vars: 1, consts: [["class", "cn flex flex-center flex-middle", 4, "ngIf"], [1, "cn", "flex", "flex-center", "flex-middle"], ["mat-button", "", "color", "neutral", "data-cy", "cookie-notice-reject-button", 1, "is-small", "reject", 3, "click"], ["data-cy", "cookie-notice-description-text"], ["href", "https://www.opswat.com/legal/cookies-policy", "target", "_blank", "data-cy", "cookie-notice-policy-link"], ["mat-button", "", "color", "primary", "data-cy", "cookie-notice-accept-button", 1, "is-small", "accept", 3, "click"]], template: function CookieNoticeComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, CookieNoticeComponent_div_0_Template, 14, 0, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.show);
        } }, dependencies: [i1.NgIf, i4.MatLegacyButton], styles: ["app-cookie-notice[_ngcontent-%COMP%]{position:absolute;z-index:3000;left:0;bottom:0;width:100%}app-cookie-notice[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:underline}app-cookie-notice[_ngcontent-%COMP%]   .cn[_ngcontent-%COMP%]{padding:16px}@media (max-width: 920px){app-cookie-notice[_ngcontent-%COMP%]   .cn[_ngcontent-%COMP%]{border-radius:0;margin-left:0;left:0;bottom:0;width:100%}}@media (min-width: 920px){app-cookie-notice[_ngcontent-%COMP%]   .cn[_ngcontent-%COMP%]{border-radius:0}}app-cookie-notice[_ngcontent-%COMP%]   .cn[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0 60px 0 0;font-size:14px;line-height:1.3em;text-align:center}app-cookie-notice[_ngcontent-%COMP%]   .cn[_ngcontent-%COMP%]   .accept[_ngcontent-%COMP%]{margin-right:10px}app-cookie-notice[_ngcontent-%COMP%]   .cn[_ngcontent-%COMP%]   .reject[_ngcontent-%COMP%]{margin-right:50px}app-cookie-notice[_ngcontent-%COMP%]   .cn[_ngcontent-%COMP%]   .decline[_ngcontent-%COMP%]{position:absolute;top:0;right:-3px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CookieNoticeComponent, [{
        type: Component,
        args: [{ selector: 'app-cookie-notice', template: "<div *ngIf=\"show\" class=\"cn flex flex-center flex-middle\">\r\n\t<div>\r\n\t\t<button mat-button color=\"neutral\" class=\"is-small reject\" (click)=\"onClickSetting()\" data-cy=\"cookie-notice-reject-button\">\r\n\t\t\tCookies Details\r\n\t\t</button>\r\n\t</div>\r\n\t<p data-cy=\"cookie-notice-description-text\">\r\n\t\tTo improve the user experience this website stores cookies on your computer.\r\n\t\t<br />\r\n\t\tBy continuing you accept our cookie policy. For additional information please read the\r\n\t\t<a href=\"https://www.opswat.com/legal/cookies-policy\" target=\"_blank\" data-cy=\"cookie-notice-policy-link\">Cookie Policy.</a>.\r\n\t</p>\r\n\t<div>\r\n\t\t<button mat-button class=\"is-small accept\" color=\"primary\" (click)=\"onClick('all')\" data-cy=\"cookie-notice-accept-button\">\r\n\t\t\tAccept All\r\n\t\t</button>\r\n\t</div>\r\n</div>\r\n", styles: ["app-cookie-notice{position:absolute;z-index:3000;left:0;bottom:0;width:100%}app-cookie-notice a{text-decoration:underline}app-cookie-notice .cn{padding:16px}@media (max-width: 920px){app-cookie-notice .cn{border-radius:0;margin-left:0;left:0;bottom:0;width:100%}}@media (min-width: 920px){app-cookie-notice .cn{border-radius:0}}app-cookie-notice .cn p{margin:0 60px 0 0;font-size:14px;line-height:1.3em;text-align:center}app-cookie-notice .cn .accept{margin-right:10px}app-cookie-notice .cn .reject{margin-right:50px}app-cookie-notice .cn .decline{position:absolute;top:0;right:-3px}\n"] }]
    }], function () { return [{ type: StorageCacheService }, { type: i2$4.CookieService }, { type: i1$4.MatLegacyDialog }]; }, null); })();

function SurveyPromptComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "p", 2);
    i0.ɵɵelementStart(2, "button", 3);
    i0.ɵɵlistener("click", function SurveyPromptComponent_div_0_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onClick("accepted")); });
    i0.ɵɵtext(3, " Take Survey ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 4);
    i0.ɵɵlistener("click", function SurveyPromptComponent_div_0_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r2); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onClick("cancelled")); });
    i0.ɵɵelementStart(5, "mat-icon");
    i0.ɵɵtext(6, " close ");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", ctx_r0.data["text"], i0.ɵɵsanitizeHtml);
} }
class SurveyPromptComponent {
    constructor(router, storageCacheService) {
        this.router = router;
        this.storageCacheService = storageCacheService;
        this.data = {};
        this.event = false;
        this.show = false;
    }
    ngOnInit() {
        this.storageCacheService.checkSurvey();
    }
    onClick(status) {
        localStorage.setItem(this.data['id'], status);
        if (status === 'accepted') {
            window.open(this.data['link'], '_blank');
        }
        this.show = false;
        this.storageCacheService.showSurvey = false;
    }
    ngOnChanges(changes) {
        this.storageCacheService.checkSurvey();
    }
    static { this.ɵfac = function SurveyPromptComponent_Factory(t) { return new (t || SurveyPromptComponent)(i0.ɵɵdirectiveInject(i3$1.Router), i0.ɵɵdirectiveInject(StorageCacheService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SurveyPromptComponent, selectors: [["app-survey-prompt"]], inputs: { data: "data", event: "event" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "survey flex flex-space-around flex-middle", 4, "ngIf"], [1, "survey", "flex", "flex-space-around", "flex-middle"], ["data-cy", "survey-prompt-descrption-text", 3, "innerHTML"], ["mat-button", "", "color", "neutral", "data-cy", "survey-prompt-take-survey-button", 1, "is-small", "accept", "outline", "in-line", "mat-button-override", 3, "click"], ["mat-icon-button", "", "data-cy", "survey-prompt-close-button", 1, "is-small", "decline", "m-l-md", "center-button", 3, "click"]], template: function SurveyPromptComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, SurveyPromptComponent_div_0_Template, 7, 1, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.storageCacheService.showSurvey);
        } }, dependencies: [i1.NgIf, i4.MatLegacyButton, i2.MatIcon], styles: ["app-survey-prompt[_ngcontent-%COMP%]{position:fixed;width:100%;bottom:0;z-index:3000;left:0}@media (min-width: 0){app-survey-prompt[_ngcontent-%COMP%]   .survey[_ngcontent-%COMP%]{border-radius:0;margin-left:0;width:100%;padding:20px 20%}}app-survey-prompt[_ngcontent-%COMP%]   .survey[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0 5px 0 0;font-size:14px;line-height:1.3em}app-survey-prompt[_ngcontent-%COMP%]   .survey[_ngcontent-%COMP%]   .accept[_ngcontent-%COMP%]{text-align:center}app-survey-prompt[_ngcontent-%COMP%]   .survey[_ngcontent-%COMP%]   .decline[_ngcontent-%COMP%]:hover{color:#fff;opacity:.8}app-survey-prompt[_ngcontent-%COMP%]   .survey[_ngcontent-%COMP%]   .in-line[_ngcontent-%COMP%]{float:right}app-survey-prompt[_ngcontent-%COMP%]   .survey[_ngcontent-%COMP%]   .mat-button-override[_ngcontent-%COMP%]{min-width:100px!important}app-survey-prompt[_ngcontent-%COMP%]   .survey[_ngcontent-%COMP%]   .center-button[_ngcontent-%COMP%]{text-align:left}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SurveyPromptComponent, [{
        type: Component,
        args: [{ selector: 'app-survey-prompt', template: "<div\r\n  *ngIf=\"storageCacheService.showSurvey\"\r\n  class=\"survey flex flex-space-around flex-middle\"\r\n>\r\n  <p\r\n    data-cy=\"survey-prompt-descrption-text\"\r\n    [innerHTML]=\"this.data['text']\"\r\n  ></p>\r\n\r\n  <button\r\n    mat-button\r\n    class=\"is-small accept outline in-line mat-button-override\"\r\n    color=\"neutral\"\r\n    (click)=\"onClick('accepted')\"\r\n    data-cy=\"survey-prompt-take-survey-button\"\r\n  >\r\n    Take Survey\r\n  </button>\r\n  <button\r\n    mat-icon-button\r\n    class=\"is-small decline m-l-md center-button\"\r\n    (click)=\"onClick('cancelled')\"\r\n    data-cy=\"survey-prompt-close-button\"\r\n  >\r\n    <mat-icon>\r\n      close\r\n    </mat-icon>\r\n  </button>\r\n\r\n</div>", styles: ["app-survey-prompt{position:fixed;width:100%;bottom:0;z-index:3000;left:0}@media (min-width: 0){app-survey-prompt .survey{border-radius:0;margin-left:0;width:100%;padding:20px 20%}}app-survey-prompt .survey p{margin:0 5px 0 0;font-size:14px;line-height:1.3em}app-survey-prompt .survey .accept{text-align:center}app-survey-prompt .survey .decline:hover{color:#fff;opacity:.8}app-survey-prompt .survey .in-line{float:right}app-survey-prompt .survey .mat-button-override{min-width:100px!important}app-survey-prompt .survey .center-button{text-align:left}\n"] }]
    }], function () { return [{ type: i3$1.Router }, { type: StorageCacheService }]; }, { data: [{
            type: Input
        }], event: [{
            type: Input
        }] }); })();

class BottomPanelComponent {
    constructor() {
        this.data = {};
    }
    ngOnInit() {
    }
    static { this.ɵfac = function BottomPanelComponent_Factory(t) { return new (t || BottomPanelComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BottomPanelComponent, selectors: [["app-bottom-panel"]], inputs: { data: "data" }, decls: 2, vars: 2, consts: [[3, "data", "event"]], template: function BottomPanelComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "app-cookie-notice")(1, "app-survey-prompt", 0);
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("data", ctx.data)("event", ctx.clickedEvent);
        } }, dependencies: [CookieNoticeComponent, SurveyPromptComponent] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BottomPanelComponent, [{
        type: Component,
        args: [{ selector: 'app-bottom-panel', template: "<app-cookie-notice></app-cookie-notice>\r\n<app-survey-prompt [data]=\"data\" [event]=\"clickedEvent\"></app-survey-prompt>\r\n" }]
    }], function () { return []; }, { data: [{
            type: Input
        }] }); })();

const _c0$8 = ["sidenav"];
const _c1$5 = ["sidenavContent"];
function StandardComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngComponentOutlet", ctx_r2.layoutService.getFooterComponent());
} }
function StandardComponent_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "app-bottom-panel", 14);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", ctx_r4.surveyArgs1);
} }
const _c2$3 = function (a1) { return { "is-opened": true, "show-survey": a1 }; };
const _c3$3 = function (a0) { return { "has-footer": a0 }; };
class StandardComponent {
    constructor(rightDrawerService, layoutService, activatedRoute, storageCacheService, environment) {
        this.rightDrawerService = rightDrawerService;
        this.layoutService = layoutService;
        this.activatedRoute = activatedRoute;
        this.storageCacheService = storageCacheService;
        this.environment = environment;
        this.sidenavMode = 'side';
        this.mobileNavBreakpoint = 640;
        this.mediumNavBreakpoint = 1300;
        this.data = {};
        this.scrollToTopSubscription = null;
        this.showSurvey = true;
        this.isOnCloud = false;
        this.data = this.activatedRoute.snapshot.data;
        this.scrollToTopSubscription = this.layoutService.scrollToTop.subscribe(() => {
            this.scrollToTop();
        });
        this.surveyArgs1 = this.environment.surveyArgs;
        this.showSurvey = this.environment.showSurvey;
        this.isOnCloud = this.environment.onCloud;
    }
    ngOnInit() {
        this.windowWidth = window.innerWidth;
        this.storageCacheService.checkSurvey();
        this.setMode();
    }
    ngOnDestroy() {
        if (this.scrollToTopSubscription instanceof Subscription) {
            this.scrollToTopSubscription.unsubscribe();
        }
    }
    onWindowResize() {
        this.windowWidth = window.innerWidth;
        this.setMode();
    }
    setMode() {
        this.sidenavMode = this.windowWidth < this.mobileNavBreakpoint ? 'over' : 'side';
    }
    scrollToTop() {
        if (this.sidenavContent) {
            this.sidenavContent.getElementRef().nativeElement.scrollTop = 0;
        }
    }
    static { this.ɵfac = function StandardComponent_Factory(t) { return new (t || StandardComponent)(i0.ɵɵdirectiveInject(RightDrawerService), i0.ɵɵdirectiveInject(LayoutService), i0.ɵɵdirectiveInject(i3$1.ActivatedRoute), i0.ɵɵdirectiveInject(StorageCacheService), i0.ɵɵdirectiveInject('environment')); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StandardComponent, selectors: [["app-standard"]], viewQuery: function StandardComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$8, 5);
            i0.ɵɵviewQuery(_c1$5, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sidenav = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sidenavContent = _t.first);
        } }, hostBindings: function StandardComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("resize", function StandardComponent_resize_HostBindingHandler() { return ctx.onWindowResize(); }, false, i0.ɵɵresolveWindow);
        } }, decls: 21, vars: 21, consts: [[3, "autosize", "ngClass"], [1, "overflow-visible", 3, "mode", "opened", "fixedInViewport"], ["sidenav", ""], [3, "ngComponentOutlet"], ["sidenavContent", ""], [1, "sidenav-toggle", 3, "click"], [1, "icon", "icon-menu"], [3, "ngClass"], [4, "ngIf"], ["mode", "over", "position", "end", 1, "right-drawer", "scroll", "hide-scroll", 3, "fixedInViewport", "opened", "closed"], ["rightDrawer", ""], [1, "close-drawer"], [3, "click"], [3, "ngTemplateOutlet"], [3, "data"]], template: function StandardComponent_Template(rf, ctx) { if (rf & 1) {
            const _r5 = i0.ɵɵgetCurrentView();
            i0.ɵɵelement(0, "app-loading-bar");
            i0.ɵɵelementStart(1, "mat-sidenav-container", 0)(2, "mat-sidenav", 1, 2);
            i0.ɵɵelementContainer(4, 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "mat-sidenav-content", null, 4)(7, "div", 5);
            i0.ɵɵlistener("click", function StandardComponent_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r5); const _r0 = i0.ɵɵreference(3); return i0.ɵɵresetView(_r0.toggle()); });
            i0.ɵɵelementStart(8, "mat-icon", 6);
            i0.ɵɵtext(9, "menu");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "main", 7);
            i0.ɵɵelementContainer(11, 3);
            i0.ɵɵelement(12, "router-outlet");
            i0.ɵɵtemplate(13, StandardComponent_ng_container_13_Template, 2, 1, "ng-container", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "mat-sidenav", 9, 10);
            i0.ɵɵlistener("closed", function StandardComponent_Template_mat_sidenav_closed_14_listener() { return ctx.rightDrawerService.close(); });
            i0.ɵɵelementStart(16, "div", 11)(17, "mat-icon", 12);
            i0.ɵɵlistener("click", function StandardComponent_Template_mat_icon_click_17_listener() { i0.ɵɵrestoreView(_r5); const _r3 = i0.ɵɵreference(15); return i0.ɵɵresetView(_r3.close()); });
            i0.ɵɵtext(18, "close");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementContainer(19, 13);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(20, StandardComponent_ng_container_20_Template, 2, 1, "ng-container", 8);
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("autosize", ctx.layoutService.sideNavAutosize)("ngClass", i0.ɵɵpureFunction1(17, _c2$3, ctx.storageCacheService.showSurvey));
            i0.ɵɵadvance(1);
            i0.ɵɵclassProp("is-expanded", ctx.layoutService.isMenuExpanded);
            i0.ɵɵproperty("mode", ctx.sidenavMode)("opened", true)("fixedInViewport", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngComponentOutlet", ctx.layoutService.getMainNavigationComponent());
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c3$3, ctx.data["showFooter"] !== false));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngComponentOutlet", ctx.layoutService.getHeaderComponent());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.data["showFooter"] !== false);
            i0.ɵɵadvance(1);
            i0.ɵɵstyleProp("width", ctx.rightDrawerService.customWidth || ctx.rightDrawerService.width, "px");
            i0.ɵɵproperty("fixedInViewport", true)("opened", ctx.rightDrawerService.isOpened());
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.rightDrawerService.getTemplate());
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showSurvey);
        } }, dependencies: [i1.NgClass, i1.NgComponentOutlet, i1.NgIf, i1.NgTemplateOutlet, i3$1.RouterOutlet, i2.MatIcon, i7$2.MatSidenav, i7$2.MatSidenavContainer, i7$2.MatSidenavContent, LoadingBarComponent, BottomPanelComponent], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StandardComponent, [{
        type: Component,
        args: [{ selector: 'app-standard', template: "<app-loading-bar></app-loading-bar>\r\n<mat-sidenav-container\r\n\t[autosize]=\"layoutService.sideNavAutosize\"\r\n\t[ngClass]=\"{ 'is-opened': true, 'show-survey': storageCacheService.showSurvey }\"\r\n>\r\n\t<mat-sidenav\r\n\t\t#sidenav\r\n\t\t[mode]=\"sidenavMode\"\r\n\t\t[opened]=\"true\"\r\n\t\t[fixedInViewport]=\"true\"\r\n\t\tclass=\"overflow-visible\"\r\n\t\t[class.is-expanded]=\"layoutService.isMenuExpanded\"\r\n\t>\r\n\t\t<ng-container [ngComponentOutlet]=\"layoutService.getMainNavigationComponent()\"></ng-container>\r\n\t</mat-sidenav>\r\n\t<mat-sidenav-content #sidenavContent>\r\n\t\t<div (click)=\"sidenav.toggle()\" class=\"sidenav-toggle\">\r\n\t\t\t<!-- <mat-icon class=\"icon icon-navigate-before\">navigate_before</mat-icon>\r\n      <mat-icon class=\"icon icon-navigate-next\">navigate_next</mat-icon> -->\r\n\t\t\t<mat-icon class=\"icon icon-menu\">menu</mat-icon>\r\n\t\t</div>\r\n\t\t<main [ngClass]=\"{ 'has-footer': data['showFooter'] !== false }\">\r\n\t\t\t<ng-container [ngComponentOutlet]=\"layoutService.getHeaderComponent()\"></ng-container>\r\n\t\t\t<router-outlet></router-outlet>\r\n\t\t\t<ng-container *ngIf=\"data['showFooter'] !== false\">\r\n\t\t\t\t<ng-container [ngComponentOutlet]=\"layoutService.getFooterComponent()\"></ng-container>\r\n\t\t\t</ng-container>\r\n\t\t</main>\r\n\t</mat-sidenav-content>\r\n\t<mat-sidenav\r\n\t\t#rightDrawer\r\n\t\tmode=\"over\"\r\n\t\tposition=\"end\"\r\n\t\t[fixedInViewport]=\"true\"\r\n\t\t[opened]=\"rightDrawerService.isOpened()\"\r\n\t\t(closed)=\"rightDrawerService.close()\"\r\n\t\tclass=\"right-drawer scroll hide-scroll\"\r\n\t\t[style.width.px]=\"rightDrawerService.customWidth || rightDrawerService.width\"\r\n\t>\r\n\t\t<div class=\"close-drawer\">\r\n\t\t\t<mat-icon (click)=\"rightDrawer.close()\">close</mat-icon>\r\n\t\t</div>\r\n\t\t<ng-container [ngTemplateOutlet]=\"rightDrawerService.getTemplate()\"></ng-container>\r\n\t</mat-sidenav>\r\n</mat-sidenav-container>\r\n<ng-container *ngIf=\"showSurvey\">\r\n\t<app-bottom-panel [data]=\"surveyArgs1\"></app-bottom-panel>\r\n</ng-container>\r\n" }]
    }], function () { return [{ type: RightDrawerService }, { type: LayoutService }, { type: i3$1.ActivatedRoute }, { type: StorageCacheService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['environment']
            }] }]; }, { sidenav: [{
            type: ViewChild,
            args: ['sidenav']
        }], sidenavContent: [{
            type: ViewChild,
            args: ['sidenavContent']
        }], onWindowResize: [{
            type: HostListener,
            args: ['window:resize', []]
        }] }); })();

class PageComponent {
    constructor(titleService) {
        this.titleService = titleService;
    }
    ngOnInit() { }
    setPageTitle(title, isNoneMetaAccess) {
        const titleText = isNoneMetaAccess ? title : `${title} | MetaAccess`;
        this.titleService.setTitle(`${titleText}`);
    }
    static { this.ɵfac = function PageComponent_Factory(t) { return new (t || PageComponent)(i0.ɵɵdirectiveInject(i1$3.Title)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PageComponent, selectors: [["app-page"]], decls: 0, vars: 0, template: function PageComponent_Template(rf, ctx) { }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageComponent, [{
        type: Component,
        args: [{ selector: 'app-page', template: "" }]
    }], function () { return [{ type: i1$3.Title }]; }, null); })();

class AutofocusDirective {
    constructor(el) {
        this.el = el;
    }
    ngOnInit() {
        if (this.autofocusValue || typeof this.autofocusValue === 'undefined') {
            this.el.nativeElement.focus();
        }
    }
    set appAutofocus(condition) {
        this.autofocusValue = condition !== false;
    }
    static { this.ɵfac = function AutofocusDirective_Factory(t) { return new (t || AutofocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: AutofocusDirective, selectors: [["", "appAutofocus", ""]], inputs: { appAutofocus: "appAutofocus" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutofocusDirective, [{
        type: Directive,
        args: [{
                selector: '[appAutofocus]',
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { appAutofocus: [{
            type: Input
        }] }); })();

class NumericDirective {
    constructor(el) {
        this.el = el;
        this.hasDecimalPoint = false;
        this.navigationKeys = [
            'Backspace',
            'Delete',
            'Tab',
            'Escape',
            'Enter',
            'Home',
            'End',
            'ArrowLeft',
            'ArrowRight',
            'Clear',
            'Copy',
            'Paste',
        ];
        this.decimal = false;
        this.decimalSeparator = '.';
        this.min = -Infinity;
        this.max = Infinity;
        this.inputElement = el && el.nativeElement;
    }
    ngOnChanges(changes) {
        if (changes.pattern) {
            this.regex = this.pattern ? RegExp(this.pattern) : null;
        }
        if (changes.min) {
            const maybeMin = Number(this.min);
            this.min = isNaN(maybeMin) ? -Infinity : maybeMin;
        }
        if (changes.max) {
            const maybeMax = Number(this.max);
            this.max = isNaN(maybeMax) ? Infinity : maybeMax;
        }
    }
    onKeyDown(e) {
        if (this.navigationKeys.indexOf(e.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
            (e.key === 'a' && e.ctrlKey === true) || // Allow: Ctrl+A
            (e.key === 'c' && e.ctrlKey === true) || // Allow: Ctrl+C
            (e.key === 'v' && e.ctrlKey === true) || // Allow: Ctrl+V
            (e.key === 'x' && e.ctrlKey === true) || // Allow: Ctrl+X
            (e.key === 'z' && e.ctrlKey === true) || // Allow: Ctrl+Z
            (e.key === 'a' && e.metaKey === true) || // Allow: Cmd+A (Mac)
            (e.key === 'c' && e.metaKey === true) || // Allow: Cmd+C (Mac)
            (e.key === 'v' && e.metaKey === true) || // Allow: Cmd+V (Mac)
            (e.key === 'x' && e.metaKey === true) || // Allow: Cmd+X (Mac)
            (e.key === 'z' && e.metaKey === true) || // Allow: Cmd+Z (Mac)
            (this.decimal && e.key === this.decimalSeparator && !this.hasDecimalPoint) // Allow: only one decimal point
        ) {
            return;
        }
        // Ensure that it is a number and stop the keypress
        if (e.key === ' ' || isNaN(Number(e.key))) {
            e.preventDefault();
        }
        // check the input pattern RegExp
        if (this.regex) {
            /* eslint-disable no-shadow */
            const newValue1 = this.forecastValue(e.key);
            if (!this.regex.test(newValue1)) {
                e.preventDefault();
            }
        }
        const newValue = Number(this.forecastValue(e.key));
        if (newValue > this.max || newValue < this.min) {
            e.preventDefault();
        }
    }
    onKeyUp(e) {
        this.updateDecimalPoint();
    }
    onPaste(event) {
        let pastedInput;
        if (window['clipboardData']) {
            // Browser is IE
            pastedInput = window['clipboardData'].getData('text');
        }
        else if (event.clipboardData && event.clipboardData.getData) {
            // Other browsers
            pastedInput = event.clipboardData.getData('text/plain');
        }
        this.pasteData(pastedInput);
        event.preventDefault();
    }
    onDrop(event) {
        const textData = event.dataTransfer.getData('text');
        this.inputElement.focus();
        this.pasteData(textData);
        event.preventDefault();
    }
    pasteData(pastedContent) {
        const sanitizedContent = this.sanitizeInput(pastedContent);
        const pasted = document.execCommand('insertText', false, sanitizedContent);
        if (!pasted) {
            if (this.inputElement.setRangeText) {
                const { selectionStart: start, selectionEnd: end } = this.inputElement;
                this.inputElement.setRangeText(sanitizedContent, start, end, 'end');
            }
            else {
                // Browser does not support setRangeText, e.g. IE
                this.insertAtCursor(this.inputElement, sanitizedContent);
            }
        }
        this.updateDecimalPoint();
    }
    insertAtCursor(myField, myValue) {
        const startPos = myField.selectionStart;
        const endPos = myField.selectionEnd;
        myField.value = myField.value.substring(0, startPos) + myValue
            + myField.value.substring(endPos, myField.value.length);
        const pos = startPos + myValue.length;
        myField.focus();
        myField.setSelectionRange(pos, pos);
        this.triggerEvent(myField, 'input');
    }
    triggerEvent(el, type) {
        if ('createEvent' in document) {
            // modern browsers, IE9+
            const e = document.createEvent('HTMLEvents');
            e.initEvent(type, false, true);
            el.dispatchEvent(e);
        }
    }
    // end stack overflow code
    sanitizeInput(input) {
        let result = '';
        if (this.decimal && this.isValidDecimal(input)) {
            const regex = new RegExp(`[^0-9${this.decimalSeparator}]`, 'g');
            result = input.replace(regex, '');
        }
        else {
            result = input.replace(/[^0-9]/g, '');
        }
        const maxLength = this.inputElement.maxLength;
        if (maxLength > 0) {
            // the input element has maxLength limit
            const allowedLength = maxLength - this.inputElement.value.length;
            result = allowedLength > 0 ? result.substring(0, allowedLength) : '';
        }
        return result;
    }
    isValidDecimal(string) {
        if (!this.hasDecimalPoint) {
            return string.split(this.decimalSeparator).length <= 2;
        }
        else {
            // the input element already has a decimal separator
            const selectedText = this.getSelection();
            if (selectedText && selectedText.indexOf(this.decimalSeparator) > -1) {
                return string.split(this.decimalSeparator).length <= 2;
            }
            else {
                return string.indexOf(this.decimalSeparator) < 0;
            }
        }
    }
    updateDecimalPoint() {
        if (this.decimal) {
            this.hasDecimalPoint =
                this.inputElement.value.indexOf(this.decimalSeparator) > -1;
        }
    }
    getSelection() {
        return this.inputElement.value.substring(this.inputElement.selectionStart, this.inputElement.selectionEnd);
    }
    forecastValue(key) {
        const selectionStart = this.inputElement.selectionStart;
        const selectionEnd = this.inputElement.selectionEnd;
        const oldValue = this.inputElement.value;
        const selection = oldValue.substring(selectionStart, selectionEnd);
        return selection
            ? oldValue.replace(selection, key)
            : oldValue.substring(0, selectionStart) +
                key +
                oldValue.substring(selectionStart);
    }
    static { this.ɵfac = function NumericDirective_Factory(t) { return new (t || NumericDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: NumericDirective, selectors: [["", "appNumeric", ""]], hostBindings: function NumericDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("keydown", function NumericDirective_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); })("keyup", function NumericDirective_keyup_HostBindingHandler($event) { return ctx.onKeyUp($event); })("paste", function NumericDirective_paste_HostBindingHandler($event) { return ctx.onPaste($event); })("drop", function NumericDirective_drop_HostBindingHandler($event) { return ctx.onDrop($event); });
        } }, inputs: { decimal: "decimal", decimalSeparator: "decimalSeparator", min: "min", max: "max", pattern: "pattern" }, features: [i0.ɵɵNgOnChangesFeature] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NumericDirective, [{
        type: Directive,
        args: [{
                selector: '[appNumeric]',
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { decimal: [{
            type: Input
        }], decimalSeparator: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], pattern: [{
            type: Input
        }], onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], onKeyUp: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }], onPaste: [{
            type: HostListener,
            args: ['paste', ['$event']]
        }], onDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }] }); })();

function StepperComponent_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
} }
const _c0$7 = function (a0) { return { "is-active": a0 }; };
function StepperComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵelement(2, "div", 4);
    i0.ɵɵelementStart(3, "div", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, StepperComponent_div_1_div_5_Template, 1, 0, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$7, ctx_r0.isActiveIndex(i_r2)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", step_r1.class);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", step_r1.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r2 !== ctx_r0.steps.length - 1);
} }
class StepperComponent {
    constructor() {
        this.steps = [];
        this.activeIndexes = [];
    }
    ngOnInit() {
    }
    isActiveIndex(index) {
        return this.activeIndexes.includes(index);
    }
    static { this.ɵfac = function StepperComponent_Factory(t) { return new (t || StepperComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StepperComponent, selectors: [["app-stepper"]], inputs: { steps: "steps", activeIndexes: "activeIndexes" }, decls: 2, vars: 1, consts: [[1, "stepper"], ["class", "step-wrap", 4, "ngFor", "ngForOf"], [1, "step-wrap"], [1, "step", 3, "ngClass"], [1, "step-icon", 3, "ngClass"], [1, "step-name"], ["class", "line", 4, "ngIf"], [1, "line"]], template: function StepperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, StepperComponent_div_1_Template, 6, 6, "div", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.steps);
        } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf], styles: ["app-stepper[_ngcontent-%COMP%]   .stepper[_ngcontent-%COMP%]   .step-wrap[_ngcontent-%COMP%]{display:flex}app-stepper[_ngcontent-%COMP%]   .stepper[_ngcontent-%COMP%]   .step-wrap[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{width:80px}app-stepper[_ngcontent-%COMP%]   .stepper[_ngcontent-%COMP%]   .step-wrap[_ngcontent-%COMP%]   .step-icon[_ngcontent-%COMP%]{width:100%;height:30px}app-stepper[_ngcontent-%COMP%]   .stepper[_ngcontent-%COMP%]   .step-wrap[_ngcontent-%COMP%]   .step-name[_ngcontent-%COMP%]{padding-top:5px;text-align:center;font-size:12px;font-weight:500}app-stepper[_ngcontent-%COMP%]   .stepper[_ngcontent-%COMP%]   .step-wrap[_ngcontent-%COMP%]   .line[_ngcontent-%COMP%]{height:2px;width:50px;margin-top:14px;margin-left:-10px;margin-right:-10px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StepperComponent, [{
        type: Component,
        args: [{ selector: 'app-stepper', template: "<div class=\"stepper\">\r\n  <div *ngFor=\"let step of steps; let i = index\" class=\"step-wrap\">\r\n    <div class=\"step\" [ngClass]=\"{'is-active': isActiveIndex(i)}\">\r\n      <div class=\"step-icon\" [ngClass]=\"step.class\"></div>\r\n      <div class=\"step-name\">\r\n        {{ step.name }}\r\n      </div>\r\n    </div>\r\n    <div *ngIf=\"i !== steps.length - 1\" class=\"line\"></div>\r\n  </div>\r\n</div>\r\n", styles: ["app-stepper .stepper .step-wrap{display:flex}app-stepper .stepper .step-wrap .step{width:80px}app-stepper .stepper .step-wrap .step-icon{width:100%;height:30px}app-stepper .stepper .step-wrap .step-name{padding-top:5px;text-align:center;font-size:12px;font-weight:500}app-stepper .stepper .step-wrap .line{height:2px;width:50px;margin-top:14px;margin-left:-10px;margin-right:-10px}\n"] }]
    }], function () { return []; }, { steps: [{
            type: Input
        }], activeIndexes: [{
            type: Input
        }] }); })();

class TrueFalseValuePipe {
    constructor(cdr) {
        this.cdr = cdr;
    }
    transform(value, args) {
        if (value === true) {
            args.setValue(1);
        }
        else if (value === false) {
            args.setValue(0);
        }
        this.cdr.detectChanges();
        return;
    }
    static { this.ɵfac = function TrueFalseValuePipe_Factory(t) { return new (t || TrueFalseValuePipe)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef, 16)); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "trueFalseValue", type: TrueFalseValuePipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrueFalseValuePipe, [{
        type: Pipe,
        args: [{
                name: 'trueFalseValue'
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, null); })();

const _c0$6 = ["pinId0"];
const _c1$4 = ["pinId1"];
const _c2$2 = ["pinId2"];
const _c3$2 = ["pinId3"];
function PinInputComponent_div_18_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "strong", 18);
    i0.ɵɵtext(2, "Wrong PIN! ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, "Not set your PIN yet, click PIN Management to set it. ");
    i0.ɵɵelementEnd();
} }
function PinInputComponent_div_18_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "strong", 18);
    i0.ɵɵtext(2, "Invalid PIN! ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, "PIN must contain 4 digits ");
    i0.ɵɵelementEnd();
} }
function PinInputComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "mat-icon", 16);
    i0.ɵɵtext(2, "warning_amber");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PinInputComponent_div_18_div_3_Template, 4, 0, "div", 17);
    i0.ɵɵtemplate(4, PinInputComponent_div_18_div_4_Template, 4, 0, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.singlePinError === "wrong-pin");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.singlePinError === "non-numeric");
} }
const _c4$2 = function (a0, a1) { return { "valid": a0, "invalid": a1 }; };
class PinInputComponent {
    // TODO GRSS 17010 fix url
    // TODO GRSS 17010 gateway pool action matmenu stays out after selecting action
    // TODO GRSS 17010 fix wording on popupconfirmpin
    // TODO GRSS 17010 change error message color
    // TODO GRSS 17010 figure out how to transfer focus to button when last value is entered
    // TODO GRSS 17010 add feature flag to services
    constructor(router, matDialog, uiService, environment) {
        this.router = router;
        this.matDialog = matDialog;
        this.uiService = uiService;
        this.environment = environment;
        this.setFocus = false;
        this.pinChange = new EventEmitter();
        this.pinValidationChange = new EventEmitter();
        this.isPinValid = true;
        this.prevValidation = null;
        this.prevPin = '';
        this.enteredNonNumeric = false;
        this.pinValue = {
            i0: '',
            i1: '',
            i2: '',
            i3: ''
        };
    }
    ngAfterViewInit() {
        if (this.setFocus) {
            setTimeout(() => {
                this.pinInput0.nativeElement.focus();
            }, 400);
        }
    }
    ngOnChanges(changes) {
        if (changes.pin.currentValue === null) {
            this.pinValue.i0 = '';
            this.pinValue.i1 = '';
            this.pinValue.i2 = '';
            this.pinValue.i3 = '';
            this.prevPin = this.pin;
            this.pin = '';
            this.evaluatePin();
            this.isPinValid = false;
        }
    }
    ngOnInit() {
        // reset values each time this is used
        this.uiService.pinResponse = null;
        this.isPinValid = true;
        this.prevValidation = null;
        this.prevPin = '';
        this.enteredNonNumeric = false;
        this.pinValue = {
            i0: '',
            i1: '',
            i2: '',
            i3: ''
        };
    }
    keyMove(event, nextInput) {
        this.prevPin = this.pin;
        this.pin = `${this.pinValue.i0}${this.pinValue.i1}${this.pinValue.i2}${this.pinValue.i3}`;
        this.pinChange.emit(this.pin);
        if (/^\d+$/.test(event.key)) {
            if (nextInput === 'submit') {
                this.pinInput0.nativeElement.blur();
                this.pinInput1.nativeElement.blur();
                this.pinInput2.nativeElement.blur();
                this.pinInput3.nativeElement.blur();
            }
            else {
                this[nextInput].nativeElement.focus();
            }
        }
        this.evaluatePin();
    }
    evaluatePin() {
        if (this.prevPin !== this.pin) {
            const isValid = /^\d{4}$/.test(this.pin);
            const value = isValid ? this.pin : null;
            if (!this.isPinValid && isValid) {
                this.isPinValid = true;
            }
            if (!!value !== this.prevValidation) {
                this.pinValidationChange.emit(value);
                this.prevValidation = !!value;
            }
        }
    }
    allowNumbers(event, chars) {
        if (chars.includes('numbers')) {
            chars = chars.filter(item => item !== 'numbers');
            chars = [
                ...chars,
                '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
            ];
        }
        const isAllowed = chars.includes(event.key);
        this.enteredNonNumeric = !isAllowed;
        if (isAllowed) {
            this.uiService.pinResponse = null;
        }
        return isAllowed;
    }
    get singlePinError() {
        if (this.enteredNonNumeric) {
            return 'non-numeric';
        }
        if (this.uiService.pinResponse === 'wrong-pin') {
            return 'wrong-pin';
        }
    }
    static { this.ɵfac = function PinInputComponent_Factory(t) { return new (t || PinInputComponent)(i0.ɵɵdirectiveInject(i3$1.Router), i0.ɵɵdirectiveInject(i1$4.MatLegacyDialog), i0.ɵɵdirectiveInject(UiService), i0.ɵɵdirectiveInject('environment')); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PinInputComponent, selectors: [["lib-pin-input"]], viewQuery: function PinInputComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$6, 5);
            i0.ɵɵviewQuery(_c1$4, 5);
            i0.ɵɵviewQuery(_c2$2, 5);
            i0.ɵɵviewQuery(_c3$2, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pinInput0 = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pinInput1 = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pinInput2 = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pinInput3 = _t.first);
        } }, inputs: { pin: "pin", setFocus: "setFocus" }, outputs: { pinChange: "pinChange", pinValidationChange: "pinValidationChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 19, vars: 10, consts: [[1, "ma-pin-component"], [1, "flex", "flex-space-between", "pin-wrap", 3, "ngClass"], [1, "pin-comp-link-container"], ["target", "_blank", 3, "href"], [1, "flex"], [1, "pin-comp-input-container"], ["type", "password", "minlength", "0", "maxlength", "1", "data-cy", "lib-pin-input-0", 3, "ngModel", "ngModelChange", "focus", "keyup", "keypress"], ["pinId0", ""], ["type", "password", "minlength", "0", "maxlength", "1", "data-cy", "lib-pin-input-1", 3, "ngModel", "ngModelChange", "focus", "keyup", "keypress"], ["pinId1", ""], ["type", "password", "minlength", "0", "maxlength", "1", "data-cy", "lib-pin-input-2", 3, "ngModel", "ngModelChange", "focus", "keyup", "keypress"], ["pinId2", ""], ["type", "password", "minlength", "0", "maxlength", "1", "data-cy", "lib-pin-input-3", 3, "ngModel", "ngModelChange", "focus", "keyup", "keypress"], ["pinId3", ""], ["class", "warn-panel flex flex-center flex-middle m-t-md", 4, "ngIf"], [1, "warn-panel", "flex", "flex-center", "flex-middle", "m-t-md"], [1, "m-r-sm", "is-small", 2, "transform", "translateY(-2px)"], [4, "ngIf"], [1, "strong"]], template: function PinInputComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "a", 3);
            i0.ɵɵtext(4, "PIN Management");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 4)(6, "div", 5)(7, "input", 6, 7);
            i0.ɵɵlistener("ngModelChange", function PinInputComponent_Template_input_ngModelChange_7_listener($event) { return ctx.pinValue.i0 = $event; })("focus", function PinInputComponent_Template_input_focus_7_listener($event) { return $event.target.select(); })("keyup", function PinInputComponent_Template_input_keyup_7_listener($event) { return ctx.keyMove($event, "pinInput1"); })("keypress", function PinInputComponent_Template_input_keypress_7_listener($event) { return ctx.allowNumbers($event, ["numbers"]); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 5)(10, "input", 8, 9);
            i0.ɵɵlistener("ngModelChange", function PinInputComponent_Template_input_ngModelChange_10_listener($event) { return ctx.pinValue.i1 = $event; })("focus", function PinInputComponent_Template_input_focus_10_listener($event) { return $event.target.select(); })("keyup", function PinInputComponent_Template_input_keyup_10_listener($event) { return ctx.keyMove($event, "pinInput2"); })("keypress", function PinInputComponent_Template_input_keypress_10_listener($event) { return ctx.allowNumbers($event, ["numbers"]); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 5)(13, "input", 10, 11);
            i0.ɵɵlistener("ngModelChange", function PinInputComponent_Template_input_ngModelChange_13_listener($event) { return ctx.pinValue.i2 = $event; })("focus", function PinInputComponent_Template_input_focus_13_listener($event) { return $event.target.select(); })("keyup", function PinInputComponent_Template_input_keyup_13_listener($event) { return ctx.keyMove($event, "pinInput3"); })("keypress", function PinInputComponent_Template_input_keypress_13_listener($event) { return ctx.allowNumbers($event, ["numbers"]); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "div", 5)(16, "input", 12, 13);
            i0.ɵɵlistener("ngModelChange", function PinInputComponent_Template_input_ngModelChange_16_listener($event) { return ctx.pinValue.i3 = $event; })("focus", function PinInputComponent_Template_input_focus_16_listener($event) { return $event.target.select(); })("keyup", function PinInputComponent_Template_input_keyup_16_listener($event) { return ctx.keyMove($event, "submit"); })("keypress", function PinInputComponent_Template_input_keypress_16_listener($event) { return ctx.allowNumbers($event, ["numbers"]); });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵtemplate(18, PinInputComponent_div_18_Template, 5, 2, "div", 14);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c4$2, ctx.isPinValid, !ctx.isPinValid));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("href", ctx.environment.pinManagementUrl, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngModel", ctx.pinValue.i0);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngModel", ctx.pinValue.i1);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngModel", ctx.pinValue.i2);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngModel", ctx.pinValue.i3);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.singlePinError);
        } }, dependencies: [i1.NgClass, i1.NgIf, i3$2.DefaultValueAccessor, i3$2.NgControlStatus, i3$2.MinLengthValidator, i3$2.MaxLengthValidator, i3$2.NgModel, i2.MatIcon], styles: [".ma-pin-component[_ngcontent-%COMP%]{position:relative;padding:15px 0;margin-bottom:15px}.ma-pin-component[_ngcontent-%COMP%]   .pin-comp-link-container[_ngcontent-%COMP%]{padding-top:8px;padding-right:10px}.ma-pin-component[_ngcontent-%COMP%]   .pin-comp-input-container[_ngcontent-%COMP%]{margin-left:4px}.ma-pin-component[_ngcontent-%COMP%]   .pin-comp-input-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:26px;height:32px;text-align:center;border-style:solid;border-radius:0}.ma-pin-component[_ngcontent-%COMP%]   .pin-comp-input-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{outline:none}.ma-pin-component[_ngcontent-%COMP%]   .ma-pin-hint[_ngcontent-%COMP%]{font-size:70%!important;position:absolute;bottom:0;left:64px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PinInputComponent, [{
        type: Component,
        args: [{ selector: 'lib-pin-input', template: "<div class=\"ma-pin-component\">\r\n  <div\r\n    class=\"flex flex-space-between pin-wrap\"\r\n    [ngClass]=\"{'valid': isPinValid, 'invalid': !isPinValid}\"\r\n  >\r\n    <div class=\"pin-comp-link-container\">\r\n      <a\r\n        [href]=\"environment.pinManagementUrl\"\r\n        target=\"_blank\"\r\n      >PIN Management</a>\r\n    </div>\r\n    <div class=\"flex\">\r\n      <div class=\"pin-comp-input-container\">\r\n        <input\r\n          type=\"password\"\r\n          #pinId0\r\n          [(ngModel)]=\"pinValue.i0\"\r\n          minlength=\"0\"\r\n          maxlength=\"1\"\r\n          (focus)=\"$event.target.select()\"\r\n          (keyup)=\"keyMove($event, 'pinInput1')\"\r\n          (keypress)=\"allowNumbers($event, ['numbers'])\"\r\n          data-cy=\"lib-pin-input-0\"\r\n        >\r\n      </div>\r\n      <div class=\"pin-comp-input-container\">\r\n        <input\r\n          type=\"password\"\r\n          #pinId1\r\n          [(ngModel)]=\"pinValue.i1\"\r\n          minlength=\"0\"\r\n          maxlength=\"1\"\r\n          (focus)=\"$event.target.select()\"\r\n          (keyup)=\"keyMove($event, 'pinInput2')\"\r\n          (keypress)=\"allowNumbers($event, ['numbers'])\"\r\n          data-cy=\"lib-pin-input-1\"\r\n        >\r\n      </div>\r\n      <div class=\"pin-comp-input-container\">\r\n        <input\r\n          type=\"password\"\r\n          #pinId2\r\n          [(ngModel)]=\"pinValue.i2\"\r\n          minlength=\"0\"\r\n          maxlength=\"1\"\r\n          (focus)=\"$event.target.select()\"\r\n          (keyup)=\"keyMove($event, 'pinInput3')\"\r\n          (keypress)=\"allowNumbers($event, ['numbers'])\"\r\n          data-cy=\"lib-pin-input-2\"\r\n        >\r\n      </div>\r\n      <div class=\"pin-comp-input-container\">\r\n        <input\r\n          type=\"password\"\r\n          #pinId3\r\n          [(ngModel)]=\"pinValue.i3\"\r\n          minlength=\"0\"\r\n          maxlength=\"1\"\r\n          (focus)=\"$event.target.select()\"\r\n          (keyup)=\"keyMove($event, 'submit')\"\r\n          (keypress)=\"allowNumbers($event, ['numbers'])\"\r\n          data-cy=\"lib-pin-input-3\"\r\n        >\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div\r\n    *ngIf=\"singlePinError\"\r\n    class=\"warn-panel flex flex-center flex-middle m-t-md\"\r\n  >\r\n    <mat-icon class=\"m-r-sm is-small\" style=\"transform: translateY(-2px);\">warning_amber</mat-icon>\r\n    <div\r\n      *ngIf=\"singlePinError === 'wrong-pin'\"\r\n    >\r\n      <strong class=\"strong\">Wrong PIN! </strong>Not set your PIN yet, click PIN Management to set it.\r\n    </div>\r\n    <div\r\n      *ngIf=\"singlePinError === 'non-numeric'\"\r\n    >\r\n      <strong class=\"strong\">Invalid PIN! </strong>PIN must contain 4 digits\r\n    </div>\r\n  </div>\r\n</div>", styles: [".ma-pin-component{position:relative;padding:15px 0;margin-bottom:15px}.ma-pin-component .pin-comp-link-container{padding-top:8px;padding-right:10px}.ma-pin-component .pin-comp-input-container{margin-left:4px}.ma-pin-component .pin-comp-input-container input{width:26px;height:32px;text-align:center;border-style:solid;border-radius:0}.ma-pin-component .pin-comp-input-container input:focus{outline:none}.ma-pin-component .ma-pin-hint{font-size:70%!important;position:absolute;bottom:0;left:64px}\n"] }]
    }], function () { return [{ type: i3$1.Router }, { type: i1$4.MatLegacyDialog }, { type: UiService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['environment']
            }] }]; }, { pinInput0: [{
            type: ViewChild,
            args: ['pinId0']
        }], pinInput1: [{
            type: ViewChild,
            args: ['pinId1']
        }], pinInput2: [{
            type: ViewChild,
            args: ['pinId2']
        }], pinInput3: [{
            type: ViewChild,
            args: ['pinId3']
        }], pin: [{
            type: Input
        }], setFocus: [{
            type: Input
        }], pinChange: [{
            type: Output
        }], pinValidationChange: [{
            type: Output
        }] }); })();

class AccessDeniedComponent {
    constructor(environment) {
        this.environment = environment;
    }
    ngOnInit() {
    }
    static { this.ɵfac = function AccessDeniedComponent_Factory(t) { return new (t || AccessDeniedComponent)(i0.ɵɵdirectiveInject('environment')); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AccessDeniedComponent, selectors: [["access-denied"]], decls: 7, vars: 0, consts: [[1, "container"], [1, "flex", "full-column", "box-denied"]], template: function AccessDeniedComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3")(3, "strong");
            i0.ɵɵtext(4, "Access denied");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "p");
            i0.ɵɵtext(6, "You don't have permission to access this page. Contact your administrators to request access");
            i0.ɵɵelementEnd()()();
        } }, styles: [".box-denied[_ngcontent-%COMP%]{display:block;padding:40px 40px 25px;margin-top:40px;border:solid 1px lightgrey}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccessDeniedComponent, [{
        type: Component,
        args: [{ selector: 'access-denied', template: "<div class=\"container\">\r\n    <div class=\"flex full-column box-denied\">\r\n        <h3><strong>Access denied</strong></h3>\r\n        <p>You don't have permission to access this page. Contact your administrators to request access</p>      \r\n    </div>\r\n</div>", styles: [".box-denied{display:block;padding:40px 40px 25px;margin-top:40px;border:solid 1px lightgrey}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['environment']
            }] }]; }, null); })();

function LineChart2Component_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 7);
    i0.ɵɵtext(1, "Last 7 days");
    i0.ɵɵelementEnd();
} }
function LineChart2Component_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
} }
function LineChart2Component_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "p", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.placeHolderMessage);
} }
const moment = moment_;
class LineChart2Component {
    constructor(chartElem) {
        this.chartElem = chartElem;
        this.data = [];
        this.placeHolderMessage = 'Loading data for graph, please wait...';
        this.hasData = true;
        this.margin = { top: 15, right: 20, bottom: 35, left: 35 };
        this.isInitialized = false;
    }
    ngOnInit() {
        // Is small graph or big graph
        this.isBig = this.className.includes('big') ? true : false;
        // Set x-axis ticks for small graph
        if (!this.isBig) {
            this.xTickCount = 3;
        }
    }
    ngAfterViewInit() {
        this.initializeChart();
        this.isInitialized = true;
    }
    ngOnChanges(changes) {
        // Only update when data is available
        if (changes.hasOwnProperty('data') && this.data && this.isInitialized && this.hasData) {
            if (Object.keys(this.data).length === 0) {
                this.hasData = false;
                this.placeHolderMessage = 'No data';
                return;
            }
            // Resize event
            window.addEventListener('resize', () => {
                this.updateSvgWidth();
                this.setSize();
                this.update();
            });
            this.update();
        }
    }
    initializeChart() {
        // Adjust title
        d3
            .select(this.chartElem.nativeElement.querySelector('.gateway-metric-line-chart-title'))
            .style('padding-left', this.margin.left + 'px');
        // Initialize main svg
        this.svg = d3
            .select(this.chartElem.nativeElement)
            .select('.' + this.className)
            .style('height', this.chartHeight + 'px')
            .append('div')
            .attr('class', 'line-chart-container')
            .append('svg')
            .attr('height', this.chartHeight)
            .attr('width', this.chartWidth);
        // Initialize inner svg
        this.svgInner = this.svg
            .append('g')
            .attr('id', 'svgInner')
            .style('transform', 'translate(' + this.margin.left + 'px, ' + this.margin.top + 'px)');
        // Initialize axis
        this.svgInner
            .append('g')
            .attr('id', 'y-axis');
        this.svgInner
            .append('g')
            .attr('id', 'x-axis');
        // Initialize grid
        this.grid = this.svgInner
            .append('g')
            .attr('id', 'backgroundGrid');
        this.grid
            .append('g')
            .attr('id', 'y-axisGrid')
            .attr('class', 'gateway-metric-line-chart-grid');
        this.grid
            .append('g')
            .attr('id', 'x-axisGrid')
            .attr('class', 'gateway-metric-line-chart-grid');
        // Initialize data group
        this.dataGroup = this.svgInner
            .append('g')
            .attr('id', 'data');
        this.lineGroup = this.dataGroup
            .append('path')
            .attr('id', 'line')
            .attr('class', 'gateway-metric-line-chart-line');
        this.pointGroup = this.dataGroup
            .append('g')
            .attr('id', 'points');
        // Initialize bisector line group
        this.data_point_group = this.svgInner
            .append('g');
        this.bisector_line = this.data_point_group
            .append('line')
            .attr('y1', 0)
            .attr('stroke', 'black')
            .attr('stroke-width', 1)
            .attr('opacity', 0);
        this.data_point = this.data_point_group
            .append('circle')
            .attr('id', 'point')
            .attr('fill', '#111F42')
            .attr('stroke', 'none')
            .attr('r', 3)
            .attr('opacity', 0);
        this.data_point_text_group = this.data_point_group
            .append('g');
        this.data_point_value_background = this.data_point_text_group
            .append('rect')
            .attr('fill', 'white')
            .attr('stroke-width', 1)
            .attr('stroke', '#111F42');
        this.data_point_value = this.data_point_text_group
            .append('text');
        this.data_point_date = this.data_point_text_group
            .append('text');
    }
    update() {
        // Set the x axis domain
        const domain = d3.extent(this.data, d => new Date(d.date));
        // Adjust the chart width
        this.updateSvgWidth();
        this.setSize();
        this.svg
            .attr('width', this.chartWidth);
        // Dynamic x axis tick count
        if (this.data.length <= 8) {
            this.xTickCount = this.data.length;
        }
        else if (this.isBig) {
            this.xTickCount = null;
        }
        // Update domains
        this.yScale = d3
            .scaleLinear()
            .domain([d3.max(this.data, d => d.value) * 1.2 + 3, d3.min(this.data, d => d.value) * .9]);
        this.xScale = d3
            .scaleUtc()
            .domain(domain);
        // Update range
        this.yScale
            .range([0, this.height]);
        this.xScale
            .range([0, this.width]);
        const xTimeFormat = '%b %d|%I:%M %p';
        // Update axis
        this.xAxis = d3
            .axisBottom(this.xScale)
            .tickFormat(d3.timeFormat(xTimeFormat))
            .tickSize(0)
            .ticks(this.xTickCount);
        this.yAxis = d3
            .axisLeft(this.yScale)
            .tickSize(0)
            .ticks(3);
        // Update grid
        this.xGridlines = d3
            .axisBottom(this.xScale)
            .tickSize(this.height)
            .tickFormat(() => '')
            .ticks(this.xTickCount);
        this.yGridlines = d3
            .axisLeft(this.yScale)
            .tickSize(this.width)
            .tickFormat(() => '')
            .ticks(3);
        // Draw new axis
        this.svgInner
            .select('#y-axis')
            .transition()
            .call(this.yAxis);
        this.svgInner
            .select('#x-axis')
            .call(this.xAxis)
            .style('transform', 'translate( 0, ' + (this.height) + 'px)')
            .selectAll('text')
            .style('text-anchor', 'start')
            .style('transform', 'translate( 0, 2px)');
        this.svgInner
            .select('#x-axis')
            .selectAll('text')
            .each((d, i, n) => this.breakXAxisLabels(d, i, n));
        // Draw new grid
        this.svg
            .select('#y-axisGrid')
            .style('transform', 'translate(' + (this.width) + 'px, 0)')
            .transition()
            .call(this.yGridlines);
        this.grid
            .select('#x-axisGrid')
            .transition()
            .call(this.xGridlines);
        // Generate the line
        const line = d3
            .line()
            .x(d => d[0])
            .y(d => d[1]);
        // Generate points
        const points = this.data.map(d => [
            this.xScale(d.date),
            this.yScale(d.value),
        ]);
        // Draw new line
        this.lineGroup
            .data([points])
            .transition()
            .duration(400)
            .attr('d', line(points));
        // Update bisector
        this.bisector_line
            .attr('y2', this.height);
        this.svgInner
            .on('mouseover', () => {
            this.data_point_group
                .attr('opacity', 1);
            this.bisector_line
                .attr('opacity', 1);
            this.data_point
                .attr('opacity', 1);
        })
            .on('mouseout', () => {
            this.data_point_group
                .attr('opacity', 0);
            this.bisector_line
                .attr('opacity', 0);
            this.data_point
                .attr('opacity', 0);
        })
            .on('mousemove', () => this.onBisectorMouseOver(points));
    }
    updateSvgWidth() {
        this.chartWidth = this.chartElem.nativeElement.children[0].clientWidth - 5;
    }
    setSize() {
        this.width = this.chartWidth - this.margin.left - this.margin.right;
        this.height = this.chartHeight - this.margin.top - this.margin.bottom;
    }
    onBisectorMouseOver(points) {
        const bisectDate = d3.bisector((d) => d.date).left;
        let closest_point_index = bisectDate(this.data, this.xScale.invert(d3.event.offsetX - this.margin.left));
        const mouseDate = d3.event.offsetX - this.margin.left;
        // Handle out of bounds error because of bisector function
        if (closest_point_index < 1) {
            closest_point_index = 1;
        }
        else if (closest_point_index >= this.data.length) {
            closest_point_index = this.data.length - 1;
        }
        const d0 = points[closest_point_index - 1];
        const d1 = points[closest_point_index];
        const closest_point = (mouseDate - d0[0] > d1[0] - mouseDate) ? d1 : d0;
        const value = this.yScale.invert(closest_point[1]);
        const date = moment(this.xScale.invert(closest_point[0]));
        let x = closest_point[0];
        let y = closest_point[1];
        const trasition_delay = 40;
        // Initialize bisector elements
        this.bisector_line
            .transition()
            .duration(trasition_delay)
            .attr('x1', x)
            .attr('x2', x);
        this.data_point
            .transition()
            .duration(trasition_delay)
            .attr('cx', x)
            .attr('cy', y);
        this.data_point_value
            .text((Math.round(value * 100) / 100) + (this.unitType === '%' ? '' : ' ') + this.unitType);
        this.data_point_date
            .text(date.format(this.interval === '1m' ? 'h:mm A' : 'MMM DD, h A'));
        // Adjust position of bisector elements
        const dateWidth = this.data_point_date.node().getBoundingClientRect().width;
        const dateHeight = this.data_point_date.node().getBoundingClientRect().height;
        const textWidth = this.data_point_value.node().getBoundingClientRect().width;
        const textHeight = this.data_point_value.node().getBoundingClientRect().height;
        const textGroupWidth = Math.max(dateWidth, textWidth) + 7;
        const textGroupHeight = dateHeight + textHeight + 3;
        // Y offset
        y += 10;
        if (y < 50) {
            y += 70;
        }
        if (x > this.width - 20) {
            x -= 30;
        }
        else if (x < 10) {
            x += 30;
        }
        this.data_point_value
            .transition()
            .duration(trasition_delay)
            .attr('x', x - (textWidth / 2))
            .attr('y', y - 34);
        this.data_point_date
            .transition()
            .duration(trasition_delay)
            .attr('x', x - (dateWidth / 2))
            .attr('y', y - 53);
        this.data_point_value_background
            .transition()
            .duration(trasition_delay)
            .attr('width', textGroupWidth)
            .attr('height', textGroupHeight)
            .attr('x', x - (textGroupWidth / 2))
            .attr('y', y - 30 - (textGroupHeight));
    }
    breakXAxisLabels(d, i, n) {
        const date = moment(d).format('MMM DD');
        const time = moment(d).format(this.interval === '1m' ? 'h:mm A' : 'h A');
        const tz = mtz.tz(mtz.tz.guess()).zoneAbbr();
        const element = d3.select(n[i]);
        element.text('');
        // Append tspan elements to x axis labels
        const date_line = element
            .append('tspan')
            .text(date);
        const time_line = element
            .append('tspan')
            .text(time)
            .attr('x', 0)
            .attr('dy', 12);
        if (i === 0) {
            time_line.text(time + ' (' + tz + ')');
        }
        // Set position of tspan elements
        const date_line_width = date_line.node().getBBox().width;
        const time_line_width = time_line.node().getBBox().width;
        date_line
            .attr('dx', -(date_line_width / 2));
        time_line
            .attr('dx', -(time_line_width / 2));
    }
    static { this.ɵfac = function LineChart2Component_Factory(t) { return new (t || LineChart2Component)(i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LineChart2Component, selectors: [["app-line-chart2"]], inputs: { recordType: "recordType", displayName: "displayName", data: "data", chartWidth: "chartWidth", chartHeight: "chartHeight", className: "className", interval: "interval", unitType: "unitType" }, features: [i0.ɵɵNgOnChangesFeature], decls: 9, vars: 6, consts: [[1, "line-chart2"], [1, "flex", "gateway-metric-line-chart-title"], [1, ""], ["class", "m-l-sm", 4, "ngIf"], [3, "className"], ["class", "line-chart-container", 4, "ngIf", "ngIfElse"], ["line_chart_placeholder", ""], [1, "m-l-sm"], [1, "line-chart-container"], [1, "gateway-metric-line-chart-loading"]], template: function LineChart2Component_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, LineChart2Component_p_4_Template, 2, 0, "p", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 4);
            i0.ɵɵtemplate(6, LineChart2Component_div_6_Template, 1, 0, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, LineChart2Component_ng_template_7_Template, 3, 1, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const _r2 = i0.ɵɵreference(8);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", ctx.displayName, " (", ctx.unitType, ")");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.isBig);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("className", ctx.className);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.data && ctx.data.length > 0)("ngIfElse", _r2);
        } }, dependencies: [i1.NgIf], styles: ["app-line-chart2[_ngcontent-%COMP%]   .line-chart-container[_ngcontent-%COMP%]{position:absolute;overflow:hidden}app-line-chart2[_ngcontent-%COMP%]   .gateway-metric-line-chart-grid[_ngcontent-%COMP%]{stroke-opacity:.3}app-line-chart2[_ngcontent-%COMP%]   .gateway-metric-line-chart-title[_ngcontent-%COMP%]{align-items:center;height:30px;padding-top:10px}app-line-chart2[_ngcontent-%COMP%]   .gateway-metric-line-chart-title[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{margin:0!important}app-line-chart2[_ngcontent-%COMP%]   .gateway-metric-line-chart-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0 0 0 8px!important}app-line-chart2[_ngcontent-%COMP%]   .gateway-metric-line-chart-line[_ngcontent-%COMP%]{fill:none;stroke-width:2px}app-line-chart2[_ngcontent-%COMP%]   .gateway-metric-line-chart-loading[_ngcontent-%COMP%]{top:300px;text-align:center}app-line-chart2[_ngcontent-%COMP%]   #svgInner[_ngcontent-%COMP%]{pointer-events:all}@media only screen and (max-width: 980px){app-line-chart2[_ngcontent-%COMP%]   .gateway-metric-line-chart-title[_ngcontent-%COMP%]{height:28px;padding-top:6px}app-line-chart2[_ngcontent-%COMP%]   .gateway-metric-line-chart-title[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-size:12px;margin:0!important}app-line-chart2[_ngcontent-%COMP%]   .gateway-metric-line-chart-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:10px;margin:0 0 0 8px!important}app-line-chart2[_ngcontent-%COMP%]   .gateway-metric-record-selector[_ngcontent-%COMP%]{display:block}app-line-chart2[_ngcontent-%COMP%]   .gateway-metric-chart-timezone-label[_ngcontent-%COMP%]{font-size:12px}}@media only screen and (max-width: 780px){app-line-chart2[_ngcontent-%COMP%]   .gateway-metric-line-chart-title[_ngcontent-%COMP%]{display:block;flex:none}app-line-chart2[_ngcontent-%COMP%]   .gateway-metric-line-chart-title[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-size:12px;margin:0!important}app-line-chart2[_ngcontent-%COMP%]   .gateway-metric-line-chart-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:10px;margin:0!important}}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LineChart2Component, [{
        type: Component,
        args: [{ selector: 'app-line-chart2', template: "<div class=\"line-chart2\">\r\n\t\t<div class=\"flex gateway-metric-line-chart-title\">\r\n\t\t\t\t<h3 class=\"\">{{displayName}} ({{unitType}})</h3>\r\n\t\t\t\t<p *ngIf=\"!isBig\" class=\"m-l-sm\">Last 7 days</p>\r\n\t\t</div>\r\n\t\t\t\t<div [className]=\"className\">\r\n\t\t\t\t\t<div *ngIf=\"!!data && data.length > 0; else line_chart_placeholder\" class=\"line-chart-container\">\r\n\t\t\t\t</div>\r\n\t\t</div>\r\n    <ng-template #line_chart_placeholder>\r\n        <div>\r\n            <p class=\"gateway-metric-line-chart-loading\" >{{ placeHolderMessage }}</p>\r\n        </div>\r\n    </ng-template>\r\n</div>", styles: ["app-line-chart2 .line-chart-container{position:absolute;overflow:hidden}app-line-chart2 .gateway-metric-line-chart-grid{stroke-opacity:.3}app-line-chart2 .gateway-metric-line-chart-title{align-items:center;height:30px;padding-top:10px}app-line-chart2 .gateway-metric-line-chart-title h3{margin:0!important}app-line-chart2 .gateway-metric-line-chart-title p{margin:0 0 0 8px!important}app-line-chart2 .gateway-metric-line-chart-line{fill:none;stroke-width:2px}app-line-chart2 .gateway-metric-line-chart-loading{top:300px;text-align:center}app-line-chart2 #svgInner{pointer-events:all}@media only screen and (max-width: 980px){app-line-chart2 .gateway-metric-line-chart-title{height:28px;padding-top:6px}app-line-chart2 .gateway-metric-line-chart-title h3{font-size:12px;margin:0!important}app-line-chart2 .gateway-metric-line-chart-title p{font-size:10px;margin:0 0 0 8px!important}app-line-chart2 .gateway-metric-record-selector{display:block}app-line-chart2 .gateway-metric-chart-timezone-label{font-size:12px}}@media only screen and (max-width: 780px){app-line-chart2 .gateway-metric-line-chart-title{display:block;flex:none}app-line-chart2 .gateway-metric-line-chart-title h3{font-size:12px;margin:0!important}app-line-chart2 .gateway-metric-line-chart-title p{font-size:10px;margin:0!important}}\n"] }]
    }], function () { return [{ type: i0.ElementRef }]; }, { recordType: [{
            type: Input
        }], displayName: [{
            type: Input
        }], data: [{
            type: Input
        }], chartWidth: [{
            type: Input
        }], chartHeight: [{
            type: Input
        }], className: [{
            type: Input
        }], interval: [{
            type: Input
        }], unitType: [{
            type: Input
        }] }); })();

function InlineNotificationComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "i");
    i0.ɵɵelementEnd();
} }
function InlineNotificationComponent_div_0_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "check");
    i0.ɵɵelementEnd();
} }
function InlineNotificationComponent_div_0_mat_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "close");
    i0.ɵɵelementEnd();
} }
function InlineNotificationComponent_div_0_mat_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "close");
    i0.ɵɵelementEnd();
} }
function InlineNotificationComponent_div_0_mat_icon_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "close");
    i0.ɵɵelementEnd();
} }
function InlineNotificationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 1);
    i0.ɵɵtemplate(2, InlineNotificationComponent_div_0_div_2_Template, 2, 0, "div", 2);
    i0.ɵɵtemplate(3, InlineNotificationComponent_div_0_mat_icon_3_Template, 2, 0, "mat-icon", 2);
    i0.ɵɵtemplate(4, InlineNotificationComponent_div_0_mat_icon_4_Template, 2, 0, "mat-icon", 2);
    i0.ɵɵtemplate(5, InlineNotificationComponent_div_0_mat_icon_5_Template, 2, 0, "mat-icon", 2);
    i0.ɵɵtemplate(6, InlineNotificationComponent_div_0_mat_icon_6_Template, 2, 0, "mat-icon", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 3)(8, "div", 4);
    i0.ɵɵprojection(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 5);
    i0.ɵɵprojection(11, 1);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 6);
    i0.ɵɵlistener("click", function InlineNotificationComponent_div_0_Template_div_click_12_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.close()); });
    i0.ɵɵelementStart(13, "mat-icon");
    i0.ɵɵtext(14, "close");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("inline-notification--wrap inline-notification--", ctx_r0.type, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.type === "neutral");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.type === "positive");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.type === "cautionary");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.type === "slightly-negative");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.type === "negative");
} }
const _c0$5 = [[["", "title", ""]], [["", "description", ""]]];
const _c1$3 = ["[title]", "[description]"];
class InlineNotificationComponent {
    constructor() {
        this.type = 'neutral';
        // eslint-disable-next-line
        this.onClose = new EventEmitter();
        this.closed = false;
    }
    ngOnInit() { }
    close() {
        this.closed = true;
        this.onClose.next();
    }
    static { this.ɵfac = function InlineNotificationComponent_Factory(t) { return new (t || InlineNotificationComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InlineNotificationComponent, selectors: [["app-inline-notification"]], inputs: { type: "type" }, outputs: { onClose: "onClose" }, ngContentSelectors: _c1$3, decls: 1, vars: 1, consts: [[3, "class", 4, "ngIf"], [1, "inline-notification--icon"], [4, "ngIf"], [1, "inline-notification--content"], [1, "inline-notification--title"], [1, "inline-notification--description"], [1, "inline-notification--close", 3, "click"]], template: function InlineNotificationComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$5);
            i0.ɵɵtemplate(0, InlineNotificationComponent_div_0_Template, 15, 8, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.closed);
        } }, dependencies: [i1.NgIf, i2.MatIcon], styles: ["app-inline-notification[_ngcontent-%COMP%]{display:block}.inline-notification--icon[_ngcontent-%COMP%]{flex:0 0 20px;width:20px;height:20px;line-height:20px;margin-right:20px;text-align:center}.inline-notification--icon[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{width:20px;height:20px;line-height:20px;font-size:16px;font-weight:500}.inline-notification--close[_ngcontent-%COMP%]{flex:0 0 20px;width:20px;height:20px;line-height:20px;margin-left:20px;text-align:center}.inline-notification--close[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{width:20px;height:20px;line-height:20px;font-size:16px}.inline-notification--close[_ngcontent-%COMP%]:hover   .mat-icon[_ngcontent-%COMP%]{cursor:pointer}.inline-notification--content[_ngcontent-%COMP%]{flex:1 1 auto}.inline-notification--wrap[_ngcontent-%COMP%]{padding:10px;display:flex;margin-bottom:5px}.inline-notification--wrap[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0}.inline-notification--title[_ngcontent-%COMP%]{font-weight:500!important;line-height:20px}.inline-notification--description[_ngcontent-%COMP%]{line-height:16px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InlineNotificationComponent, [{
        type: Component,
        args: [{ selector: 'app-inline-notification', template: "<div *ngIf=\"!closed\" class=\"inline-notification--wrap inline-notification--{{ type }}\">\r\n\t<div class=\"inline-notification--icon\">\r\n\t\t<div *ngIf=\"type === 'neutral'\">i</div>\r\n\t\t<mat-icon *ngIf=\"type === 'positive'\">check</mat-icon>\r\n\t\t<mat-icon *ngIf=\"type === 'cautionary'\">close</mat-icon>\r\n\t\t<mat-icon *ngIf=\"type === 'slightly-negative'\">close</mat-icon>\r\n\t\t<mat-icon *ngIf=\"type === 'negative'\">close</mat-icon>\r\n\t</div>\r\n\t<div class=\"inline-notification--content\">\r\n\t\t<div class=\"inline-notification--title\">\r\n\t\t\t<ng-content select=\"[title]\"></ng-content>\r\n\t\t</div>\r\n\t\t<div class=\"inline-notification--description\">\r\n\t\t\t<ng-content select=\"[description]\"></ng-content>\r\n\t\t</div>\r\n\t</div>\r\n\t<div class=\"inline-notification--close\" (click)=\"close()\">\r\n\t\t<mat-icon>close</mat-icon>\r\n\t</div>\r\n</div>\r\n", styles: ["app-inline-notification{display:block}.inline-notification--icon{flex:0 0 20px;width:20px;height:20px;line-height:20px;margin-right:20px;text-align:center}.inline-notification--icon .mat-icon{width:20px;height:20px;line-height:20px;font-size:16px;font-weight:500}.inline-notification--close{flex:0 0 20px;width:20px;height:20px;line-height:20px;margin-left:20px;text-align:center}.inline-notification--close .mat-icon{width:20px;height:20px;line-height:20px;font-size:16px}.inline-notification--close:hover .mat-icon{cursor:pointer}.inline-notification--content{flex:1 1 auto}.inline-notification--wrap{padding:10px;display:flex;margin-bottom:5px}.inline-notification--wrap p{margin:0}.inline-notification--title{font-weight:500!important;line-height:20px}.inline-notification--description{line-height:16px}\n"] }]
    }], function () { return []; }, { type: [{
            type: Input
        }], onClose: [{
            type: Output
        }] }); })();

const _c0$4 = ["editField"];
function PageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 17);
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("svgIcon", item_r7 == null ? null : item_r7.icon);
} }
function PageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", ctx_r15.editableValue)("matTooltipDisabled", !ctx_r15.uiService.willTrim(ctx_r15.editableValue, item_r7));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r15.uiService.trimTitle(ctx_r15.editableValue, item_r7 == null ? null : item_r7.maxLength), " ");
} }
const _c1$2 = function (a0) { return { "item-betwwen": a0 }; };
function PageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(4);
    const item_r7 = ctx_r19.$implicit;
    const i_r8 = ctx_r19.index;
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", item_r7.title)("matTooltipDisabled", !ctx_r16.uiService.willTrim(item_r7.title, item_r7))("ngClass", i0.ɵɵpureFunction1(4, _c1$2, i_r8 + 1 < ctx_r16.breadcrumbItems.length && i_r8 !== 0));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.uiService.trimTitle(item_r7.title, item_r7 == null ? null : item_r7.maxLength), " ");
} }
function PageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_mat_icon_1_Template, 1, 1, "mat-icon", 14);
    i0.ɵɵtemplate(2, PageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_span_2_Template, 2, 3, "span", 15);
    i0.ɵɵtemplate(3, PageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_span_3_Template, 2, 6, "span", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    const item_r7 = ctx_r20.$implicit;
    const i_r8 = ctx_r20.index;
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r7 == null ? null : item_r7.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.isLastBreadcrumbEditable && i_r8 + 1 === ctx_r12.breadcrumbItems.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r12.isLastBreadcrumbEditable || i_r8 + 1 !== ctx_r12.breadcrumbItems.length);
} }
function PageTitleComponent_ng_container_2_ng_container_1_div_1_a_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", ctx_r21.editableValue)("matTooltipDisabled", !ctx_r21.uiService.willTrim(ctx_r21.editableValue, item_r7));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r21.uiService.trimTitle(ctx_r21.editableValue, item_r7 == null ? null : item_r7.maxLength), " ");
} }
function PageTitleComponent_ng_container_2_ng_container_1_div_1_a_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r22 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", item_r7.title)("matTooltipDisabled", !ctx_r22.uiService.willTrim(item_r7.title, item_r7));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r22.uiService.trimTitle(item_r7.title, item_r7 == null ? null : item_r7.maxLength), " ");
} }
function PageTitleComponent_ng_container_2_ng_container_1_div_1_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵtemplate(1, PageTitleComponent_ng_container_2_ng_container_1_div_1_a_2_span_1_Template, 2, 3, "span", 15);
    i0.ɵɵtemplate(2, PageTitleComponent_ng_container_2_ng_container_1_div_1_a_2_span_2_Template, 2, 3, "span", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(3);
    const item_r7 = ctx_r25.$implicit;
    const i_r8 = ctx_r25.index;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", item_r7.routerLink)("ngClass", i0.ɵɵpureFunction1(4, _c1$2, i_r8 + 1 < ctx_r13.breadcrumbItems.length && i_r8 !== 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.isLastBreadcrumbEditable && i_r8 + 1 === ctx_r13.breadcrumbItems.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r13.isLastBreadcrumbEditable || i_r8 + 1 !== ctx_r13.breadcrumbItems.length);
} }
const _c2$1 = function (a0, a1) { return { "is-last": a0, "is-first": a1 }; };
function PageTitleComponent_ng_container_2_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, PageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_Template, 4, 3, "ng-container", 7);
    i0.ɵɵtemplate(2, PageTitleComponent_ng_container_2_ng_container_1_div_1_a_2_Template, 3, 6, "a", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    const i_r8 = ctx_r26.index;
    const item_r7 = ctx_r26.$implicit;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c2$1, i_r8 + 1 === ctx_r10.breadcrumbItems.length, i_r8 === 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(item_r7 == null ? null : item_r7.routerLink));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r7 == null ? null : item_r7.routerLink);
} }
function PageTitleComponent_ng_container_2_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1, " / ");
    i0.ɵɵelementEnd();
} }
function PageTitleComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PageTitleComponent_ng_container_2_ng_container_1_div_1_Template, 3, 6, "div", 10);
    i0.ɵɵtemplate(2, PageTitleComponent_ng_container_2_ng_container_1_div_2_Template, 2, 0, "div", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r8 = i0.ɵɵnextContext().index;
    const ctx_r9 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r8 + 1 !== ctx_r9.breadcrumbItems.length || i_r8 + 1 === ctx_r9.breadcrumbItems.length && !ctx_r9.isEditing)("ngIfElse", _r1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r8 + 1 !== ctx_r9.breadcrumbItems.length);
} }
function PageTitleComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PageTitleComponent_ng_container_2_ng_container_1_Template, 3, 3, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r7 == null ? null : item_r7.title);
} }
function PageTitleComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 22, 23);
    i0.ɵɵlistener("ngModelChange", function PageTitleComponent_ng_template_3_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r29.editableValue = $event); })("blur", function PageTitleComponent_ng_template_3_Template_input_blur_0_listener() { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r31.onBlur()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r2.editableValue);
} }
function PageTitleComponent_div_5_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function PageTitleComponent_div_5_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r34.onEdit()); });
    i0.ɵɵelement(1, "mat-icon", 28);
    i0.ɵɵelementEnd();
} }
function PageTitleComponent_div_5_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("mousedown", function PageTitleComponent_div_5_button_2_Template_button_mousedown_0_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r36.onSave()); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "save");
    i0.ɵɵelementEnd()();
} }
function PageTitleComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, PageTitleComponent_div_5_button_1_Template, 2, 0, "button", 25);
    i0.ɵɵtemplate(2, PageTitleComponent_div_5_button_2_Template, 3, 0, "button", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.isEditing);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isEditing);
} }
function PageTitleComponent_ng_content_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ngIf", "!tabItems.length"]);
} }
const _c3$1 = function () { return {}; };
function PageTitleComponent_nav_9_ng_container_1_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 32, 33);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r41 = i0.ɵɵreference(1);
    const item_r39 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", item_r39.routerLink)("queryParams", item_r39.queryParams || i0.ɵɵpureFunction0(4, _c3$1))("active", _r41.isActive);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r39.title, " ");
} }
function PageTitleComponent_nav_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PageTitleComponent_nav_9_ng_container_1_a_1_Template, 3, 5, "a", 31);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r39 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r39 == null ? null : item_r39.routerLink) && (item_r39 == null ? null : item_r39.title));
} }
function PageTitleComponent_nav_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "nav", 30);
    i0.ɵɵtemplate(1, PageTitleComponent_nav_9_ng_container_1_Template, 2, 1, "ng-container", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r5.tabItems);
} }
function PageTitleComponent_div_10_ng_container_5_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 39)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r45 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", item_r45 == null ? null : item_r45.disabled)("routerLink", item_r45 == null ? null : item_r45.routerLink);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r45.title);
} }
function PageTitleComponent_div_10_ng_container_5_ng_container_1_ng_container_2_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 42);
    i0.ɵɵlistener("click", function PageTitleComponent_div_10_ng_container_5_ng_container_1_ng_container_2_button_1_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r54); const item_r45 = i0.ɵɵnextContext(3).$implicit; return i0.ɵɵresetView(item_r45 == null ? null : item_r45.onClick($event)); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r45 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("disabled", item_r45 == null ? null : item_r45.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r45.title);
} }
function PageTitleComponent_div_10_ng_container_5_ng_container_1_ng_container_2_button_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 43)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r45 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("disabled", item_r45 == null ? null : item_r45.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r45.title);
} }
function PageTitleComponent_div_10_ng_container_5_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PageTitleComponent_div_10_ng_container_5_ng_container_1_ng_container_2_button_1_Template, 3, 2, "button", 40);
    i0.ɵɵtemplate(2, PageTitleComponent_div_10_ng_container_5_ng_container_1_ng_container_2_button_2_Template, 3, 2, "button", 41);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r45 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r48 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r48.isFunction(item_r45 == null ? null : item_r45.onClick));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r48.isFunction(item_r45 == null ? null : item_r45.onClick));
} }
function PageTitleComponent_div_10_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PageTitleComponent_div_10_ng_container_5_ng_container_1_ng_container_1_Template, 4, 3, "ng-container", 7);
    i0.ɵɵtemplate(2, PageTitleComponent_div_10_ng_container_5_ng_container_1_ng_container_2_Template, 3, 2, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r45 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r45 == null ? null : item_r45.routerLink);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(item_r45 == null ? null : item_r45.routerLink));
} }
function PageTitleComponent_div_10_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PageTitleComponent_div_10_ng_container_5_ng_container_1_Template, 3, 2, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r45 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r45 == null ? null : item_r45.title);
} }
function PageTitleComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34)(1, "button", 35);
    i0.ɵɵelement(2, "mat-icon", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-menu", 37, 38);
    i0.ɵɵtemplate(5, PageTitleComponent_div_10_ng_container_5_Template, 2, 1, "ng-container", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r43 = i0.ɵɵreference(4);
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matMenuTriggerFor", _r43);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r6.contextMenuItems);
} }
const _c4$1 = ["*"];
class PageTitleComponent {
    constructor(uiService) {
        this.uiService = uiService;
        this.breadcrumbItems = [];
        this.tabItems = [];
        this.contextMenuItems = [];
        this.isLastBreadcrumbEditable = false;
        this.editableFieldSaved = new EventEmitter();
        this.editableValue = '';
        this.editableValueOriginal = '';
        this.isEditing = false;
    }
    ngOnInit() {
        if (this.isLastBreadcrumbEditable && this.breadcrumbItems?.length) {
            this.editableValue = this.breadcrumbItems[this.breadcrumbItems.length - 1].title;
            this.editableValueOriginal = this.editableValue;
        }
    }
    ngAfterViewInit() {
        this.editField.changes.subscribe((_) => this.focusEditField());
    }
    focusEditField() {
        if (this.editField.length > 0) {
            this.editField.first.nativeElement.focus();
        }
    }
    onEdit() {
        this.isEditing = true;
    }
    onSave() {
        this.isEditing = false;
        this.editableValueOriginal = this.editableValue;
        this.editableFieldSaved.emit(this.editableValue);
    }
    onBlur() {
        this.isEditing = false;
        this.editableValue = this.editableValueOriginal;
    }
    isFunction(fce) {
        return typeof fce === 'function';
    }
    static { this.ɵfac = function PageTitleComponent_Factory(t) { return new (t || PageTitleComponent)(i0.ɵɵdirectiveInject(UiService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PageTitleComponent, selectors: [["app-page-title"]], viewQuery: function PageTitleComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$4, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editField = _t);
        } }, inputs: { breadcrumbItems: "breadcrumbItems", tabItems: "tabItems", contextMenuItems: "contextMenuItems", isLastBreadcrumbEditable: "isLastBreadcrumbEditable" }, outputs: { editableFieldSaved: "editableFieldSaved" }, ngContentSelectors: _c4$1, decls: 11, vars: 5, consts: [[1, "page-title"], [1, "page-title--left"], [4, "ngFor", "ngForOf"], ["input", ""], ["class", "icon-wrap", 4, "ngIf"], [1, "page-title--right"], [1, "page-title--right-left"], [4, "ngIf"], ["animationDuration", "0ms", "mat-tab-nav-bar", "", 4, "ngIf"], ["class", "page-title--right-right", 4, "ngIf"], ["class", "page-title--title", 3, "ngClass", 4, "ngIf", "ngIfElse"], ["class", "slash p-sm", 4, "ngIf"], [1, "page-title--title", 3, "ngClass"], [3, "routerLink", "ngClass", 4, "ngIf"], ["class", "page-title--icon", 3, "svgIcon", 4, "ngIf"], ["matTooltipPosition", "above", 3, "matTooltip", "matTooltipDisabled", 4, "ngIf"], ["matTooltipPosition", "above", 3, "matTooltip", "matTooltipDisabled", "ngClass", 4, "ngIf"], [1, "page-title--icon", 3, "svgIcon"], ["matTooltipPosition", "above", 3, "matTooltip", "matTooltipDisabled"], ["matTooltipPosition", "above", 3, "matTooltip", "matTooltipDisabled", "ngClass"], [3, "routerLink", "ngClass"], [1, "slash", "p-sm"], ["mat-input", "", 3, "ngModel", "ngModelChange", "blur"], ["editField", ""], [1, "icon-wrap"], ["mat-icon-button", "", 3, "click", 4, "ngIf"], ["mat-icon-button", "", 3, "mousedown", 4, "ngIf"], ["mat-icon-button", "", 3, "click"], ["svgIcon", "edit"], ["mat-icon-button", "", 3, "mousedown"], ["animationDuration", "0ms", "mat-tab-nav-bar", ""], ["mat-tab-link", "", "routerLinkActive", "", 3, "routerLink", "queryParams", "active", 4, "ngIf"], ["mat-tab-link", "", "routerLinkActive", "", 3, "routerLink", "queryParams", "active"], ["rla", "routerLinkActive"], [1, "page-title--right-right"], ["mat-icon-button", "", 1, "icon-wrap", 3, "matMenuTriggerFor"], ["svgIcon", "options"], ["xPosition", "before"], ["menu", "matMenu"], ["mat-menu-item", "", 3, "disabled", "routerLink"], ["mat-menu-item", "", 3, "disabled", "click", 4, "ngIf"], ["mat-menu-item", "", 3, "disabled", 4, "ngIf"], ["mat-menu-item", "", 3, "disabled", "click"], ["mat-menu-item", "", 3, "disabled"]], template: function PageTitleComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, PageTitleComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
            i0.ɵɵtemplate(3, PageTitleComponent_ng_template_3_Template, 2, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(5, PageTitleComponent_div_5_Template, 3, 2, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 5)(7, "div", 6);
            i0.ɵɵtemplate(8, PageTitleComponent_ng_content_8_Template, 1, 0, "ng-content", 7);
            i0.ɵɵtemplate(9, PageTitleComponent_nav_9_Template, 2, 1, "nav", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(10, PageTitleComponent_div_10_Template, 6, 2, "div", 9);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.breadcrumbItems);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.isLastBreadcrumbEditable && (ctx.breadcrumbItems == null ? null : ctx.breadcrumbItems.length));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.tabItems.length);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.tabItems.length);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.contextMenuItems.length);
        } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i3$1.RouterLink, i3$1.RouterLinkActive, i3$2.DefaultValueAccessor, i3$2.NgControlStatus, i3$2.NgModel, i4.MatLegacyButton, i2.MatIcon, i6.MatLegacyMenu, i6.MatLegacyMenuItem, i6.MatLegacyMenuTrigger, i8$2.MatLegacyTabNav, i8$2.MatLegacyTabLink, i8.MatLegacyTooltip], styles: ["app-page-title[_ngcontent-%COMP%]   .page-title[_ngcontent-%COMP%]{height:30px;display:flex;justify-content:space-between;align-items:center}app-page-title[_ngcontent-%COMP%]   .page-title--left[_ngcontent-%COMP%], app-page-title[_ngcontent-%COMP%]   .page-title--right[_ngcontent-%COMP%]{display:flex;align-items:center}app-page-title[_ngcontent-%COMP%]   .page-title--title[_ngcontent-%COMP%]{font-size:16px;line-height:30px}app-page-title[_ngcontent-%COMP%]   .page-title--title.is-last[_ngcontent-%COMP%]{font-weight:500}app-page-title[_ngcontent-%COMP%]   .page-title--title.is-first[_ngcontent-%COMP%]{font-weight:500}app-page-title[_ngcontent-%COMP%]   .page-title--icon[_ngcontent-%COMP%]{vertical-align:sub}app-page-title[_ngcontent-%COMP%]   .page-title[_ngcontent-%COMP%]   .slash[_ngcontent-%COMP%]{font-size:16px}app-page-title[_ngcontent-%COMP%]   .page-title[_ngcontent-%COMP%]   .icon-wrap[_ngcontent-%COMP%]{width:30px!important;display:flex}app-page-title[_ngcontent-%COMP%]   .page-title[_ngcontent-%COMP%]   .icon-wrap[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{margin:0 auto;width:30px!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageTitleComponent, [{
        type: Component,
        args: [{ selector: 'app-page-title', template: "<div class=\"page-title\">\r\n\r\n  <!-- Left side -->\r\n  <div class=\"page-title--left\">\r\n\r\n    <!-- Breadcrumb items -->\r\n    <ng-container *ngFor=\"let item of breadcrumbItems; let i = index\">\r\n      <ng-container *ngIf=\"item?.title\">\r\n        <div\r\n          *ngIf=\"i + 1 !== breadcrumbItems.length || (i + 1 === breadcrumbItems.length && !isEditing); else input\"\r\n          class=\"page-title--title\"\r\n          [ngClass]=\"{\r\n            'is-last': i + 1 === breadcrumbItems.length,\r\n            'is-first': i === 0\r\n          }\"\r\n        >\r\n          <ng-container *ngIf=\"!item?.routerLink\">\r\n\t\t\t<mat-icon class=\"page-title--icon\" *ngIf=\"item?.icon\" [svgIcon]=\"item?.icon\"></mat-icon>\r\n            <span\r\n              *ngIf=\"isLastBreadcrumbEditable && i + 1 === breadcrumbItems.length\"\r\n              [matTooltip]=\"editableValue\"\r\n              [matTooltipDisabled]=\"!uiService.willTrim(editableValue, item)\"\r\n              matTooltipPosition=\"above\"\r\n            >\r\n              {{ uiService.trimTitle(editableValue, item?.maxLength) }}\r\n            </span>\r\n            <span\r\n              *ngIf=\"!isLastBreadcrumbEditable || i + 1 !== breadcrumbItems.length\"\r\n              [matTooltip]=\"item.title\"\r\n              [matTooltipDisabled]=\"!uiService.willTrim(item.title, item)\"\r\n              matTooltipPosition=\"above\"\r\n\t\t\t  [ngClass]=\"{'item-betwwen': i + 1 < breadcrumbItems.length && i !== 0}\"\r\n            >\r\n              {{ uiService.trimTitle(item.title, item?.maxLength) }}\r\n            </span>\r\n          </ng-container>\r\n          <a *ngIf=\"item?.routerLink\" [routerLink]=\"item.routerLink\" [ngClass]=\"{'item-betwwen': i + 1 < breadcrumbItems.length && i !== 0}\">\r\n            <span\r\n              *ngIf=\"isLastBreadcrumbEditable && i + 1 === breadcrumbItems.length\"\r\n              [matTooltip]=\"editableValue\"\r\n              [matTooltipDisabled]=\"!uiService.willTrim(editableValue, item)\"\r\n              matTooltipPosition=\"above\"\r\n            >\r\n              {{ uiService.trimTitle(editableValue, item?.maxLength) }}\r\n            </span>\r\n            <span\r\n              *ngIf=\"!isLastBreadcrumbEditable || i + 1 !== breadcrumbItems.length\"\r\n              [matTooltip]=\"item.title\"\r\n              [matTooltipDisabled]=\"!uiService.willTrim(item.title, item)\"\r\n              matTooltipPosition=\"above\"\r\n            >\r\n              {{ uiService.trimTitle(item.title, item?.maxLength) }}\r\n            </span>\r\n          </a>\r\n        </div>\r\n        <div\r\n          *ngIf=\"i + 1 !== breadcrumbItems.length\"\r\n          class=\"slash p-sm\"\r\n        >\r\n\t\t  /\r\n        </div>\r\n      </ng-container>\r\n    </ng-container>\r\n\r\n    <!-- Editable input field and save button -->\r\n    <ng-template #input>\r\n      <input\r\n        #editField\r\n        mat-input\r\n        [(ngModel)]=\"editableValue\"\r\n        (blur)=\"onBlur()\"\r\n      />\r\n    </ng-template>\r\n    <div\r\n      *ngIf=\"isLastBreadcrumbEditable && this.breadcrumbItems?.length\"\r\n      class=\"icon-wrap\"\r\n    >\r\n      <button\r\n        mat-icon-button\r\n        *ngIf=\"!isEditing\"\r\n        (click)=\"onEdit()\"\r\n      >\r\n        <mat-icon svgIcon=\"edit\"></mat-icon>\r\n      </button>\r\n      <button\r\n        mat-icon-button\r\n        *ngIf=\"isEditing\"\r\n        (mousedown)=\"onSave()\"\r\n      >\r\n        <mat-icon>save</mat-icon>\r\n      </button>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Right side -->\r\n  <div class=\"page-title--right\">\r\n\r\n    <!-- Tabs -->\r\n    <div class=\"page-title--right-left\">\r\n      <ng-content *ngIf=\"!tabItems.length\"></ng-content>\r\n      <nav\r\n        *ngIf=\"tabItems.length\"\r\n        animationDuration=\"0ms\"\r\n        mat-tab-nav-bar\r\n      >\r\n        <ng-container *ngFor=\"let item of tabItems\">\r\n          <a\r\n            mat-tab-link\r\n            *ngIf=\"item?.routerLink && item?.title\"\r\n            [routerLink]=\"item.routerLink\"\r\n\t\t\t[queryParams]=\"item.queryParams || {}\"\r\n            routerLinkActive\r\n            #rla=\"routerLinkActive\"\r\n            [active]=\"rla.isActive\"\r\n          >\r\n            {{ item.title }}\r\n          </a>\r\n        </ng-container>\r\n      </nav>\r\n    </div>\r\n\r\n    <!-- Context menu -->\r\n    <div\r\n      *ngIf=\"!!contextMenuItems.length\"\r\n      class=\"page-title--right-right\"\r\n    >\r\n      <button\r\n        mat-icon-button\r\n        class=\"icon-wrap\"\r\n        [matMenuTriggerFor]=\"menu\"\r\n      >\r\n        <mat-icon svgIcon=\"options\"></mat-icon>\r\n      </button>\r\n      <mat-menu #menu=\"matMenu\" xPosition=\"before\">\r\n        <ng-container *ngFor=\"let item of contextMenuItems\">\r\n          <ng-container *ngIf=\"item?.title\">\r\n            <ng-container *ngIf=\"item?.routerLink\">\r\n              <button\r\n                mat-menu-item\r\n                [disabled]=\"item?.disabled\"\r\n                [routerLink]=\"item?.routerLink\"\r\n              >\r\n                <span>{{ item.title }}</span>\r\n              </button>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"!item?.routerLink\">\r\n              <button\r\n                *ngIf=\"isFunction(item?.onClick)\"\r\n                mat-menu-item\r\n                [disabled]=\"item?.disabled\"\r\n                (click)=\"item?.onClick($event)\"\r\n              >\r\n                <span>{{ item.title }}</span>\r\n              </button>\r\n              <button\r\n                *ngIf=\"!isFunction(item?.onClick)\"\r\n                mat-menu-item\r\n                [disabled]=\"item?.disabled\"\r\n              >\r\n                <span>{{ item.title }}</span>\r\n              </button>\r\n            </ng-container>\r\n          </ng-container>\r\n        </ng-container>\r\n      </mat-menu>\r\n    </div>\r\n  </div>\r\n</div>", styles: ["app-page-title .page-title{height:30px;display:flex;justify-content:space-between;align-items:center}app-page-title .page-title--left,app-page-title .page-title--right{display:flex;align-items:center}app-page-title .page-title--title{font-size:16px;line-height:30px}app-page-title .page-title--title.is-last{font-weight:500}app-page-title .page-title--title.is-first{font-weight:500}app-page-title .page-title--icon{vertical-align:sub}app-page-title .page-title .slash{font-size:16px}app-page-title .page-title .icon-wrap{width:30px!important;display:flex}app-page-title .page-title .icon-wrap .mat-icon{margin:0 auto;width:30px!important}\n"] }]
    }], function () { return [{ type: UiService }]; }, { breadcrumbItems: [{
            type: Input
        }], tabItems: [{
            type: Input
        }], contextMenuItems: [{
            type: Input
        }], isLastBreadcrumbEditable: [{
            type: Input
        }], editableFieldSaved: [{
            type: Output
        }], editField: [{
            type: ViewChildren,
            args: ['editField']
        }] }); })();

const iconList = [
    'alert-octagon',
    'align-block',
    'align-center',
    'align-left',
    'align-right',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'attachment',
    'audit',
    'award',
    'back',
    'bar',
    'bidirection',
    'blitz',
    'bold',
    'brain',
    'brush',
    'calendar',
    'cancel',
    'certificate',
    'chart-bar',
    'chart-line',
    'chart-pie',
    'chart-stats',
    'check-square',
    'check',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'circle-check',
    'circle-warning',
    'clock',
    'clone',
    'close-small',
    'close',
    'cloud',
    'copy',
    'cpu',
    'credit-card',
    'crosshair',
    'dashboard',
    'db',
    'deep-cdr',
    'disabled',
    'download',
    'drag',
    'edit-block',
    'edit',
    'email-inbound',
    'email-outbound',
    'expand',
    'export',
    'external-link',
    'eye-hide',
    'eye-show',
    'failed-cautinary',
    'file-analysis',
    'file-archive',
    'file-block',
    'file-check',
    'file-export',
    'file-extension',
    'file-multiple',
    'file-multiplev2',
    'file-raw',
    'file-scan',
    'file-text',
    'file',
    'filter',
    'folder-open',
    'folder',
    'forward',
    'globe',
    'groups',
    'help',
    'highlight',
    'history',
    'home',
    'hourglass',
    'images',
    'inbox',
    'info',
    'italics',
    'key',
    'laptop',
    'layers',
    'life-saver',
    'link',
    'list',
    'lock-cross',
    'lock',
    'malware-2',
    'malware',
    'menu',
    'metascan',
    'modules',
    'notifications',
    'options',
    'organisations',
    'package-up',
    'package',
    'page-blank',
    'page-report',
    'page-text',
    'paperplane',
    'phishing',
    'pin',
    'plus',
    'policy',
    'proactive-dlp',
    'progress',
    'queue',
    'refresh',
    'remove',
    'repeat',
    'research',
    'screen',
    'search',
    'server',
    'settings',
    'shapes',
    'share',
    'shield',
    'solid-down',
    'solid-left',
    'solid-right',
    'solid-up',
    'sort-down',
    'sort-up',
    'sort',
    'star',
    'storage',
    'approval',
    'target',
    'intelligence',
    'inventory',
    'underline',
    'unlock',
    'unmanaged',
    'unwanted',
    'update',
    'upload',
    'usb',
    'user',
    'users',
    'view-grid',
    'view-list',
    'vulnerability',
    'watch',
    'workflow',
    'yara',
    'product-overview',
    'product-group',
    'product-individual',
    'support',
    'contact',
    'licensed-and-manageable',
    'licensed-and-non-manageable',
    'non-licensed-and-manageable',
    'linked',
    'license-inc',
    'integrity-failures',
    'icon_wrong',
    'icon_circle_check',
    'usbc',
    'usba',
    'unknow_media_type',
    'sd_card',
    'micro_sd',
    'compact_flash_card',
    'media-type-other',
    'academy',
    'dashboard-engine',
    'license-v2',
    'partner',
    'faq',
    'no-product-managed',
    'supervisor-approval',
    'hourglass-v2',
];

const _c0$3 = ["searchField"];
function SearchFieldComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function SearchFieldComponent_button_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onClearSearchField()); });
    i0.ɵɵelementStart(1, "mat-icon", 8);
    i0.ɵɵtext(2, "close");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.disabled);
} }
class SearchFieldComponent {
    constructor() {
        this.isExpanded = false;
        this.disabled = false;
        this.maxlength = 256;
        this.customClass = '';
        this.searchTermChange = new EventEmitter();
        this.search = new EventEmitter();
        this.clear = new EventEmitter();
        this.blurInput = new EventEmitter();
    }
    ngOnInit() {
        if (this.searchTerm) {
            this.isExpanded = true;
        }
    }
    toggle() {
        this.isExpanded = !this.isExpanded;
        if (this.isExpanded) {
            this.myInputField.nativeElement.focus();
        }
    }
    onSearchTermChange() {
        this.searchTermChange.emit(this.searchTerm);
    }
    onSearch() {
        this.search.emit(this.searchTerm);
    }
    onClearSearchField() {
        this.searchTerm = '';
        this.searchTermChange.emit(this.searchTerm);
        this.clear.emit();
    }
    onBlur() {
        if (this.searchTerm) {
            return;
        }
        if (this.isExpanded) {
            this.toggle();
        }
        this.blurInput.emit();
    }
    static { this.ɵfac = function SearchFieldComponent_Factory(t) { return new (t || SearchFieldComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SearchFieldComponent, selectors: [["app-search-field"]], viewQuery: function SearchFieldComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$3, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.myInputField = _t.first);
        } }, inputs: { searchTerm: "searchTerm", placeholder: "placeholder", disabled: "disabled", maxlength: "maxlength", customClass: "customClass" }, outputs: { searchTermChange: "searchTermChange", search: "search", clear: "clear", blurInput: "blurInput" }, decls: 8, vars: 9, consts: [[1, "search-wrap"], ["mat-icon-button", "", "color", "neutral", 1, "search-icon", 3, "disabled", "click"], ["svgIcon", "search"], ["appearance", "outline", 1, "search", "is-small"], ["matInput", "", 3, "maxlength", "placeholder", "ngModel", "ngModelChange", "keyup", "keyup.enter", "blur"], ["searchField", ""], ["mat-icon-button", "", "matSuffix", "", "aria-label", "Clear", "class", "is-xsmall m-r-xs", 3, "disabled", "click", 4, "ngIf"], ["mat-icon-button", "", "matSuffix", "", "aria-label", "Clear", 1, "is-xsmall", "m-r-xs", 3, "disabled", "click"], [1, "mat-icon"]], template: function SearchFieldComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
            i0.ɵɵlistener("click", function SearchFieldComponent_Template_button_click_1_listener() { return ctx.toggle(); });
            i0.ɵɵelement(2, "mat-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div")(4, "mat-form-field", 3)(5, "input", 4, 5);
            i0.ɵɵlistener("ngModelChange", function SearchFieldComponent_Template_input_ngModelChange_5_listener($event) { return ctx.searchTerm = $event; })("keyup", function SearchFieldComponent_Template_input_keyup_5_listener() { return ctx.onSearchTermChange(); })("keyup.enter", function SearchFieldComponent_Template_input_keyup_enter_5_listener() { return ctx.onSearch(); })("blur", function SearchFieldComponent_Template_input_blur_5_listener() { return ctx.onBlur(); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, SearchFieldComponent_button_7_Template, 3, 1, "button", 6);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵclassMapInterpolate1("search-field ", ctx.customClass, "");
            i0.ɵɵproperty("@detailExpand", ctx.isExpanded ? "expanded" : "collapsed");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("maxlength", ctx.maxlength)("placeholder", ctx.placeholder)("ngModel", ctx.searchTerm);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.searchTerm);
        } }, dependencies: [i1.NgIf, i3$2.DefaultValueAccessor, i3$2.NgControlStatus, i3$2.MaxLengthValidator, i3$2.NgModel, i4.MatLegacyButton, i2.MatIcon, i6$1.MatLegacyFormField, i6$1.MatLegacySuffix, i7.MatLegacyInput], styles: ["app-search-field[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]{display:flex;align-items:flex-end}app-search-field[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search-field[_ngcontent-%COMP%]{overflow:hidden;width:225px}app-search-field[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search-field[_ngcontent-%COMP%]   .search[_ngcontent-%COMP%]{width:225px}app-search-field[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search-field.w-195[_ngcontent-%COMP%]{width:195px!important}app-search-field[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search-field.w-195[_ngcontent-%COMP%]   .search[_ngcontent-%COMP%]{width:195px!important}app-search-field[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search-icon[_ngcontent-%COMP%]{height:29px!important;margin-right:5px}"], data: { animation: [
                trigger('detailExpand', [
                    state('collapsed', style({ opacity: '0', width: '0px' })),
                    state('expanded', style({ opacity: '1', width: '225px' })),
                    transition('expanded <=> collapsed', animate('0.3s cubic-bezier(0.4, 0.0, 0.2, 1)')),
                ]),
            ] } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchFieldComponent, [{
        type: Component,
        args: [{ selector: 'app-search-field', animations: [
                    trigger('detailExpand', [
                        state('collapsed', style({ opacity: '0', width: '0px' })),
                        state('expanded', style({ opacity: '1', width: '225px' })),
                        transition('expanded <=> collapsed', animate('0.3s cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    ]),
                ], template: "<div class=\"search-wrap\">\r\n  <button\r\n    mat-icon-button\r\n    class=\"search-icon\"\r\n    color=\"neutral\"\r\n    (click)=\"toggle()\"\r\n    [disabled]=\"disabled\"\r\n  >\r\n    <mat-icon svgIcon=\"search\"></mat-icon>\r\n  </button>\r\n  <div\r\n    class=\"search-field {{ customClass }}\"\r\n    [@detailExpand]=\"isExpanded ? 'expanded' : 'collapsed'\"\r\n  >\r\n    <mat-form-field appearance=\"outline\" class=\"search is-small\">\r\n      <input\r\n        #searchField\r\n        matInput\r\n        [maxlength]=\"maxlength\"\r\n        [placeholder]=\"placeholder\"\r\n        [(ngModel)]=\"searchTerm\"\r\n        (keyup)=\"onSearchTermChange()\"\r\n        (keyup.enter)=\"onSearch()\"\r\n        (blur)=\"onBlur()\"\r\n      />\r\n      <button\r\n        mat-icon-button\r\n        *ngIf=\"searchTerm\"\r\n        matSuffix\r\n        aria-label=\"Clear\"\r\n        class=\"is-xsmall m-r-xs\"\r\n        [disabled]=\"disabled\"\r\n        (click)=\"onClearSearchField()\"\r\n      >\r\n        <mat-icon class=\"mat-icon\">close</mat-icon>\r\n      </button>\r\n    </mat-form-field>\r\n  </div>\r\n</div>\r\n", styles: ["app-search-field .search-wrap{display:flex;align-items:flex-end}app-search-field .search-wrap .search-field{overflow:hidden;width:225px}app-search-field .search-wrap .search-field .search{width:225px}app-search-field .search-wrap .search-field.w-195{width:195px!important}app-search-field .search-wrap .search-field.w-195 .search{width:195px!important}app-search-field .search-wrap .search-icon{height:29px!important;margin-right:5px}\n"] }]
    }], function () { return []; }, { searchTerm: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], disabled: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], customClass: [{
            type: Input
        }], searchTermChange: [{
            type: Output
        }], search: [{
            type: Output
        }], clear: [{
            type: Output
        }], blurInput: [{
            type: Output
        }], myInputField: [{
            type: ViewChild,
            args: ['searchField']
        }] }); })();

const _c0$2 = ["editField"];
const _c1$1 = function (a0) { return { maxLength: a0 }; };
function EditNameComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matTooltip", ctx_r0.editFieldValue)("matTooltipDisabled", !ctx_r0.uiService.willTrim(ctx_r0.editFieldValue, i0.ɵɵpureFunction1(3, _c1$1, ctx_r0.limitTextLength)));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.uiService.trimTitle(ctx_r0.editFieldValue, ctx_r0.limitTextLength), " ");
} }
function EditNameComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 6)(2, "mat-form-field", 7)(3, "input", 8, 9);
    i0.ɵɵlistener("ngModelChange", function EditNameComponent_div_3_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.editFieldValue = $event); })("keyup.enter", function EditNameComponent_div_3_Template_input_keyup_enter_3_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onSearch()); })("blur", function EditNameComponent_div_3_Template_input_blur_3_listener() { i0.ɵɵrestoreView(_r4); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onSearch()); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@detailExpand", ctx_r1.isExpanded ? "expanded" : "collapsed");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("maxlength", ctx_r1.maxlength)("placeholder", ctx_r1.placeholder)("ngModel", ctx_r1.editFieldValue);
} }
class EditNameComponent {
    constructor(uiService) {
        this.uiService = uiService;
        this.isExpanded = false;
        this.disabled = false;
        this.fieldTooltip = '';
        this.verifyPattern = '';
        this.errMsg = '';
        this.maxlength = 256;
        this.limitTextLength = 50;
        this.save = new EventEmitter();
        this.blurInput = new EventEmitter();
        this.errorMsg = new EventEmitter();
    }
    ngOnInit() { }
    toggle() {
        this.isExpanded = !this.isExpanded;
        if (this.isExpanded) {
            this.myInputField.nativeElement.focus();
        }
    }
    onSearch() {
        if (!this.editFieldValue) {
            this.editFieldValue = this.originalData.name;
            this.toggle();
            return;
        }
        if (this.editFieldValue === this.originalData.name) {
            this.toggle();
            return;
        }
        if (this.verifyPattern && !this.verifyPattern.test(this.editFieldValue)) {
            this.errorMsg.emit();
        }
        else {
            this.toggle();
            this.save.emit(this.editFieldValue);
        }
    }
    onBlur() {
        if (this.editFieldValue) {
            return;
        }
        if (this.isExpanded) {
            this.toggle();
        }
        this.blurInput.emit();
    }
    static { this.ɵfac = function EditNameComponent_Factory(t) { return new (t || EditNameComponent)(i0.ɵɵdirectiveInject(UiService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EditNameComponent, selectors: [["app-edit-name"]], viewQuery: function EditNameComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$2, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.myInputField = _t.first);
        } }, inputs: { editFieldValue: "editFieldValue", placeholder: "placeholder", disabled: "disabled", fieldTooltip: "fieldTooltip", verifyPattern: "verifyPattern", errMsg: "errMsg", originalData: "originalData", maxlength: "maxlength", limitTextLength: "limitTextLength" }, outputs: { save: "save", blurInput: "blurInput", errorMsg: "errorMsg" }, decls: 6, vars: 4, consts: [[1, "search-wrap"], [3, "ngSwitch"], [4, "ngSwitchCase"], ["mat-icon-button", "", "color", "neutral", 1, "search-icon", 3, "disabled", "click"], ["svgIcon", "edit"], ["matTooltipPosition", "above", 1, "edit-label", 3, "matTooltip", "matTooltipDisabled"], [1, "search-field"], ["appearance", "outline", 1, "search", "is-small"], ["matInput", "", 3, "maxlength", "placeholder", "ngModel", "ngModelChange", "keyup.enter", "blur"], ["editField", ""]], template: function EditNameComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, EditNameComponent_div_2_Template, 3, 5, "div", 2);
            i0.ɵɵtemplate(3, EditNameComponent_div_3_Template, 5, 4, "div", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "button", 3);
            i0.ɵɵlistener("click", function EditNameComponent_Template_button_click_4_listener() { return ctx.toggle(); });
            i0.ɵɵelement(5, "mat-icon", 4);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitch", ctx.isExpanded);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", false);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngSwitchCase", true);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.disabled);
        } }, dependencies: [i1.NgSwitch, i1.NgSwitchCase, i3$2.DefaultValueAccessor, i3$2.NgControlStatus, i3$2.MaxLengthValidator, i3$2.NgModel, i4.MatLegacyButton, i2.MatIcon, i6$1.MatLegacyFormField, i7.MatLegacyInput, i8.MatLegacyTooltip], styles: ["app-edit-name[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]{display:flex;align-items:flex-end;align-items:center}app-edit-name[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{max-width:250px;overflow:hidden;text-overflow:ellipsis}app-edit-name[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search-field[_ngcontent-%COMP%]{overflow:hidden;width:250px;max-width:250px}app-edit-name[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search-field[_ngcontent-%COMP%]   .search[_ngcontent-%COMP%]{width:250px;font-weight:500}app-edit-name[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search-icon[_ngcontent-%COMP%]{height:29px!important;margin-right:5px}app-edit-name[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .edit-label[_ngcontent-%COMP%]{font-weight:500}"], data: { animation: [
                trigger('detailExpand', [
                    state('collapsed', style({ opacity: '0', width: '0px' })),
                    state('expanded', style({ opacity: '1', width: '250px' })),
                    transition('expanded <=> collapsed', animate('0.3s cubic-bezier(0.4, 0.0, 0.2, 1)')),
                ]),
            ] } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditNameComponent, [{
        type: Component,
        args: [{ selector: 'app-edit-name', animations: [
                    trigger('detailExpand', [
                        state('collapsed', style({ opacity: '0', width: '0px' })),
                        state('expanded', style({ opacity: '1', width: '250px' })),
                        transition('expanded <=> collapsed', animate('0.3s cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    ]),
                ], template: "<div class=\"search-wrap\">\r\n\t<div [ngSwitch]=\"isExpanded\">\r\n\t\t<div *ngSwitchCase=\"false\">\r\n\t\t\t<span\r\n\t\t\t\t[matTooltip]=\"editFieldValue\"\r\n\t\t\t\t[matTooltipDisabled]=\"!uiService.willTrim(editFieldValue, { maxLength: limitTextLength })\"\r\n\t\t\t\tmatTooltipPosition=\"above\"\r\n\t\t\t\tclass=\"edit-label\"\r\n\t\t\t>\r\n\t\t\t\t{{ uiService.trimTitle(editFieldValue, limitTextLength) }}\r\n\t\t\t</span>\r\n\t\t</div>\r\n\t\t<div *ngSwitchCase=\"true\">\r\n\t\t\t<div class=\"search-field\" [@detailExpand]=\"isExpanded ? 'expanded' : 'collapsed'\">\r\n\t\t\t\t<mat-form-field appearance=\"outline\" class=\"search is-small\">\r\n\t\t\t\t\t<input\r\n\t\t\t\t\t\t#editField\r\n\t\t\t\t\t\tmatInput\r\n\t\t\t\t\t\t[maxlength]=\"maxlength\"\r\n\t\t\t\t\t\t[placeholder]=\"placeholder\"\r\n\t\t\t\t\t\t[(ngModel)]=\"editFieldValue\"\r\n\t\t\t\t\t\t(keyup.enter)=\"onSearch()\"\r\n\t\t\t\t\t\t(blur)=\"onSearch()\"\r\n\t\t\t\t\t/>\r\n\t\t\t\t</mat-form-field>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<button mat-icon-button class=\"search-icon\" color=\"neutral\" (click)=\"toggle()\" [disabled]=\"disabled\">\r\n\t\t<mat-icon svgIcon=\"edit\"></mat-icon>\r\n\t</button>\r\n</div>\r\n", styles: ["app-edit-name .search-wrap{display:flex;align-items:flex-end;align-items:center}app-edit-name .search-wrap span{max-width:250px;overflow:hidden;text-overflow:ellipsis}app-edit-name .search-wrap .search-field{overflow:hidden;width:250px;max-width:250px}app-edit-name .search-wrap .search-field .search{width:250px;font-weight:500}app-edit-name .search-wrap .search-icon{height:29px!important;margin-right:5px}app-edit-name .search-wrap .edit-label{font-weight:500}\n"] }]
    }], function () { return [{ type: UiService }]; }, { editFieldValue: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], disabled: [{
            type: Input
        }], fieldTooltip: [{
            type: Input
        }], verifyPattern: [{
            type: Input
        }], errMsg: [{
            type: Input
        }], originalData: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], limitTextLength: [{
            type: Input
        }], save: [{
            type: Output
        }], blurInput: [{
            type: Output
        }], errorMsg: [{
            type: Output
        }], myInputField: [{
            type: ViewChild,
            args: ['editField']
        }] }); })();

const _c0$1 = ["searchField"];
function SearchProductComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 10);
    i0.ɵɵtext(4, "|");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r1.activeIndex, "/", ctx_r1.total, "");
} }
function SearchProductComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function SearchProductComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onMoveToBack()); });
    i0.ɵɵelement(1, "mat-icon", 12);
    i0.ɵɵelementEnd();
} }
function SearchProductComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function SearchProductComponent_button_9_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.onMoveToNext()); });
    i0.ɵɵelement(1, "mat-icon", 14);
    i0.ɵɵelementEnd();
} }
function SearchProductComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function SearchProductComponent_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.onClear()); });
    i0.ɵɵelement(1, "mat-icon", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r4.disabled);
} }
class SearchProductComponent {
    constructor() {
        this.isExpanded = false;
        this.disabled = false;
        this.maxlength = 256;
        this.customClass = '';
        this.total = 0;
        this.activeIndex = 0;
        this.searchTermChange = new EventEmitter();
        this.search = new EventEmitter();
        this.clear = new EventEmitter();
        this.blurInput = new EventEmitter();
        this.moveToNext = new EventEmitter();
        this.moveToBack = new EventEmitter();
    }
    ngOnInit() { }
    toggle() {
        this.isExpanded = !this.isExpanded;
        if (this.isExpanded) {
            this.myInputField.nativeElement.focus();
        }
    }
    onSearchTermChange() {
        this.searchTermChange.emit(this.searchTerm);
    }
    onSearch() {
        if (this.searchTerm.trim()) {
            this.search.emit();
        }
        else {
            this.onClear();
        }
    }
    onClear() {
        this.searchTerm = '';
        this.clear.emit();
    }
    onBlur() {
        if (this.searchTerm) {
            return;
        }
        if (this.isExpanded) {
            this.toggle();
        }
        this.blurInput.emit();
    }
    onMoveToNext() {
        this.moveToNext.emit();
    }
    onMoveToBack() {
        this.moveToBack.emit();
    }
    static { this.ɵfac = function SearchProductComponent_Factory(t) { return new (t || SearchProductComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SearchProductComponent, selectors: [["app-search-product"]], viewQuery: function SearchProductComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.myInputField = _t.first);
        } }, inputs: { searchTerm: "searchTerm", placeholder: "placeholder", disabled: "disabled", maxlength: "maxlength", customClass: "customClass", total: "total", activeIndex: "activeIndex" }, outputs: { searchTermChange: "searchTermChange", search: "search", clear: "clear", blurInput: "blurInput", moveToNext: "moveToNext", moveToBack: "moveToBack" }, decls: 11, vars: 12, consts: [[1, "search-wrap"], ["mat-icon-button", "", "color", "neutral", 1, "search-icon", 3, "disabled", "click"], ["svgIcon", "search"], ["appearance", "outline", 1, "search", "is-small", "flex", "flex-middle"], ["matInput", "", 3, "maxlength", "placeholder", "ngModel", "ngModelChange", "input", "keyup.enter", "blur"], ["searchField", ""], [4, "ngIf"], ["mat-icon-button", "", "matSuffix", "", "aria-label", "Previous", "class", "is-xsmall m-r-sm", 3, "click", 4, "ngIf"], ["mat-icon-button", "", "matSuffix", "", "aria-label", "Next", "class", "is-xsmall m-r-sm mat-icon-sm", 3, "click", 4, "ngIf"], ["mat-icon-button", "", "matSuffix", "", "aria-label", "Clear", "class", "is-xsmall m-r-sm mat-icon-sm", 3, "disabled", "click", 4, "ngIf"], ["matSuffix", "", 1, "m-r-sm", 2, "font-size", "12px"], ["mat-icon-button", "", "matSuffix", "", "aria-label", "Previous", 1, "is-xsmall", "m-r-sm", 3, "click"], ["svgIcon", "chevron-up", 1, "mat-icon-sm"], ["mat-icon-button", "", "matSuffix", "", "aria-label", "Next", 1, "is-xsmall", "m-r-sm", "mat-icon-sm", 3, "click"], ["svgIcon", "chevron-down", 1, "mat-icon-sm"], ["mat-icon-button", "", "matSuffix", "", "aria-label", "Clear", 1, "is-xsmall", "m-r-sm", "mat-icon-sm", 3, "disabled", "click"], ["svgIcon", "close", 1, "mat-icon-sm"]], template: function SearchProductComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
            i0.ɵɵlistener("click", function SearchProductComponent_Template_button_click_1_listener() { return ctx.toggle(); });
            i0.ɵɵelement(2, "mat-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div")(4, "mat-form-field", 3)(5, "input", 4, 5);
            i0.ɵɵlistener("ngModelChange", function SearchProductComponent_Template_input_ngModelChange_5_listener($event) { return ctx.searchTerm = $event; })("input", function SearchProductComponent_Template_input_input_5_listener() { return ctx.onSearchTermChange(); })("keyup.enter", function SearchProductComponent_Template_input_keyup_enter_5_listener() { return ctx.onSearch(); })("blur", function SearchProductComponent_Template_input_blur_5_listener() { return ctx.onBlur(); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, SearchProductComponent_ng_container_7_Template, 5, 2, "ng-container", 6);
            i0.ɵɵtemplate(8, SearchProductComponent_button_8_Template, 2, 0, "button", 7);
            i0.ɵɵtemplate(9, SearchProductComponent_button_9_Template, 2, 0, "button", 8);
            i0.ɵɵtemplate(10, SearchProductComponent_button_10_Template, 2, 1, "button", 9);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵclassMapInterpolate1("search-field ", ctx.customClass, "");
            i0.ɵɵproperty("@detailExpand", ctx.isExpanded ? "expanded" : "collapsed");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("maxlength", ctx.maxlength)("placeholder", ctx.placeholder)("ngModel", ctx.searchTerm);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.total);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.total);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.total);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.searchTerm);
        } }, dependencies: [i1.NgIf, i3$2.DefaultValueAccessor, i3$2.NgControlStatus, i3$2.MaxLengthValidator, i3$2.NgModel, i4.MatLegacyButton, i2.MatIcon, i6$1.MatLegacyFormField, i6$1.MatLegacySuffix, i7.MatLegacyInput], styles: ["app-search-product[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]{display:flex!important;align-items:flex-end!important}app-search-product[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search-field[_ngcontent-%COMP%]{overflow:hidden;width:225px}app-search-product[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search-field[_ngcontent-%COMP%]   .search[_ngcontent-%COMP%]{width:225px}app-search-product[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search-field.w-195[_ngcontent-%COMP%]{width:195px!important}app-search-product[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search-field.w-195[_ngcontent-%COMP%]   .search[_ngcontent-%COMP%]{width:195px!important}app-search-product[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .search-icon[_ngcontent-%COMP%]{height:29px!important;margin-right:5px}app-search-product[_ngcontent-%COMP%]   .search-wrap[_ngcontent-%COMP%]   .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-button-wrapper[_ngcontent-%COMP%]   .mat-icon-sm[_ngcontent-%COMP%]{width:16px!important;height:16px!important}"], data: { animation: [
                trigger('detailExpand', [
                    state('collapsed', style({ opacity: '0', width: '0px' })),
                    state('expanded', style({ opacity: '1', width: '225px' })),
                    transition('expanded <=> collapsed', animate('0.3s cubic-bezier(0.4, 0.0, 0.2, 1)')),
                ]),
            ] } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchProductComponent, [{
        type: Component,
        args: [{ selector: 'app-search-product', animations: [
                    trigger('detailExpand', [
                        state('collapsed', style({ opacity: '0', width: '0px' })),
                        state('expanded', style({ opacity: '1', width: '225px' })),
                        transition('expanded <=> collapsed', animate('0.3s cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    ]),
                ], template: "<div class=\"search-wrap\">\r\n  <button\r\n    mat-icon-button\r\n    class=\"search-icon\"\r\n    color=\"neutral\"\r\n    (click)=\"toggle()\"\r\n    [disabled]=\"disabled\"\r\n  >\r\n    <mat-icon svgIcon=\"search\"></mat-icon>\r\n  </button>\r\n  <div\r\n    class=\"search-field {{ customClass }}\"\r\n    [@detailExpand]=\"isExpanded ? 'expanded' : 'collapsed'\"\r\n  >\r\n    <mat-form-field\r\n      appearance=\"outline\"\r\n      class=\"search is-small flex flex-middle\"\r\n    >\r\n      <input\r\n        #searchField\r\n        matInput\r\n        [maxlength]=\"maxlength\"\r\n        [placeholder]=\"placeholder\"\r\n        [(ngModel)]=\"searchTerm\"\r\n        (input)=\"onSearchTermChange()\"\r\n        (keyup.enter)=\"onSearch()\"\r\n        (blur)=\"onBlur()\"\r\n      />\r\n      <ng-container *ngIf=\"total\">\r\n        <span class=\"m-r-sm\" style=\"font-size: 12px\" matSuffix\r\n          >{{ activeIndex }}/{{ total }}</span\r\n        >\r\n        <span class=\"m-r-sm\" style=\"font-size: 12px\" matSuffix>|</span>\r\n      </ng-container>\r\n\r\n      <button\r\n        mat-icon-button\r\n        *ngIf=\"total\"\r\n        matSuffix\r\n        aria-label=\"Previous\"\r\n        class=\"is-xsmall m-r-sm\"\r\n        (click)=\"onMoveToBack()\"\r\n      >\r\n        <mat-icon class=\"mat-icon-sm\" svgIcon=\"chevron-up\"></mat-icon>\r\n      </button>\r\n      <button\r\n        mat-icon-button\r\n        *ngIf=\"total\"\r\n        matSuffix\r\n        aria-label=\"Next\"\r\n        class=\"is-xsmall m-r-sm mat-icon-sm\"\r\n        (click)=\"onMoveToNext()\"\r\n      >\r\n        <mat-icon class=\"mat-icon-sm\" svgIcon=\"chevron-down\"></mat-icon>\r\n      </button>\r\n      <button\r\n        mat-icon-button\r\n        *ngIf=\"searchTerm\"\r\n        matSuffix\r\n        aria-label=\"Clear\"\r\n        class=\"is-xsmall m-r-sm mat-icon-sm\"\r\n        [disabled]=\"disabled\"\r\n        (click)=\"onClear()\"\r\n      >\r\n        <mat-icon class=\"mat-icon-sm\" svgIcon=\"close\"></mat-icon>\r\n      </button>\r\n    </mat-form-field>\r\n  </div>\r\n</div>\r\n", styles: ["app-search-product .search-wrap{display:flex!important;align-items:flex-end!important}app-search-product .search-wrap .search-field{overflow:hidden;width:225px}app-search-product .search-wrap .search-field .search{width:225px}app-search-product .search-wrap .search-field.w-195{width:195px!important}app-search-product .search-wrap .search-field.w-195 .search{width:195px!important}app-search-product .search-wrap .search-icon{height:29px!important;margin-right:5px}app-search-product .search-wrap .mat-form-field-suffix .mat-button-wrapper .mat-icon-sm{width:16px!important;height:16px!important}\n"] }]
    }], function () { return []; }, { searchTerm: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], disabled: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], customClass: [{
            type: Input
        }], total: [{
            type: Input
        }], activeIndex: [{
            type: Input
        }], searchTermChange: [{
            type: Output
        }], search: [{
            type: Output
        }], clear: [{
            type: Output
        }], blurInput: [{
            type: Output
        }], moveToNext: [{
            type: Output
        }], moveToBack: [{
            type: Output
        }], myInputField: [{
            type: ViewChild,
            args: ['searchField']
        }] }); })();

class HighlightSearchPipe {
    constructor() {
        this.highlightedClass = 'highlighted-text'; // Need highlighted-text for counting and scrolling into product views
    }
    transform(value, search, color = 'bg-primary-A700') {
        if (search && search.trim()) {
            const valueStr = value; // Ensure numeric values are converted to strings
            return valueStr.replace(new RegExp('(?![^&;]+;)(?!<[^<>]*)(' + search + ')(?![^<>]*>)(?![^&;]+;)', 'gi'), // NOSONAR
            `<strong class="${color} ${this.highlightedClass}">$1</strong>`);
        }
        return value;
    }
    static { this.ɵfac = function HighlightSearchPipe_Factory(t) { return new (t || HighlightSearchPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "highlightSearch", type: HighlightSearchPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HighlightSearchPipe, [{
        type: Pipe,
        args: [{
                name: 'highlightSearch',
            }]
    }], null, null); })();

const _c0 = ["editField"];
function OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 17);
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("svgIcon", item_r5 == null ? null : item_r5.icon);
} }
function OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", ctx_r13.editableValue)("matTooltipDisabled", !ctx_r13.uiService.willTrim(ctx_r13.editableValue, item_r5));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.uiService.trimTitle(ctx_r13.editableValue, item_r5 == null ? null : item_r5.maxLength), " ");
} }
const _c1 = function (a0) { return { "item-betwwen": a0 }; };
function OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(4);
    const item_r5 = ctx_r17.$implicit;
    const i_r6 = ctx_r17.index;
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", item_r5.title)("matTooltipDisabled", !ctx_r14.uiService.willTrim(item_r5.title, item_r5))("ngClass", i0.ɵɵpureFunction1(4, _c1, i_r6 + 1 < ctx_r14.breadcrumbItems.length && i_r6 !== 0));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.uiService.trimTitle(item_r5.title, item_r5 == null ? null : item_r5.maxLength), " ");
} }
function OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_mat_icon_1_Template, 1, 1, "mat-icon", 14);
    i0.ɵɵtemplate(2, OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_span_2_Template, 2, 3, "span", 15);
    i0.ɵɵtemplate(3, OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_span_3_Template, 2, 6, "span", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    const item_r5 = ctx_r18.$implicit;
    const i_r6 = ctx_r18.index;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r5 == null ? null : item_r5.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.isLastBreadcrumbEditable && i_r6 + 1 === ctx_r10.breadcrumbItems.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r10.isLastBreadcrumbEditable || i_r6 + 1 !== ctx_r10.breadcrumbItems.length);
} }
function OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_a_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", ctx_r19.editableValue)("matTooltipDisabled", !ctx_r19.uiService.willTrim(ctx_r19.editableValue, item_r5));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.uiService.trimTitle(ctx_r19.editableValue, item_r5 == null ? null : item_r5.maxLength), " ");
} }
function OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_a_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", item_r5.title)("matTooltipDisabled", !ctx_r20.uiService.willTrim(item_r5.title, item_r5));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r20.uiService.trimTitle(item_r5.title, item_r5 == null ? null : item_r5.maxLength), " ");
} }
function OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵtemplate(1, OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_a_2_span_1_Template, 2, 3, "span", 15);
    i0.ɵɵtemplate(2, OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_a_2_span_2_Template, 2, 3, "span", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(3);
    const item_r5 = ctx_r23.$implicit;
    const i_r6 = ctx_r23.index;
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", item_r5.routerLink)("ngClass", i0.ɵɵpureFunction1(4, _c1, i_r6 + 1 < ctx_r11.breadcrumbItems.length && i_r6 !== 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.isLastBreadcrumbEditable && i_r6 + 1 === ctx_r11.breadcrumbItems.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r11.isLastBreadcrumbEditable || i_r6 + 1 !== ctx_r11.breadcrumbItems.length);
} }
const _c2 = function (a0, a1) { return { "is-last": a0, "is-first": a1 }; };
function OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_ng_container_1_Template, 4, 3, "ng-container", 9);
    i0.ɵɵtemplate(2, OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_a_2_Template, 3, 6, "a", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    const i_r6 = ctx_r24.index;
    const item_r5 = ctx_r24.$implicit;
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c2, i_r6 + 1 === ctx_r8.breadcrumbItems.length, i_r6 === 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(item_r5 == null ? null : item_r5.routerLink));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r5 == null ? null : item_r5.routerLink);
} }
function OcmPageTitleComponent_ng_container_2_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1, "/");
    i0.ɵɵelementEnd();
} }
function OcmPageTitleComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OcmPageTitleComponent_ng_container_2_ng_container_1_div_1_Template, 3, 6, "div", 10);
    i0.ɵɵtemplate(2, OcmPageTitleComponent_ng_container_2_ng_container_1_div_2_Template, 2, 0, "div", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r6 = i0.ɵɵnextContext().index;
    const ctx_r7 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r6 + 1 !== ctx_r7.breadcrumbItems.length || i_r6 + 1 === ctx_r7.breadcrumbItems.length && !ctx_r7.isEditing)("ngIfElse", _r1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r6 + 1 !== ctx_r7.breadcrumbItems.length);
} }
function OcmPageTitleComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OcmPageTitleComponent_ng_container_2_ng_container_1_Template, 3, 3, "ng-container", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r5 == null ? null : item_r5.title);
} }
function OcmPageTitleComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 22, 23);
    i0.ɵɵlistener("ngModelChange", function OcmPageTitleComponent_ng_template_3_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r27.editableValue = $event); })("blur", function OcmPageTitleComponent_ng_template_3_Template_input_blur_0_listener() { i0.ɵɵrestoreView(_r28); const ctx_r29 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r29.onBlur()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r2.editableValue);
} }
function OcmPageTitleComponent_div_5_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function OcmPageTitleComponent_div_5_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r32.onEdit()); });
    i0.ɵɵelement(1, "mat-icon", 28);
    i0.ɵɵelementEnd();
} }
function OcmPageTitleComponent_div_5_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("mousedown", function OcmPageTitleComponent_div_5_button_2_Template_button_mousedown_0_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r34.onSave()); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "save");
    i0.ɵɵelementEnd()();
} }
function OcmPageTitleComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, OcmPageTitleComponent_div_5_button_1_Template, 2, 0, "button", 25);
    i0.ɵɵtemplate(2, OcmPageTitleComponent_div_5_button_2_Template, 3, 0, "button", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.isEditing);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isEditing);
} }
const _c3 = function () { return {}; };
function OcmPageTitleComponent_nav_8_ng_container_1_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 32, 33);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r39 = i0.ɵɵreference(1);
    const item_r37 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", item_r37.routerLink)("queryParams", item_r37.queryParams || i0.ɵɵpureFunction0(4, _c3))("active", _r39.isActive);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r37.title, " ");
} }
function OcmPageTitleComponent_nav_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OcmPageTitleComponent_nav_8_ng_container_1_a_1_Template, 3, 5, "a", 31);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r37 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r37 == null ? null : item_r37.routerLink) && (item_r37 == null ? null : item_r37.title));
} }
function OcmPageTitleComponent_nav_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "nav", 30);
    i0.ɵɵtemplate(1, OcmPageTitleComponent_nav_8_ng_container_1_Template, 2, 1, "ng-container", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.tabItems);
} }
const _c4 = ["*"];
class OcmPageTitleComponent {
    constructor(uiService) {
        this.uiService = uiService;
        this.breadcrumbItems = [];
        this.tabItems = [];
        this.contextMenuItems = [];
        this.isLastBreadcrumbEditable = false;
        this.editableFieldSaved = new EventEmitter();
        this.editableValue = '';
        this.editableValueOriginal = '';
        this.isEditing = false;
    }
    ngOnInit() {
        if (this.isLastBreadcrumbEditable && this.breadcrumbItems?.length) {
            this.editableValue = this.breadcrumbItems[this.breadcrumbItems.length - 1].title;
            this.editableValueOriginal = this.editableValue;
        }
    }
    ngAfterViewInit() {
        this.editField.changes.subscribe((_) => this.focusEditField());
    }
    focusEditField() {
        if (this.editField.length > 0) {
            this.editField.first.nativeElement.focus();
        }
    }
    onEdit() {
        this.isEditing = true;
    }
    onSave() {
        this.isEditing = false;
        this.editableValueOriginal = this.editableValue;
        this.editableFieldSaved.emit(this.editableValue);
    }
    onBlur() {
        this.isEditing = false;
        this.editableValue = this.editableValueOriginal;
    }
    isFunction(fce) {
        return typeof fce === 'function';
    }
    static { this.ɵfac = function OcmPageTitleComponent_Factory(t) { return new (t || OcmPageTitleComponent)(i0.ɵɵdirectiveInject(UiService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OcmPageTitleComponent, selectors: [["app-ocm-page-title"]], viewQuery: function OcmPageTitleComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editField = _t);
        } }, inputs: { breadcrumbItems: "breadcrumbItems", tabItems: "tabItems", contextMenuItems: "contextMenuItems", isLastBreadcrumbEditable: "isLastBreadcrumbEditable" }, outputs: { editableFieldSaved: "editableFieldSaved" }, ngContentSelectors: _c4, decls: 11, vars: 3, consts: [[1, "page-title"], [1, "page-title--breadcrumb"], [4, "ngFor", "ngForOf"], ["input", ""], ["class", "icon-wrap", 4, "ngIf"], [1, "page-title--tab", "w-100-p"], [1, "page-title--tab-left", "w-100-p"], ["animationDuration", "0ms", "mat-tab-nav-bar", "", 4, "ngIf"], [1, "page-title--tab-right"], [4, "ngIf"], ["class", "page-title--title", 3, "ngClass", 4, "ngIf", "ngIfElse"], ["class", "slash p-sm", 4, "ngIf"], [1, "page-title--title", 3, "ngClass"], [3, "routerLink", "ngClass", 4, "ngIf"], ["class", "page-title--icon", 3, "svgIcon", 4, "ngIf"], ["matTooltipPosition", "above", 3, "matTooltip", "matTooltipDisabled", 4, "ngIf"], ["matTooltipPosition", "above", 3, "matTooltip", "matTooltipDisabled", "ngClass", 4, "ngIf"], [1, "page-title--icon", 3, "svgIcon"], ["matTooltipPosition", "above", 3, "matTooltip", "matTooltipDisabled"], ["matTooltipPosition", "above", 3, "matTooltip", "matTooltipDisabled", "ngClass"], [3, "routerLink", "ngClass"], [1, "slash", "p-sm"], ["mat-input", "", 3, "ngModel", "ngModelChange", "blur"], ["editField", ""], [1, "icon-wrap"], ["mat-icon-button", "", 3, "click", 4, "ngIf"], ["mat-icon-button", "", 3, "mousedown", 4, "ngIf"], ["mat-icon-button", "", 3, "click"], ["svgIcon", "edit"], ["mat-icon-button", "", 3, "mousedown"], ["animationDuration", "0ms", "mat-tab-nav-bar", ""], ["mat-tab-link", "", "routerLinkActive", "", 3, "routerLink", "queryParams", "active", 4, "ngIf"], ["mat-tab-link", "", "routerLinkActive", "", 3, "routerLink", "queryParams", "active"], ["rla", "routerLinkActive"]], template: function OcmPageTitleComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, OcmPageTitleComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
            i0.ɵɵtemplate(3, OcmPageTitleComponent_ng_template_3_Template, 2, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(5, OcmPageTitleComponent_div_5_Template, 3, 2, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 5)(7, "div", 6);
            i0.ɵɵtemplate(8, OcmPageTitleComponent_nav_8_Template, 2, 1, "nav", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 8);
            i0.ɵɵprojection(10);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.breadcrumbItems);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.isLastBreadcrumbEditable && (ctx.breadcrumbItems == null ? null : ctx.breadcrumbItems.length));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.tabItems.length);
        } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i3$1.RouterLink, i3$1.RouterLinkActive, i3$2.DefaultValueAccessor, i3$2.NgControlStatus, i3$2.NgModel, i4.MatLegacyButton, i2.MatIcon, i8$2.MatLegacyTabNav, i8$2.MatLegacyTabLink, i8.MatLegacyTooltip], styles: ["app-ocm-page-title[_ngcontent-%COMP%]   .page-title--breadcrumb[_ngcontent-%COMP%], app-ocm-page-title[_ngcontent-%COMP%]   .page-title--tab[_ngcontent-%COMP%]{display:flex;align-items:center}app-ocm-page-title[_ngcontent-%COMP%]   .page-title--breadcrumb-right[_ngcontent-%COMP%], app-ocm-page-title[_ngcontent-%COMP%]   .page-title--tab-right[_ngcontent-%COMP%]{position:absolute;right:0}app-ocm-page-title[_ngcontent-%COMP%]   .page-title--breadcrumb[_ngcontent-%COMP%]{margin-bottom:20px}app-ocm-page-title[_ngcontent-%COMP%]   .page-title--title[_ngcontent-%COMP%]{font-size:16px;line-height:30px}app-ocm-page-title[_ngcontent-%COMP%]   .page-title--title.is-last[_ngcontent-%COMP%]{font-weight:500}app-ocm-page-title[_ngcontent-%COMP%]   .page-title--title.is-first[_ngcontent-%COMP%]{font-weight:500}app-ocm-page-title[_ngcontent-%COMP%]   .page-title--icon[_ngcontent-%COMP%]{vertical-align:sub}app-ocm-page-title[_ngcontent-%COMP%]   .page-title[_ngcontent-%COMP%]   .slash[_ngcontent-%COMP%]{font-size:16px}app-ocm-page-title[_ngcontent-%COMP%]   .page-title[_ngcontent-%COMP%]   .icon-wrap[_ngcontent-%COMP%]{width:30px!important;display:flex}app-ocm-page-title[_ngcontent-%COMP%]   .page-title[_ngcontent-%COMP%]   .icon-wrap[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{margin:0 auto;width:30px!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OcmPageTitleComponent, [{
        type: Component,
        args: [{ selector: 'app-ocm-page-title', template: "<div class=\"page-title\">\r\n\t<!-- Left side -->\r\n\t<div class=\"page-title--breadcrumb\">\r\n\t\t<!-- Breadcrumb items -->\r\n\t\t<ng-container *ngFor=\"let item of breadcrumbItems; let i = index\">\r\n\t\t\t<ng-container *ngIf=\"item?.title\">\r\n\t\t\t\t<div\r\n\t\t\t\t\t*ngIf=\"i + 1 !== breadcrumbItems.length || (i + 1 === breadcrumbItems.length && !isEditing); else input\"\r\n\t\t\t\t\tclass=\"page-title--title\"\r\n\t\t\t\t\t[ngClass]=\"{\r\n\t\t\t\t\t\t'is-last': i + 1 === breadcrumbItems.length,\r\n\t\t\t\t\t\t'is-first': i === 0\r\n\t\t\t\t\t}\"\r\n\t\t\t\t>\r\n\t\t\t\t\t<ng-container *ngIf=\"!item?.routerLink\">\r\n\t\t\t\t\t\t<mat-icon class=\"page-title--icon\" *ngIf=\"item?.icon\" [svgIcon]=\"item?.icon\"></mat-icon>\r\n\t\t\t\t\t\t<span\r\n\t\t\t\t\t\t\t*ngIf=\"isLastBreadcrumbEditable && i + 1 === breadcrumbItems.length\"\r\n\t\t\t\t\t\t\t[matTooltip]=\"editableValue\"\r\n\t\t\t\t\t\t\t[matTooltipDisabled]=\"!uiService.willTrim(editableValue, item)\"\r\n\t\t\t\t\t\t\tmatTooltipPosition=\"above\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t{{ uiService.trimTitle(editableValue, item?.maxLength) }}\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t<span\r\n\t\t\t\t\t\t\t*ngIf=\"!isLastBreadcrumbEditable || i + 1 !== breadcrumbItems.length\"\r\n\t\t\t\t\t\t\t[matTooltip]=\"item.title\"\r\n\t\t\t\t\t\t\t[matTooltipDisabled]=\"!uiService.willTrim(item.title, item)\"\r\n\t\t\t\t\t\t\tmatTooltipPosition=\"above\"\r\n\t\t\t\t\t\t\t[ngClass]=\"{ 'item-betwwen': i + 1 < breadcrumbItems.length && i !== 0 }\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t{{ uiService.trimTitle(item.title, item?.maxLength) }}\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</ng-container>\r\n\t\t\t\t\t<a\r\n\t\t\t\t\t\t*ngIf=\"item?.routerLink\"\r\n\t\t\t\t\t\t[routerLink]=\"item.routerLink\"\r\n\t\t\t\t\t\t[ngClass]=\"{ 'item-betwwen': i + 1 < breadcrumbItems.length && i !== 0 }\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t\t<span\r\n\t\t\t\t\t\t\t*ngIf=\"isLastBreadcrumbEditable && i + 1 === breadcrumbItems.length\"\r\n\t\t\t\t\t\t\t[matTooltip]=\"editableValue\"\r\n\t\t\t\t\t\t\t[matTooltipDisabled]=\"!uiService.willTrim(editableValue, item)\"\r\n\t\t\t\t\t\t\tmatTooltipPosition=\"above\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t{{ uiService.trimTitle(editableValue, item?.maxLength) }}\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t<span\r\n\t\t\t\t\t\t\t*ngIf=\"!isLastBreadcrumbEditable || i + 1 !== breadcrumbItems.length\"\r\n\t\t\t\t\t\t\t[matTooltip]=\"item.title\"\r\n\t\t\t\t\t\t\t[matTooltipDisabled]=\"!uiService.willTrim(item.title, item)\"\r\n\t\t\t\t\t\t\tmatTooltipPosition=\"above\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t{{ uiService.trimTitle(item.title, item?.maxLength) }}\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div *ngIf=\"i + 1 !== breadcrumbItems.length\" class=\"slash p-sm\">/</div>\r\n\t\t\t</ng-container>\r\n\t\t</ng-container>\r\n\r\n\t\t<!-- Editable input field and save button -->\r\n\t\t<ng-template #input>\r\n\t\t\t<input #editField mat-input [(ngModel)]=\"editableValue\" (blur)=\"onBlur()\" />\r\n\t\t</ng-template>\r\n\t\t<div *ngIf=\"isLastBreadcrumbEditable && this.breadcrumbItems?.length\" class=\"icon-wrap\">\r\n\t\t\t<button mat-icon-button *ngIf=\"!isEditing\" (click)=\"onEdit()\">\r\n\t\t\t\t<mat-icon svgIcon=\"edit\"></mat-icon>\r\n\t\t\t</button>\r\n\t\t\t<button mat-icon-button *ngIf=\"isEditing\" (mousedown)=\"onSave()\">\r\n\t\t\t\t<mat-icon>save</mat-icon>\r\n\t\t\t</button>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Right side -->\r\n\t<div class=\"page-title--tab w-100-p\">\r\n\t\t<!-- Tabs -->\r\n\t\t<div class=\"page-title--tab-left w-100-p\">\r\n\t\t\t<!-- <ng-content *ngIf=\"!tabItems.length\"></ng-content> -->\r\n\t\t\t<nav *ngIf=\"tabItems.length\" animationDuration=\"0ms\" mat-tab-nav-bar>\r\n\t\t\t\t<ng-container *ngFor=\"let item of tabItems\">\r\n\t\t\t\t\t<a\r\n\t\t\t\t\t\tmat-tab-link\r\n\t\t\t\t\t\t*ngIf=\"item?.routerLink && item?.title\"\r\n\t\t\t\t\t\t[routerLink]=\"item.routerLink\"\r\n\t\t\t\t\t\t[queryParams]=\"item.queryParams || {}\"\r\n\t\t\t\t\t\trouterLinkActive\r\n\t\t\t\t\t\t#rla=\"routerLinkActive\"\r\n\t\t\t\t\t\t[active]=\"rla.isActive\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t\t{{ item.title }}\r\n\t\t\t\t\t</a>\r\n\t\t\t\t</ng-container>\r\n\t\t\t</nav>\r\n\t\t</div>\r\n\r\n\t\t<!-- Context menu -->\r\n\t\t<div class=\"page-title--tab-right\">\r\n\t\t\t<ng-content></ng-content>\r\n\t\t</div>\r\n\t\t<!-- <div *ngIf=\"!!contextMenuItems.length\" class=\"page-title--tab-right\">\r\n\t\t\t<button mat-icon-button class=\"icon-wrap\" [matMenuTriggerFor]=\"menu\">\r\n\t\t\t\t<mat-icon svgIcon=\"options\"></mat-icon>\r\n\t\t\t</button>\r\n\t\t\t<mat-menu #menu=\"matMenu\" xPosition=\"before\">\r\n\t\t\t\t<ng-container *ngFor=\"let item of contextMenuItems\">\r\n\t\t\t\t\t<ng-container *ngIf=\"item?.title\">\r\n\t\t\t\t\t\t<ng-container *ngIf=\"item?.routerLink\">\r\n\t\t\t\t\t\t\t<button mat-menu-item [disabled]=\"item?.disabled\" [routerLink]=\"item?.routerLink\">\r\n\t\t\t\t\t\t\t\t<span>{{ item.title }}</span>\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t</ng-container>\r\n\t\t\t\t\t\t<ng-container *ngIf=\"!item?.routerLink\">\r\n\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t\t*ngIf=\"isFunction(item?.onClick)\"\r\n\t\t\t\t\t\t\t\tmat-menu-item\r\n\t\t\t\t\t\t\t\t[disabled]=\"item?.disabled\"\r\n\t\t\t\t\t\t\t\t(click)=\"item?.onClick($event)\"\r\n\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t<span>{{ item.title }}</span>\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t<button *ngIf=\"!isFunction(item?.onClick)\" mat-menu-item [disabled]=\"item?.disabled\">\r\n\t\t\t\t\t\t\t\t<span>{{ item.title }}</span>\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t</ng-container>\r\n\t\t\t\t\t</ng-container>\r\n\t\t\t\t</ng-container>\r\n\t\t\t</mat-menu>\r\n\t\t</div> -->\r\n\t</div>\r\n</div>\r\n", styles: ["app-ocm-page-title .page-title--breadcrumb,app-ocm-page-title .page-title--tab{display:flex;align-items:center}app-ocm-page-title .page-title--breadcrumb-right,app-ocm-page-title .page-title--tab-right{position:absolute;right:0}app-ocm-page-title .page-title--breadcrumb{margin-bottom:20px}app-ocm-page-title .page-title--title{font-size:16px;line-height:30px}app-ocm-page-title .page-title--title.is-last{font-weight:500}app-ocm-page-title .page-title--title.is-first{font-weight:500}app-ocm-page-title .page-title--icon{vertical-align:sub}app-ocm-page-title .page-title .slash{font-size:16px}app-ocm-page-title .page-title .icon-wrap{width:30px!important;display:flex}app-ocm-page-title .page-title .icon-wrap .mat-icon{margin:0 auto;width:30px!important}\n"] }]
    }], function () { return [{ type: UiService }]; }, { breadcrumbItems: [{
            type: Input
        }], tabItems: [{
            type: Input
        }], contextMenuItems: [{
            type: Input
        }], isLastBreadcrumbEditable: [{
            type: Input
        }], editableFieldSaved: [{
            type: Output
        }], editField: [{
            type: ViewChildren,
            args: ['editField']
        }] }); })();

const globalRippleConfig = {
    disabled: true,
    animation: {
        enterDuration: 0,
        exitDuration: 0,
    },
};
class UiModule {
    constructor(domSanitizer, matIconRegistry) {
        this.domSanitizer = domSanitizer;
        this.matIconRegistry = matIconRegistry;
        for (const iconName of iconList) {
            this.matIconRegistry.addSvgIcon(iconName, this.domSanitizer.bypassSecurityTrustResourceUrl(`./assets/icons/${iconName}.svg`));
        }
    }
    static { this.ɵfac = function UiModule_Factory(t) { return new (t || UiModule)(i0.ɵɵinject(i1$3.DomSanitizer), i0.ɵɵinject(i2.MatIconRegistry)); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: UiModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            {
                provide: MAT_RIPPLE_GLOBAL_OPTIONS,
                useValue: globalRippleConfig,
            },
        ], imports: [CommonModule,
            RouterModule,
            FormsModule,
            ReactiveFormsModule,
            MatLegacyButtonModule,
            MatLegacyCheckboxModule,
            MatLegacyChipsModule,
            MatIconModule,
            MatDatepickerModule,
            MatLegacyFormFieldModule,
            MatLegacyRadioModule,
            MatLegacySelectModule,
            MatLegacySliderModule,
            MatLegacyMenuModule,
            MatLegacyTabsModule,
            MatNativeDateModule,
            MatLegacyInputModule,
            MatLegacyProgressSpinnerModule,
            MatLegacySlideToggleModule,
            MatSidenavModule,
            MatLegacyCardModule,
            MatDividerModule,
            MatExpansionModule,
            MatGridListModule,
            MatLegacyListModule,
            MatLegacyProgressBarModule,
            MatLegacyTooltipModule,
            MatLegacyPaginatorModule,
            MatSortModule,
            MatLegacyTableModule,
            MatLegacyDialogModule,
            MatLegacySnackBarModule,
            MatButtonToggleModule,
            HttpClientModule, MatLegacyButtonModule,
            MatLegacyCheckboxModule,
            MatLegacyChipsModule,
            MatIconModule,
            MatDatepickerModule,
            MatLegacyFormFieldModule,
            MatLegacyRadioModule,
            MatLegacySelectModule,
            MatLegacySliderModule,
            MatLegacyMenuModule,
            MatLegacyTabsModule,
            MatLegacyInputModule,
            MatNativeDateModule,
            MatLegacyProgressSpinnerModule,
            MatLegacySlideToggleModule,
            MatSidenavModule,
            MatLegacyCardModule,
            MatDividerModule,
            MatExpansionModule,
            MatGridListModule,
            MatLegacyListModule,
            MatLegacyProgressBarModule,
            MatLegacyTooltipModule,
            MatLegacyPaginatorModule,
            MatSortModule,
            MatLegacyTableModule,
            MatLegacyDialogModule,
            MatButtonToggleModule,
            MatStepperModule,
            HttpClientModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UiModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    LoadingBarComponent,
                    DonutChartComponent,
                    LineChartComponent,
                    SeverityIndicatorComponent,
                    ActionIndicatorComponent,
                    ScoreTagComponent,
                    StatusIndicatorComponent,
                    LoadingIndicatorComponent,
                    LogTypeIndicatorComponent,
                    LoadingErrorIndicatorComponent,
                    ComplianceIndicatorComponent,
                    CountdownComponent,
                    StandardComponent,
                    PageComponent,
                    ClipboardDirective,
                    MomentPipe,
                    TrimPipe,
                    SafeUrlPipe,
                    SafeHtmlPipe,
                    GenericTableComponent,
                    CustomColumnComponent,
                    MaIconComponent,
                    MatSelectSearchComponent,
                    MatSelectSearchClearDirective,
                    SplitSelectComponent,
                    SplitSelectNotificationComponent,
                    AutofocusDirective,
                    OpswatTooltipDirective,
                    NumericDirective,
                    BarChartComponent,
                    StepperComponent,
                    TrueFalseValuePipe,
                    CookieNoticeComponent,
                    BottomPanelComponent,
                    SurveyPromptComponent,
                    PinInputComponent,
                    AccessDeniedComponent,
                    LineChart2Component,
                    InlineNotificationComponent,
                    PageTitleComponent,
                    OcmPageTitleComponent,
                    SearchFieldComponent,
                    EditNameComponent,
                    SearchProductComponent,
                    HighlightSearchPipe,
                    CookiesSettingDialogComponent,
                ],
                imports: [
                    CommonModule,
                    RouterModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatLegacyButtonModule,
                    MatLegacyCheckboxModule,
                    MatLegacyChipsModule,
                    MatIconModule,
                    MatDatepickerModule,
                    MatLegacyFormFieldModule,
                    MatLegacyRadioModule,
                    MatLegacySelectModule,
                    MatLegacySliderModule,
                    MatLegacyMenuModule,
                    MatLegacyTabsModule,
                    MatNativeDateModule,
                    MatLegacyInputModule,
                    MatLegacyProgressSpinnerModule,
                    MatLegacySlideToggleModule,
                    MatSidenavModule,
                    MatLegacyCardModule,
                    MatDividerModule,
                    MatExpansionModule,
                    MatGridListModule,
                    MatLegacyListModule,
                    MatLegacyProgressBarModule,
                    MatLegacyTooltipModule,
                    MatLegacyPaginatorModule,
                    MatSortModule,
                    MatLegacyTableModule,
                    MatLegacyDialogModule,
                    MatLegacySnackBarModule,
                    MatButtonToggleModule,
                    HttpClientModule,
                ],
                exports: [
                    LoadingBarComponent,
                    MatLegacyButtonModule,
                    MatLegacyCheckboxModule,
                    MatLegacyChipsModule,
                    MatIconModule,
                    MatDatepickerModule,
                    MatLegacyFormFieldModule,
                    MatLegacyRadioModule,
                    MatLegacySelectModule,
                    MatLegacySliderModule,
                    MatLegacyMenuModule,
                    MatLegacyTabsModule,
                    MatLegacyInputModule,
                    MatNativeDateModule,
                    MatLegacyProgressSpinnerModule,
                    MatLegacySlideToggleModule,
                    MatSidenavModule,
                    MatLegacyCardModule,
                    MatDividerModule,
                    MatExpansionModule,
                    MatGridListModule,
                    MatLegacyListModule,
                    MatLegacyProgressBarModule,
                    MatLegacyTooltipModule,
                    MatLegacyPaginatorModule,
                    MatSortModule,
                    MatLegacyTableModule,
                    MatLegacyDialogModule,
                    MatButtonToggleModule,
                    DonutChartComponent,
                    LineChartComponent,
                    SeverityIndicatorComponent,
                    ActionIndicatorComponent,
                    ScoreTagComponent,
                    StatusIndicatorComponent,
                    LoadingIndicatorComponent,
                    LogTypeIndicatorComponent,
                    LoadingErrorIndicatorComponent,
                    ComplianceIndicatorComponent,
                    MatStepperModule,
                    CountdownComponent,
                    StandardComponent,
                    PageComponent,
                    ClipboardDirective,
                    AutofocusDirective,
                    OpswatTooltipDirective,
                    NumericDirective,
                    MomentPipe,
                    TrimPipe,
                    SafeUrlPipe,
                    SafeHtmlPipe,
                    GenericTableComponent,
                    CustomColumnComponent,
                    MaIconComponent,
                    MatSelectSearchComponent,
                    MatSelectSearchClearDirective,
                    SplitSelectComponent,
                    SplitSelectNotificationComponent,
                    BarChartComponent,
                    StepperComponent,
                    TrueFalseValuePipe,
                    CookieNoticeComponent,
                    BottomPanelComponent,
                    SurveyPromptComponent,
                    PinInputComponent,
                    AccessDeniedComponent,
                    LineChart2Component,
                    InlineNotificationComponent,
                    HttpClientModule,
                    PageTitleComponent,
                    OcmPageTitleComponent,
                    SearchFieldComponent,
                    EditNameComponent,
                    SearchProductComponent,
                    HighlightSearchPipe,
                ],
                providers: [
                    {
                        provide: MAT_RIPPLE_GLOBAL_OPTIONS,
                        useValue: globalRippleConfig,
                    },
                ],
            }]
    }], function () { return [{ type: i1$3.DomSanitizer }, { type: i2.MatIconRegistry }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(UiModule, { declarations: [LoadingBarComponent,
        DonutChartComponent,
        LineChartComponent,
        SeverityIndicatorComponent,
        ActionIndicatorComponent,
        ScoreTagComponent,
        StatusIndicatorComponent,
        LoadingIndicatorComponent,
        LogTypeIndicatorComponent,
        LoadingErrorIndicatorComponent,
        ComplianceIndicatorComponent,
        CountdownComponent,
        StandardComponent,
        PageComponent,
        ClipboardDirective,
        MomentPipe,
        TrimPipe,
        SafeUrlPipe,
        SafeHtmlPipe,
        GenericTableComponent,
        CustomColumnComponent,
        MaIconComponent,
        MatSelectSearchComponent,
        MatSelectSearchClearDirective,
        SplitSelectComponent,
        SplitSelectNotificationComponent,
        AutofocusDirective,
        OpswatTooltipDirective,
        NumericDirective,
        BarChartComponent,
        StepperComponent,
        TrueFalseValuePipe,
        CookieNoticeComponent,
        BottomPanelComponent,
        SurveyPromptComponent,
        PinInputComponent,
        AccessDeniedComponent,
        LineChart2Component,
        InlineNotificationComponent,
        PageTitleComponent,
        OcmPageTitleComponent,
        SearchFieldComponent,
        EditNameComponent,
        SearchProductComponent,
        HighlightSearchPipe,
        CookiesSettingDialogComponent], imports: [CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatLegacyButtonModule,
        MatLegacyCheckboxModule,
        MatLegacyChipsModule,
        MatIconModule,
        MatDatepickerModule,
        MatLegacyFormFieldModule,
        MatLegacyRadioModule,
        MatLegacySelectModule,
        MatLegacySliderModule,
        MatLegacyMenuModule,
        MatLegacyTabsModule,
        MatNativeDateModule,
        MatLegacyInputModule,
        MatLegacyProgressSpinnerModule,
        MatLegacySlideToggleModule,
        MatSidenavModule,
        MatLegacyCardModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatLegacyListModule,
        MatLegacyProgressBarModule,
        MatLegacyTooltipModule,
        MatLegacyPaginatorModule,
        MatSortModule,
        MatLegacyTableModule,
        MatLegacyDialogModule,
        MatLegacySnackBarModule,
        MatButtonToggleModule,
        HttpClientModule], exports: [LoadingBarComponent,
        MatLegacyButtonModule,
        MatLegacyCheckboxModule,
        MatLegacyChipsModule,
        MatIconModule,
        MatDatepickerModule,
        MatLegacyFormFieldModule,
        MatLegacyRadioModule,
        MatLegacySelectModule,
        MatLegacySliderModule,
        MatLegacyMenuModule,
        MatLegacyTabsModule,
        MatLegacyInputModule,
        MatNativeDateModule,
        MatLegacyProgressSpinnerModule,
        MatLegacySlideToggleModule,
        MatSidenavModule,
        MatLegacyCardModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatLegacyListModule,
        MatLegacyProgressBarModule,
        MatLegacyTooltipModule,
        MatLegacyPaginatorModule,
        MatSortModule,
        MatLegacyTableModule,
        MatLegacyDialogModule,
        MatButtonToggleModule,
        DonutChartComponent,
        LineChartComponent,
        SeverityIndicatorComponent,
        ActionIndicatorComponent,
        ScoreTagComponent,
        StatusIndicatorComponent,
        LoadingIndicatorComponent,
        LogTypeIndicatorComponent,
        LoadingErrorIndicatorComponent,
        ComplianceIndicatorComponent,
        MatStepperModule,
        CountdownComponent,
        StandardComponent,
        PageComponent,
        ClipboardDirective,
        AutofocusDirective,
        OpswatTooltipDirective,
        NumericDirective,
        MomentPipe,
        TrimPipe,
        SafeUrlPipe,
        SafeHtmlPipe,
        GenericTableComponent,
        CustomColumnComponent,
        MaIconComponent,
        MatSelectSearchComponent,
        MatSelectSearchClearDirective,
        SplitSelectComponent,
        SplitSelectNotificationComponent,
        BarChartComponent,
        StepperComponent,
        TrueFalseValuePipe,
        CookieNoticeComponent,
        BottomPanelComponent,
        SurveyPromptComponent,
        PinInputComponent,
        AccessDeniedComponent,
        LineChart2Component,
        InlineNotificationComponent,
        HttpClientModule,
        PageTitleComponent,
        OcmPageTitleComponent,
        SearchFieldComponent,
        EditNameComponent,
        SearchProductComponent,
        HighlightSearchPipe] }); })();

/*
 * Public API Surface of opswat-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccessDeniedComponent, ActionIndicatorComponent, AutofocusDirective, BarChartComponent, BarChartService, BottomPanelComponent, ClipboardDirective, ComplianceIndicatorComponent, CookieNoticeComponent, CountdownComponent, CustomColumnComponent, DonutChartComponent, EditNameComponent, FilterService, GenericTable, GenericTableComponent, HighlightSearchPipe, InlineNotificationComponent, LayoutService, LineChart2Component, LineChartComponent, LoadingBarComponent, LoadingBarService, LoadingErrorIndicatorComponent, LoadingIndicatorComponent, LogTypeIndicatorComponent, MaIconComponent, MatSelectSearchClearDirective, MatSelectSearchComponent, MomentPipe, NumericDirective, OcmPageTitleComponent, OpswatTooltipDirective, PageComponent, PageTitleComponent, PinInputComponent, RightDrawerService, SafeHtmlPipe, SafeUrlPipe, ScoreTagComponent, SearchFieldComponent, SearchProductComponent, SearchProductService, SeverityIndicatorComponent, SplitSelectComponent, SplitSelectNotificationComponent, StandardComponent, StatusIndicatorComponent, StepperComponent, SurveyPromptComponent, TrimPipe, TrueFalseValuePipe, UiModule, UiService };
